(function () {
	'use strict';

	angular.module('ngTextTruncate', ['pascalprecht.translate'])

			.directive('ngTextTruncate', ['$compile', 'ValidationServices', 'CharBasedTruncation', 'WordBasedTruncation',
				function ($compile, ValidationServices, CharBasedTruncation, WordBasedTruncation) {
					return {
						restrict: 'A',
						require: ['ngModel'],
						scope: {
							model: '=ngModel',
							charsThreshould: '@ngTtCharsThreshold',
							wordsThreshould: '@ngTtWordsThreshold',
							customMoreLabel: '@ngTtMoreLabel',
							customLessLabel: '@ngTtLessLabel'
						},
						link: function ($scope, $element, $attrs, $reqs) {

							$scope.toggleShow = function ($event) {
								$event.stopPropagation();
								$scope.open = !$scope.open;
							};

							$scope.useToggling = $attrs.ngTtNoToggling === undefined;

							$scope.open = false;

							ValidationServices.failIfWrongThreshouldConfig($scope.charsThreshould, $scope.wordsThreshould);

							var CHARS_THRESHOLD = parseInt($scope.charsThreshould);
							var WORDS_THRESHOLD = parseInt($scope.wordsThreshould);

							$scope.$watch('model', function () {
								$element.empty();

								if (CHARS_THRESHOLD) {
									if ($scope.model && CharBasedTruncation.truncationApplies($scope, CHARS_THRESHOLD)) {
										CharBasedTruncation.applyTruncation(CHARS_THRESHOLD, $scope, $element);

									} else {
										$element.append($scope.model);
									}

								} else {

									if ($scope.model && WordBasedTruncation.truncationApplies($scope, WORDS_THRESHOLD)) {
										WordBasedTruncation.applyTruncation(WORDS_THRESHOLD, $scope, $element);

									} else {
										$element.append($scope.model);
									}

								}
							});
						}
					};
				}
			])

			.factory('ValidationServices', function () {
				return {
					failIfWrongThreshouldConfig: function (firstThreshould, secondThreshould) {
						if ((!firstThreshould && !secondThreshould) || (firstThreshould && secondThreshould)) {
							throw 'You must specify one, and only one, type of threshould (chars or words)';
						}
					}
				};
			})

			.factory('CharBasedTruncation', ['$compile', function ($compile) {
					return {
						truncationApplies: function ($scope, threshould) {
							return $scope.model.length > threshould;
						},
						applyTruncation: function (threshould, $scope, $element) {
							if ($scope.useToggling) {
								var el = angular.element('<span>' +
										$scope.model.substr(0, threshould) +
										'<span ng-show="!open">...</span>' +
										'<span class="btn-link ngTruncateToggleText" ' +
										'ng-click="toggleShow($event)" ng-show="!open">' +
										' ' + ($scope.customMoreLabel ? $scope.customMoreLabel : 'More') +
										'</span>' +
										'<span ng-show="open">' +
										$scope.model.substring(threshould) +
										'<span class="btn-link ngTruncateToggleText"' +
										'ng-click="toggleShow($event)">' +
										' ' + ($scope.customLessLabel ? $scope.customLessLabel : 'Less') +
										'</span>' +
										'</span>' +
										'</span>');
								$compile(el)($scope);
								$element.append(el);

							} else {
								$element.append($scope.model.substr(0, threshould) + '...');

							}
						}
					};
				}])

			.factory('WordBasedTruncation', ['$compile', '$translate', function ($compile, $translate) {
					return {
						truncationApplies: function ($scope, threshould) {
							return $scope.model.split(' ').length > threshould;
						},
						applyTruncation: function (threshould, $scope, $element) {
							var splitText = $scope.model.split(' ');
							if ($scope.useToggling) {
								var el = angular.element('<span>' +
										splitText.slice(0, threshould).join(' ') +
										'<span ng-show="!open">...</span>' +
										' <span class="btn-link ngTruncateToggleText" ' +
										'ng-click="toggleShow($event)"' +
										'ng-show="!open">' +
										$translate.instant(($scope.customMoreLabel ? $scope.customMoreLabel : 'Plus')) +
										'</span>' +
										'<span ng-show="open">' +
										splitText.slice(threshould, splitText.length).join(' ') +
										' <span class="btn-link ngTruncateToggleText"' +
										'ng-click="toggleShow($event)">' +
										$translate.instant(($scope.customLessLabel ? $scope.customLessLabel : 'Moins')) +
										'</span>' +
										'</span>' +
										'</span>');
								$compile(el)($scope);
								$element.append(el);

							} else {
								$element.append(splitText.slice(0, threshould).join(' ') + '...');
							}
						}
					};
				}]);
}());
;
(function (angular) {
	'use strict';

	/**
	 * Initialize the core app module
	 */
	var core = angular.module('Core', ['ngResource', 'ngCookies']);

	core.run(function () {
		// Load locales depending of the user's locale
//		var script = 'bower_components/select2/select2_locale_' + Language.current().toLowerCase() + '.js';
//		$.getScript(script, function() { });
	});
})(angular);
;
(function(angular) {
	'use strict';
	/**
	 * Add directives to the audit module
	 */
	var dir = angular.module('Core');

	/**
	 * Expand or collapse an area
	 * params:
	 * onToggle: function(toggled). Use in your html: on-toggle="fn(toggled)" the function parameter name is important !
	 */
	dir.directive('stlToggler', [function() {

			return {
				restrict: 'E',
				replace: true,
				transclude: true,
				scope: {
					lessTitle: '@',
					moreTitle: '@',
					toggled: '@',
					onToggle: '&'
				},
				templateUrl: 'components/core/toggler/toggler.html',
				link: function(scope) {
					var refresh = function() {
						if (scope.toggled) {
							scope.tTitle = scope.lessTitle;
							scope.intTog = true;
						} else {
							scope.tTitle = scope.moreTitle;
							scope.intTog = false;
						}
					};
					if (scope.toggled === null || scope.toggled === undefined || scope.toggled === '') {
						scope.toggled = false;
					}
					scope.toggled = (typeof scope.toggled).toUpperCase() === 'STRING' ? scope.toggled.toUpperCase() === 'TRUE' : scope.toggled;

					scope.exp = function() {
						if (scope.toggled) {
							scope.toggled = false;
						} else {
							scope.toggled = true;
						}
						refresh();

						if (scope.onToggle !== null) {
							scope.onToggle({
								toggled: scope.toggled
							});
						}
					};

					refresh();
				}
			};
		}]);
})(angular);;
(function(angular) {
	'use strict';

	var COLUMN_ACTION_CLEAR = 'CLEAR_SORT';

	var COLUMN_ACTION_SET_SORT = 'SET_SORT';

	var COLUMN_ACTION_SORT_OPTION = 'SORT';

	var COLUMN_ACTION_SORT_DESC = 'DESC';

	var COLUMN_ACTION_SORT_ASC = 'ASC';

	var COLUMN_ACTION_DISABLE_SORTING = 'DISABLE_SORTING';

	var COLUMN_ACTION_ENABLE_SORTING = 'ENABLE_SORTING';

	var ROW_ACTION_SELECT = 'SELECT';

	var ROW_ACTION_UNSELECT = 'UNSELECT';

	var ROW_SELECT_IF_INDEX = 'ROW_SELECT_FOR_INDEX';

	var IS_ROW_SELECTED = 'IS_ROW_SELECTED';

	var core = angular.module('Core');

	var TABLE_KEY = 'STL-TABLE';

	/**
	 * Define utils for the stl table
	 */
	core.service('StlTableUtils', [function() {
			this.getDefaultPagingConfig = function(minPage) {
				var min = 30;
				if (minPage) {
					min = minPage;
				}
				return {
					//count: 0,
					//selectedPage: 0,
					pageFormating: [min, 100]//, //Optionnal
							//totalElementsPerPage: min //Optionnal but if included pageFormating is required
				};
			};
		}]);

	core.directive('stlTable', ['$timeout', 'FiltersService', function($timeout, FiltersService) {

			return {
				restrict: 'E',
				replace: true,
				transclude: true,
				//template: '<div class="stl-table"><div class="table-responsive" ng-transclude></div></div>',
				template: '<div class="stl-table" ng-transclude></div>',
				scope: {
					notification: '&?',
					selectNotification: '&?',
					control: '=?',
					model: '=',
					options: '=?',
					localSort: '=?'
				},
				/**
				 * options :
				 * disableSorting : true // disable the table sorting
				 * defaultSortColumn : 'column key name' // the default sorted column
				 * defaultSortDesc : true to sort desc
				 * selectionMode: (NONE, SINGLE, MULTIPLE) default "MULTIPLE"
				 */
				link: function(scope, element, attribute, controller) {
					$('table', element).addClass('table-hover');
					$('table', element).addClass('table');
					$('table.stl-table-paging', element).removeClass('table');
					$('table.stl-table-paging', element).removeClass('table-hover');
				},
				controller: ['$scope', '$element', function($scope, $element) {
						var self = this;
						var sortingDisabled = false;
						var uniqueKey = null;

						this.selectionMode = 'MULTIPLE';

						//Key : index , value : obejct
						var selectedObjects = {};
						var currentSortedColumn = null;
						var currentSelectedPage = null;
						var currentPageFormating = null;
						var currentSortDesc = null;
						var headerMap = {};
						var rowMap = {};

						//Options
						this.loadOptions = function() {
							if ($scope.options !== undefined) {
								if ($scope.options['disableSorting'] !== undefined && $scope.options['disableSorting'] === true) {
									sortingDisabled = true;
								}
								if ($scope.options['defaultSortColumn'] !== undefined) {
									currentSortedColumn = $scope.options['defaultSortColumn'];
								}
								if ($scope.options['defaultSortDesc'] !== undefined) {
									currentSortDesc = $scope.options['defaultSortDesc'];
								}
								if ($scope.options['selectionMode'] !== undefined) {
									this.selectionMode = $scope.options['selectionMode'];
								}
								if ($scope.options.uniqueKey) {
									uniqueKey = TABLE_KEY + '-' + $scope.options.uniqueKey;
									var storage = FiltersService.getFilter(uniqueKey);
									if (storage) {
										currentSortedColumn = storage['column'];
										currentSortDesc = storage['desc'];
										currentSelectedPage = storage['currentSelectedPage'];
										currentPageFormating = storage['currentPageFormating'];
									}
								}
							}
						};
						this.loadOptions();

						if ('localSort' in $scope) {
							$scope.localSort = {
								column: currentSortedColumn,
								dir: currentSortDesc

							};
						}

						$scope.toggleSelectLine = function($event, data) {
							$($event).addClass('active');
						};
						this.sendParentControllerNotification = function() {
							$scope.notification({
								sortColumnKey: currentSortedColumn,
								sortDesc: currentSortDesc,
								paging: currentSelectedPage,
								formating: currentPageFormating
							});
						};

						this.updateLocalSort = function() {
							if ('localSort' in $scope) {
								$scope.localSort = {
									column: currentSortedColumn,
									dir: currentSortDesc
								};
							}
						};

						this.updateStorage = function() {
							if (uniqueKey) {
								FiltersService.setFilter(uniqueKey, {
									column: currentSortedColumn,
									desc: currentSortDesc,
									currentSelectedPage: currentSelectedPage,
									currentPageFormating: currentPageFormating
								});
							}
						};

						this.getStorage = function() {
							if (uniqueKey) {
								return FiltersService.getFilter(uniqueKey);
							}
						};

						this.headerRegister = function(key, callBackControlls) {
							headerMap[key] = callBackControlls;

							if (sortingDisabled) {
								callBackControlls(COLUMN_ACTION_DISABLE_SORTING);
							}

							if (currentSortedColumn === key) {
								var updateOptions = {};
								updateOptions[COLUMN_ACTION_SORT_OPTION] = currentSortDesc ? COLUMN_ACTION_SORT_DESC : COLUMN_ACTION_SORT_ASC;
								callBackControlls(COLUMN_ACTION_SET_SORT, updateOptions);
							}
						};

						this.rowRegister = function(rowId, callBackFn) {
							rowMap[rowId] = callBackFn;
						};

						this.rowUnregister = function(rowId) {
							delete rowMap[rowId];
						};

						this.updateSort = function(columnKey, sortDesc) {

							currentSortDesc = sortDesc;

							if (currentSortedColumn !== null && columnKey !== currentSortedColumn) {
								headerMap[currentSortedColumn](COLUMN_ACTION_CLEAR);
							}

							currentSortedColumn = columnKey;

							self.updateStorage();

							self.updateLocalSort();

							this.sendParentControllerNotification();

						};
						this.pagingExternalChange = function(selectedPage) {
							currentSelectedPage = selectedPage;
							self.updateStorage();
						};

						this.selectPage = function(selectedPage) {
							currentSelectedPage = selectedPage;
							this.sendParentControllerNotification();
							self.updateStorage();
						};

						this.formatingExternalChange = function(format) {
							currentPageFormating = format;
							self.updateStorage();
						};

						this.selectFormat = function(format) {
							currentPageFormating = format;
							this.sendParentControllerNotification();
							self.updateStorage();
						};

						this.isObjectSelected = function() {
							for (var r in selectedObjects) {
								return !!r;
							}
							return false;
						};

						this.updateSelectedElements = function() {
							selectedObjects = {};
							for (var row in rowMap) {
								var info = rowMap[row](IS_ROW_SELECTED);
								if (info) {
									selectedObjects[info.index] = info.object;
								}
							}
						};

						this.selectElement = function(index, object) {
							if ($scope.selectionMode !== 'NONE') {
								selectedObjects[index] = object;
							}

							if ($scope.selectNotification) {
								$timeout(function() {
									$scope.selectNotification({
										index: index,
										data: object
									});
								});
							}
						};

						this.unselectElement = function(index, object, destroyed) {
							if (selectedObjects[index] !== undefined) {
								delete selectedObjects[index];
								if ($scope.selectNotification) {
									$timeout(function() {
										$scope.selectNotification({
											index: -1,
											service: null,
											data: object,
											destroyed: destroyed,
											oldIndex: index
										});
									});
								}
							}
						};

						this.selectAll = function() {
							// Only for multiple selection
							if (this.selectionMode === 'MULTIPLE') {
								for (var row in rowMap) {
									rowMap[row](ROW_ACTION_SELECT);
								}
							}
						};

						this.unselectAll = function() {
							for (var row in rowMap) {
								rowMap[row](ROW_ACTION_UNSELECT);
							}
						};

						this.sort = function(options) {
							if (options === undefined || options['columnKey'] === undefined || options['desc'] === undefined || headerMap[options['columnKey']]) {
								return;
							}
							var column = options['columnKey'];

							if (currentSortedColumn !== null && currentSortedColumn !== column) {
								headerMap[currentSortedColumn](COLUMN_ACTION_CLEAR);
							}

							currentSortedColumn = column;

							options['desc'] = (typeof options['desc']).toUpperCase() === 'STRING' ? options['desc'].toUpperCase() === 'TRUE' : options['desc'];

							var updateOptions = {};
							updateOptions[COLUMN_ACTION_SORT_OPTION] = options['desc'] ? COLUMN_ACTION_SORT_DESC : COLUMN_ACTION_SORT_ASC;
							headerMap[column](COLUMN_ACTION_SET_SORT, updateOptions);

							self.updateStorage();

							self.updateLocalSort();
						};

						this.setSelectionMode = function(mode) {
							self.selectionMode = mode;
						};

						var selectLine = function(index) {
							for (var row in rowMap) {
								rowMap[row](ROW_SELECT_IF_INDEX, parseInt(index));
							}
						};

						var getSelectedObjects = function() {
							self.updateSelectedElements();
							return selectedObjects;
						};

						var getCurrentState = function() {
							return {
								sortColumnKey: currentSortedColumn,
								sortDesc: currentSortDesc,
								paging: currentSelectedPage,
								formating: currentPageFormating
							};
						};

						var ctrlsCmd = {
							sort: self.sort,
							selectedObjects: getSelectedObjects,
							selectAll: self.selectAll,
							unselectAll: self.unselectAll,
							getCurrentState: getCurrentState,
							updateSelectedElements: self.updateSelectedElements,
							selectLine: selectLine,
							isObjectSelected: self.isObjectSelected,
							setSelectionMode: self.setSelectionMode
						};

						$scope.control = function(action, options) {
							if (ctrlsCmd[action]) {
								return ctrlsCmd[action](options);
							}
						};


					}]
			};
		}])
			.directive('stlTableHead', [function() {
					return {
						restrict: 'A',
						require: '^stlTable',
						replace: true,
						transclude: true,
						scope: {
							sortable: '@',
							key: '@'
						},
						template: '<th class="stl-table-th-head" ng-click="toggleSort()">' +
								'<div ng-transclude></div>' +
								'<div class="stl-table-sort-btns">' +
								// use span+font rather than png
								'<span class="iconbtn iconexp iconexp-navigate-up" ng-if="showDesc"></span>' +
								'<span class="iconbtn iconexp iconexp-navigate-down" ng-if="showAsc"></span>' +
								//'<div class="stl-table-sort-desc" ng-if="showDesc">desc</div>' +
								//'<div class="stl-table-sort-asc"  ng-if="showAsc">asc</div>' +
								'</div>' +
								'</th>',
						link: function(scope, element, attribute, controller) {
							var sortingEnabled = true;
							var key = scope.key;
							scope['showDesc'] = false;
							scope['showAsc'] = false;

							var colSortable = true;
							if (scope.sortable !== undefined && scope.sortable !== null) {
								colSortable = scope.sortable.toLowerCase() === 'true';
							}
							if (!colSortable) {
								$(element).addClass('stl-disable-table-sorting');
							}

							/**
							 *
							 * @param {String} action Nom de l'action à exécuter.
							 * @param {Object} options Options en fonction de l'action pour le passage de paramètres additionnels.
							 * @returns {undefined}
							 */
							var controlls = function(action, options) {
								var sort = action === COLUMN_ACTION_SET_SORT && options !== undefined && options[COLUMN_ACTION_SORT_OPTION] !== undefined;

								if (action === COLUMN_ACTION_CLEAR) {
									scope['showDesc'] = false;
									scope['showAsc'] = false;
								} else if (sort) {
									scope['showDesc'] = options[COLUMN_ACTION_SORT_OPTION] === COLUMN_ACTION_SORT_DESC;
									scope['showAsc'] = options[COLUMN_ACTION_SORT_OPTION] === COLUMN_ACTION_SORT_ASC;
								} else if (action === COLUMN_ACTION_DISABLE_SORTING) {
									sortingEnabled = false;
									$(element).addClass('stl-disable-table-sorting');
								} else if (action === COLUMN_ACTION_ENABLE_SORTING && colSortable) {
									sortingEnabled = true;
									$(element).removeClass('stl-disable-table-sorting');
								}
							};

							scope.toggleSort = function() {
								if (!sortingEnabled || !colSortable) {
									return;
								}
								if (scope['showAsc'] === false) {
									scope['showDesc'] = false;
									scope['showAsc'] = true;
									controller.updateSort(key, false);
								} else {
									scope['showDesc'] = true;
									scope['showAsc'] = false;
									controller.updateSort(key, true);
								}
							};

							controller.headerRegister(key, controlls);
						}
					};
				}])
			.directive('stlTableRowSelection', [function() {
					var uniqueId = 0;
					var ACTIVE_CLS = 'active';
					var UNSELECTABLE_CLS = 'unselectable';
					return {
						restrict: 'A',
						require: '^stlTable',
						scope: {
							stlTableRowSelection: '=',
							index: '=',
							disabled: '=?'
						},
						link: function(scope, element, attributes, controller) {
							//var sc = angular.element(element).scope(); retrive the ng-repeat scope
							var rowId = uniqueId++;
							var selectField = null;
							if (attributes['selectField']) {
								selectField = attributes['selectField'];
							}

							var updateSelectedFiled = function(value) {
								if (selectField !== null) {
									scope.stlTableRowSelection[selectField] = value;
								}
							};

							element.bind('$destroy', function() {
								if ($(element).hasClass(ACTIVE_CLS) && !attributes['noDestroyEvent']) {
									controller.unselectElement(scope.index, scope.stlTableRowSelection, true);
								}
								controller.rowUnregister(rowId);
							});

							$(element).on('click', function(ev) {
								if ($(element).hasClass(UNSELECTABLE_CLS)) {
									return;
								}
								if (controller.selectionMode !== 'NONE') {
									if ($(element).hasClass(ACTIVE_CLS)) {
										$(element).removeClass(ACTIVE_CLS);
										updateSelectedFiled(false);
										controller.unselectElement(scope.index, scope.stlTableRowSelection);
									} else {
										if (!scope.disabled && scope.disabled !== true) {
											if (controller.selectionMode === 'SINGLE') {
												controller.unselectAll();
											}
											updateSelectedFiled(true);
											$(element).addClass(ACTIVE_CLS);
											controller.selectElement(scope.index, scope.stlTableRowSelection);
										}

									}
								}

							});
							var callBackFn = function(action, options) {
								if (action === ROW_ACTION_SELECT && !$(element).hasClass(ACTIVE_CLS)) {
									$(element).addClass(ACTIVE_CLS);
									updateSelectedFiled(true);
									controller.selectElement(scope.index, scope.stlTableRowSelection);
								} else if (action === ROW_ACTION_UNSELECT && $(element).hasClass(ACTIVE_CLS)) {
									$(element).removeClass(ACTIVE_CLS);
									updateSelectedFiled(false);
									controller.unselectElement(scope.index, scope.stlTableRowSelection);
								} else if (action === IS_ROW_SELECTED && $(element).hasClass(ACTIVE_CLS)) {
									return {
										index: scope.index,
										object: scope.stlTableRowSelection
									};
								} else if (action === ROW_SELECT_IF_INDEX && options === scope.index) {
									$(element).addClass(ACTIVE_CLS);
									controller.selectElement(scope.index, scope.stlTableRowSelection);
								}
							};
							controller.rowRegister(rowId, callBackFn);
							if (selectField !== null && scope.stlTableRowSelection[selectField] === true) {
								$(element).addClass(ACTIVE_CLS);
								controller.selectElement(scope.index, scope.stlTableRowSelection);
							}
						}
					};
				}])
			.directive('stlTablePaging', ['$sce', '$translate', function ($sce, $translate) {
					return {
						restrict: 'AE',
						require: '^stlTable',
						replace: true,
						scope: {
							parameters: '=',
							pageCount: '=',
							selectedPage: '='
						},
						templateUrl: 'scripts/core/table/paginator.html',
						link: function(scope, element, attributes, controller) {
							var initNbPages = function(count, parameters) {
								var nbPages = Math.floor(count / parameters.totalElementsPerPage);
								if (count % parameters.totalElementsPerPage > 0) {
									nbPages++;
								}
								return nbPages;
							};
							var createPage = function(index) {
								return {
									label: index + 1,
									index: index
								};
							};
							var createNoPage = function() {
								return {
									label: '...',
									index: null
								};
							};
							var buildPages = function(count) {
								var pages = [];
								scope.count = count;
								if (count) {
									var nbPages = initNbPages(count, scope.parameters);
									scope.totalPages = nbPages;
									var selectedPage = scope.parameters.selectedPage;

									if (selectedPage + 1 > nbPages) {
										scope.selectPage(nbPages - 1);
									}

									var elemenentAfficheDu = (scope.parameters.totalElementsPerPage * selectedPage) + 1;
									var elemenentAfficheAu = elemenentAfficheDu + scope.parameters.totalElementsPerPage - 1;

									if (count < elemenentAfficheAu) {
										elemenentAfficheAu = count;
									}
									$translate('resultXaYsurZ', {x: elemenentAfficheDu, y: elemenentAfficheAu, z: count}).then(function (translatedValue) {
										//scope.elementsCount = $sce.trustAsHtml(I18nService.localize('resultXaYsurZ', [elemenentAfficheDu, elemenentAfficheAu, count]));
										scope.elementsCount = $sce.trustAsHtml(translatedValue);
									});



									if (nbPages > 9) {
										var start;
										var end;

										start = selectedPage - 2;
										end = selectedPage + 2;

										var addStart = false;
										var addEnd = false;

										if (start < 2) {
											start = 0;
											end = 6;
										} else {
											addStart = true;
										}
										if (scope.totalPages - end < 2) {
											end = scope.totalPages-1;
											start = scope.totalPages - 6;
										} else {
											addEnd = true;
										}

										if (!!addStart) {
											pages.push(createPage(0));
											pages.push(createNoPage());
										}

										for (var i = start; i <= end; i++) {
											pages.push(createPage(i));
										}

										if (!!addEnd) {
											pages.push(createNoPage());
											pages.push(createPage(scope.totalPages-1));
										}

									} else {
										for (var j = 0; j < nbPages; j++) {
											pages.push(createPage(j));
										}
									}
								} else {
									$translate('AucunResultat').then(function (translatedValue) {
										scope.elementsCount = $sce.trustAsHtml(translatedValue);
									});
								}
								scope.pages = pages;
							};
							buildPages(0);
							scope.$watchCollection('[parameters.selectedPage, parameters.count, parameters.totalElementsPerPage]', function() {
								if (scope.parameters.count || scope.parameters.count === 0) {
									buildPages(scope.parameters.count);
								} else {
									$translate('AucunResultat').then(function (translatedValue) {
										scope.elementsCount = $sce.trustAsHtml(translatedValue);
									});
								}

							});

							scope.next = function() {
								scope.selectPage(scope.parameters.selectedPage + 1);
							};
							scope.prev = function() {
								scope.selectPage(scope.parameters.selectedPage - 1);
							};

							scope.selectPage = function(page) {
								scope.parameters.selectedPage = page;
								controller.selectPage(page);
							};
							scope.selectFormat = function(format) {
								scope.parameters.totalElementsPerPage = format;
								controller.selectFormat(format);
							};
							scope.$watch('parameters', function() {
								if (scope.parameters.pageFormating) {
									if (scope.parameters.totalElementsPerPage === undefined) {
										scope.parameters.totalElementsPerPage = scope.parameters.pageFormating[0];
										var storage = controller.getStorage();
										if (storage && storage['currentSelectedPage']) {
											scope.parameters.totalElementsPerPage = storage['currentPageFormating'];
											scope.parameters.selectedPage = storage['currentSelectedPage'];
										}

									}
									if (!scope.parameters.selectedPage) {
										scope.parameters.selectedPage = 0;
									}

									controller.formatingExternalChange(scope.parameters.totalElementsPerPage);

									controller.pagingExternalChange(scope.parameters.selectedPage);
								}

							}, true);
							if (scope.parameters) {
								controller.pagingExternalChange(scope.parameters.selectedPage);
							}
						}
					};
				}])
			/*.directive('stlTableBtns', [function() {
			 return {
			 restrict: 'E',
			 link: function(scope, element) {
			 // A voir si utile
			 /*$('button', element).addClass('btn');
			 $('button', element).attr('type', 'button');*
			 }
			 };
			 }]) */
			.directive('stlTableAction', [function() {
					return {
						restrict: 'A',
						require: '^stlTable',
						scope: {
							stlTableAction: '='
						},
						link: function(scope, element, attributes, controller) {
							element.on('click', function() {
								if (scope.stlTableAction === 'selectAll') {
									controller.selectAll();
								} else if (scope.stlTableAction === 'unselectAll') {
									controller.unselectAll();
								}
							});
						}
					};
				}])
			.directive('stlTableNoSelection', [function() {
					return {
						restrict: 'A',
						link: function(scope, element) {
							$(element).on('click', function(ev) {
								ev.stopPropagation();
							});
						}
					};
				}]);

	core.filter('stlTableLocalSortPaging', ['ObjectFilter', function(ObjectFilter) {
			return function(list, sortOptions, pagingOptions) {
				if (!list) {
					return null;
				} else if (!sortOptions) {
					return list;
				} else {
					return ObjectFilter.sortFilterArray(list, [sortOptions]);
				}
			};
		}]);

	core.filter('stlTableLocalSort', ['ObjectFilter', function(ObjectFilter) {
			return function(list, sortOptions) {
				if (!list) {
					return null;
				} else if (!sortOptions) {
					return list;
				} else {
					return ObjectFilter.sortFilterArray(list, [sortOptions]);
				}
			};
		}]);
})(angular);;
(function(angular) {
	'use strict';

	var core = angular.module('Core');

	/*
	 * User service
	 */
	core.service('UserService', ['$log', '$rootScope', '$q', function($log, $rootScope, $q) {
			var self = this;
			var deferred = $q.defer();
			this.userDetails = {
				userName: 'anonymous'
			};
			this.userData = {};

			this.getPromise = function() {
				return deferred.promise;
			};
			/**
			 * User details object (must contains following fields):
			 * {
			 *		userName: (String) login of the user
			 *		lastName: (Option String) name of the user
			 *		firstName: (Option String) first name of the user
			 * }
			 *
			 * @param {UserDetail} userDetails the detailed info of the user
			 */
			this.setUserDetails = function(userDetails) {
				if (!userDetails) {
					$log.error('UserService: The userDetails are null !');
					return;
				}
				if (!userDetails.userName) {
					$log.error('UserService: The userDetails must contain a userName !');
					return;
				}
				this.userDetails = userDetails;
				$log.debug('UserService: New user details (login: ' + this.userDetails.login + ')');

				$rootScope.$broadcast('user-details-initialized');
				deferred.resolve(userDetails);
			};

			this.getUserName = function() {
				return this.userDetails.userName;
			};

			this.getUserEmail = function() {
				return this.userDetails.email;
			};

			/**
			 * Get the user name and firstname
			 * @returns {String} name + first name or userName when no name / first name
			 */
			this.getUserNameFirstName = function() {
				var name = '';
				if (!this.userDetails.lastName && !this.userDetails.firstName) {
					name = this.getUserName();
				} else if (this.userDetails.lastName && this.userDetails.firstName) {
					name = this.userDetails.lastName + this.userDetails.firstName;
				} else {
					name = this.userDetails.lastName;
				}
				return name;
			};

			this.hasRole = function(role) {
				return self.userDetails.personneRoleIdsMap && self.userDetails.personneRoleIdsMap[role];
			};

			this.getIdForRole = function(role) {
				if (self.userDetails.personneRoleIdsMap && self.userDetails.personneRoleIdsMap[role]) {
					return self.userDetails.personneRoleIdsMap[role];
				}
				return null;
			};

			/**
			 * Attach data to the current user
			 * @param {Object} userData the data of the user
			 */
			this.setUserData = function(userData) {
				this.userData = userData;
			};

			/**
			 * Get the user data
			 * @returns {Object} the user data
			 */
			this.getUserData = function() {
				return this.userData;
			};
		}]);
})(angular);;
(function(angular) {
	'use strict';
	var core = angular.module('Core');

	/*
	 * Local storage service
	 */
	core.service('SecurityService', function($log, $rootScope, $location, $timeout, NotificationService, $translate) {

		var permMatrix = {};
		var userRoles = [];

		/*
		 * Initialize the security service
		 */
		this.initMatrix = function(matrix) {
			permMatrix = matrix;

			$log.debug('SecurityService: Permission matrix initialized.');
		};

		/*
		 * Initialize security roles
		 */
		this.initUserRoles = function(roles) {
			userRoles = roles;

			if (roles && roles.length > 0) {
				$rootScope.$broadcast('security-loaded');
				$log.debug('SecurityService: User roles initialized: ' + JSON.stringify(roles));
			} else {
				this.rejectUser();
			}
		};

		var getKey = function(role, action) {
			var key = '';
			if (role && action) {
				key = role.toUpperCase() + '___' + action.toUpperCase();
			}
			return key;
		};

		this.setDroit = function(action, droit) {
			permMatrix[action] = droit;
		};

		/**
		 * get a droit for a role and an action
		 * @param {type} role the role to check
		 * @param {type} action the action to list
		 * @returns {TypeDroit} the droit attached
		 */
		this.getDroit = function(role, action) {
			var droit = 'NONE';
			var d = permMatrix[getKey(role, action)];
			if (d) {
				droit = d;
			}
			return droit;
		};

		this.getMatrix = function() {
			return permMatrix;
		};

		/**
		 *
		 * @param {type} action the action to get the droits
		 * @returns {TypeDroit[]} the droits associated for the action
		 */
		this.getDroits = function(action) {
			var droits = [];

			for (var i = 0; i < userRoles.length; i++) {
				var r = userRoles[i];
				var d = this.getDroit(r, action);
				if (d && d !== 'NONE') {
					droits.push(d);
				}
			}

			if (droits.length === 0) {
				droits.push('NONE');
			}

			return droits;
		};




		this.getUserRoles = function() {
			return userRoles;
		};

		var checker = {};
		/**
		 * Add a checker for a desired action and resource
		 * This is used for custom permission checks
		 * @param {TypeAction} action
		 * @param {function} fn the function called to check if the user has right: boolean fn(droit, resourceValue, options)
		 *
		 */
		this.addPermissionChecker = function(action, fn) {
			var spl = action.split('\.');
			var resource = spl[0];
			var act = spl[1];
			if (!checker[resource]) {
				checker[resource] = {};
			}
			checker[resource][act] = fn;
		};

		/**
		 * Add multiple checkers for desired actions and resource
		 * This is used for custom permission checks
		 * @param {TypeAction[]} actions
		 * @param {function} fn the function called to check if the user has right: boolean fn(droit, resourceValue, options)
		 *
		 */
		this.addPermissionCheckers = function(actions, fn) {
			if (actions && actions.length > 0) {
				for (var i = 0; i < actions.length; i++) {
					var action = actions[i];
					this.addPermissionChecker(action, fn);
				}
			}
		};

		/**
		 * Ask the permission service if the currently connected user has the rights to perform an action
		 * @param {type} action the action to test
		 * @param {type} resourceValue
		 * @param {type} options
		 * @returns {Boolean} true if the user has the right to perform the desired operation
		 *
		 * Example: ELEVE.LIST (from perm matrix) -> function(ELEVE.LIST, value, options)
		 */
		this.hasResourcePermission = function(action, resourceValue, options) {

			// Simple check. If we find "ALL", we don't need to check more...
			if (this.hasDroit(action, ['ALL'])) {
				return true;
			}

			// When resource is null, we return false
			if (!resourceValue) {
				return false;
			}

			var spl = action.split('\.');
			var resource = spl[0];
			var act = spl[1];

			var result = false;
			if (checker[resource] && checker[resource][act]) {
				var droits = this.getDroits(action);
				for (var i = 0; i < droits.length; i++) {
					var droit = droits[i];
					if (!(droit === 'NONE')) {
						result = checker[resource][act](droit, resourceValue, options);
						if (result) {
							break;
						}
					}
				}
			} else {
				$log.warn('SecurityService: No checker found for resource.action: ' + action + '!');
			}
			return result;
		};

		/**
		 * Check if at least 1 "droit" is authorized from the list of "droits"
		 * @param {TypeAction} action
		 * @param {TypeDroit[]} droits list of droit (a or is make between droits) (could be also a single object)
		 * @returns {boolean} true if permissions match
		 */
		this.hasDroit = function(action, droits) {
			var avDroits = this.getDroits(action);
			var reqDroits = [];
			if (droits instanceof Array) {
				reqDroits = droits;
			} else {
				reqDroits.push(droits);
			}

			var permitted = false;

			// Let's see if we find a corresponding droit
			for (var i = 0; i < avDroits.length; i++) {
				var avd = avDroits[i];
				if (avd === 'ALL') {
					permitted = true;
					break;
				} else {
					for (var j = 0; j < reqDroits.length; j++) {
						if (reqDroits[j] === avd) {
							permitted = true;
							break;
						}
					}
				}
			}

			return permitted;
		};

		/**
		 * Returns true if at least 1 droit is not NONE
		 * @param {ActionType} action the action to test
		 * @returns {boolean} true if any role is different than NONE
		 */
		this.hasAnyDroit = function(action) {
			var permitted = false;
			var avDroits = this.getDroits(action);
			// Let's see if we find a corresponding droit
			for (var i = 0; i < avDroits.length; i++) {
				var avd = avDroits[i];
				if (avd && avd !== 'NONE') {
					permitted = true;
					break;
				}
			}
			return permitted;
		};

		/**
		 * Called when the user has no rights over the application
		 * In that case we redirect the view to the corresponding view
		 */
		this.rejectUser = function() {
			$rootScope.$broadcast('user-security-rejected');
		};

		/**
		 * This method reject the current location (user is redirected) and a message is displayed
		 */
		this.rejectLocation = function() {
			$timeout(function() {
				NotificationService.notify('WARN', $translate.instant('error.security.location.rejected'));
				$location.path('/');
			});
		};

		this.hasRole = function(role) {
			for (var i = 0; i < userRoles.length; i++) {
				if (userRoles[i] === role) {
					return true;
				}
			}
			return false;
		};
	});

	/* Security directives */
	/*
	 * Used to disable functionalities of the app with the security service
	 * @param {String} securedAction: TODO
	 * @param {String} policy:  hide (css hide), remove (remove elements from the dom), disable (add ng-disabled)
	 * @param {String} disabledText: Displays this text when the security is not allowed
	 * @param {String} hasAny see SecurityService.hasAnyDroit()
	 * @param {String} hasAnyOf see SecurityService.hasDroit()
	 * @param {Object} hasResourcePermission see SecurityService hasResourcePermission
	 *		hasResourcePermission's object definition:
	 *			{
	 *				resourceValue: The resource itself
	 *				options: Options to transmit
	 *			}
	 */
	core.directive('stlSecured', function($log, SecurityService) {
		return {
			transclude: true,
			scope: {
				'securedAction': '=',
				'hasAny': '@',
				'hasAnyOf': '=',
				'policy': '@',
				'disabledText': '=',
				'hasResourcePermission': '=',
				'hasRole': '='
			},
			restrict: 'E',
			replace: true,
			template: '<span>' +
					'<span class="stl-secured-area" ng-show="!secHidden" ng-transclude></span>' +
					'<span ng-if="secHidden && disabledText">{{disabledText}}</span>' +
					'</span>',
			link: function(scope, element, attrs) {
				var permitted = false;

				scope.secHidden = false;
				scope.secDisabled = false;

				var lastSecurityApply = {
					securedAction: undefined,
					hasResourcePermission: undefined
				};

				var applySecurity = function() {
					lastSecurityApply.securedAction = scope.securedAction;
					lastSecurityApply.hasResourcePermission = scope.hasResourcePermission;

					// Handle security...
					if (!scope.securedAction) {
						$log.warn('stlSecured: no secured-action set ! don\'t forget to use \'SECURED_ACTION\' when static !');
						permitted = false;
					} else if (attrs['hasAny'] !== undefined) {
						permitted = SecurityService.hasAnyDroit(scope.securedAction);
					} else if (attrs['hasAnyOf'] !== undefined) {
						permitted = SecurityService.hasDroit(scope.securedAction, scope.hasAnyOf);
					} else if (attrs['hasResourcePermission'] !== undefined) {
						permitted = false;
						var params = scope.hasResourcePermission;
						if (params) {
							permitted = SecurityService.hasResourcePermission(
									scope.securedAction, params.resourceValue, params.options);
						} else {
							permitted = false;
						}
					} else if (attrs['hasRole']) {
						permitted = SecurityService.hasRole(attrs['hasRole']);
					}

					var policy = 'hide';
					if (scope.policy) {
						policy = scope.policy;
					}

					if (policy === 'remove') {
						if (!permitted) {
							element.find('span.stl-secured-area').remove();
						}
						scope.secHidden = !permitted;
					} else if (policy === 'disable') {
						if (!permitted) {
							var inputs = element.find('input');
							inputs.attr('disabled', true);
						}
					} else {
						scope.secHidden = !permitted;
					}
				};

				scope.$watchCollection('[securedAction, hasResourcePermission]', function(newVal, oldVal) {
					if (!angular.equals(newVal, oldVal)
							|| lastSecurityApply.securedAction !== newVal[0]
							|| lastSecurityApply.hasResourcePermission !== newVal[1]) {
						applySecurity();
					}
				}, true);
				applySecurity();

			}
		};
	});

	/*
	 * Used to disable functionalities of the app with the security service
	 *
	 */
	core.directive('hasAnyRight', function(SecurityService, $rootScope) {
		return {
			scope: true,
			restrict: 'A',
			link: function(scope, element, attrs) {
				var permitted = false;
				var securedAction = null;
				if (attrs['securedAction'] !== undefined) {
					securedAction = attrs['securedAction'];
				}

				var apply = function() {
					// Handle security...
					if (securedAction && attrs['hasAnyRight'] !== undefined) {
						permitted = SecurityService.hasAnyDroit(securedAction);
					}

					if (!permitted) {
						element.hide();
					} else {
						element.show();
					}
				};
				apply();

				$rootScope.$on('security-loaded', function() {
					apply();
				});
			}
		};
	});
})(angular);
;
/* global App */

(function(angular) {
	'use strict';
	/**
	 * Notification service
	 */
//	if (angular.isDefined(App) && App.optLockFn === null) {
//		App.optLockFn = function() {
//			location.reload();
//		};
//	}
	var core = angular.module('Core');
	core.service('NotificationService', function ($rootScope, $log, toaster, $translate) {
		var instance = this;

		var optLockFn = null;

		this.setOptLockFunction = function(fn) {
			optLockFn = fn;
		};

		var uniqueNotificationKeys = {};

		/**
		 * Examples:
		 * notificationService.notify("SUCCESS", "SUCCESS", "SUCCESS Level");
		 * notificationService.notify("ERROR", "ERROR", "ERROR Level");
		 * notificationService.notify("WARN", "WARNING", "WARNING Level");
		 * notificationService.notify("INFO", "INFO", "INFO Level");
		 *
		 * @param {String} level SUCCESS, ERROR, WARN, INFO
		 * @param {String} title Title of the box
		 * @param {String} html HTML Contents of the box
		 */
		this.notify = function(level, title, html) {
			switch (level) {
				case 'SUCCESS':
					toaster.pop('success', title, html, 5000, 'trustedHtml');
					break;
				case 'ERROR':
					toaster.pop('error', title, html, 15000, 'trustedHtml');
					break;
				case 'INFO':
					toaster.pop('note', title, html, 5000, 'trustedHtml');
					break;
				case 'WARN':
					toaster.pop('warning', title, html, 15000, 'trustedHtml');
					break;
			}
		};
		this.showAjaxErrorMessage = function(status, title, url) {
			var ttl = title;
			if (!ttl) {
				ttl = $translate.instant('error.ajax.message');
			}
			var message = $translate.instant('error.ajax.status') + ': ' + status;
			instance.notify('ERROR', ttl, message);

			$log.warn('NotificationService: request failed. Status: ' + status + ' URL: ' + url);
		};

		this.notifyUniqueError = function(key) {
			if (uniqueNotificationKeys[key]) {
				return;
			}

			instance.notify('ERROR', '', $translate.instant(key));
		};

		var isBusinessError = function(error) {
			return error.errorType.indexOf('ERR_BUS_') === 0;
		};

		var isGeneralError = function(error) {
			return  error.errorType.indexOf('ERR_GEN_') === 0;
		};

		var showBusinessErrorMessage = function(status, error) {
			var title = $translate.instant('error.business.' + error.errorType);

			var messageKey = 'error.business.' + error.errorType + '.message';
			var message = $translate.instant(messageKey);
			if (message === messageKey) {
				message = null;
			}
			instance.notify('ERROR', title, message);
		};

		var showDataNotFoundErrorMessage = function(error) {
			var title = $translate.instant('error.ajax.status.' + 404);
			var clazz = null;
			var id = null;
			if (error.parameters) {
				if (error.parameters.length > 0) {
					clazz = error.parameters[0];
				}
				if (error.parameters.length > 1) {
					id = error.parameters[1];
				}
			}

			var htmlMessage = '';
			if (clazz) {
				var paths = clazz.split('\.');
				clazz = paths[paths.length - 1];
				htmlMessage += $translate.instant('error.resource') + ': ' + clazz;
				if (id) {
					htmlMessage += ', ' + $translate.instant('error.id') + ': ' + id;
				}
			}

			instance.notify('ERROR', title, htmlMessage);
		};

		var showDependanceNotFoundErrorMessage = function (error) {
			var title = $translate.instant('error.code.' + error.errorType);
			var clazz = null;
			var id = null;
			if (error.parameters) {
				if (error.parameters.length > 0) {
					clazz = error.parameters[0];
				}
				if (error.parameters.length > 1) {
					id = error.parameters[1];
				}
			}

			var htmlMessage = '';
			if (clazz) {
				var paths = clazz.split('\.');
				clazz = paths[paths.length - 1];
				htmlMessage += $translate.instant('error.resource') + ': ' + clazz;
				if (id) {
					htmlMessage += ', ' + $translate.instant('error.id') + ': ' + id;
				}
			}

			instance.notify('ERROR', title, htmlMessage);
		};

		var showNotAuthorizedErrorMessage = function(error) {
			var title = $translate.instant('error.ajax.status.' + 403);
			instance.notify('ERROR', title);
		};

		var showOptLockErrorMessage = function(error) {
			var title = $translate.instant('error.ajax.status.' + 409);

			var fn = function() {
				location.reload();
			};
			if (optLockFn) {
				fn = optLockFn;
			}

			App.optLockFn = optLockFn;

			var message = '<a type="button" class="btn btn-default btn-glyph" onclick="App.optLockFn()" style="color: black;">' +
					$translate.instant('error.optlock.reload') + ' <span class="glyphicon glyphicon-refresh"></span></a>';

			instance.notify('WARN', title, message);
		};

		this.showWarnWithReload = function (title, message) {
			App.realoadFn = function () {
				location.reload();
			};
			var htmlMessage = message + '<br><a type="button" class="btn btn-default btn-glyph" onclick="App.realoadFn()" style="color: black;">' +
					$translate.instant('error.optlock.reload') + ' <span class="glyphicon glyphicon-refresh"></span></a>';

			instance.notify('WARN', title, htmlMessage);
		};

		this.showApplicationErrorMessage = function(status, url, error) {
			if (isBusinessError(error)) {
				showBusinessErrorMessage(status, error);
			} else {
				switch (error.errorType) {
					case 'ERR_GEN_10':
						showDataNotFoundErrorMessage(error);
						break;
					case 'ERR_GEN_20':
						showOptLockErrorMessage(error);
						break;
					case 'ERR_GEN_30':
						showNotAuthorizedErrorMessage(error);
						break;
					case 'ERR_GEN_42':
						showDependanceNotFoundErrorMessage(error);
						break;
					default:
						var message = '';
						if (isGeneralError(error)) {
							message = $translate.instant('error.code') + ': ' + $translate.instant('error.code.' + error.errorType);
							instance.notify('ERROR', '', message);
						} else {
							var title = $translate.instant('error.ajax.status.' + status);
							message = $translate.instant('error.code') + ': ' + error.errorType;
							instance.notify('ERROR', title, message);
						}
						break;
				}
			}

			// Log data...
			var params = ' ';
			if (error.parameters) {
				for (var i = 0; i < error.parameters.length; i++) {
					params += error.parameters[i] + ' ';
				}
			}
			$log.warn('NotificationService: request failed. Status: ' + status + ' Error type: ' + error.errorType +
					' Params: [' + params + '] message: ' + error.message + ', url: ' + url);
		};

		this.showOptimisticLock = function(message, fn) {
			var msg;
			if (message) {
				msg = message;
			} else {
				msg = $translate.instant('error.optlock.message');
			}

			if (fn !== undefined && fn !== null) {
				$rootScope.optLockFn = fn;
			} else {
				$rootScope.optLockFn = function() {
					location.reload();
				};
			}

			msg +=
					'<br /><br />' +
					'<a type="button" class="btn btn-default btn-glyph" onclick="App.optLockFn()" style="color: black;">' +
					$translate.instant('error.optlock.reload') + ' <span class="glyphicon glyphicon-refresh"></span></a>';
			this.notify('WARN', null, msg);

		};
		this.clear = function() {
			toaster.clear();
		};
	});
})(angular);
;
(function(angular) {
	'use strict';
	/*
	 * Notification service
	 */
	var core = angular.module('Core');
	core.service('LoaderService', function($timeout) {
		var loaderShown = 0;
		var close = function() {
			if (loaderShown === 0) {
				var elt = $('#app-loader');
				if (elt) {
					//elt.hide();
					elt.removeClass('fade in');
					elt.addClass('fade out');
				}
			}
		};
		this.show = function() {
			if (loaderShown === 0) {
				setTimeout(function() {
					if (loaderShown > 0) {
						var elt = $('#app-loader');
						if (elt) {
							elt.removeClass('fade out');
							elt.addClass('fade in');
						}
					}
				}, 300);
			}
			loaderShown++;
		};
		this.hide = function() {
			loaderShown--;
			if (loaderShown < 0) {
				loaderShown = 0;
			}
			$timeout(function() {
				if (loaderShown === 0) {
					close();
					$timeout(function() {
						close();
					}, 2000);
				}
			}, 300);
		};
		close();
	});
})(angular);
;

(function(angular) {
	'use strict';
	/**
	 * navigation module
	 */
	var navigation = angular.module('Core');

	navigation.service('NavigationService', ['$log', '$rootScope', '$timeout', '$location', '$window',
		'NotificationService', 'LocalStorageService', '$translate', 'ModalService',
		function($log, $rootScope, $timeout, $location, $window, NotificationService, LocalStorageService, $translate, ModalService) {

			this.MAX_OPEN_TABS = 8;
			this.LOCAL_STORAGE_KEY = 'LS_MAIN_TABS';

			this.crtTabId = 0;
			this.tabs = [];
			this.activeTab = null;

			this.navEnabled = true;

			var service = this;
			var historicTab = [];
			var lastActivatedTab;

			var hiddenTab = null;

			/**
			 * Change the active status of all tab to "not active"
			 */
			var deactiveAllTabs = function() {
				var all = service.tabs;
				for (var i = 0; i < all.length; i++) {
					if (all[i].active === true) {
						lastActivatedTab = all[i];
					}
					all[i].active = false;
				}
			};

			/*
			 * Search a tab for a url
			 * @param {String} url Used to identify the tab
			 * @returns: the tab that match the url or null if the tab is not found
			 */
			var searchTab = function(url) {
				if (url.charAt(url.length - 1) === '/') {
					url = url.substring(0, url.length - 1);
				}
				var tabs = service.tabs;
				for (var i = 0; i < tabs.length; i++) {
					var tab = tabs[i];
					var urlB = tab.tabUrl;
					if (urlB.charAt(urlB.length - 1) === '/') {
						urlB = urlB.substring(0, urlB.length - 1);
					}
					if (urlB === url) {
						return tab;
					}
				}
				return null;
			};

			/*
			 * Search a tab for a url
			 * @param {String} url Used to identify the tab
			 * @returns: the tab that match the url or null if the tab is not found
			 */
			var searchTabByUrlContains = function(url) {
				var tabs = service.tabs;
				for (var i = 0; i < tabs.length; i++) {
					var tab = tabs[i];
					if (tab.tabUrl.indexOf(url) > -1) {
						return tab;
					}
				}
				return null;
			};

			/**
			 * Will look in the tabs to activate the right tab
			 */
			var updateActiveTab = function() {
				var currentUrl = $location.absUrl();
				if (currentUrl !== null) {
					var spl = currentUrl.split('#');
					if (spl.length > 1) {
						spl = spl[1].split('?');
						currentUrl = spl[0];
					} else {
						currentUrl = '/';
					}
				}

				deactiveAllTabs();
				var tab = searchTab(currentUrl);
				if (tab !== null) {
					historicTab.push(tab);
					tab.active = true;
					service.activeTab = tab;
					$log.debug('NavigationService: Tab with url [' + tab.tabUrl + '] is now active.');
				}
			};

			/*
			 * Search a tab by his id
			 * @param {int} id Used to identify the tab
			 * @returns: the tab that match the url or null if the tab is not found
			 */
			var searchTabById = function(id) {
				var tabs = service.tabs;
				for (var i = 0; i < tabs.length; i++) {
					var tab = tabs[i];
					if (tab.tabId === id) {
						return tab;
					}
				}
				return null;
			};

			/**
			 *
			 * @param {Tab} tabSrc the src
			 * @param {Tab} tabTarget the destination of the copy
			 * @returns {Tab} the destination tab
			 */
			var copyTabConfiguration = function(tabSrc, tabTarget) {
				if (tabSrc !== null && tabTarget !== null) {
					if (tabSrc.tabUrl) {
						tabTarget.tabUrl = tabSrc.tabUrl;
					}
					if (tabSrc.iconUrl) {
						tabTarget.iconUrl = tabSrc.iconUrl;
					}
					if (tabSrc.text) {
						tabTarget.text = tabSrc.text;
					}
					if (tabSrc.closeable) {
						tabTarget.closeable = tabSrc.closeable;
					}
					if (tabSrc.dirty !== undefined) {
						tabTarget.dirty = tabSrc.dirty;
					}
					if (tabSrc.loading !== undefined && tabSrc.loading !== null) {
						tabTarget.loading = tabSrc.loading;
					}

					if (tabSrc.configuration !== undefined && tabSrc.configuration !== null) {
						tabTarget.configuration = tabSrc.configuration;
					}

					if (tabSrc.transient !== undefined && tabSrc.transient !== null) {
						tabTarget.transient = tabSrc.transient;
					}

					if (tabSrc.initParams !== undefined && tabSrc.initParams !== null) {
						tabTarget.initParams = tabSrc.initParams;
					}

					if (tabSrc.hidden !== undefined) {
						tabTarget.hidden = tabSrc.hidden;
					}
				}
				return tabTarget;
			};

			var getActiveTab = function() {
				for (var i = 0; i < service.tabs.length; i++) {
					var tab = service.tabs[i];
					if (tab.active) {
						return tab;
					}
				}
				return null;
			};

			var checkNavEnabled = function() {
				if (!service.navEnabled) {
					var title = $translate.instant('navigation.navDisabledTitle');
					var msg = $translate.instant('navigation.navDisabled');
					NotificationService.notify('INFO', title, msg);
					return false;
				}
				return true;
			};

			$rootScope.$on('$locationChangeStart', function(event, newUrl, oldUrl) {
				if (service.navEnabled) {
					updateActiveTab();
					$rootScope.$broadcast('navigation-update');
				} else {
					event.preventDefault();
					if (!checkNavEnabled()) {
						$log.info('NavigationService: Could not change route location. Navigation is disabled.');
					}
				}
				return;
			});

			/* Update the localstorage with the tabs */
			var updateStorage = function() {
				var storageTabs = [];
				for (var i = 0; i < service.tabs.length; i++) {
					var t = service.tabs[i];
					if (!(t.transient === true)) {
						storageTabs.push(t);
					}
				}
				LocalStorageService.setValue(service.LOCAL_STORAGE_KEY, storageTabs);
			};

			var loadStorage = function() {
				if (LocalStorageService.isValueSet(service.LOCAL_STORAGE_KEY)) {
					$log.debug('NavigationService: Loading tabs from the local storage...');

					var lsTabs = LocalStorageService.getValue(service.LOCAL_STORAGE_KEY);
					var newTabs = [];
					for (var i = 0; i < lsTabs.length && i < service.MAX_OPEN_TABS; i++) {
						var tab = {};
						service.crtTabId++;
						tab.tabId = service.crtTabId;
						copyTabConfiguration(lsTabs[i], tab);
						tab.hidden = false;
						tab.dirty = false;
						newTabs.push(tab);
						$log.debug('NavigationService: Tabs with url "' + tab.tabUrl + '" loaded from local storage.');
					}


					// we look if we have to close the current tab
					var activeTab = getActiveTab();
					if (activeTab !== null) {

						if (activeTab.transient === true) {
							newTabs.push(activeTab);
							$log.debug('NavigationService: Current active tab is transient. We don\'t change the location.');
						} else {
							var url = activeTab.tabUrl;
							var found = false;
							for (var j = 0; j < newTabs.length; j++) {
								if (newTabs[j].tabUrl === url) {
									found = true;
								}
							}
							if (!found) {
								// Change page...
								// but re-enable navigation before...
								service.enableNavigation();
								$location.path('/');
							}
						}
					}
					service.tabs = newTabs;



					updateActiveTab();

					$rootScope.$broadcast('navigation-update');

					$log.debug('NavigationService: Tabs loaded with success from local storage.');
				} else {
					$log.debug('NavigationService: No tabs found in local storage.');
				}
			};



			var changeLocation = function(url) {
				$timeout(function() {
					$location.path(url);
				});
			};

			var openLastTab = function() {
				while (historicTab.length > 0) {
					var tab = historicTab.pop();
					if (searchTabById(tab.tabId) !== null) {
						changeLocation(tab.tabUrl);
						return;
					}
				}
				$location.path('/');
			};

			var getTabPosition = function(tabId) {
				for (var i = 0; i < service.tabs.length; i++) {
					if (service.tabs[i].tabId === tabId) {
						return i;
					}
				}
				return null;
			};

			var removeHiddenTab = function() {
				if (hiddenTab !== null) {
					searchTabById(hiddenTab);
					var position = getTabPosition(hiddenTab.tabId);
					if (position !== null) {
						service.tabs.splice(position, 1);
						updateStorage();
					}
					hiddenTab = null;
				}
			};

			/**
			 * Open a new tab. If the url is already present in the tabs list, the tab is not opened !
			 * @param {Tab} tab:
			 * {
			 *	tabUrl: The url to use in the tab
			 *	text: The text inside the tab
			 *	iconUrl: A link to an icon (24x24px)
			 *	closeable: true to use a closeable tab
			 *	loading: true to display the ajax loader / false to hide
			 *	transient: true to create a transient tab. When true, the tab is not stored to local storage (default false)
			 *	initParams: Data to pass to the tab to open (default null)
			 * }
			 * @param {Options} options
			 * {
			 *	activateTab: use true to directly open the url defined in the tab
			 * }
			 * @returns the tab created or already present tab
			 */
			this.openTab = function(tab, options) {
				var openedTab = searchTab(tab.tabUrl);
				if (openedTab === null) {
					if (!checkNavEnabled()) {
						$log.info('NavigationService: Navigation is disabled. The tab will not be opened !');
					} else {
						$log.debug('NavigationService: Opening tab with url [' + tab.tabUrl + ']...');
						openedTab = tab;
						this.crtTabId++;
						tab.tabId = this.crtTabId;
						this.tabs.push(tab);
						removeHiddenTab();
						if (this.openTabsSize() > this.MAX_OPEN_TABS) {
							var title = $translate.instant('navigation.tabsLimitTitle');
							var msg = $translate.instant('navigation.tabsLimit');
							NotificationService.notify('INFO', title, msg);
							$log.info('NavigationService: Number of opened tabs limit reached. The tab will not be opened !');
							service.activeTab = null;
							hiddenTab = tab;
							tab.hidden = true;
						}

						updateActiveTab();
						updateStorage();
						$rootScope.$broadcast('navigation-update');
						$log.debug('NavigationService: Tab with url [' + tab.tabUrl + '] opened.');


					}
				} else {
					// Let's update the tab...
					updateActiveTab();
					this.updateTab(openedTab.tabId, tab);
				}

				if (options && options.activateTab && openedTab) {
					$log.debug('NavigationService: Moving location to [' + openedTab.tabUrl + '].');
					changeLocation(openedTab.tabUrl);
				}

				return openedTab;
			};

			/**
			 * get the number of open tabs
			 * @returns {int} number of open tabs
			 */
			this.openTabsSize = function() {
				return this.tabs.length;
			};

			/**
			 * Activate a new tab from the list
			 * @param {int} tabId
			 */
			this.activateTab = function(tabId) {
				if (!checkNavEnabled()) {
					$log.info('NavigationService: Could not activate tab with id ' + tabId + '. Navigation is disabled.');
					return;
				}
				var tab = searchTabById(tabId);
				if (tab !== null) {
					changeLocation(tab.tabUrl);
				} else {
					$log.error('NavigationService: Could not activate tab with id ' + tabId + '. The tab doesn\'t exist.');
				}
			};

			/**
			 * Close a tab by his id
			 * @param {int} tabId the tab id (optional: when null the current tab is closed)
			 */
			this.closeTab = function(tabId, move) {
				var mustMove = true;
				if (move === false) {
					mustMove = false;
				}
				var tid = tabId;
				if ((tid === undefined || tid === null) && service.activeTab) {
					tid = service.activeTab.tabId;
				}
				var found = false;
				for (var i = 0; i < this.tabs.length; i++) {
					if (this.tabs[i].tabId === tid) {
						var tab = this.tabs[i];
						var confirmFn = function() {
							service.tabs.splice(i, 1);
							$log.debug('NavigationService: Tab with id [' + tab.tabId + '] has been closed.');
							$rootScope.$broadcast('navigation-update');
							updateStorage();

							if (tab.active) {
								service.enableNavigation();

								if (mustMove === true) {
									// let's move to /
									$timeout(function() {
										$log.debug('NavigationService: Tab with id [' + tab.tabId + '] was active. Moving user to /.');
										openLastTab();

									});
								}
							} else if (hiddenTab !== null && service.openTabsSize() <= service.MAX_OPEN_TABS) {
								hiddenTab.hidden = false;
								hiddenTab = null;
							}
						};

						if (tab.closeable === true) {
							if (!tab.dirty) {
								confirmFn();
							} else {
								// User must confirm !
								ModalService.confirmationModal({
									modalTitle: $translate.instant('navigation.fermerTabTitre'),
									modalText: $translate.instant('navigation.fermerTabMessage')
								}, confirmFn);
							}
						} else {
							$log.warn('NavigationService: Tab with id [' + tab.tabId + '] is not closeable ! The tab will not be closed.');
						}

						found = true;
						break;
					}
				}
				if (!found) {
					$log.error('NavigationService: Could not close tab with id ' + tabId + '. The tab was not found.');
				}
			};

			this.closeErrorTab = function() {
				var tid = service.activeTab.tabId;
				this.closeTab(tid, false);
			};

			/**
			 * get the currently opened tab
			 * @returns {Tab} the currently opened tab
			 */
			this.getActiveTab = function() {
				return getActiveTab();
			};

			/**
			 * Update an existing tab
			 * @param {type} tabId the tab identifiant
			 * @param {type} config the tab configuration
			 */
			this.updateTab = function(tabId, config) {
				// First we get the tab by his id...
				var crtTab = searchTabById(tabId);

				// If url is the same than another tab, we close the current tab
				var tabUrl = this.getTabByUrl(config.tabUrl);
				if (tabUrl && tabUrl.tabId !== tabId) {
					crtTab = tabUrl;
					this.closeTab(tabId, false);
				}

				if (crtTab !== null) {
					copyTabConfiguration(config, crtTab);
					updateStorage();
					$rootScope.$broadcast('navigation-update');
				} else {
					$log.error('NavigationService: Could not find tab with id ' + tabId + '.');
				}
			};

			/**
			 * Get a tab by url
			 * @param {String} url the url to search
			 * @returns {Tab} the tab found
			 */
			this.getTabByUrl = function(url) {
				return searchTab(url);
			};

			/**
			 * Get a tab by url contains
			 * @param {String} url the url to search
			 * @returns {Tab} the tab found
			 */
			this.getTabByUrlContains = function(url) {
				return searchTabByUrlContains(url);
			};

			/**
			 * Load a list of tabs
			 * @param {Tab[]} tabs
			 */
			this.loadTabs = function(tabs) {
				if (tabs !== null) {
					for (var i = 0; i < tabs.length; i++) {
						service.openTab(tabs[i]);
					}
				}
			};

			/**
			 * Get the full list of opened tabs
			 * @returns {Array} the tabs
			 */
			this.getTabs = function() {
				return service.tabs;
			};

			/**
			 * Look in each tab if at least one is dirty. In that case we return true.
			 * @returns {boolean} true if at least 1 tab is dirty
			 */
			this.isDirty = function() {
				for (var i = 0; i < this.tabs.length; i++) {
					var t = this.tabs[i];
					if (t.dirty) {
						return true;
					}
				}
				return false;
			};

			this.clearDirtyStates = function() {
				for (var i = 0; i < this.tabs.length; i++) {
					var t = this.tabs[i];
					t.dirty = false;
				}
			};

			this.tabData = {};


			var getTabUrlOrCrt = function(tabUrl) {
				var url = tabUrl;
				if (url === undefined || url === null) {
					url = $location.path();
				}
				return url;
			};

			/**
			 * Get the tab configuration from url
			 * (if tabUrl is undefined the function attempt to retrive the current tab configuration).
			 * @param {String|undefined} tabUrl The tab URL
			 * @returns {Object|null} the configuration
			 */
			this.getTabConfiguration = function(tabUrl) {
				var tab = searchTab(getTabUrlOrCrt(tabUrl));

				if (tab === null) {
					return null;
				}
				return tab.configuration;
			};

			/**
			 * Set the tab configuration for the passed url
			 * (if tabUrl is undefined the function set the passed configuration to the current tab).
			 * @param {Obejct} configuration The configuration to save for the selected tab
			 * @param {String|undefined} tabUrl
			 * @returns {void}
			 */
			this.setTabConfiguration = function(configuration, tabUrl) {
				var tab = searchTab(getTabUrlOrCrt(tabUrl));

				if (tab === null) {
					return;
				}
				tab.configuration = configuration;
				updateStorage();
			};

			/**
			 * Store data in the navigation for a desired tab
			 * @param {String} (option) tabUrl the url of the tab. If null the current location is used
			 * @param {Object} data data to save
			 */
			this.saveTabData = function(data, tabUrl) {
				var url = getTabUrlOrCrt(tabUrl);
				this.tabData[url] = data;
				$log.debug('NavigationService: Data stored for url ' + url);
			};

			/**
			 * Returns true if data are saved in this tab
			 * @param {String} (option) tabUrl the url of the tab. If null the current location is used
			 * @returns {boolean} true if data are saved in this tab
			 */
			this.hasTabData = function(tabUrl) {
				var url = getTabUrlOrCrt(tabUrl);
				return this.tabData[url] !== undefined && this.tabData[url] !== null;
			};

			/**
			 * Returns te data associated to the tab url
			 * @param {String} (option) tabUrl the url of the tab. If null the current location is used
			 * @returns {Object} the data stored in the tab
			 */
			this.getTabData = function(tabUrl) {
				var url = getTabUrlOrCrt(tabUrl);
				var data = null;
				if (this.hasTabData()) {
					data = this.tabData[url];
				}
				return data;
			};

			/**
			 * Clear the data sored in a tab
			 * @param {String} (option) tabUrl the url of the tab. If null the current location is used
			 */
			this.clearTabData = function(tabUrl) {
				var url = getTabUrlOrCrt(tabUrl);
				this.tabData[url] = null;
				$log.debug('NavigationService: Data cleared for url ' + url);
			};

			/**
			 * Disable the $route
			 */
			this.disableNavigation = function() {
				this.navEnabled = false;
				$rootScope.$broadcast('navigation-enabled', this.navEnabled);
				$log.debug('NavigationService: navigation disabled.');
			};
			/**
			 * Disable the $route
			 */
			this.enableNavigation = function() {
				this.navEnabled = true;
				$rootScope.$broadcast('navigation-enabled', this.navEnabled);
				$log.debug('NavigationService: navigation enabled.');
			};

			/**
			 * @returns {boolean} true when nav is enabled
			 */
			this.isNavigationEnabled = function() {
				return this.navEnabled;
			};


			this.init = function() {
				loadStorage();
				// add a tracker to the localstorage.
				LocalStorageService.registerValueTracker(this.LOCAL_STORAGE_KEY, function() {
					loadStorage();
				});
			};

			/**
			 * Hide the tabs
			 */
			this.hideNavigation = function() {
				$rootScope.$broadcast('navigation-hidden');
			};

			/**
			 * re enable nav and set the path
			 * @param {String} path the path to use (optional)
			 */
			this.forcePath = function(path) {
				this.enableNavigation();
				this.clearDirtyStates();
				if (path) {
					$timeout(function() {
						$location.path(path);
					});
				}
			};



			// Window close detection
			$window.onbeforeunload = function() {
				if (service.isDirty()) {
					return $translate.instant('navigation.fermerFenetre');
				}
			};
		}]);
})(angular);
;
(function(angular) {
	'use strict';
	/**
	 * navigation module
	 */
	var navigation = angular.module('Core');

	/*
	 * Used to enable / disable elements when navigation is enabled / disabled
	 * In fact add a class (nav-disabled) to the element when disabled.
	 */
	navigation.directive('navStateAware', ['$rootScope',
		function($rootScope) {
			return {
				scope: false,
				restrict: 'A',
				link: function(scope, element, attrs) {
					scope.navEnabled = true;
					$rootScope.$on('navigation-enabled', function(event, enabled) {
						scope.navEnabled = enabled;
						if (!enabled) {
							$(element).addClass('nav-disabled');
							$(element).attr('disabled', 'disabled');
						} else {
							$(element).removeClass('nav-disabled');
							$(element).removeAttr('disabled');
						}
					});
				}
			};
		}]);

	/*
	 * Used to enable / disable elements when navigation is enabled / disabled
	 * In fact add a class (nav-disabled) to the element when disabled.
	 */
	navigation.directive('navStateDisabled', ['$rootScope', '$log',
		function($rootScope, $log) {
			return {
				scope: false,
				restrict: 'A',
				link: function(scope, element, attrs) {
					scope.navEnabled = true;

					var links = $(element);
					links.click('click', function(e) {
						if (!scope.navEnabled) {
							e.preventDefault();
							$log.debug('navStateDisabled: Navigation is disabled. Link event prevented.');
						}
					});

					$rootScope.$on('navigation-enabled', function(event, enabled) {
						scope.navEnabled = enabled;
						if (!enabled) {
							$(element).addClass('nav-disabled');
							$(element).attr('disabled', 'disabled');
						} else {
							$(element).removeClass('nav-disabled');
							$(element).removeAttr('disabled');
						}
					});
				}
			};
		}]);

	/*
	 * Used to disable all links when present and the nav is disabled
	 */
	navigation.directive('mainTabs', ['$rootScope', '$location', '$timeout', '$log', 'NavigationService',
		function($rootScope, $location, $timeout, $log, NavigationService) {
			return {
				priority: 1000,
				scope: false,
				restrict: 'E',
				replace: true,
				transclude: true,
				templateUrl: 'components/core/navigation/navigation-tabs.html',
				controller: ['$scope', function($scope) {
						$scope.tabs = [];

						$scope.navEnabled = true;

						var hidden = false;


						/*
						 * Search a tab by his id
						 * @param {int} id Used to identify the tab
						 * @returns: the tab that match the url or null if the tab is not found
						 */
						var searchTabById = function(id) {
							var tabs = $scope.tabs;
							for (var i = 0; i < tabs.length; i++) {
								var tab = tabs[i];
								if (tab.tabId === id) {
									return tab;
								}
							}
							return null;
						};
						var loadTabs = function() {
							if (hidden === false) {
								$scope.tabs = NavigationService.getTabs();
							} else {
								$scope.tabs = [];
							}
						};
						/*
						 * Change the currently displayed tab
						 */
						var activateTab = function(tab) {
							if (NavigationService.isNavigationEnabled()) {
								$timeout(function() {
									$location.path(tab.tabUrl);
								}, 0);
							}
						};


						$scope.activate = function(tabId) {
							var tab = searchTabById(tabId);
							if (tab !== null) {
								activateTab(tab);
							}
						};

						$scope.close = function(tabId) {
							NavigationService.closeTab(tabId);
						};

						// EVENT HANDLING
						$rootScope.$on('navigation-update', function() {
							loadTabs();
						});
						$rootScope.$on('navigation-enabled', function(event, enabled) {
							$scope.navEnabled = enabled;
						});
						$rootScope.$on('navigation-hidden', function() {
							hidden = true;
							loadTabs();
						});



						loadTabs();
					}]
			};
		}]);
})(angular);;
/*
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */


(function(angular) {
	'use strict';

	angular.module('Core')
			.directive('stlNavBar', [function() {
					return {
						restrict: 'E',
						replace: true,
						transclude: true,
						templateUrl: 'components/core/navbar/navbar.html',
						scope: {
							notification: '&',
							control: '=?',
							ngModel: '=',
							items: '='
						},
						/**
						 * options :
						 * disableSorting : true // disable the table sorting
						 * defaultSortColumn : 'column key name' // the default sorted column
						 * defaultSortDesc : true to sort desc
						 */
						link: function(scope, element, attribute, controller) {
							scope.o = [];
							scope.navbarOpen = true;

							if (scope.ngModel.open !== undefined) {
								scope.navbarOpen = scope.ngModel.open;
							}


							scope.control = function(action, options) {
								if (action === 'setOpen') {
									scope.navbarOpen = options;
								}
							};

							scope.select = function(item) {
								scope.notification({
									action: 'itemSelected',
									options: item
								});
								scope.ngModel.item = item;
							};

							scope.toggleNavbar = function() {
								scope.navbarOpen = !scope.navbarOpen;
								scope.notification({
									action: 'opened',
									options: scope.navbarOpen
								});
							};
						},
						controller: ['$scope', function($scope) {

							}]
					};
				}]);
})(angular);
;
(function(angular) {
	'use strict';
	/**
	 * Modal service
	 */
	var core = angular.module('Core');

	core.service('ModalService', ['$modal', '$timeout', '$q', '$sce', '$translate',
		function ($modal, $timeout, $q, $sce, $translate) {

			this.nbShown = 0;
			this.zIndexStart = 9000000;

			var lockModalOpened = false;
			var lockedModalInstance = null;

			this.crtModalId = 1;
			var instance = this;

			var infoModalTemplate = '' +
					'<div class="modal-header" ng-if="modalTitle != null" stl-shortcut>' +
					'<h3>{{modalTitle | translate}}</h3>' +
					'</div>' +
					'<div id="{modal-id}" class="modal-body">' +
					'{{modalText | translate}}' +
					'<div ng-if="htmlTxt" ng-bind-html="htmlTxt"></div>' +
					'</div>' +
					'<div class="modal-footer">' +
					'<button class="btn {{validateBtnCls }}" ng-click="validate()">{{validateBtn | translate}}</button>' +
					'</div>';
			var inputModalTemplate = '' +
					'<div class="modal-header" ng-if="modalTitle != null">' +
					'<h3>{{modalTitle | translate}}</h3>' +
					'</div>' +
					'<div id="{modal-id}" class="modal-body">' +
					'{{modalText | translate}} : ' +
					'<input ng-model="input" type="text"/>' +
					'</div>' +
					'<div class="modal-footer">' +
					'<button class="btn {{cancelBtnCls}}" ng-click="cancel()">{{cancelBtn | translate}}</button>' +
					'<button class="btn {{validateBtnCls}}" ng-click="validate(input)">{{validateBtn | translate}}</button>' +
					'</div>';
			var textareaModalTemplate = '' +
					'<div class="modal-header" ng-if="modalTitle != null">' +
					'<h3>{{modalTitle | translate}}</h3>' +
					'</div>' +
					'<div id="{modal-id}" class="modal-body">' +
					'{{modalText | translate}} : <br />' +
					'<textarea style="width:100%" ng-model="input.txt"></textarea>' +
					'</div>' +
					'<div class="modal-footer">' +
					'<button class="btn {{validateBtnCls}}" ng-click="validate(input)">{{validateBtn | translate}}</button>' +
					'<button class="btn {{cancelBtnCls}}" ng-click="cancel()">{{cancelBtn | translate}}</button>' +
					'</div>';
			var selectModalTemplate = '' +
					'<div class="modal-header" ng-if="modalTitle != null">' +
					'<h3>{{modalTitle | translate}}</h3>' +
					'</div>' +
					'<div id="{modal-id}" class="modal-body">' +
					'{{modalText | translate}} : ' +
					'<ui-select ng-model="input" theme="bootstrap" ng-change="change($select.selected)" append-to-body="true" class="width-200">' +
					'<ui-select-match>' +
					'{{$select.selected.label}}' +
					'</ui-select-match>' +
					'<ui-select-choices repeat="d in $data | filter: {label: $select.search }">' +
					'<div ng-bind-html="d.label | highlight: $select.search"></div>' +
					'</ui-select-choices>' +
					'</ui-select>' +
					'</div>' +
					'<div class="modal-footer">' +
					'<button class="btn {{validateBtnCls}}" ng-disabled="!input" ng-click="validate(input)">{{validateBtn | translate}}</button>' +
					'<button class="btn {{cancelBtnCls}}" ng-click="cancel()">{{cancelBtn | translate}}</button>' +
					'</div>';

			var confirmationModalTemplate = '' +
					'<div class="modal-header" ng-if="modalTitle != null" stl-shortcut>' +
					'<h3>{{modalTitle | translate}}</h3>' +
					'</div>' +
					'<div id="{modal-id}" class="modal-body">' +
					'{{modalText | translate}}' +
					'<div ng-if="htmlTxt" ng-bind-html="htmlTxt"></div>' +
					'</div>' +
					'<div class="modal-footer">' +
					'<button class="btn {{validateBtnCls}}" ng-click="ok()">{{validateBtn | translate}}</button>' +
					'<button class="btn {{cancelBtnCls}}" ng-click="cancel()">{{cancelBtn | translate}}</button>' +
					'</div>';
			var lockModalTemplate = '' +
					'<div class="modal-header" ng-if="modalTitle != null">' +
					'<h3>{{modalTitle | translate}}</h3>' +
					'</div>' +
					'<div id="{modal-id}" class="modal-body lockModal">' +
					'{{modalText | translate}}' +
					'</div>';
			var downloadPopupTemplate = '' +
					'<div class="modal-header" ng-if="modalTitle != null">' +
					'<h3>{{modalTitle | translate}}</h3>' +
					'</div>' +
					'<div id="{modal-id}" class="modal-body">' +
					'{{modalText | translate}}' +
					'</div>' +
					'<div class="modal-footer">' +
					'<a href="{{link}}" download class="btn {{validateBtnCls}}" ng-click="close()" target="_blank">{{validateBtn | translate}}</a>' +
					'<button class="btn {{cancelBtnCls}}" ng-click="close()">{{cancelBtn | translate}}</button>' +
					'</div>';
			var imageShowTemplate = '' +
					'<div class="modal-header" ng-if="modalTitle != null">' +
					'<h3>{{modalTitle | translate}}</h3>' +
					'</div>' +
					'<div id="{modal-id}" class="modal-body" style="text-align:center">' +
					'<img ng-src={{src}} />' +
					'</div>' +
					'<div class="modal-footer">' +
					'<button class="btn {{cancelBtnCls}}" ng-click="close()">{{cancelBtn | translate}}</button>' +
					'</div>';
			var multiButtonsTemplate = '' +
					'<div class="modal-header" ng-if="modalTitle != null">' +
					'<h3>{{modalTitle | translate}}</h3>' +
					'</div>' +
					'<div id="{modal-id}" class="modal-body">' +
					'{{modalText | translate}}' +
					'</div>' +
					'<div class="modal-footer">' +
					'<button ng-repeat="btn in buttons" class="btn {{btn.btnClass}}" ng-click="btn.action(close)">{{btn.text | translate}}</button>' +
					'</div>';
			function globalInit($scope, options) {
				$scope.modalTitle = null;
				if (options['modalTitle'] !== undefined) {
					$scope.modalTitle = options['modalTitle'];
				}

				$scope.modalText = options['modalText'];

				if (!options['validateBtn']) {
					$translate('Continuer').then(function (translatedValue) {
						$scope.validateBtn = translatedValue;
					});
				} else {
					$scope.validateBtn = options['validateBtn'];
				}

				if (!options['cancelBtn']) {
					$translate('Annuler').then(function (translatedValue) {
						$scope.cancelBtn = translatedValue;
					});
				} else {
					$scope.cancelBtn = options['cancelBtn'];
				}

				if (!options['validateBtnCls']) {
					$scope.validateBtnCls = 'btn-primary';
				} else {
					$scope.validateBtnCls = options['validateBtnCls'];
				}

				if (!options['cancelBtnCls']) {
					$scope.cancelBtnCls = 'btn-default';
				} else {
					$scope.cancelBtnCls = options['cancelBtnCls'];
				}

				if (options['htmlText']) {
					$scope.htmlTxt = $sce.trustAsHtml(options['htmlText']);
				}
			}

			function setZIndex(zindex, id, time) {
				$timeout(function() {
					var modalBody = $('#modal-bts-' + id);
					var modal = modalBody.parent().parent().parent();
					modal.css('z-index', zindex + 1);
					modal.prev().css('z-index', zindex);
				}, time);
			}

			function resolveOpened(modalPromise) {
				var id = instance.crtModalId;
				var zindex = instance.zIndexStart + (instance.nbShown * 2 /* Z-Index form modal + back drop.. */);
				modalPromise.opened.then(function() {
					setZIndex(zindex, id, 0);
					setZIndex(zindex, id, 200);
				});
			}

			function resolvePromise(defered, modalPromise) {

				resolveOpened(modalPromise);

				modalPromise.result.then(function(data) {
					defered.resolve(data);
				},
						function() {
							defered.reject();
						});
			}

			function getTemplate(template) {
				return template.replace('{modal-id}', 'modal-bts-' + instance.crtModalId);
			}

			return {
				/*
				 options {
				   	validateBtn : "validate button text"
				   	cancelBtn : "cancel button text"
				  	validateBtnCls : btn-primary | btn-danger ...
				  	cancelBtnCls : btn-primary | btn-danger ...
				  	modalTitle : "the title if null header are hidden"
				 	modalText : "the title if null header are hidden"
					htmlText : "HTML txt"
				}
				 */
				confirmationModal: function(options, validateCallBack, cancelCallBack) {
					var defered = $q.defer();
					$timeout(function() {
						instance.crtModalId++;
						instance.nbShown++;
						resolvePromise(defered, $modal.open({
							template: getTemplate(confirmationModalTemplate),
							controller: ['$scope', '$modalInstance', function($scope, $modalInstance) {
									var canceled = false;
									globalInit($scope, options);

									$scope.ok = function() {
										$modalInstance.close();
										if (validateCallBack) {
											validateCallBack();
										}
									};

									$scope.cancel = function() {
										canceled = true;
										$modalInstance.dismiss('cancel');
										if (cancelCallBack) {
											cancelCallBack();
										}
									};

									$scope.keyPressed = function (e) {
										if (e.which === 13) {
											$scope.ok();
										}
									};

									$modalInstance.result.then(function() {
									}, function() {
										if (canceled === false && cancelCallBack) {
											cancelCallBack();
										}
									});
								}]
						}));
					}, 20);
					return defered.promise;
				},
				/* options {
				 validateBtn : "validate button text"
				 cancelBtn : "cancel button text"
				 validateBtnCls : btn-primary | btn-danger ...
				 cancelBtnCls : btn-primary | btn-danger ...
				 modalTitle : "the title if null header are hidden"
				 modalText : "the title if null header are hidden"
				 }
				 buttons: [button]
				 buttn: {
				 btnClass: css,
				 action: function,
				 text: string
				 }
				 *
				 */
				multiButtonsModal: function(options, buttons) {
					var defered = $q.defer();
					$timeout(function() {
						instance.crtModalId++;
						instance.nbShown++;
						resolvePromise(defered, $modal.open({
							template: getTemplate(multiButtonsTemplate),
							controller: ['$scope', '$modalInstance', function($scope, $modalInstance) {
									globalInit($scope, options);

									var managedButtons = [];
									var cancelFn = function() {
										$scope.cancel();
									};
									for (var i = 0; i < buttons.length; i++) {
										var fn = buttons[i].action;
										if (!fn) {
											buttons[i].action = cancelFn;
										}
										managedButtons.push(buttons[i]);
									}
									$scope.buttons = managedButtons;

									$scope.cancel = function() {
										$modalInstance.dismiss('cancel');
									};

									$scope.close = function() {
										$scope.cancel();
									};

									$modalInstance.result.then(function() {
									}, function() {
									});
								}]
						}));
					}, 20);
					return defered.promise;
				},

				inputModal: function(options, cancelCallBack, validateCallBack) {
					var defered = $q.defer();
					$timeout(function() {
						instance.crtModalId++;
						instance.nbShown++;
						resolvePromise(defered, $modal.open({
							template: getTemplate(inputModalTemplate),
							controller: ['$scope', '$modalInstance', function($scope, $modalInstance) {
									if (!options.cancelBtn) {
										$translate('Ok').then(function (translatedValue) {
											options.cancelBtn = translatedValue;
										});
									}
									globalInit($scope, options);
									if (options.defaultValue) {
										$scope.input = options.defaultValue;
									}
									$scope.cancel = function() {
										$modalInstance.dismiss('cancel');
										if (cancelCallBack) {
											cancelCallBack();
										}
									};
									$scope.validate = function(input) {
										$modalInstance.close(input);
										if (validateCallBack) {
											validateCallBack(input);
										}
									};
								}]
						}));
					}, 20);
					return defered.promise;
				},
				textareaModal: function(options, cancelCallBack, validateCallBack) {
					var defered = $q.defer();
					$timeout(function() {
						instance.crtModalId++;
						instance.nbShown++;
						resolvePromise(defered, $modal.open({
							template: getTemplate(textareaModalTemplate),
							controller: ['$scope', '$modalInstance', function($scope, $modalInstance) {
									if (!options.cancelBtn) {
										$translate('Ok').then(function (translatedValue) {
											options.cancelBtn = translatedValue;
										});
									}
									$scope.input = {};

									globalInit($scope, options);
									if (options.defaultTxt) {
										$scope.input.txt = options.defaultTxt;
									}
									$scope.cancel = function() {
										$modalInstance.dismiss('cancel');
										if (cancelCallBack) {
											cancelCallBack();
										}
									};
									$scope.validate = function(input) {
										$modalInstance.close(input.txt);
										if (validateCallBack) {
											validateCallBack(input.txt);
										}
									};
								}]
						}));
					}, 20);
					return defered.promise;
				},
				/* options :
				 * (facultatif) preSelectedObject : objet de la liste preselectionne
				 */
				selectModal: function(options, cancelCallBack, validateCallBack) {
					var defered = $q.defer();
					$timeout(function() {
						instance.crtModalId++;
						instance.nbShown++;
						resolvePromise(defered, $modal.open({
							template: function() {
								return getTemplate(selectModalTemplate);
							},
							controller: ['$scope', '$modalInstance', function($scope, $modalInstance) {
									$scope.$data = options.data;
									globalInit($scope, options);
									if (options.defaultValue) {
										$scope.input = options.defaultValue;
									}
									$scope.cancel = function() {
										$modalInstance.dismiss('cancel');
										if (cancelCallBack) {
											cancelCallBack();
										}
									};
									$scope.validate = function (input) {
										$modalInstance.close(input.id);
										if (validateCallBack) {
											validateCallBack(input);
										}
									};
									$scope.change = function (input) {
										$scope.input = input;
									};
								}]
						}));
					}, 20);
					return defered.promise;
				},
				infoModal: function(options, validateCallBack) {
					var defered = $q.defer();
					$timeout(function() {
						instance.crtModalId++;
						instance.nbShown++;
						resolvePromise(defered, $modal.open({
							template: getTemplate(infoModalTemplate),
							controller: ['$scope', '$modalInstance', function($scope, $modalInstance) {
									if (!options.cancelBtn) {
										$translate('Ok').then(function (translatedValue) {
											options.cancelBtn = translatedValue;
										});
									}
									globalInit($scope, options);

									$scope.validate = function() {
										$modalInstance.close();
										if (validateCallBack) {
											validateCallBack();
										}
									};

									$scope.keyPressed = function (e) {
										if (e.which === 13) {
											$scope.validate();
										}
									};
								}]
						}));
					}, 20);
					return defered.promise;
				},
				downloadPopup: function(options) {
					$timeout(function() {
						instance.crtModalId++;
						instance.nbShown++;
						resolveOpened($modal.open({
							template: getTemplate(downloadPopupTemplate),
							controller: ['$scope', '$modalInstance', function($scope, $modalInstance) {
									globalInit($scope, options);
									$scope.link = options['link'];
									$scope.close = function() {
										$modalInstance.dismiss('cancel');
									};
								}]
						}));
					}, 20);
				},
				imageShow: function(options) {
					$timeout(function() {
						instance.crtModalId++;
						instance.nbShown++;
						resolveOpened($modal.open({
							windowClass: 'imageShow',
							template: getTemplate(imageShowTemplate),
							controller: ['$scope', '$modalInstance', function($scope, $modalInstance) {
									globalInit($scope, options);
									$scope.src = options['src'];
									$scope.close = function() {
										$modalInstance.dismiss('cancel');
									};
								}]
						}));
					}, 20);
				},
				lockModal: function(options) {

					if (lockModalOpened) {
						return;
					}
					lockModalOpened = true;
					$timeout(function() {
						instance.crtModalId++;
						instance.nbShown++;
						lockedModalInstance = $modal.open({
							backdrop: 'static',
							keyboard: false,
							template: getTemplate(lockModalTemplate),
							controller: ['$scope', '$modalInstance', function($scope, $modalInstance) {
									globalInit($scope, options);

									$modalInstance.result.then(function() {
									}, function() {
										lockModalOpened = false;
										lockedModalInstance = null;
									});
								}]
						});
					}, 20);
				},
				unLockModal: function() {
					if (lockedModalInstance) {
						lockedModalInstance.dismiss('cancel');
					}
				},
				getNbShown: function() {
					return instance.nbShown;
				},
				incNbShown: function() {
					return ++instance.nbShown;
				},
				getZIndexStart: function() {
					return instance.zIndexStart;
				}
			};

		}]);



	/* Modal directives */
	core.directive('stlModal', ['$timeout', 'ModalService', function($timeout, ModalService) {
			var nbCreated = 0;
			var nbOpened = 0;

			var shown = [];

			return {
				restrict: 'E',
				scope: {
					modal: '=',
					visible: '=',
					closable: '@',
					onClose: '&'
				},
				replace: true,
				transclude: true,
				template:
						'<div ng-show="visible" id="{{id}}" class="stl-modal-container">' +
						'<div ng-if="visible && modal" class="stl-modal-back modal-backdrop in"></div>' +
						'<div class="stl-modal">' +
						'<div class="modal" role="dialog">' +
						'<div ng-if="visible" class="modal-content" ng-transclude></div>' +
						'</div>' +
						'</div>' +
						'</div>',
				link: function(scope, element) {
					nbCreated++;
					var id = 'stl-modal-' + nbCreated;
					var visible = false;

					var eventsAdded = false;

					var isCurrent = function() {
						if (shown[shown.length - 1] === id) {
							return true;
						}
						return false;
					};

					var setBackVisible = function(zIndex) {
						var elt = element.find('.stl-modal-back');
						elt.css('z-index', zIndex);
					};


					var eventName = 'keyup.' + id;
					var clickEventName = 'click.' + id;

					var removeEvents = function() {
						if (eventsAdded) {
							$(document).unbind(eventName);
							$(document).unbind(clickEventName);
							eventsAdded = false;
						}
					};

					var initEvents = function() {
						$timeout(function() {
							if (scope.isClosable() && scope.visible) {
								$(document).on(eventName, function(e) {
									var code = e.keyCode ? e.keyCode : e.which;
									if (isCurrent() && code === 27) {
										$timeout(function() {
											scope.visible = false;
										});
									}
								});

								$(document).on(clickEventName, function(e) {
									/*var sel = '#' + id + ' .modal';
									 if (isCurrent() && !$(e.target).closest(sel).length) {
									 if ($(sel).is(":visible")) {
									 $timeout(function() {
									 scope.visible = false;
									 });
									 }
									 }*/
								});

								eventsAdded = true;
							}
						}, 0);
					};


					var setVisible = function(newVal) {
						if (newVal !== undefined && newVal !== null) {
							var modal = element.find('.stl-modal').first();
							var modalBS = element.find('.modal').first();
							if (newVal === true) {
								// new shown...
								ModalService.incNbShown();
								var zIndex = ModalService.getZIndexStart() + (ModalService.getNbShown() * 2 /* Z-Index form modal + back drop.. */);
								modal.css('z-index', zIndex + 1);
								modalBS.css('z-index', zIndex + 1);

								setBackVisible(zIndex);

								nbOpened++;
								visible = true;

								if (!eventsAdded) {
									initEvents();
								}

								shown.push(id);

							} else if (visible === true) {
								nbOpened--;
								if (nbOpened === 0) {
									setBackVisible();
								}
								if (scope.onClose) {
									scope.onClose();
								}
								visible = false;

								removeEvents();
								shown.pop();
							}
						}
					};

					setVisible(scope.visible);

					scope.id = id;

					scope.$watch('visible', function(newVal, oldVal) {
						if (newVal !== oldVal) {
							setVisible(newVal);
						}
					});
					scope.$watch('modal', function(newVal, oldVal) {
						if (newVal !== oldVal) {
							applyBackVisible(newVal);
						}
					});


					var cleanUp = function() {
						$('#' + id).remove();
						removeEvents();
					};

					scope.$on('$destroy', function() {
						cleanUp();
					});
				},
				controller: ['$scope', function($scope) {

						$scope.isClosable = function() {
							var closable = true;
							if ($scope.closable === 'false') {
								closable = false;
							}
							return closable;
						};

						this.hide = function() {
							$scope.visible = false;
						};

						this.isClosable = function() {
							return $scope.isClosable();
						};

						this.isAutoResized = function() {
							if ($('#' + $scope.id).attr('class')) {
								return $('#' + $scope.id).attr('class').indexOf('stl-modal-dialog') < 0;
							}
							return false;
						};
					}]
			};
		}]);
	core.directive('stlModalHead', [function() {
			return {
				restrict: 'E',
				replace: true,
				transclude: true,
				require: '^stlModal',
				template:
						'<div class="modal-header">' +
						'<button ng-if="closable" type="button" ng-click="hide()" class="close">&times;</button>' +
						'<h4 class="modal-title" ng-transclude></h4>' +
						'</div>',
				link: function(scope, element, attr, stlModal) {
					scope.closable = stlModal.isClosable();

					scope.hide = function() {
						stlModal.hide();
					};
				}
			};
		}]);
	core.directive('stlModalBody', ['$window', function($window) {
			return {
				scope: false,
				require: '^stlModal',
				restrict: 'E',
				replace: true,
				transclude: true,
				template:
						'<div class="modal-body" ng-style="height" ng-transclude>' +
						'</div>',
				link: function(scope, element, attribute, stlModal) {

					var getInfos = function() {
						return {
							scroll: element.scrollTop(),
							height: element.height(),
							outerHeight: element.outerHeight(),
							innerHeight: element.innerHeight(),
							scrollHeiht: element[0].scrollHeight,
							top: element.offset().top,
							left: element.offset().left
						};
					};

					element.on('scroll', function(e) {
						scope.$broadcast('modal-body-scroll', getInfos());
					});

					$(window).on('resize', function(e) {
						scope.$broadcast('modal-body-resize', getInfos());
					});

					if (stlModal.isAutoResized()) {
						angular.element($window).bind('resize', function() {
							if (stlModal.isAutoResized()) {
								scope.$apply(function() {
									scope.height = {height: window.innerHeight * 0.8 - 120 + 'px'};
								});
							}
						});
						scope.height = {height: (window.innerHeight * 0.8 - 120) + 'px'};
					} else {
						if (attribute['minHeight']) {
							scope.height = {height: attribute['minHeight'] + 'px'};
						} else {
							scope.height = {height: 'auto'};
						}

					}
				}
			};
		}]);
	core.directive('stlModalFooter', [function() {
			return {
				require: '^stlModal',
				scope: {
					showCloseButton: '@?'
				},
				restrict: 'E',
				replace: true,
				transclude: true,
				template:
						'<div class="modal-footer">' +
						'<span ng-transclude></span>' +
						'<button ng-if="showCloseButton" type="button" class="btn btn-primary" ng-click="hide()"><i18n key="bouton.fermer"></i18n></button>' +
						'</div>',
				link: function(scope, element, attrs, stlModal) {
					scope.hide = function() {
						stlModal.hide();
					};

					if (scope.showCloseButton === 'false') {
						scope.showCloseButton = false;
					}
				}
			};
		}]);
})(angular);;
(function(angular) {
	'use strict';
	var core = angular.module('Core');

	/*
	 * Local storage service
	 */
	core.service('LocalStorageService', function($log, $window, $timeout, InfoService, Principal) {

		var VERSION_KEY = '__LS_VERSIONS';

		this.versions = {};
		this.trackers = {};

		// Event change listener is disable for performance reasons
		// In IE this may create many digests cycles
		var CHANGE_LISTENER_ENABLED = false;

		var instance = this;

		var prefix = null;
		var version = null;
		var login = null;

		var globalKeys = {};

		Principal.identity().then(function(account) {
			login = account !== null ? (account.email ? account.email : account.login) : '';
		});

		var getKey = function(key) {
			var k = key;
			if (!globalKeys[key]) {
				k = prefix + '_';
				if (version && '' !== version) {
					k += version + '_';
				} else {
					k += InfoService.getVersion() + '_';
				}
				k += login + '_';
				k += key;
			}
			return k;
		};

		var doSetValue = function(key, value, updtVersion) {
			var itemValue = null;
			if (localStorage !== null) {
				try {
					itemValue = JSON.stringify(value);
				} catch (e) {
					itemValue = value;
				}
				localStorage.setItem(getKey(key), itemValue);
				$log.debug('LocalStorageService: setValue() key: ' + key + '.');
				if (updtVersion) {
					updateVersion(key);
				}
			}
		};

		var updateVersion = function(key) {
			instance.versions[key] = new Date().getTime();
			doSetValue(VERSION_KEY, instance.versions, false);
			$log.debug('LocalStorageService: Version updated for ' + key);
		};

		var handleVersionChanges = function(changes, lsVersions) {
			for (var i = 0; i < changes.length; i++) {
				var key = changes[i];
				// let's update our version with the version from the local storage
				instance.versions[key] = lsVersions[key];

				var tracker = instance.trackers[key];
				if (tracker !== undefined && tracker !== null) {
					$log.debug('LocalStorageService: Tracker found for key: [' + key + '].');
					tracker();
				}
			}
		};

		var detectVersionChanges = function() {
			$log.debug('LocalStorageService: Detecting version modifications...');
			var keyChanges = [];
			var lsVersions = instance.getValue(VERSION_KEY);
			for (var key in lsVersions) {
				if (instance.versions[key] !== lsVersions[key]) {
					keyChanges.push(key);
				}
			}
			$log.debug('LocalStorageService: Following versions are not up to date: [' + keyChanges + '].');

			handleVersionChanges(keyChanges, lsVersions);
		};

		var initChangeListener = function() {
			if (CHANGE_LISTENER_ENABLED === true) {
				$window.addEventListener('storage', function() {
					$timeout(function() {
						detectVersionChanges();
					});
				});
			}
		};

		initChangeListener();

		this.setVersion = function(v) {
			version = v;
		};

		this.setLogin = function(l) {
			login = l;
		};

		this.setPrefix = function(p) {
			prefix = p;
		};

		/**
		 * True if the value is set
		 * @param {type} key the key to check
		 * @returns {Boolean} true when a value is set for the key
		 */
		this.isValueSet = function(key) {
			var v = this.getValue(key);
			return v !== null && v !== '';
		};

		/**
		 * Get the value attached to a key or null if not set
		 * @param {String} key the value to get
		 * @returns {Object} the value behind the key
		 */
		this.getValue = function(key) {
			var value = null;
			if (localStorage !== null) {
				var item = localStorage.getItem(getKey(key));

				$log.debug('LocalStorageService: getValue() key: ' + key + '.');

				if (item !== null) {
					try {
						value = JSON.parse(item);
					} catch (e) {
						value = item;
					}
				}
			}
			return value;
		};

		/**
		 * Set the value for a key
		 * @param {String} key the key to use
		 * @param {Object} value the value to save in the local storage
		 */
		this.setValue = function(key, value) {
			doSetValue(key, value, true);
		};



		/**
		 * Clear the value attached to the key
		 * @param {String} key the key to remove from the local storage
		 */
		this.clearValue = function(key) {
			this.setValue(key, null);
		};

		/**
		 * Register a tracker for a value. When the value is changed from the local storage, the tracker function is called.
		 * @param {String} key key to bind the tracker
		 * @param {type} fn the function called when data have changed
		 */
		this.registerValueTracker = function(key, fn) {
			this.trackers[key] = fn;
		};

		/**
		 * Add a global key (the key is not composed from version / user)
		 * @param {String} key the key that is now global
		 */
		this.addGlobalKey = function(key) {
			globalKeys[key] = true;
		};
	});
})(angular);;
(function(angular) {
	'use strict';
	var core = angular.module('Core');

	/*
	 * Local storage service
	 */
	core.service('LocalCache', ['$log', function($log) {
			var instance = this;

			instance.cache = {};

			/**
			 * Get the value attached to a key or null if not set
			 * @param {String} key the value to get
			 * @returns {Object} the value behind the key
			 */
			this.getValue = function(key) {
				var val = null;
				if (instance.cache[key]) {
					val = instance.cache[key];
				}
				return val;
			};

			/**
			 * True if the value is set
			 * @param {type} key the key to check
			 * @returns {Boolean} true when a value is set for the key
			 */
			this.isInCache = function(key) {
				var v = this.getValue(key);
				return v !== null && v !== '';
			};

			/**
			 * Set the value for a key
			 * @param {String} key the key to use
			 * @param {Object} value the value to save in the local storage
			 */
			this.setValue = function(key, value) {
				$log.info('LocalCache: Cache set for key ' + key);
				instance.cache[key] = value;
			};



			/**
			 * Clear the value attached to the key
			 * @param {String} key the key to remove from the local storage
			 */
			this.clearValue = function(key) {
				this.setValue(key, null);
			};
		}]);
})(angular);;
(function(angular) {
	'use strict';

	/**
	 * Define the HTTP Interceptor
	 */
	var core = angular.module('Core');
	core.factory('HttpInterceptor', function($q, $log, $window, $location, $timeout) {

		// Define http interceptor functions
		var notification = null;
		var loader = null;
		var navigation = null;
		var translate = null;

		var optLockFn = function() {
			navigation.forcePath();
			$timeout(function() {
				$window.location.reload();
			});
		};

		// Show ajax loader
		var showLoader = function() {
			if (loader) {
				loader.show();
			}
		};

		// Hide ajax loader
		var hideLoader = function() {
			if (loader) {
				loader.hide();
			}
		};

		// Handle error
		var error = function(response) {
			hideLoader();

			// Init...
			var status = response.status;
			if (response.data && response.data.httpStatus) {
				status = response.data.httpStatus;
			}


			var data = response.data;
			var message = data ? data.message : '';

			var url = '';
			if (response.config) {
				url = response.config.url;
			}
			if (url) {
				url = url.split('?');
			}

			// Let's see if the error is an ErrorDTO
			if (response.data && response.data.errorType) {
				// More error handling...
				switch (response.data.errorType) {
					case 'ERR_GEN_10': // data not found
					case 'ERR_GEN_30': // data not found
						// Re enable navigation
						navigation.forcePath('/' + status);
						break;
					case 'ERR_GEN_20':
						notification.setOptLockFunction(optLockFn);
						break;
				}
				notification.showApplicationErrorMessage(status, url, response.data);
			} else {
				// Handle by status code
				switch (status) {
					case 0:
						notification.notify('ERROR', translate.instant('error.ajax.status.' + status), null);
						break;
					case 400:
					case 412:
						// TODO VALIDATION ERROR !
						if (response.data.violations) {
							message += '<br /><ul>';
							for (var i = 0; i < response.data.violations.length; i++) {
								message += '<li>' + response.data.violations[i].message + '</li>';
							}
							message += '</ul>';
							notification.notify('ERROR', null, message);
						} else if (message) {
							notification.notify('ERROR', null, message);
						} else {
							var msg = translate.instant('error.ajax.status.' + status);
							notification.showAjaxErrorMessage(status, msg, url);
						}
						break;
					case 401:
						$log.warn('HttpInterceptor: User is unauthorized.');
						break;
					case 403:
					case 404:
						if (!message) {
							message = translate.instant('error.ajax.status.' + status);
						}
						notification.showAjaxErrorMessage(status, message, url);
						// Redirect
						$timeout(function() {
							$location.path('/' + status);
						}, 100);
						break;
					case 407: // Proxy login required
						notification.notify('ERROR', translate.instant('error.ajax.status.407'), null);
						$timeout(function() {
							// redirect to login page
							$window.location = '#/login';
						}, 2000);
						break;
					case 500:
						if (!message) {
							message = translate.instant('error.ajax.status.' + status);
						}
						notification.showAjaxErrorMessage(status, message, url);
						break;
					case 409:
						notification.showOptimisticLock(message);
						break;
					default :
						notification.showAjaxErrorMessage(status, message, url);
				}
			}
		};

		var success = function(response) {
			var _success = true;
			if (response.data && response.data.httpStatus >= 400) {
				// We are in an error case !
				error(response);
				_success = false;
			} else {
				hideLoader();
			}
			return _success;
		};
		return {
			request: function(config) {
				showLoader();
				return config || $q.when(config);
			},
			response: function(response) {
				var ok = success(response);
				if (ok !== false) {
					return response || $q.when(response);
				} else {
					return $q.reject(response);
				}
			},
			responseError: function(rejection) {
				error(rejection);
				return $q.reject(rejection);
			},
			init: function(NotificationService, LoaderService, NavigationService, TranslateService) {
				notification = NotificationService;
				loader = LoaderService;
				navigation = NavigationService;
				translate = TranslateService;
			}
		};
	});
})(angular);
;
(function(angular) {
	'use strict';
	/**
	 * Add directives to the audit module
	 */
	var core = angular.module('Core');
	/*
	 * Extended form
	 *
	 * commands: {
	 *	applyData: Data are saved internally in the form and the dirty flag is set to false,
	 *	setDirty: Set dirty the global form
	 * }
	 */
	core.directive('stlUpload', function ($timeout, $translate, LoaderService, NotificationService) {
		/**
		 * Gives auto submit with form without any input type = sumbit
		 */
		return {
			restrict: 'E',
			scope: {
				uploadAction: '=',
				buttonText: '=',
				uploadDisabled: '=',
				onSuccess: '&',
				fileTypes: '@',
				successMessageKey: '@',
				errorMessageKey: '@',
				fileNotAllowedMessageKey: '@',
				dropZone: '@',
				beforeUpload: '=?',
				parameters: '=?'
			},
			replace: true,
			templateUrl: 'components/core/form/upload/upload.html',
			transclude: true,
			link: function (scope, element, attrs) {
				var types = [];
				if (scope.fileTypes) {
					var ts = scope.fileTypes.split(',');
					for (var i = 0; i < ts.length; i++) {
						types.push(ts[i]);
					}
				}
				scope.options = {
					autoUpload: !scope.beforeUpload
				};
				var hasDropZone = false;
				if (scope.dropZone && scope.dropZone !== '') {
					scope.options.dropZone = $(scope.dropZone);
					hasDropZone = true;
				}

				var isAllowed = function (filename) {
					var allowed = false;
					var fn = filename.toUpperCase();
					if (types.length > 0) {
						for (var j = 0; j < types.length; j++) {
							var t = types[j].toUpperCase();
							allowed = fn.indexOf(t, fn.length - t.length) !== -1;
							if (allowed === true) {
								break;
							}
						}
					}
					return allowed;
				};

				$(element).bind('fileuploadadd', function(e, data) {

					var files = data.files;
					var err = false;
					var notificationFn = function() {
						NotificationService.notify('INFO', $translate.instant(scope.fileNotAllowedMessageKey));
					};

					for (var j = 0; j < files.length; j++) {
						var f = files[j];
						if (!isAllowed(f.name)) {
							err = true;
							e.preventDefault();
							$timeout(notificationFn);
						}
					}
					if (!err && scope.beforeUpload) {
						scope.beforeUpload(scope.parameters).then(function() {
							data.submit();
						});
					}

				});
				$(element).bind('fileuploadsubmit', function (e, data) {
					// Submitting... let's show the loader
					LoaderService.show();
				});
				$(element).bind('fileuploaddone', function (e, data) {
					// Submitting... let's show the loader
					LoaderService.hide();
					$timeout(function () {
						NotificationService.notify('SUCCESS', $translate.instant(scope.successMessageKey));
						if (scope.onSuccess) {
							scope.onSuccess();
						}
					});

				});
				$(element).bind('fileuploadfail', function (e, data) {
					$timeout(function () {
						// Submitting... let's show the loader
						LoaderService.hide();
						if (data.result && data.result.httpStatus) {

							NotificationService.showApplicationErrorMessage(
									data.result.httpStatus, scope.uploadAction, data.result);
						} else {
							NotificationService.notify('ERROR', $translate.instant(scope.errorMessageKey));
						}
					});
				});

				// Remove event handlers on destroy
				scope.$on('$destroy', function () {
					$(element).unbind('fileuploadsubmit');
					$(element).unbind('fileuploaddone');
					$(element).unbind('fileuploadfail');

					if (hasDropZone) {
						$(scope.dropZone).unbind('dragover');
					}
				});

				var dropzoneEnabled = false;
				if (hasDropZone && (GLOBALVARS.browser.type !== 'ie' || GLOBALVARS.browser.version > 9)) {
					dropzoneEnabled = true;
				}

				var timeoutDropZone = null;

				if (dropzoneEnabled) {
					$(document).bind('dragover', function(e) {
						if (scope.uploadDisabled === true) {
							return;
						}
						var dropZone = $(scope.dropZone);
						if (!timeoutDropZone) {
							dropZone.addClass('in');
							dropZone.css('display', 'block');
						} else {
							clearTimeout(timeoutDropZone);
						}
						var found = false, node = e.target;
						do {
							if (node === dropZone[0]) {
								found = true;
								break;
							}
							node = node.parentNode;
						} while (node !== null);
						if (found) {
							dropZone.addClass('hover');
						} else {
							dropZone.removeClass('hover');
						}

						timeoutDropZone = setTimeout(function() {
							timeoutDropZone = null;
							dropZone.removeClass('in hover');
							dropZone.css('display', 'none');
						}, 100);
					});
				}
			}
		};
	});

    core.directive('fileModel', ['$parse', function ($parse) {
        return {
            restrict: 'A',
            link: function(scope, element, attrs) {
                var model = $parse(attrs.fileModel);
                var modelSetter = model.assign;

                element.bind('change', function(){
                    scope.$apply(function(){
                        modelSetter(scope, element[0].files[0]);
                    });
                });
            }
        };
    }]);

})(angular);
;
/**
 * French translation for bootstrap-datepicker
 * Nico Mollet <nico.mollet@gmail.com>
 */
;(function($){
	$.fn.datepicker.dates['fr'] = {
		days: ["dimanche", "lundi", "mardi", "mercredi", "jeudi", "vendredi", "samedi"],
		daysShort: ["dim.", "lun.", "mar.", "mer.", "jeu.", "ven.", "sam."],
		daysMin: ["d", "l", "ma", "me", "j", "v", "s"],
		months: ["janvier", "février", "mars", "avril", "mai", "juin", "juillet", "août", "septembre", "octobre", "novembre", "décembre"],
		monthsShort: ["janv.", "févr.", "mars", "avril", "mai", "juin", "juil.", "août", "sept.", "oct.", "nov.", "déc."],
		today: "Aujourd'hui",
		monthsTitle: "Mois",
		clear: "Effacer",
		weekStart: 1,
		format: "dd/mm/yyyy"
	};
}(jQuery));
;
/**
 * French (Switzerland) translation for bootstrap-datepicker
 * Christoph Jossi <c.jossi@ascami.ch>
 * Based on 
 * French translation for bootstrap-datepicker
 * Nico Mollet <nico.mollet@gmail.com>
 */
;(function($){
	$.fn.datepicker.dates['fr'] = {
		days: ["Dimanche", "Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi"],
		daysShort: ["Dim", "Lun", "Mar", "Mer", "Jeu", "Ven", "Sam"],
		daysMin: ["D", "L", "Ma", "Me", "J", "V", "S"],
		months: ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"],
		monthsShort: ["Jan", "Fév", "Mar", "Avr", "Mai", "Jui", "Jul", "Aou", "Sep", "Oct", "Nov", "Déc"],
		today: "Aujourd'hui",
		monthsTitle: "Mois",
		clear: "Effacer",
		weekStart: 1,
		format: "dd.mm.yyyy"
	};
}(jQuery));
;
/**
 * German translation for bootstrap-datepicker
 * Sam Zurcher <sam@orelias.ch>
 */
;(function($){
	$.fn.datepicker.dates['de'] = {
		days: ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"],
		daysShort: ["Son", "Mon", "Die", "Mit", "Don", "Fre", "Sam"],
		daysMin: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
		months: ["Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"],
		monthsShort: ["Jan", "Feb", "Mär", "Apr", "Mai", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dez"],
		today: "Heute",
		monthsTitle: "Monate",
		clear: "Löschen",
		weekStart: 1,
		format: "dd.mm.yyyy"
	};
}(jQuery));
;
(function (angular) {
	'use strict';
	/**
	 * Add directives to the audit module
	 */
	var core = angular.module('Core');
	/*
	 * Extended form
	 *
	 * commands: {
	 *	applyData: Data are saved internally in the form and the dirty flag is set to false,
	 *	setDirty: Set dirty the global form
	 * }
	 */
	core.directive('stlFormGroup', ['$log', '$timeout', function ($log, $timeout) {
			/**
			 * Gives auto submit with form without any input type = sumbit
			 */
			return {
				restrict: 'E',
				scope: {
					editing: '=', // read / write
					editable: '=',
					formData: '=',
					save: '&',
					saveClose: '&',
					saveNew: '&',
					beforeCancel: '&',
					cancel: '&',
					close: '&',
					onDirty: '&',
					onStartEdit: '&',
					onEndEdit: '&',
					commands: '=?',
					commandsQueue: '=?'
				},
				replace: true,
				template:
						'<div class="stl-form-group" ng-class="{\'stl-form-group-editing\': editMode}" ng-transclude>' +
						'</div>',
				transclude: true,
				link: function (scope, element, attrs) {
					if (!attrs.editable) {
						scope.readOnly = false;
					} else {
						scope.$watch('editable', function (newVal) {
							scope.readOnly = !newVal;
						});
					}
					scope.handleSubmit = function () {
						if (scope.submit !== null && scope.submit !== '') {
							scope.submit();
						}
					};
				},
				controller: ['$scope', function ($scope) {

						var instance = this;
						var crtFormId = 0;
						var forms = [];
						var crtControlsId = 0;
						var controls = [];
						var formDataCopy = {};
						var focusableComponents = [];

						var registrationId = 0;

						var eventListeners = [];
						var sendEvents = function (event, data) {
							if (eventListeners.length) {
								for (var i = 0; i < eventListeners.length; i++) {
									var el = eventListeners[i];
									if (el.onFormEvent) {
										el.onFormEvent(event, data);
									}
								}
								$log.debug('stlFormGroup: events [' + event + '] sent.');
							}
						};

						this.addFormEventListener = function (listener) {
							eventListeners.push(listener);
							$log.debug('stlFormGroup: form event listener registered.');
						};

						var debug = function () {
							if ($scope.editMode) {
								$log.debug('stlFormGroup: Group is now in edition mode.');
							} else {
								$log.debug('stlFormGroup: Group is now in read only mode.');
							}
						};

						var saveFormData = function () {
							if ($scope.editMode) {
								// Make a copy of the data...
								formDataCopy = angular.copy($scope.formData);
								$log.debug('stlFormGroup: form data saved.');
							}
						};

						var update = function () {
							saveFormData();
							for (var i = 0; i < forms.length; i++) {
								forms[i].setEditMode($scope.editMode);
							}
							for (var j = 0; j < controls.length; j++) {
								controls[j].setEditMode($scope.editMode);
							}
							debug();
						};


						var updateFormControls = function () {
							for (var i = 0; i < controls.length; i++) {
								controls[i].setReadOnly($scope.readOnly);
							}
						};
						var setReadOnly = function (ro) {
							if (ro) {
								instance.setEditMode(false);
							}
							updateFormControls();
						};

						var setDirty = function (dirty) {
							for (var i = 0; i < forms.length; i++) {
								var form = forms[i];
								form.setDirty(dirty);
							}

							for (var j = 0; j < controls.length; j++) {
								var ctrl = controls[j];
								ctrl.setDirty(dirty);
							}

							$scope.dirty = dirty;
							if ($scope.onDirty !== undefined && $scope.onDirty !== null) {
								$scope.onDirty({dirty: dirty});
							}
						};

						/**
						 * Register a focusable component. Only 1 component could get the focus.
						 * @param {FC} fc contains an id and a function to call
						 */
						this.registerFocusableComponent = function (fc) {
							focusableComponents.push(fc);
						};
						/**
						 * Register a focusable component. Only 1 component could get the focus.
						 * @param {int} id the function to call to focus the element
						 */
						this.unregisterFocusableComponent = function (id) {
							for (var i = 0; i < focusableComponents.length; i++) {
								var fc = focusableComponents[i];
								if (fc.id === id) {
									// remove the focusable component...
									focusableComponents.splice(i, 1);
									break;
								}
							}
						};

						this.close = function () {
							if ($scope.close) {
								$scope.close();
							}
						};
						this.setEditMode = function (mode) {
							var diff = mode !== $scope.editMode;

							var edit = false;

							if (!diff) {
								return;
							}

							if (mode && $scope.onStartEdit) {
								$scope.onStartEdit();
								edit = true;
							}

							$scope.editMode = mode;
							update();

							if (!mode && $scope.onEndEdit) {
								$scope.onEndEdit();
							}

							if (edit && focusableComponents.length > 0) {
								focusableComponents[0].fn();
							}
						};

						this.getEditMode = function () {
							return $scope.editMode;
						};

						this.cancelEdition = function () {
							if ($scope.beforeCancel && $scope.beforeCancel()) {
								return; // Stop propagation enabled
							}

							sendEvents('beforeCancel');

							this.setEditMode(false);
							// restore the saved data...
							$scope.formData = formDataCopy;
							setDirty(false);
							$log.debug('stlFormGroup: form data restored.');
							if ($scope.cancel) {
								$scope.cancel({oldValue: formDataCopy});
							}

							sendEvents('afterCancel', {
								data: formDataCopy
							});
						};

						var callBeforeSave = function () {
							sendEvents('beforeSave');
						};
						var callAfterSave = function () {
							sendEvents('afterSave');
						};

						this.save = function () {
							callBeforeSave();
							var callbackFn = function () {
								instance.setEditMode(false);
								saveFormData();
								setDirty(false);
								callAfterSave();
							};
							if ($scope.save) {
								return $scope.save({fn: callbackFn});
							}
						};
						this.saveClose = function () {
							callBeforeSave();
							var callbackFn = function () {
								instance.setEditMode(false);
								saveFormData();
								setDirty(false);
								if (instance.close) {
									instance.close();
								}
								callAfterSave();
							};
							if ($scope.saveClose) {
								$scope.saveClose({fn: callbackFn});
							}
						};
						this.saveNew = function () {
							callBeforeSave();
							var callbackFn = function () {
								// Creation in edit mode = true...
								instance.setEditMode(true);
								saveFormData();
								setDirty(false);
								callAfterSave();
							};
							if ($scope.saveNew) {
								$scope.saveNew({fn: callbackFn});
							}
						};
						this.handleDirty = function () {
							var dirty = false;
							for (var i = 0; i < forms.length; i++) {
								var form = forms[i];
								if (form.dirty) {
									dirty = true;
									break;
								}
							}
							if (dirty !== $scope.dirty) {
								setDirty(dirty);
							}
						};

						$scope.valid = false;
						this.handleValid = function (form /* optional */) {

							var valid = true;

							if (form && forms.length > 1) { // Fast validate method. Used in register
								valid = $scope.valid && form.valid;
							} else {
								for (var i = 0; i < forms.length; i++) {
									var subform = forms[i];
									if (!subform.valid) {
										valid = false;
										break;
									}
								}
							}

							if ($scope.valid !== valid) {
								$scope.valid = valid;
								for (var j = 0; j < controls.length; j++) {
									controls[j].setValid($scope.valid);
								}
							}
						};

						this.registerForm = function (form) {
							crtFormId++;
							registrationId++;
							forms.push(form);
							form.setEditMode($scope.editMode);
							this.handleValid(form);

							form.registrationId = registrationId;

							$log.debug('stlFormGroup: form with registration id ' + registrationId + ' is registerd.');

							return registrationId;
						};
						this.unregisterForm = function (_registrationId) {
							for (var i = 0; i < forms.length; i++) {
								var form = forms[i];
								if (form.registrationId === _registrationId) {
									forms.splice(i, 1);
								}
							}
							this.handleValid();

							$log.debug('stlFormGroup: form with registration id ' + _registrationId + ' is UNregisterd.');
						};
						this.registerFormControls = function (control) {
							crtControlsId++;
							controls.push(control);
							control.setEditMode($scope.editMode);
							control.setReadOnly($scope.readOnly);
							control.setValid($scope.valid);
						};


						$scope.$watch('readOnly', function (newVal, oldVal) {
							if (newVal !== oldVal) {
								setReadOnly(newVal);
							}
						});
						$scope.$watch('editing', function (newVal, oldVal) {
							if (newVal !== undefined && newVal !== null && newVal !== oldVal) {
								$scope.editMode = $scope.editing;
								update();
							}
						});
						$scope.editMode = false;
						if ($scope.editing !== undefined && $scope.editing !== null) {
							$scope.editMode = $scope.editing;
							saveFormData();


							if ($scope.editMode && $scope.onStartEdit) {
								$scope.onStartEdit();
							}
						}

						// Dump all required variable from this form group
						var dumpState = function () {
							return {
								originalData: formDataCopy,
								userData: $scope.formData,
								dirty: $scope.dirty,
								edit: $scope.editMode
							};
						};
						// restore state previously dumped
						var restoreState = function (data) {
							formDataCopy = data.originalData;
							$scope.formData = data.userData;
							setDirty(data.dirty);
							instance.setEditMode(data.edit);
						};

						// add commands to this form
						var handleCommand = function (action, options) {
							var ret = null;
							$log.debug('stlFormGroup: handling action ' + action + '...');
							if (action === 'applyData') {
								saveFormData();
								setDirty(false);
							} else if (action === 'dump') {
								ret = dumpState();
							} else if (action === 'restore') {
								$log.error('stlFormGroup: action "restore" is disabled !');
								//restoreState(options.data);
							} else if (action === 'setDirty') {
								setDirty(options.dirty);
							} else if (action === 'save') {
								return instance.save();
							} else if (action === 'setEditMode') {
								instance.setEditMode(options);
							} else {
								$log.error('stlFormGroup: no action available for ' + action + ' option: [' + options + '].');
							}
							$log.debug('stlFormGroup: action ' + action + ' handled.');
							return ret;
						};

						$scope.$watch('commandsQueue', function (commands) {
							if (commands !== undefined && commands !== null) {

								// Let's handle commands
								for (var i = 0; i < commands.length; i++) {
									var c = commands[i];
									handleCommand(c.action, c.options);
								}

								$scope.commandsQueue = [];
							}
						}, true);

						$scope.commands = function (action, options) {
							return handleCommand(action, options);
						};

						this.sendCommand = function (action, options) {
							handleCommand(action, options);
						};

						debug();
					}]
			};
		}]);
	/**
	 * Extended form
	 */
	core.directive('stlForm', function (Language, $timeout, $log) {
		var formId = 0;
		/**
		 * Gives auto submit with form without any input type = sumbit
		 */
		return {
			require: ['^?stlFormGroup', 'stlForm'],
			restrict: 'E',
			scope: {
				submit: '&',
				title: '=',
				detached: '@',
				editable: '=?',
				stlFormShow: '=?',
				controller: '=?'
			},
			replace: true,
			template: function () {
				return '<form ng-show="m.shown" name="stlForm' + formId++ + '" ng-submit="handleSubmit()" class="app-form form-horizontal" no-validate>' +
						'	<input type="submit" style="visibility:hidden; position: absolute;top: 0px;"></input>' +
						'	<div class="panel panel-form" ng-transclude>' +
						'	</div>' +
						'</form>';
			},
			transclude: true,
			link: function (scope, element, attrs, ctrl) {
				var formGroup = null;
				if (ctrl[0]) {
					formGroup = ctrl[0];
				}
				scope.controller = ctrl[1];
				scope.editMode = false;
				scope.hasEditAttr = false;
				scope.m = {};
				if (attrs['editable'] !== undefined) {
					scope.editable = false;
				} else {
					scope.editable = true;
				}

				scope.registrationId = null;

				var form = attrs.name;
				scope.form = form;
				scope.formName = form;

				scope.handleSubmit = function () {
					if (scope.submit !== null && scope.submit !== '') {
						scope.submit();
					}
				};
				scope.dirty = false;
				scope.$watch(form + '.$dirty', function (newVal, oldVal) {
					if (newVal !== oldVal && newVal !== scope.dirty) {
						scope.dirty = newVal;
						if (formGroup) {
							formGroup.handleDirty();
						}
					}
				});
				scope.setDirty = function (dirty) {
					if (dirty) {
						scope[form].$setDirty();
					} else {
						scope[form].$setPristine();
					}
					scope.dirty = dirty;
				};

				var register = function () {
					if (formGroup && !scope.detached === true) {
						scope.registrationId = formGroup.registerForm(scope);
					}
				};

				// Watch form validity
				scope.valid = scope[form].$valid;
				scope.$watch(form + '.$valid', function (newVal, oldVal) {
					if (formGroup && newVal !== undefined && newVal !== null && newVal !== scope.valid) {
						scope.valid = newVal;
						formGroup.handleValid();
					}
				});

				scope.m.shown = false;
				if (!attrs['stlFormShow'] || scope.stlFormShow && scope.stlFormShow === true) {
					scope.m.shown = true;
					register();
				}

				scope.isFormGroupEditing = function () {
					var editing = false;
					if (formGroup) {
						editing = formGroup.getEditMode();
					}
					return editing;
				};

				var unregister = function () {
					if (formGroup) {
						formGroup.unregisterForm(scope.registrationId);
					}
				};
				scope.$on('$destroy', function () {
					unregister();
				});

				scope.$watch('stlFormShow', function (newVal) {
					if (newVal !== scope.m.shown) {
						if (newVal === true) {
							$timeout(function () {
								scope.m.shown = true;
								register();
								if (formGroup) {
									formGroup.handleValid();
								}
							});
						} else if (newVal === false) {
							$timeout(function () {
								scope.m.shown = false;
								unregister();
							});
						}
					}
				});
			},
			controller: ['$scope', function ($scope) {
					var rws = [];
					var crtRWId = 0;

					$scope.setEditMode = function (editMode) {
						var edit = editMode;
						if ($scope.editable !== undefined && $scope.editable !== null) {
							edit = edit && $scope.editable === true;
						}
						if (edit !== $scope.editMode) {
							$scope.editMode = edit;
							// Call children...
							for (var i = 0; i < rws.length; i++) {
								rws[i].setEditMode($scope.editMode);
							}
						}
					};

					// Re call setEditMode to apply the editable changes
					$scope.$watch('editable', function (newVal) {
						if (newVal !== undefined && newVal !== null) {
							$scope.setEditMode($scope.isFormGroupEditing());
						}
					});

					this.getForm = function () {
						return $scope[$scope.formName];
					};

					// Register a rw component
					this.register = function (rw) {
						crtRWId++;
						rws.push(rw);
						rw.setEditMode($scope.editMode);
					};

					/*
					 * @deprecated
					 */
					this.getFormObject = function () {
						return $scope[$scope.formName];
					};

					this.initSubScope = function (scope) {
						scope.locale = Language.current().toUpperCase();
						scope.form = $scope[$scope.formName];

						scope.isEmpty = function (input) {
							if (scope.form[input] === undefined) {
								return;
							}
							return scope.form[input].$isEmpty(scope.form[input].$modelValue);
						};
					};

					this.isEditing = function () {
						return $scope.editMode;
					};

					/**
					 * Used by form components to call the default action (submit)
					 */
					this.submit = function () {
						$scope.handleSubmit();
					};
				}]
		};
	});
	core.directive('stlFormHead', ['$timeout', function ($timeout) {
			return {
				restrict: 'E',
				scope: {
				},
				replace: true,
				template:
						'<div class="panel-heading" >{{editMode}}<span ng-transclude class="stl-form-head"></span></div>',
				transclude: true
			};
		}]);
	core.directive('stlFormContent', [function () {
			return {
				restrict: 'E',
				/*scope: {
				 },*/
				replace: true,
				template:
						'<div class="panel-body">' +
						'	<div ng-transclude></div>' +
						'</div>',
				transclude: true
			};
		}]);
	core.directive('stlFormControls', [function () {
			return {
				require: '^stlFormGroup',
				restrict: 'E',
				scope: {
					btnSaveAndNew: '=',
					hiddeBtns: '@?',
					valid: '=?'
				},
				replace: true,
				templateUrl: 'components/core/form/core-form-controls.html',
				transclude: true,
				link: function (scope, element, attrs, formGroup) {
					var btnsList = ['close', 'edit', 'cancel', 'save', 'saveClose'];

					var hiddeBtns = {};
					if (scope.hiddeBtns) {
						var hiddeBtnsList = scope.hiddeBtns.split(',');
						for (var i = 0; i < hiddeBtnsList.length; i++) {
							hiddeBtns[hiddeBtnsList[i]] = true;
						}
					}

					for (var j = 0; j < btnsList.length; j++) {
						if (!hiddeBtns[btnsList[j]]) {
							scope[btnsList[j] + 'Btn'] = true;
						}
					}

					scope.readOnly = true;
					scope.dirty = false;
					scope.edit = function () {
						formGroup.setEditMode(true);
					};
					scope.cancel = function () {
						formGroup.cancelEdition();
					};
					scope.save = function () {
						formGroup.save();
					};
					scope.saveClose = function () {
						formGroup.saveClose();
					};
					scope.saveNew = function () {
						formGroup.saveNew();
					};
					scope.setReadOnly = function (ro) {
						scope.readOnly = ro;
					};
					scope.setDirty = function (dirty) {
						scope.dirty = dirty;
					};
					scope.editMode = false;
					scope.setEditMode = function (editMode) {
						scope.editMode = editMode;
					};

					scope.valid = true;
					scope.setValid = function (valid) {
						scope.valid = valid;
					};


					scope.close = function () {
						formGroup.close();
					};

					formGroup.registerFormControls(scope);
				},
				controller: ['$scope', function ($scope) {
						this.crtId = 0;
						var instance = this;
						$scope.buttonsShown = 0;
						this.registerButton = function () {
							$scope.buttonsShown++;
							return instance.crtId++;
						};
						this.unRegisterButton = function (btnId) {
							$scope.buttonsShown = $scope.buttonsShown - 1;
						};
					}
				]
			};
		}]);
	core.directive('stlFormControlsBtn', ['$timeout', function ($timeout) {
			return {
				require: '^stlFormControls',
				restrict: 'A',
				scope: false,
				link: function (scope, element, attrs, controls) {
					var btnId = controls.registerButton();
					element.bind('$destroy', function () {
						$timeout(function () {
							controls.unRegisterButton(btnId);
						});
					});
				}
			};
		}]);

	core.directive('stlInputField', ['$translate', '$timeout', function ($translate, $timeout) {

			return {
				restrict: 'E',
				scope: {
					ngModel: '=',
					enum: '@',
					formatter: '&',
					labelTooltip: '=?'
				},
				replace: true,
				transclude: true,
				template: function (e, a) {

					var specificParameters = ['label-col', 'label-text', 'input-col', 'input-id', 'input-btns', 'inputsize', 'labelsize', 'labelkey', 'inputid', 'ngModel', 'enum'];
					var normalParameters = '';
					for (var key in a) {
						if (!(key.indexOf('$') === 0) && specificParameters.indexOf(key) === -1) {
							normalParameters += key + '="' + a[key.toString()] + '"';
						}
					}

					var labelCol = 0;
					if (e.attr('label-col')) {
						labelCol = e.attr('label-col');
					}

					var inputCol = 12 - labelCol;
					if (e.attr('input-col')) {
						inputCol = e.attr('input-col');
					}

					var labelText = '0';
					if (e.attr('label-text')) {
						labelText = e.attr('label-text');
					}

					var inputId = labelText;
					if (e.attr('input-col')) {
						inputCol = e.attr('input-col');
					}

					var type = 'text';
					if (e.attr('type')) {
						type = e.attr('type');
					}

					var btns = [];
					if (e.attr('input-btns')) {
						btns = angular.fromJson(e.attr('input-btns'));
					}

					var tpl = '';
					tpl += '<div class="form-group">';
					if (labelCol > 0) {
						tpl += '<label for="' + inputId + '" class="col-sm-' + labelCol + ' control-label" translate="' + labelText + '">' + labelText + '</label>';
					}
					tpl += '<div class="col-sm-' + inputCol + '">';

					if (type === 'text' && btns.length === 0) {
						tpl += '<input type="text" class="form-control input-sm" id="' + inputId + '">';
					} else if (type === 'text' && btns.length > 0) {
						tpl += '<div class="input-group">';
						tpl += '	<input type="text" class="form-control input-sm" id="' + inputId + '">';
						tpl += '	<span class="input-group-btn">';
						btns.forEach(function (item) {
							var primary = item.primary ? ' btn-primary' : '';
							tpl += '	<button class="btn' + primary + ' btn-xs btn-default input-sm" type="button" onclick="asdf()">';
							tpl += '		<span class="' + item.icon + '" aria-hidden="true">';
							tpl += '	</button>';
						});
						tpl += '	</span>';
						tpl += '</div>';


						/*
						 <input type="text" class="form-control input-sm" id="exampleInputName2" />
						 <span class="input-group-btn">

						 <span class="glyphicon glyphicon-remove" aria-hidden="true"></span>

						 <button class="btn btn-default btn-xs input-sm" type="button">
						 <span class="glyphicon glyphicon-ok" aria-hidden="true">
						 </button>
						 </span>
						 */
					} else {
						tpl += 'Unsupported field type: ' + type;
					}

					tpl += '	</div>';
					tpl += '</div>';

					return tpl;
				},
				link: function (scope, element, attrs, form) {

					if (scope.enum) {
						scope.enumValue = '\'' + element.attr('enum') + '.FR\' | translate';
						console.log(scope.enumValue);
					}

					scope.load = true;
					$timeout(function () {
						scope.load = false;
					}, 3000);
				}
			};
		}]);
	/*
	 core.directive('stlInputField', ['$translate', '$timeout', function ($translate, $timeout) {

	 return {
	 restrict: 'E',
	 scope: {
	 ngModel: '=',
	 enum: '@',
	 formatter: '&',
	 labelTooltip: '=?'
	 },
	 replace: true,
	 transclude: true,
	 template: function (e, a) {

	 var specificParameters = ['inputsize', 'labelsize', 'labelkey', 'inputid', 'ngModel', 'enum'];
	 var normalParameters = '';
	 for (var key in a) {
	 if (!(key.indexOf('$') === 0) && specificParameters.indexOf(key) === -1) {
	 normalParameters += key + '="' + a[key.toString()] + '"';
	 }
	 }

	 var inputSize = 1;
	 if (e.attr('inputSize')) {
	 inputSize = e.attr('inputSize');
	 }
	 var labelSize = 1;
	 if (e.attr('labelSize')) {
	 labelSize = e.attr('labelSize');
	 }
	 var label = '';
	 if (e.attr('labelKey')) {
	 label = e.attr('labelKey');
	 }
	 var inputId = '';
	 if (e.attr('inputId')) {
	 inputId = e.attr('inputId');
	 }

	 var templ = '<div><label for="' + inputId + '" class="col-md-' + labelSize + ' control-label" translate="' + label + '">TODO Label</label>'
	 + '<div class="col-md-' + inputSize + '">'
	 + '<input id="' + inputId + '"';
	 //if (enumeration !== '') {
	 templ += ' value=" {{ $scope.enumValue }}" ';
	 //	} else {
	 templ += ' ng-model="ngModel" ';
	 //	}
	 templ += ' class="form-control" ' + normalParameters + ' />'
	 + '</div></div>';
	 return templ;
	 },
	 link: function (scope, element, attrs, form) {

	 if (scope.enum) {
	 scope.enumValue = '\'' + element.attr('enum') + '.FR\' | translate';
	 console.log(scope.enumValue);
	 }

	 scope.load = true;
	 $timeout(function () {
	 scope.load = false;
	 }, 3000);
	 }
	 };
	 }]);

	 */


	/**
	 * Directive that provides a read / edit mode of the child directive.
	 * To fill the read only label, you have 2 possibilities
	 *	1) Use the directive stl-rw-emitter on the child component (input)
	 *	2) Use "text" directive to force a value to this field
	 *
	 * formatter attribute is a function available in the form scope that is used to format the ng-model value (optional)
	 *
	 */
	core.directive('stlReadWrite', ['$timeout', function ($timeout) {
			var getReadValue = function (value) {
				if (value !== undefined && value !== null && value !== NaN) {
					return value;
					//return $sce.trustAsHtml(value + ''); <- NEVER DO THIS
				} else {
					return '';
				}
			};
			return {
				require: '^?stlForm',
				restrict: 'E',
				scope: {
					text: '=',
					formatter: '&',
					labelTooltip: '=?'
				},
				replace: true,
				template: function (e, a) {
					var size = 7;
					if (a['size']) {
						size = a['size'];
					}
					var tooltip = '';
					if (a['labelTooltip']) {
						tooltip = 'stl-tooltip="labelTooltip"';
					}
					return '<div class="col-md-' + size + ' stl-read-write">' +
							'	<label class="stl-read-write-label" ng-if="!editMode"><span ng-bind-html="readValue"  ' + tooltip + '></span></label>' +
							'	<div class="stl-read-write-cmpnt" ng-if="!load" ng-show="editMode" ng-transclude></div>' +
							'</div>';
				},
				transclude: true,
				link: function (scope, element, attrs, form) {
					scope.load = true;
					$timeout(function () {
						scope.load = false;
					}, 3000);
					scope.$watch('editMode', function (newValue, oldValue) {
						if (scope.load && scope.editMode) {
							scope.load = false;
						}
					});

					scope.test = 'ttt';

					if (attrs['noBootstrap']) {
						$(element).removeClass('col-md-7');
					}

					scope.editMode = false;
					if (scope.text) {
						scope.readValue = getReadValue(scope.text);
					} else {
						scope.readValue = getReadValue('');
					}
					if (!attrs.formatter) {
						scope.formatter = null;
					}

					scope.setEditMode = function (editMode) {
						scope.editMode = editMode;
					};
					scope.$watch('text', function (newVal, oldVal) {
						if (newVal !== oldVal || scope.readValue !== newVal) {
							scope.readValue = getReadValue(newVal);
						}
					}, true);

					if (form) {
						form.register(scope);
					}
				},
				controller: ['$scope', function ($scope) {
						this.dataLabel = '';
						this.setDataLabel = function (value) {
							if ($scope.text === undefined) {
								if ($scope.formatter !== null) {
									this.dataLabel = $scope.formatter({value: value});
								} else {
									this.dataLabel = value;
								}
								$scope.readValue = getReadValue(this.dataLabel);
							}
						};
					}
				]
			};
		}]);
	/*
	 * Send event to the parent scope when the ng-model changes
	 * Need to be used to auto fill the data label from stl-read-write
	 */
	core.directive('stlRwEmitter', [function () {
			return {
				require: '^stlReadWrite',
				restrict: 'A',
				scope: {
					ngModel: '='
				},
				link: function (scope, element, attrs, stl) {
					scope.$watch('ngModel', function (newVal, oldVal) {
						if (newVal !== oldVal) {
							stl.setDataLabel(newVal);
						}
					});
				}
			};
		}]);
	core.directive('stlLabelInput', [function () {
			return {
				restrict: 'E',
				transclude: true,
				scope: {
					i18n: '@'
				},
				template:
						'<div class="form-group">' +
						'<label class="col-md-5 control-label stl-label"><i18n key="{{i18n}}"></label>' +
						'<div class="col-md-7 stl-read-write">' +
						'<div class="stl-read-write-cmpnt" ng-transclude></div>' +
						'</div>' +
						'</div>'
			};
		}]);
	/*
	 * STL Label
	 */
	core.directive('stlLabel', [function () {
			return {
				restrict: 'E',
				replace: true,
				template: function (e, a) {
					var size = 5;
					if (a['size']) {
						size = a['size'];
					}
					return '<label class="col-md-' + size + ' control-label stl-label" ng-transclude></label>';
				},
				transclude: true,
				link: function (scope, element, attrs, stl) {
					scope.$watch('ngModel', function (newVal, oldVal) {
						if (newVal !== oldVal) {
							stl.setDataLabel(newVal);
						}
					});
				}
			};
		}]);
	core.directive('stlFormLine', [function () {
			var REQUIRED_PREFIX = 'RE_';
			var WANTED_PREFIX = 'WA_';
			return {
				restrict: 'AE',
				compile: function (element, attributes) {

					var required = attributes['stlRequired'] !== undefined;
					var wanted = attributes['stlWanted'] !== undefined;
					var attributeName = attributes['stlFormLine'];
					var requiredAttribute = REQUIRED_PREFIX + attributeName;
					var wantedAttribute = WANTED_PREFIX + attributeName;

					var setLabel = function () {
						if (required) {
							$(this).append(
									'<span >' +
									' *' +
									'</span>');
						} else {
							$(this).append(
									'<span ' +
									'ng-if="' + requiredAttribute + ' !== undefined && ' +
									requiredAttribute + ' === true " >' +
									' *' +
									'</span>');
						}
					};

					$('label.control-label', element).each(setLabel);
					$('stl-label', element).each(setLabel);

					var inputUpdate = function (el, input) {
						if (input === undefined) {
							input = el;
						}
						var inputName = attributeName;
						if ($(input).attr('name') !== undefined) {
							inputName = $(el).attr('name');
						} else {
							$(input).attr('name', inputName);
						}
						//ng-class="{'input-error':form.nom.$error.required}"
						if (required) {
							$(el).attr('ng-class',
									'{' +
									'"input-error": ' +
									'form.' + inputName + '.$error.required ' +
									'}'
									);

							$(input).attr('ng-required', true);
						} else if (wanted) {
							$(el).attr('ng-class',
									'{' +
									'"input-wanted": ' +
									'isEmpty("' + inputName + '") ' +
									'}'
									);
						} else {
							$(el).attr('ng-class',
									'{' +
									'"input-error": ' +
									'form.' + inputName + '.$error.required && ' +
									requiredAttribute + ' !== undefined && ' +
									requiredAttribute + ' === true ' +
									',' +
									'"input-wanted": ' +
									'isEmpty("' + inputName + '") && ' +
									wantedAttribute + ' !== undefined && ' +
									wantedAttribute + ' === true ' +
									'}'
									);

							$(input).attr('ng-required', requiredAttribute);
						}

					};

					//stl - date - picker

					$(':input', element).each(function () {
						var el = this;
						if ($(this).attr('type') !== undefined && $(this).attr('type').toLowerCase() === 'radio') {
							el = $('stl-read-write', element);
						}
						inputUpdate(el, this);
					});

					$('stl-date-picker', element).each(function () {
						inputUpdate(this);
					});


				}
			};

		}]);

	core.directive('stlIsError', function () {
		return {
			restrict: 'A',
			link: function (scope, element, attribute, controller) {
				$(element).on('keyup', function () {
					if (scope.form[attribute['name']].$valid) {
						$(element).removeClass('input-error');
					} else {
						$(element).addClass('input-error');
					}
				});
			}
		};
	});
	core.directive('focusAware', ['$timeout', '$rootScope', function ($timeout, $rootScope) {
			var id = 0;
			return {
				restrict: 'A',
				scope: true,
				require: '^?stlFormGroup',
				link: function (scope, element, attrs, formGroup) {
					id++;
					scope.id = id;
					var focusMe = function () {
						$timeout(function () {
							var inputs = element.find(':input');
							if (inputs && inputs.length > 0) {
								for (var i = 0; i < inputs.length; i++) {
									var input = inputs[i];
									var ji = $(input);
									if (ji.is(':visible')) {
										ji.focus();
										break;
									}
								}
							} else {
								element.focus();
							}
						}, 50);
					};

					// VAR NAME
					var fcName = attrs['focusAware'];

					$rootScope.$on('send-focus', function (event, name) {
						if (fcName && fcName === name) {
							focusMe();
						}
					});

					// Register focus...
					if (formGroup) {
						var fc = {
							id: scope.id,
							fn: focusMe
						};
						formGroup.registerFocusableComponent(fc);
					}

					if (formGroup) {
						element.bind('$destroy', function () {
							$timeout(function () {
								formGroup.unregisterFocusableComponent(scope.id);
							});
						});
					}
				}
			};
		}]);

	core.directive('stlSelect', ['$log', function ($log) {
			return {
				restrict: 'A',
				require: 'select',
				link: function (scope, element, attrs, formGroup) {
					var watch = true;
					var observerMode = null;
					var observer = null;

					var destroyObservers = function () {
						$log.debug('stlSelect: Destroying observers [' + observerMode + ']...');
						if (observerMode === 'DOMEvent') {
							$(element).unbind('DOMSubtreeModified');
						} else if (observerMode === 'MutationObserver') {
							observer.disconnect();
						}
					};


					var redraw = function () {
						// Créé un nouvel élément qui sera inséré puis supprimé dans le select pour forcer son rendu
						var option = document.createElement('option');
						var control = $(element)[0];
						control.add(option, 0);
						try {
							control.remove(0);
						} catch (e) {
							$log.info('stlSelect: Bug in IE: ' + e);
						}
						watch = false;
					};

					var onChange = function (mutations) {
						if (watch === true) {
							setTimeout(redraw, 200);
						}
						watch = true;
					};


					var initObserver = function () {
						$log.debug('stlSelect: Initializing observers...');
						var MutationObserver = window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;

						if (MutationObserver) {
							observerMode = 'MutationObserver';
							observer = new MutationObserver(function (mutations) {
								onChange(mutations);
							});
							observer.observe($(element)[0], {
								attributes: true,
								childList: true,
								characterData: true,
								subtree: true
							});
						} else {
							observerMode = 'DOMEvent';
							$(element).bind('DOMSubtreeModified', function () {
								onChange();
							});
							$(element).bind('click', function () {
								watch = false;
							});
						}
						$log.debug('stlSelect: Observer: ' + observerMode);

						scope.$on('$destroy', function () {
							destroyObservers();
						});
					};

					// Only when IE...
					if (GLOBALVARS.browser.type === 'ie') {
						initObserver();
					}
				}
			};
		}]);

	core.directive('stlStaticControl', function (toaster, $translate) {
		return {
			restrict: 'E',
			scope: {
				value: '@value'
			},
			link: function (scope, element, attrs) {
				scope.onClipboardSuccess = function (e) {
					e.clearSelection();
					toaster.pop('note', '', $translate.instant('msg.CopieDansLePressePapier') + ': ' + e.text, 2000);
				};
			},
			template: function (element, attributes) {
				var labelWidth = 2;
				var fieldWidth = 12 - labelWidth;
				var label = '';
				var id = '';
				var idAttribute = '';
				var clip = '';

				if (angular.isDefined(attributes['labelWidth'])) {
					labelWidth = parseInt(attributes['labelWidth'], 10);
				}

				if (angular.isDefined(attributes['fieldWidth'])) {
					fieldWidth = parseInt(attributes['fieldWidth'], 10);
				}

				if (angular.isDefined(attributes['contentId'])) {
					id = attributes['contentId'];
					idAttribute = ' id="' + id + '"';
				}

				if (angular.isDefined(attributes['clipable'])) {
					clip = '<span ngclipboard data-clipboard-target="#' + id + '" ngclipboard-success="onClipboardSuccess(e);" class="iconbtn iconexp iconexp-copy" aria-label="Copied!"></span>';
				}

				if (angular.isDefined(attributes['translateKey'])) {
					var translateKey = attributes['translateKey'];
					label = '<label class="col-md-' + labelWidth + ' control-label" translate="' + translateKey + '">' + translateKey + '</label>';
				}

				return	'<div>' +
						label +
						'	<div class="col-md-' + fieldWidth + '">' +
						'		<p class="form-control-static"' + idAttribute + '>{{value}}' +
						clip +
						'		</p>' +
						'	</div>' +
						'</div>';
			}
		};
	});

})(angular);
;
(function(angular) {
	'use strict';
    var isNotNumber = function(value) {
        return value === undefined || value === null || value === '' || isNaN(parseFloat(value));
    };

	var core = angular.module('Core');

	core.directive('stlDatePicker', function($timeout, $log, Language) {
		return {
			restrict: 'E',
			require: ['ngModel', '?^stlForm'],
			replace: true,
			transclude: false,
			scope: {
				model: '=ngModel',
				startDate: '=startDate',
				endDate: '=endDate',
				required: '=required',
                dayMonthOnly: '=dayMonthOnly'
			},
			template: function (e, a) {
				var tmpl = '';
				var ro = '';

				if (a['readonly']) {
					ro = ' readonly="true"';
				}

				tmpl += '<span class="datepicker-core">';

				if (a['required']) {
					tmpl += '	<div class="date" ng-class="getNgClassRequired()">';
				} else {
					tmpl += '	<div class="date">';
				}

				tmpl += '		<div class="input-group input-group-sm">';
				tmpl += '			<input type="text" class="form-control input-sm datepicker-core-data" ng-class="getNgClassRequired()" '+ro+' />';
				tmpl += '			<input type="text" class="form-control input-sm datepicker-core-dp" readonly value="" ng-class="getNgClassRequired()" />';
				tmpl += '			<span class="input-group-btn">';
				tmpl += '				<button class="btn btn-default" type="button" ng-click="showDP()" tabindex="-1">';
				tmpl += '					<span class="glyphicon glyphicon-calendar" aria-hidden="true"></span>';
				tmpl += '				</button>';
				tmpl += '			</span>';
				tmpl += '		</div>';
				tmpl += '	</div>';
				tmpl += '</span>';

				return tmpl;
			},
			link: function (scope, element, attrs, reqs) {
				var dpFormat = 'dd.mm.yyyy'; // View format
				var viewFormat = 'DD.MM.YYYY'; // View format
                var viewFormatFull = 'DD.MM.YYYY'; // View format
				var viewFormatSmall = 'DD.MM.YY'; // View format (with only 2 years digit...)
				var modelFormat = 'YYYY-MM-DD'; // JSON model format
                var dayMonthFormat = 'DD.MM';

                var yearPreset = null;

                var setYearPreset = function(year) {
                    yearPreset = year;
                    viewFormat = dayMonthFormat;
                };

                if (scope.dayMonthOnly) {
                    setYearPreset(scope.dayMonthOnly);
                }

                scope.$watch('dayMonthOnly', function(newVal, oldVal) {
                    if (newVal !== oldVal) {
                        setYearPreset(newVal);
                    }
                });

				var inputHidden = element.find('input.datepicker-core-dp');
				var input = element.find('input.datepicker-core-data');

				var stlForm = reqs[1];
				var controller = reqs[0];

				scope.getNgClassRequired = function () {
					if (!scope.model) {
						return 'input-error : true';
					} else {
						return '';
					}
				};

				var setDpFieldVisible = function(visible) {
					if (visible) {
						inputHidden.css('display', 'block');
						input.css('display', 'none');
					} else {
						inputHidden.css('display', 'none');
						input.css('display', 'block');
					}
				};
				setDpFieldVisible(false);

				var dpTarget = inputHidden;
				var formatModelDate = function(date) {
					if (date === undefined) {
						return null;
					}
					var formatted = moment(date).format(modelFormat);
                    if (formatted === 'Invalid date') {
                        formatted = null;
                    }
					return formatted;
				};
				var parseModelDate = function(dateString) {
					var date = null;
					if (dateString !== undefined && dateString !== '') {
						date = moment(dateString, modelFormat).toDate();
					}
					if (date && isNaN(date.getTime())) {
						date = null;
					}
                    if (date === 'Invalid date') {
                        date = null;
                    }
					return date;
				};

				var formatDate = function(date) {
					if (date === undefined) {
						return null;
					}
                    var formatted = null;
                    if (yearPreset) {
                        formatted = moment(date).format(viewFormatFull);
                    } else {
                        formatted = moment(date).format(viewFormat);
                    }

                    if (formatted === 'Invalid date') {
                        formatted = null;
                    }

					return formatted;
				};

                var formatViewDate = function(date) {
                    if (date === undefined) {
                        return null;
                    }
                    var formatted = moment(date).format(viewFormat);
                    if (formatted === 'Invalid date') {
                        formatted = null;
                    }
                    return formatted;
                };

				var parseDate = function(dateString) {
					var date = null;
					if (dateString !== undefined && dateString !== '') {
                        if (yearPreset) {
                            date = moment(dateString + '.' + yearPreset, viewFormatFull).toDate();
                        } else {
                            date = moment(dateString, viewFormat).toDate();
                            if (date.getFullYear() < 1000) {
                                date = moment(dateString, viewFormatSmall).toDate();
                            }
                        }
					}

                    if (date === 'Invalid date') {
                        date = null;
                    }

					if (date !== undefined && date !== null && isNaN(date.getTime())) {
						date = null;
					}
					return date;
				};
				// Define locale to use
				var locale = Language.current();
				if (locale !== undefined) {
					locale = locale.toLowerCase();
				} else {
					locale = 'fr';
				}

				var createPicker = function() {
					var config = {
						format: dpFormat,
						autoclose: true,
						todayBtn: true,
						todayHighlight: true,
						orientation: 'auto',
						keyboardNavigation: true,
						language: locale
					};

					if (scope.startDate) {
						config.startDate = parseModelDate(scope.startDate);
					}
					if (scope.endDate) {
						config.endDate = parseModelDate(scope.endDate);
					}

					var dp = dpTarget.datepicker(config);
					dp.on('hide', function() {
						setDpFieldVisible(false);
					});
					dp.on('changeDate', function() {
						update();
					});
					return dp;
				};

				var picker = null;
				/*
				 *
				 * @returns {DatePicker} create or get the date picker
				 */
				var getPicker = function() {
					if (picker === null) {
						picker = createPicker();
					}
					return picker;
				};

				var pickerSet = function() {
					return picker !== null;
				};

				var updatePicker = function() {
					if (pickerSet()) {
						dpTarget.datepicker('update');
					}
				};

				var update = function() {
					getPicker();
					var dpDate = dpTarget.datepicker('getDate');
					if (dpDate) {
						$timeout(function() {
							var date = dpDate;
							var time = null;
							if (date !== null) {
								time = date.getTime();
							}

							if (time !== null && isNaN(time)) {
								time = null;
							} else {
								time = formatModelDate(time);
							}

							if (scope.model !== time) {
								scope.model = time;
								controller.$setViewValue(scope.model);
							}
						});
					} else {
						$timeout(function() {
							if (scope.model !== null) {
								scope.model = null;
								controller.$setViewValue(scope.model);
							}
						});
					}
				};

				var updateUserValue = function(withEnter) {
					$timeout(function() {
						var val = input.val();
						var date = null;
						var viewVal = '';
						var modelVal = null;
						if (val) {
							date = parseDate(val);
							viewVal = formatViewDate(date);
							modelVal = formatModelDate(date);
							// Update the datepicker
							if (pickerSet()) {
                                if (yearPreset) {
                                    dpTarget.val(formatDate(date));
                                } else {
                                    dpTarget.val(viewVal);
                                }
								dpTarget.datepicker('update');
							}
						}
						if (scope.model !== modelVal) {
							scope.model = modelVal;
							controller.$setViewValue(scope.model);
							input.val(viewVal);
						}

						if (withEnter === true && stlForm) {
							// let's call the default action
							stlForm.submit();
						}
					});
				};

				var cls = $(element).attr('class');
				input.attr('class', input.attr('class') + ' ' + cls);
				var fill = function(data) {
					if (data !== undefined && data !== null) {
						var date = parseModelDate(data);
						if (Object.prototype.toString.call(date) === '[object Date]' && !isNaN(date.getTime())) {
							input.val(formatViewDate(date));
							inputHidden.val(formatDate(date));
							updatePicker();
						}
						else {
							input.val(null);
							inputHidden.val(null);
							updatePicker();
						}
					} else {
						input.val(null);
						inputHidden.val(null);
						updatePicker();
					}
				};
				fill(scope.model);

				scope.$watch('model', function(dt) {
					fill(dt);
				});

				scope.$watch('startDate', function(newSD, oldSD) {
					if (newSD !== oldSD /*|| div.datepicker('getDate').getTime() < parseModelDate(newSD).getTime()*/) {
						if (scope.model !== undefined && newSD !== undefined && scope.model < newSD) {
							scope.model = null;
						}
						if (pickerSet()) {
							if (newSD) {
								dpTarget.datepicker('setStartDate', parseModelDate(newSD));
							} else {
								dpTarget.datepicker('setStartDate', null);
							}
						}
					}
				});
				scope.$watch('endDate', function(newSD, oldSD) {
					if (newSD !== oldSD) {
						if (scope.model !== undefined && newSD !== undefined && scope.model > newSD) {
							scope.model = null;
						}
						if (pickerSet()) {
							if (newSD) {
								dpTarget.datepicker('setEndDate', parseModelDate(newSD));
							} else {
								dpTarget.datepicker('setEndDate', null);
							}
						}
					}
				});
				scope.clearDP = function() {
					scope.model = null;
					controller.$setViewValue(null);

					getPicker();
					dpTarget.datepicker('update', new Date());
				};
				scope.showDP = function() {
					setDpFieldVisible(true);
					dpTarget.focus();

					getPicker();
					dpTarget.datepicker('show');
				};

				// Event binding
				input.bind({
					blur: updateUserValue
				});
				input.keypress(function(event) {
					if (event.which === 13) {
						event.preventDefault();
						updateUserValue(true);
					}
				});
			}
		};
	});
    core.directive('stlSmartFloat', ['$timeout', function($timeout) {
			/**
			 * Parameters:
			 * ng-model: binding
			 * min-value: minimal value
			 * max-value: maximal value
			 * precision: number after comma (optional, default 2)
			 */
			return {
				restrict: 'E',
				require: 'ngModel',
				scope: {
					model: '=ngModel',
					minValue: '=',
					maxValue: '=',
					precision: '=',
					change: '&ngChange'
				},
				replace: true,
				template: '<input type="text"></input>',
				link: function(scope, element, attrs, controller) {
					var precision = 2;
					scope.$watch('precision', function(p) {
						if (scope.precision !== null) {
							precision = scope.precision;
						} else {
							precision = 2;
						}
					});

					var formatValue = function(value) {
						if (value === null || value === '') {
							return '';
						} else {
							return accounting.formatNumber(value, {
								thousand: '\'',
								decimal: '.',
								precision: precision
							});
						}
					};

					var setValue = function(value) {
						$timeout(function() {
							var val = parseFloat(value);
							if (isNaN(val)) {
								val = null;
							}

							scope.model = val;

							controller.$setViewValue(val);
							controller.$setValidity('number', true);

							if (val !== null) {
								var viewValue = formatValue(val);
								$(element).val(formatValue(viewValue));
							} else {
								$(element).val(scope.model);
							}



							if (scope.change !== undefined) {
								scope.change();
							}
						});
					};
					var fix = function() {

						if ($(element).val() === null || $(element).val() === '') {
							return '';
						}

						var value = accounting.formatNumber($(element).val(), {
							thousand: '',
							decimal: '.',
							precision: precision
						});
						return value;
					};

					var showWarn = function(warn) {
						if (warn) {
							$(element).css('border-color', '#AD6D00');
							$(element).css('color', '#AD6D00');
						} else {
							$(element).css('border-color', 'inherited');
							$(element).css('color', 'inherited');
						}
					};

					var validate = function() {
						var vv = fix();
						var warnClass = false;
						if (scope.minValue !== null && scope.minValue !== '' && vv !== null && vv < scope.minValue) {
							vv = scope.minValue;
							warnClass = true;
						}
						if (scope.maxValue !== null && scope.maxValue !== '' && vv !== null && vv > scope.maxValue) {
							vv = scope.maxValue;
							warnClass = true;
						}

						showWarn(warnClass);
						setValue(vv);
					};
					scope.$watch('minValue', function(newValue, oldValue) {
						if (newValue !== oldValue) {
							validate();
						}
					});
					scope.$watch('maxValue', function(newValue, oldValue) {
						if (newValue !== oldValue) {
							validate();
						}
					});
					scope.$watch('model', function(newValue) {
						var viewValue = formatValue(newValue);
						$timeout(function() {
							$(element).val(viewValue);
						}, 100);
					});
					element.bind('focus', function() {
						$(element).val(scope.model);
					});
					element.bind('blur', function() {
						validate();
					});
					// Unbing ng-model on change
					element.unbind('input').unbind('keydown').unbind('change');
				}
			};
		}]);
	core.directive('stlSuggestBox', ['$timeout', '$q', function($timeout, $q) {
		return {
				require: 'ngModel',
				restrict: 'E',
				scope: {
					model: '=ngModel',
					editable: '@',
					asyncFunction: '&',
					itemFormatter: '&',
					required: '=?ngRequired'
				},
				template: '<span class="stlSuggestBox"><input type="text"' +
						'ng-required="required" ' +
						'ng-model="model"' +
						'typeahead="item.value as item.label for item in getItems($viewValue)"' +
						'typeahead-editable="editable"' +
						'typeahead-input-formatter="inputFormatter()"' +
						'typeahead-wait-ms="200"></span>',
				link: function(scope, element, attribute, ngModel) {
					scope.inputFormatter = function(item) {
						if (scope.itemFormatter) {
							return scope.itemFormatter({
								item: scope.model
							});
						}
						return item;
					};
					scope.getItems = function(val) {
						var deferred = $q.defer();
						scope.asyncFunction({
							viewValue: val
						}).then(function(data) {
							var items = [];
							for (var i = 0; i < data.data.length; i++) {
								var item = data.data[i];
								var label = item;
								if (scope.itemFormatter) {
									label = scope.itemFormatter({item: label});
								}
								items.push({
									label: label,
									value: item
								});
							}
							deferred.resolve(items);
						});

						return deferred.promise;
					};
				}
			};
		}]);



	/*
	 * multi-options: {
	 *		getKey: function(item) { return the key attached to this object }
	 *		getLabel: function(item) { return the text associated to this object}
	 *		idAsValue: boolean (true to use the id instead of the full object in the multi select)
	 *		tags : boolean (true to use tag adding)
	 * }
	 */
	core.directive('stlMultiSelect', function($timeout, $log) {
		return {
			require: ['ngModel', '^?stlForm'],
			restrict: 'E',
			scope: {
				model: '=ngModel',
				multiData: '=',
				multiOptions: '=?',
				onChange: '&?'
			},
			compile: function(elem, attributes) {
				var isMulti = '';
				if (attributes.multiple !== undefined) {
					isMulti = 'multiple';
				}

				elem.append('<div class="stl-multi-select"><input type="hidden" ' + isMulti + ' ></div>');


				var link = function(scope, element, attrs, controller) {
					scope.multiple = isMulti;

					var options = {};
					if (scope.multiOptions) {
						options = scope.multiOptions;
					}
					scope.$watch('multiOptions', function(newVal) {
						if (newVal) {
							options = newVal;
						}
					}, true);

					var input = $(element.find('input'));
					var select2 = null;
					var dataLoaded = false;
					var initialized = false;

					var loadedData = {};

					var getKey = function(item) {
						if (options.getKey) {
							return options.getKey(item);
						} else {
							return item.id;
						}
					};

					var getLabel = function(item) {
						if (options.getLabel) {
							return options.getLabel(item);
						} else if (item.text) {
							return item.text;
						} else {
							return getKey(item);
						}
					};

					var getNewModelFromTag = function(tag) {
						if (options.getNewModelFromTag) {
							return options.getNewModelFromTag(tag);
						} else {
							return {
								id: tag,
								text: tag
							};
						}
					};

					var updateModel = function(data) {
						// Here we get the ids...
						// Let's get the data attached to this id !
						var results = [];

						if (data && data.length > 0) {
							var res = [];
							for (var i = 0; i < data.length; i++) {
								var id = data[i];

								if (options.idAsValue === true) {
									res.push(id);
								} else {
									var loaded = loadedData[id];
									if (loaded && loaded.data) {
										res.push(loaded.data);
									} else if (scope.multiOptions && scope.multiOptions.tags) {
										res.push(getNewModelFromTag(id));
									} else {
										// data not found...
										$log.warn('stlMultiSelect: No data found for key ' + id);
									}
								}
							}
							if (res.length > 0) {
								results = res;
							} else if (!scope.model) {
								// Keep the same value than model...
								results = scope.model;
							} else {
								results = [];
							}
						}

						$timeout(function() {
							if (initialized && !angular.equals(scope.model, results)) {
								scope.model = results;
								if (controller[1].isEditing()) {
									controller[0].$setViewValue(results);
								}
							}
						});
					};

					var initSelection = function(elt, callback) {
						var val = $(elt).val();
						var ids = [];
						if (val) {
							ids = val.split(',');
						}

						var full = [];

						for (var i = 0; i < ids.length; i++) {
							var id = ids[i];
							// Let's get data...
							var text = '';
							var data = loadedData[id];
							if (!data || !data.text) {
								text = id;
							} else {
								text = data.text;
							}
							var d = {
								id: id,
								text: text
							};
							full.push(d);
						}

						callback(full);
					};

					var doGetSelection = function(data) {
						var ret = null;
						var val = data;
						if (val) {
							ret = val.split(',');
						}
						return ret;
					};

					var getSelection = function() {
						return doGetSelection(getSelect().val());
					};

					var createSelect = function() {
						var s2 = input.select2({
							allowClear: true,
							data: scope.multiData,
							multiple: scope.multiple,
							initSelection: initSelection,
							query: getData
						});
						s2.on('change', function() {
							updateModel(getSelection());
							if (scope.onChange) {
								scope.onChange();
							}
						});

						select2 = s2;

						return select2;
					};

					var getSelect = function() {
						if (select2 === null) {
							createSelect();
						}
						return select2;
					};

					var updateSelection = function(data) {
						if (!dataLoaded) {
							getData();
						} else {

							// Create a list of keys...
							var values = [];

							if (data) {
								for (var i = 0; i < data.length; i++) {
									var d = data[i];
									var key;
									if (options.idAsValue === true) {
										key = d;
									} else {
										key = getKey(d);
									}
									values.push(key);
								}
							}

							getSelect().val(values);

							if (dataLoaded) {
								getSelect().trigger('change');
							}
						}
					};

					var customIds = 0;
					var getData = function(query) {
						var matchs = [];
						var items = [];

						var fullMatch = false;
						if (scope.multiData) {
							for (var im = 0; im < scope.multiData.length; im++) {
								var d = scope.multiData[im];

								var result = {
									id: getKey(d),
									text: getLabel(d)
								};

								if (query && query.matcher) {
									if (query.matcher(query.term, result.text, {})) {
										if (result.text === query.term) {
											fullMatch = true;
										}
										matchs.push(result);
										items.push(d);
									}
								} else {
									matchs.push(result);
									items.push(d);
								}
							}
							if (query && query.term && query.term.length > 0 && scope.multiOptions && scope.multiOptions.tags && !fullMatch) {
								matchs.unshift({id: query.term, text: query.term});
							}
						}

						var data = {
							results: matchs
						};

						for (var i = 0; i < items.length; i++) {
							var item = items[i];
							var key = getKey(item);
							loadedData[key] = {};

							var text = getLabel(item);

							loadedData[key].text = text;
							loadedData[key].data = item;
						}

						if (query) {
							query.callback(data);
						}

						if (!dataLoaded) {
							dataLoaded = true;
							if (scope.model) {
								updateSelection(scope.model);
							}
						}
					};

					/*
					 * Update the loaded data and set the model data object...
					 */
					var updateLoadedData = function(model) {
						if (model) {
							for (var i = 0; i < model.length; i++) {
								var d = model[i];
								var key = getKey(d);
								if (!loadedData[key]) {
									loadedData[key] = {};
								}
									loadedData[key].text = getLabel(d);
									loadedData[key].data = d;

							}
						}
					};

					scope.$watchCollection('model', function(newVal, oldVal) {
						if (!angular.equals(newVal, oldVal)) {
							initialized = true;
							updateLoadedData(newVal);
							updateSelection(newVal);
						}
					});

					scope.$watchCollection('multiData', function(newVal, oldVal) {
						if (newVal && newVal.length > 0) {
							initialized = true;
							updateSelection(scope.model);

						}
					});

					if (scope.model) {
						updateSelection(scope.model);
					} else {
						createSelect();
					}
				};
				return link;
			}

		};
	});

	core.directive('select', function($parse) {
		return {
			restrict: 'E',
			compile: function(element, attributes) {
				element.append('<option value="">&nbsp;</option>');
				return function(scope, elt, attrs) {
					scope.$watch(attrs['ngModel'], function(data) {
						var model = $parse(attrs['ngModel']);  // Get the model
						if (data !== '' || typeof data === 'boolean') {
							if (typeof data === 'boolean') {
								model.assign(scope, data + '');  // Assigns a value to it
							}
						} else {
							model.assign(scope, null);  // Assigns a value to it
						}
						//scope.$apply();
					}, true);

				};
			}
		};
	});
	core.directive('regexValidator', ['StringUtil', function(StringUtil) {
		var regexMasks = {
			regexEmail: '[a-zA-Z0-9._%-]+@[a-zA-Z0-9-]+\\.[a-zA-Z]{2,4}',
			regexPhone: '([\\+][0-9]{11})?|([0][0-9]{9})?',
			regexFloat: '[0-9]+[.]?[0-9]*'
		};
		return {
			restrict: 'A',
			require: ['^stlForm', 'ngModel'],
			scope : {
				regexValidator: '@'
			},
			link: function(scope, element, attr, ctrl) {
				var mask;
				var stlForm = ctrl[0];
					var form;
					var regex = regexMasks[scope.regexValidator] ? regexMasks[scope.regexValidator] : scope.regexValidator;
				if (stlForm) {
					form = stlForm.getForm();
				}

					mask = new RegExp(regex, 'g');
				function customValidator(ngModelValue) {
					//console.log(mask.exec(ngModelValue));
						/*console.log(ngModelValue.match(mask));
					if (mask.test(ngModelValue)) {
						ctrl[1].$setValidity('uppercaseValidator', true);
					} else {
						ctrl[1].$setValidity('uppercaseValidator', false);
					}*/
						if (StringUtil.regexGlobalMatch(ngModelValue, regex)) {
							ctrl[1].$setValidity('uppercaseValidator', true);
						} else {
							ctrl[1].$setValidity('uppercaseValidator', false);
						}
					return ngModelValue;
				}

				ctrl[1].$parsers.push(customValidator);


			}
		};
		}]);
	core.directive('stlMask', function() {
		var regexMasks = {
			regexEmail: '[a-zA-Z0-9._%-]+@[a-zA-Z0-9-]+\\.[a-zA-Z]{2,4}',
			regexPhone: '([\\+][0-9]{11})?|([0][0-9]{9})?',
			regexFloat: '[0-9]+[.]?[0-9]*'
		};

		return {
			restrict: 'A',
			require: ['^stlForm', 'ngModel'],
			link: function(scope, element, attribute, tab) {
				var noError = attribute['stlMaskNoError'] !== undefined;

				var stlForm = tab[0];
				//var ngModel = tab[1];
				var mask = attribute['stlMask'];

				var editing = false;
				var originalValue = null;

				var form = null;
				if (stlForm) {
					form = stlForm.getForm();
				}

				var validElement = function() {
					var value = $(element).val();
					if (editing === false) {
						return;
					}

					scope.$apply(function() {
						tab[1].$setViewValue(value);
					});

					if ($(element).inputmask('isComplete') || value === undefined || value === '') {
						$(element).removeClass('input-error');
						scope.$apply(function() {
							if (form) {
								form.$setValidity('mask', true);
							}
						});
					} else if (!noError) {
						$(element).addClass('input-error');
						scope.$apply(function() {
							if (form) {
								form.$setValidity('mask', false);
							}
						});
					}
				};

				var options = {
					onKeyValidation: function() {
						validElement();
					},
					onKeyUp: validElement
				};

				if (regexMasks[mask] !== undefined) {
					options['regex'] = regexMasks[mask];
					mask = 'Regex';
				} else if (attribute['customRegex']) {
					options['regex'] = attribute['customRegex'];
					mask = 'Regex';
				}

				$(element).inputmask(mask, options);// .on('keydown', validElement);
				//$(element).inputmask('Regex', {regex: "[a-zA-Z0-9._%-]+@[a-zA-Z0-9-]+\\.[a-zA-Z]{2,4}"});
				//$(element).inputmask('email');
				//$(element).inputmask('Regex', {regex: '[a-zA-Z0-9._%-]+@[a-zA-Z0-9-]+\\.[a-zA-Z]{2,4}'});
				//$(element).inputmask('Regex', {regex: '[\\+]?[0-9-]+'});


				$(element).bind('focus', function() {
					editing = true;
					originalValue = $(element).val();
				});
				$(element).bind('blur', function() {
					editing = false;
					originalValue = null;
				});
			}
		};
	});

	/*
	 * Apply a regex to the field and check
	 *
	 * Attributes:
	 *	stl-regex: Your regex to use
	 *	stl-regex-policy:
	 *		-warning: show a warning (default)
	 *		-validation: Change validation status
	 *	stl-regex-i18n-key: the message to show when the field is invalid
	 *	stl-regex-text: The message to show in the popup (override stl-regex-i18n-key)
	 */
	core.directive('stlRegex', function() {
		return {
			restrict: 'A',
			require: 'ngModel',
			scope: {
				model: '=ngModel'
			},
			link: function(scope, element, attribute, controller) {
				var input = $(element);

				var regex = attribute['stlRegex'];
				//var policy = 'validation';

				var getValue = function() {
					if (input && input.val) {
						return input.val();
					}
					return null;
				};

				var isValid = function() {
					var value = getValue();
					var vcheck = '';
					if (!value) {
						return true; // We allow blank...
					}

					vcheck = value;

					var rex = new RegExp('^' + regex + '$', 'gi');
					var res = rex.test(vcheck);
					return res;
				};

				var validate = function() {
					var valid = isValid();
					if (valid) {
						$(element).removeClass('input-warn');
					} else {
						$(element).addClass('input-warn');
					}
				};

				input.bind({
					blur: validate
				});

				scope.$watch('model', function() {
					validate();
				});
			}
		};
	});

	/**
	 * This select is auto disabled when the list is empty or when only 1 entry is present
	 * When only 1 entry is present, this entry is auto selected
	 */
	core.directive('stlCriteriaSelect', ['$timeout', function($timeout) {
			return {
				require: 'ngModel',
				restrict: 'E',
				scope: {
					model: '=ngModel',
					options: '@',
					listData: '=',
					listChange: '&',
					listAutoSelect: '&',
					noEmpty: '@',
					emptyName: '=?'
				},
				template:
						'<select stl-select ng-model="model" ng-options="{{options}}" ng-change="handleChange()" ng-disabled="disabled">' +
						'<option ng-style="displayEmpty" value="">{{emptyName}}</option>' +
						'</select>',
				link: function(scope) {
					scope.displayEmpty = '';
					if (!scope.emptyName) {
						scope.emptyName = '';
					}


					if (scope.noEmpty && scope.noEmpty === 'true') {
						scope.displayEmpty = {display: 'none'};
					}
					var autoSelect = function() {
						var list = [];
						if (scope.listData) {
							list = scope.listData;
						}

						scope.disabled = list.length <= 1;

						if (list.length === 1 && scope.model !== list[0]) {
							// auto select...
							scope.model = list[0];
							scope.handleChange();
						}
					};

					scope.handleChange = function() {
						if (scope.listChange) {
							$timeout(function() {
								scope.listChange();
							}, 20);
						}
					};

					scope.$watchCollection('listData', function() {
						autoSelect();
						scope.$data = scope.listData;
					});

					autoSelect();
				}
			};
		}]);

    core.directive('stlCurrencyInput', function ($filter) {
        return {
            require: 'ngModel',
            restrict: 'A',
            link: function (scope, elm, attrs, ctrl) {

                var isFocused = false;
                var selectContent = true;

                var myBlurFunctionToCall = attrs.resetIfEmpty;

                var nbDecimals = attrs['stlCurrencyInput'];
                if (!nbDecimals) {
                    nbDecimals = 2;
                }

                var isDot = function(e) {
                    return e.which === 46;
                };

                var isNumber = function(e) {
                    return e.which >= 48 && e.which <= 57;
                };

                var arrondi5Centime = function(value) {
                    if (!value) {
                        return 0;
                    }
                    if (nbDecimals < 0) {
                        return value;
                    }
                    var n = parseFloat(value);
                    return Math.round(n * 20) / 20;
                };

                var isBlank = function(value) {
                    return (value === undefined || value === null || value === '');
                };

                var isNotBlank = function(value) {
                    return !isBlank(value);
                };

                var isFieldRequired = function() {
                    return angular.isDefined(attrs.required);
                };

                elm.bind('blur', function () {
                    isFocused = false;

                    if (ctrl.$viewValue) {
                        ctrl.$modelValue = arrondi5Centime(ctrl.$modelValue);
                        ctrl.$viewValue = $filter('currency')(ctrl.$modelValue, nbDecimals, 0);
                    } else if (myBlurFunctionToCall) {
                        scope.$eval(myBlurFunctionToCall);
                    }
                    ctrl.$render();
                });

                elm.bind('focus', function () {
                    isFocused = true;
                    if (!isFieldRequired() && isNaN(ctrl.$modelValue)) {
                        ctrl.$modelValue = 0;
                    }
                    if (isNotBlank(ctrl.$modelValue)) {
                        ctrl.$modelValue = arrondi5Centime(ctrl.$modelValue);
                    }

                    if (angular.isDefined(attrs.required) && isBlank(ctrl.$modelValue)) {
                        ctrl.$viewValue = '';
                    } else {
                        ctrl.$viewValue = '' + ctrl.$modelValue.toFixed(2);
                    }

                    ctrl.$render();
                    if (selectContent) {
                        this.select();
                    }
                    selectContent = true;
                });

                elm.bind('mousedown', function() {
                    selectContent = false;
                });

                elm.bind('keypress', function (e) {
                    var value = ctrl.$modelValue ? ctrl.$modelValue.toString() : '';
                    if (!(isDot(e) || isNumber(e))) {
                        e.preventDefault();
                        return;
                    }
                    if (isDot(e) && value && value.indexOf('.') > -1) {
                        e.preventDefault();
                        return;
                    }
                });

                ctrl.$formatters.push(function () {
                    var defaultValue = 0;
                    if (isFieldRequired()) {
                        defaultValue = '';
                    }
                    if (ctrl.$modelValue !== 0) {
                        ctrl.$modelValue = ctrl.$modelValue || defaultValue;
                    }
                    if (isFocused) {
                        if (nbDecimals >= 0) {
                            return arrondi5Centime(ctrl.$modelValue).toFixed(2);
                        } else {
                            return ctrl.$modelValue > 0 ? ctrl.$modelValue : '';
                        }
                    }
                    return $filter('currency')(ctrl.$modelValue, nbDecimals, 0);
                });
            }
        };
    });
	core.directive('stlPercentageInput', function ($filter) {
		return {
			require: 'ngModel',
			restrict: 'A',
			link: function (scope, ele, attr, ctrl) {

				function getNombreDecimals() {
					var decimals = attr.decimals ? parseInt(attr.decimals) : 2;
					return decimals;
				}

                ctrl.$parsers.unshift(function (viewValue) {
					if (viewValue === null || angular.isUndefined(viewValue) || viewValue === '') {
						return undefined;
					}
					var val = parseFloat(viewValue) / 100;
					if(!isNaN(val)) {
					    return val;
                    } else {
					    return undefined;
                    }
				});

                ctrl.$formatters.unshift(function (modelValue) {
					if (angular.isDefined(modelValue)) {
						return $filter('percentage')(modelValue, getNombreDecimals());
					}
				});

                ctrl.$validators.min = function (modelValue, viewValue) {
                    if(!angular.isDefined(modelValue)) {
                        return true;
                    }

                    if(angular.isDefined(attr['min']) && modelValue < attr['min'] / 100) {
                        return false;
                    }
                    else {
                        return true;
                    }
                };

                ctrl.$validators.max = function (modelValue, viewValue) {
                    if(!angular.isDefined(modelValue)) {
                        return true;
                    }

                    if(angular.isDefined(attr['max'])  && modelValue > attr['max'] / 100) {
                        return false;
                    }
                    else {
                        return true;
                    }
                };

				ele.on('blur', function () {
					if (angular.isDefined(ctrl.$modelValue)) {
						ele.val($filter('percentage')(ctrl.$modelValue, getNombreDecimals()));
					}
					else if (angular.isDefined(ctrl.$viewValue) && !isNotNumber(ctrl.$viewValue)) {
					    ele.val($filter('percentage')(ctrl.$viewValue / 100, getNombreDecimals()));
                    }
				});

				ele.bind('focus', function () {
					if (ctrl.$modelValue !== undefined && ctrl.$modelValue !== null) {
                        var viewValue = $filter('percentage')(ctrl.$modelValue, getNombreDecimals(), false);
                        ctrl.$viewValue = viewValue.replace(new RegExp('\'', 'g'), '');
					}
                    ctrl.$render();
				});
			}
		};
	});

	core.directive('stlNumber', function () {
		return {
			require: 'ngModel',
			restrict: 'A',
			link: function (scope, elm, attrs, ctrl) {
				function parseNumbers(text) {
					var transformedInput = text.replace(/[^0-9]/g, '');
					if (transformedInput !== text) {
						ctrl.$setViewValue(transformedInput);
						ctrl.$render();
					}
					return transformedInput;
				}
				ctrl.$parsers.push(parseNumbers);
			}
		};
	});


    core.directive('testDirective', function() {
        return {
            restrict: 'E',
            scope: {
                dayMonthOnly: '=dayMonthOnly'
            },
            link: function (scope, element, attrs, reqs) {



                var setLabel = function(text) {
                    console.log(text);
                };

                setLabel(scope.dayMonthOnly);

                /*
                scope.$watch('dayMonthOnly', function(newVal, oldVal) {
                    if (newVal !== oldVal) {
                        setLabel(newVal);
                    }
                });
                */
                attrs.$observe('dayMonthOnly', function() {

                });

            }
        };
    });

})(angular);
;
/**
 * Primeo - Gestion des écoles primaires
 *
 * SITel - Service de l'informatique et des télécommunications
 * ITA - Amt für Informatik und Telekommunikation
 * Impasse de la colline 1 Givisiez, CH-1701 Fribourg
 *
 * All rights reserved.
 */

'use strict';
/**
 * Convert a utc date to the format yyyy.MM.dd hh:mm:ss
 * this require moment.js !
 */
var core = angular.module('CoreUtils', []);

core.service('ObjectUtils', [function () {
    var self = this;
    /**
     * Read an object property by a path
     * by example:
     * readPath({address:{npa: 1630}}, 'address.npa') will return 1630
     * @param {Object} obj the object to read
     * @param {type} path the path to access
     * @returns {?} the object value
     */
    this.readPath = function (obj, path) {
        var ret = null;
        if (path && obj) {
            var crtObj = obj;
            var paths = path.split('\.');
            for (var i = 0; i < paths.length; i++) {
                var p = paths[i];
                crtObj = crtObj[p];
                if (!crtObj) {
                    break;
                }
            }
            if (crtObj) {
                ret = crtObj;
            }
        }
        return ret;
    };

    this.readPathSafe = function (obj, path, defaultValue) {
        var val = null;
        if (defaultValue !== undefined && defaultValue !== null) {
            val = defaultValue;
        }

        var pathComplete = false;

        // Read the path...
        if (path && obj) {
            var crtObj = obj;
            var paths = path.split('\.');
            for (var i = 0; i < paths.length; i++) {
                var p = paths[i];
                crtObj = crtObj[p];
                if (crtObj === undefined || crtObj === null) {
                    break;
                }
                if (i === paths.length - 1) {
                    pathComplete = true;
                }
            }
            if (pathComplete) {
                val = crtObj;
            }
        }

        return val;
    };

    this.isEntry = function (object) {
        for (var r in object) {
            return !!r;
        }
        return false;
    };

    this.searchInEnumFromValue = function (value, enumArray) {
        if (!value || !enumArray) {
            return null;
        }
        for (var i = 0; i < enumArray.length; i++) {
            if (enumArray[i] && enumArray[i].value === value) {
                return enumArray[i];
            }
        }
        return null;
    };

    this.searchIndex = function (list, value, path) {
        for (var i = 0; i < list.length; i++) {
            if (self.readPath(list[i], path) === value) {
                return i;
            }
        }
        return -1;
    };

    this.isNonEmptyArrayInPath = function (object, path) {
        var obj = self.readPath(object, path);
        return !!(obj && obj.length && obj.length > 0);
    };

    this.isNonEmptyObject = function (object) {
        if (!object) {
            return false;
        }
        for (var key in object) {
            return !!key;
        }
        return false;
    };

    this.searchParameterParents = function (object, parameter) {
        for (var key in object) {
            if (key === parameter) {
                return object;
            }
            if ((typeof object[key]).toUpperCase() === 'OBJECT' && object[key] && !object[key].length) {
                var val = self.searchParameterParents(object[key], parameter);
                if (val) {
                    return val;
                }
            }
        }
        return null;
    };

}]);

core.service('FileManager', function ($translate, ModalService) {
    return {
        downloadFile: function (link) {
            var emergencyDownload = function () {
                ModalService.downloadPopup({
                    validateBtn: $translate.instant('common.button.download'),
                    cancelBtn: $translate.instant('common.button.cancel'),
                    validateBtnCls: 'btn-primary',
                    cancelBtnCls: 'btn-default',
                    modalText: $translate.instant('common.download.confirmation'),
                    link: link
                });
            };
//				if (GLOBALVARS.browser.type === 'ie' || GLOBALVARS.browser.mobile === true) {
//					emergencyDownload();
//					return;
//				}
            try {
                var downloadAtt = document.createAttribute('download');
                var save = document.createElement('a');
                save.href = link;
                save.target = '_blank';
                save.setAttributeNode(downloadAtt);
                var evt = document.createEvent('MouseEvents');
                evt.initMouseEvent('click', true, true,
                    window, 1, 0, 0, 0, 0,
                    false, false, false, false, 0, null);

                save.dispatchEvent(evt);
            } catch (e) {
                emergencyDownload();
            }

        }
    };
});

core.service('ObjectFilter', ['ObjectUtils', '$filter', function (ObjectUtils, $filter) {
    this.sortArray = function (array, keys) {
        array.sort(function (a, b) {
            for (var i = 0; i < keys.length; i++) {
                var key = keys[i];

                var sort = key;
                if (!sort.column) {
                    var dir = true;
                    if (key.charAt(0) === '-') {
                        dir = false;
                        key = key.substring(1);
                    }

                    sort = {
                        column: key,
                        dir: dir
                    };
                }

                var m = 1;
                if (sort.dir === true) {
                    m = -1;
                }
                var av = ObjectUtils.readPathSafe(a, sort.column, '');
                var bv = ObjectUtils.readPathSafe(b, sort.column, '');
                if (av > bv) {
                    return 1 * m;
                } else if (av < bv) {
                    return -1 * m;
                }
            }
            return 0;
        });
        return array;
    };

    this.sortFilterArray = function (array, keys) {
        var sorted = array;
        for (var i = 0; i < keys.length; i++) {
            sorted = $filter('orderBy')(sorted, keys[i].column, keys[i].dir);
        }
        return sorted;
    };
}]);


core.service('StlDateUtils', [function () {
    var self = this;
    /**
     * Check if a date (date) is in an interval
     * @param {Interva} interval ({begin, end})
     * @param {type} date the date to test
     * @returns {boolean} true when date in interval
     */

    this.isInInterval = function (interval, date) {
        return interval.begin.getTime() <= date.getTime() && interval.end.getTime() >= date.getTime();
    };

    this.convertToHumanDate = function (date) {
        return moment(date).format('DD.MM.YYYY');
    };

    this.convertToHumainDateWithSecs = function (date) {
        return moment(date).format('DD.MM.YYYY HH:mm:ss');
    };

    this.convertToBusinessDate = function (date) {
        return moment(date).format('YYYY-MM-DD');
    };
    this.convertFromBusinessDate = function (date) {
        return moment(date, 'YYYY-MM-DD').toDate();
    };

    this.convertFromBusinessDateGlobal = function (date) {
        return moment(date).toDate();
    };

    this.getMaxDate = function () {
        return moment('9999-01-01', 'YYYY-MM-DD').toDate();
    };

    this.getMaxBusinessDate = function () {
        return this.convertToBusinessDate(this.getMaxDate());
    };

    this.getMinDate = function () {
        return moment('1900-01-01', 'YYYY-MM-DD').toDate();
    };

    this.getMinBusinessDate = function () {
        return this.convertToBusinessDate(this.getMinDate());
    };

    this.addDays = function (date, days) {
        return moment(date).add(days, 'days').toDate();
    };

    this.isBusinessMaxDate = function (bDate) {
        var date = this.convertFromBusinessDate(bDate);
        if (date) {
            return date.getFullYear() >= 9999;
        } else {
            return false;
        }
    };

    this.createInterval = function (start, end) {
        return {
            start: start,
            end: end
        };
    };

    /**
     *
     * @param {type} interval {start (Date or YYYY-MM-DD), end (Date or YYYY-MM-DD)} (inclusibve)
     * @param {type} date the date to test
     * @returns {boolean} true if the date is in the interval
     */
    this.isInInterval = function (interval, date) {
        try {
            var is = interval.start;
            var ie = interval.end;

            var start, end;
            if (is instanceof Date) {
                start = interval.start.getTime();
            } else {
                start = moment(interval.start, 'YYYY-MM-DD').toDate().getTime();
            }
            if (ie instanceof Date) {
                end = interval.end.getTime();
            } else {
                end = moment(interval.end, 'YYYY-MM-DD').toDate().getTime();
            }
            var test = date.getTime();
            return start <= test && end >= test;
        } catch (e) {
            return false;
        }
    };

    this.getCorrectDateForInterval = function (businessDate, from, to) {
        var date = self.convertFromBusinessDate(businessDate);
        date.setFullYear(from.getFullYear());
        if (from.getTime() > date.getTime()) {
            date.setFullYear(to.getFullYear());
        }
        return date;
    };
}]);

core.service('ConnectionUtils', ['$http', '$q', function ($http, $q) {
    this.checkAuthenticated = function (checkUrl) {
        var deferred = $q.defer();
        $http({
            method: 'get',
            url: checkUrl
        }).then(function (data) {
            try {
                if (!data.data.connected) {
                    deferred.reject(data);
                    return;
                }
            } catch (e) {
                deferred.reject(data);
                return;
            }
            deferred.resolve();
        }, function (data) {
            deferred.reject(data);
        });
        return deferred.promise;
    };
}]);

core.service('StringUtil', [function () {
    this.regexGlobalMatch = function (value, regex) {
        var ar = value.match(new RegExp(regex, 'g'));
        for (var i = 0; ar && i < ar.length; i++) {
            if (ar[i] === value) {
                return true;
            }
        }
        return false;
    };

    this.toTitleCase = function (str) {
        return str.replace(/(?:^|\s)\w/g, function (match) {
            return match.toUpperCase();
        });
    };
}]);

core.service('PrintUtil', [function () {
    this.printDiv = function (divId, frameWidth, frameHeight) {
        var printContents = document.getElementById(divId).innerHTML;

        var linkTags = document.getElementsByTagName('link');
        var stylesheets = '';
        angular.forEach(linkTags, function(value, key) {
            stylesheets += '<link rel="stylesheet" type="text/css" href="'+ value.href +'" />';
        });

        var popupWin = window.open('', '_blank', 'width=' + frameWidth + ',height=' + frameHeight);
        popupWin.document.open();
        popupWin.document.write('<html><head>' + stylesheets + '</head><body onload="window.print()" onfocus="setTimeout(function () { window.close(); }, 500);">' + printContents + '</body></html>');
        popupWin.document.close();
    };
}]);

core.service('ErrorUtil', ['$log', '$translate', 'StringUtil', function ($log, $translate) {
    this.translateError = function (error, defaultKey, prefix) {
        var translatedErrorMsg = $translate.instant(defaultKey);
        var msgPrefix = prefix ? prefix : '';
        var translation = $translate.instant(msgPrefix + error.data.message);
        if (translation && translation.indexOf(error.data.message) < 0) {
            translatedErrorMsg = translation;
        }
        return translatedErrorMsg;
    };

    this.treatError = function(error, frontend, frontendLogFn) {
        $log.error(error);

        if (frontend) {
            frontendLogFn.apply(this);
        }
    };

}]);

core.service('ValidationUtil', ['$translate', 'StringUtil', function ($translate, StringUtil) {
    this.getValidationMessage = function (validationDtos, indexableItems, fields) {
        var msg = null;
        angular.forEach(fields, function (value) {
            var validationDto = validationDtos[indexableItems.index + value];
            if (!angular.isUndefined(validationDto) && validationDto !== null) {
                if (msg == null) {
                    msg = '';
                } else {
                    msg += '<br/><br/>';
                }
                msg += '<b>' + $translate.instant(StringUtil.toTitleCase(validationDto.field)) + ' :</b> ' + $translate.instant(validationDto.message);
            }
        });
        return msg;
    };
}]);
;
/**
 * Primeo - Gestion des Ã©coles primaires
 *
 * SITel - Service de l'informatique et des tÃ©lÃ©communications
 * ITA - Amt fÃ¼r Informatik und Telekommunikation
 * Impasse de la colline 1 Givisiez, CH-1701 Fribourg
 *
 * All rights reserved.
 */

(function(angular) {
	'use strict';
	var isNotNumber = function(value) {
		return value === undefined || value === null || value === '' || isNaN(parseFloat(value));
	};
	/**
	 * Convert a utc date to the format yyyy.MM.dd hh:mm:ss
	 * this require moment.js !
	 */
	var filter = angular.module('Core');
	filter.filter('i18nDate', ['StlDateUtils', function (DateUtils) {
			return function(input) {
				if (input === null || input === undefined) {
					return '';
				}

				if (DateUtils.isBusinessMaxDate(input)) {
					return '';
				}

				var dateStr = moment(input, 'YYYY-MM-DD').format('DD.MM.YYYY');

				return dateStr;
			};
		}]);
	filter.filter('i18nDateTime', ['StlDateUtils', function (DateUtils) {
			return function(input) {
				if (input === null || input === undefined) {
					return '';
				}

				if (DateUtils.isBusinessMaxDate(input)) {
					return '';
				}

				var dateStr = moment(input, 'YYYY-MM-DD HH:mm:ss').format('DD.MM.YYYY HH:mm:ss');

				return dateStr;
			};
		}]);
	filter.filter('businessDate', ['StlDateUtils', function (DateUtils) {
			return function(input) {
				if (input === null || input === undefined) {
					return '';
				}

				return DateUtils.convertToBusinessDate(input);
			};
		}]);
	filter.filter('fromBusinessDate', function() {
		return function(input) {
			if (input === null || input === undefined || input === '') {
				return null;
			}

			var date = moment(input, 'YYYY-MM-DD');
			if (date) {
				return date.toDate();
			}
			return null;
		};
	});
	filter.filter('formatText', [function () {
			return function (input) {
				if (!input) {
					return input;
				}
				var output = input
						//replace possible line breaks.
						.replace(/(\r\n|\r|\n)/g, '<br/>')
						//replace tabs
						.replace(/\t/g, '&nbsp;&nbsp;&nbsp;&nbsp;');
						//replace spaces.
				//.replace(/ /g, '&nbsp;');
				return output;
			};
		}]);
	filter.filter('list2line', [function() {
			return function(line, params) {
				var text = '';
				if (line && line.length > 0) {
					for (var i = 0; i < line.length; i++) {
						if (i > 0) {
							text += ', ';
						}
						var value = line[i];
						if (params && params.formatter) {
							value = params.formatter(value);
						}
						text += value;
					}
				}
				return text;
			};
		}]);
	filter.filter('firstLetter', [function() {
			return function(word) {
				if (word === undefined || word === null || word === '') {
					return '';
				}
				return word.charAt(0);
			};
		}]);
	// Convert a YYYY year to YY (2014 -> 14)
	filter.filter('year2digits', [function() {
			return function(year) {
				var y = null;
				if (year !== null) {
					y = year % 100;
				}
				return y;
			};
		}]);
	filter.filter('tel', function() {
		return function(tel) {
			if (!tel) {
				return null;
			}
			var endPhone = '';

			if (tel.length < 3) {
				return tel;
			}

			// replace all spaces with ''
			tel = tel.replace(/\s/g, '');

//var value = tel.toString().trim().replace(/^\+/, '');
			if (tel.substring(0, 3) === '+41') {
				//+41 form
				endPhone = tel.substring(0, 3) + ' ';
				endPhone += tel.substring(3, 5) + ' ';
				endPhone += tel.substring(5, 8) + ' ';
				endPhone += tel.substring(8, 10) + ' ';
				endPhone += tel.substring(10, 12) + ' ';
				//endPhone = $.inputmask.format(tel, {alias: "+99 99 999 99 99"});
			} else {
				endPhone = tel.substring(0, 3) + ' ';
				endPhone += tel.substring(3, 6) + ' ';
				var i = 6;
				while (tel.length >= i + 2) {
					endPhone += tel.substring(i, i + 2) + ' ';
					i += 2;
				}
				if (tel.length > i) {
					endPhone += tel.substring(i, tel.length);
				}
				//endPhone = $.inputmask.format(tel, {alias: "999 999 [99]*"});
			}
			return endPhone;
		};
	});

	/**
	 * Convert a list of objects to a string
	 * path is used to read a property from the object. By example for
	 * personne.contact.npa the filter is: personnes | objects2string:'personne.contact.npa'}
	 */
	filter.filter('objects2string', ['ObjectUtils', function(ObjectUtils) {
			return function(objects, path) {
				var text = '';
				if (objects) {
					for (var i = 0; i < objects.length; i++) {
						var obj = objects[i];
						var t = ObjectUtils.readPath(obj, path);
						if (t) {
							if (i > 0) {
								text += ', ';
							}
							text += t;
						}
					}
				}
				return text;
			};
		}]);

	filter.filter('truncateEmailDomain', [function() {
			return function(email) {
				var label = email;
				if (email) {
					var spl = email.split('@');
					var start = spl[0] + '@';
					if (spl.length > 0) {
						var spl2 = spl[1].split('\.');
						var end = '...' + spl2[spl2.length - 1];
						label = start + end;
					}
				} else {
					label = '';
				}
				return label;
			};
		}]);
	filter.filter('email2link', ['$filter', function($filter) {
			return function(email, truncate) {
				var label = email;
				if (!!truncate) {
					label = $filter('truncateEmailDomain')(label);
				}
				var link = '<a href="mailto:' + email + '">' + label + '</a>';
				return link;
			};
		}]);

	filter.filter('booleanLabel', function($translate) {
		return function(value) {
			var b = null;
			if (value === 'true' || value === true) {
				b = true;
			} else if (value === 'false' || value === false) {
				b = false;
			}

			var key = 'non';
			if (b === true) {
				key = 'oui';
			} else if (b === false) {
				key = 'non';
			} else {
				return '';
			}

			return $translate.instant(key);
		};
	});

	filter.filter('checkBoxLabel', [function() {
			return function(value, msg) {
				var b = null;
				if (value === 'true' || value === true) {
					b = true;
				} else if (value === 'false' || value === false) {
					b = false;
				}

				var key = '-';
				if (b === true) {
					key = msg;
				}

				return key;
			};
		}]);

	filter.filter('scopeSearch', [function() {
			return function(items, searchString, callBack) {
				return callBack(searchString);
			};
		}]);

	filter.filter('label', [function() {
			return function(labels) {
				if (labels && labels.length) {
					var l = [];
					for (var i = 0; i < labels.length; i++) {
						l.push(labels[i].label.text);
					}
					return l.sort().join(', ');
				}
				return '';
			};
		}]);

	filter.filter('toPercent', [function() {
			return function(number, digits) {
				if (!digits) {
					digits = 0;
				}
				if (number) {
					var n = number * 100;
					return n.toFixed(digits);
				} else {
					return 0;
				}

			};
		}]);
	filter.filter('toFixed', [function() {
			return function(number, digits) {
				if (!digits) {
					digits = 0;
				}
				if (number) {
					return number.toFixed(digits);
				} else {
					return 0;
				}

			};
		}]);

	filter.filter('nullToEscape', [function() {
			return function(value) {
				return value ? value : '&nbsp;';
			};
		}]);

	filter.filter('enumFilter', function($filter) {
		return function(items, search, prefix) {
			var out = [];
			// be sure we have an array as input
			if (angular.isArray(items)) {
				// for each enum element, check if it contains the search string
				items.forEach(function(item){
					var translated = $filter('translate')(prefix+item).toString().toLowerCase();
					search = search.toString().toLowerCase();
					if (translated.indexOf(search) > -1) {
						out.push(item);
					}
				});
			} else {
				// let the output be the input untouched
				out = items;
			}
			return out;
		};
	});

	// This filter makes the assumption that the input will be in decimal form (i.e. 17% is 0.17).
	filter.filter('percentage', ['$filter', function ($filter) {
        function decimalPlaces(inputPercentOver100){
            if (inputPercentOver100 === null) {
                return null;
            }
            var count = 0;
            if (Math.floor(inputPercentOver100) !== inputPercentOver100) {
                count = inputPercentOver100.toString().split(".")[1].length || 0;
            }
            if (count > 6) {
                return 6; // Limité à 8 décimals en base de données (1.234567 => 0.01234567)
            } else if (count > 0) {
                return count;
            } else {
                return 0;
            }
        };

        return function (input, decimals, displayPercent) {
            if (displayPercent === undefined) {
                displayPercent = true;
            }
            if (isNotNumber(input)) {
                return '';
            } else {
                var inputPercentOver100 = Math.round((input * 100) * 1000000) / 1000000;
                if (decimals === undefined) {
                    decimals = decimalPlaces(inputPercentOver100);
                }

                var res = $filter('number')(inputPercentOver100.toFixed(Math.max(0, ~~decimals)), decimals);
                if (res !== undefined && res !== '') {
                    res = res.replace(',', '.');
                    if (displayPercent === true || displayPercent === 1) {
                        res += '%';
                    }
                }
                return res;
            }
        };
	}]);

	filter.filter('currency', ['$filter', function ($filter) {
		return function (input, nbDecimals, displayCurrency) {
			if (nbDecimals === undefined) {
				nbDecimals = 2;
			}
			if (displayCurrency === undefined) {
				displayCurrency = true;
			}
			if (isNotNumber(input)) {
				return '';
			} else {
				input = parseFloat(input);
				var re = '\\d(?=(\\d{' + (3) + '})+' + (nbDecimals > 0 ? '\\.' : '$') + ')';
				var res = '';
				if (displayCurrency === true || displayCurrency === 1) {
					res += 'CHF ';
				}
				if (nbDecimals === 2) {
					input = Math.round(input * 20) / 20; // arrondi au 5 centimes
				}
				res += input.toFixed(Math.max(0, ~~nbDecimals)).replace(new RegExp(re, 'g'), '$&\'');
				return res;
			}
		};
	}]);

	//filtre pour les hashmap, permet de definir un range lorsque la clé est un nombre
	filter.filter('within', function () {
		return function (items, from, to) {
			var result = {};
			angular.forEach(items, function (value, key) {
				if (from <= parseInt(key) && parseInt(key) <= to) {
					result[key] = value;
				}
			});
			return result;
		};
	});


})(angular);
;
(function(angular) {
	'use strict';
	/**
	 * Add directives to the audit module
	 */
	var dir = angular.module('Core');
	dir.directive('infoBox', [function() {
			return {
				restrict: 'E',
				template:
						'<div class="alert alert-info infobox">' +
						'	<span class="glyphicon glyphicon-info-sign" style="font-size: 20px;"></span>' +
						'	<span class="infobox-content" ng-transclude></span><div class="spacer"></div>' +
						'</div>',
				replace: true,
				transclude: true,
				scope: false
			};
		}]);

	dir.directive('email', ['$filter', function($filter) {
		return {
			restrict: 'EA',
			template: '<a href="mailto:{{email}}" ng-if="email">{{emailLabel}}</a>',
			scope: {
				email: '=',
				truncateDomain: '@'
			},
			link: function(scope) {
				var setLabel = function(email) {
					var label = email;

					// Desactivation du truncate pour l'instant (attente réactions client, le domain peut être important)
					/*if (!!scope.truncateDomain) {
						label = $filter('truncateEmailDomain')(label);
					}*/

					scope.emailLabel = label;
				};
				setLabel(scope.email);
				scope.$watch('email', function(newVal, oldVal) {
					if (newVal !== oldVal) {
						setLabel(newVal);
					}
				});
			}
		};
		}]);
	dir.directive('mouseListener', [function() {
			return {
				restrict: 'A',
				link: function(scope, element, attribute, controller) {
					$(element).on('mouseenter', function() {
						controller.mouseenter();
					});
					$(element).on('mouseleave', function() {
						controller.mouseleave();
					});
				},
				controller: [function() {
						var listeners = [];
						var sendNotification = function(notification) {
							for (var i = 0; i < listeners.length; i++) {
								listeners[i](notification);
							}
						};
						this.mouseenter = function() {
							sendNotification('mouseenter');
						};
						this.mouseleave = function() {
							sendNotification('mouseleave');
						};
						this.registerForNotification = function(_callBack) {
							listeners.push(_callBack);
						};
				}]
			};
		}]);
	dir.directive('parentMouseListener', [function() {
			return {
				restrict: 'A',
				require: '^mouseListener',
				link: function(scope, element, attribute, controller) {
					var type = attribute['parentMouseListener'];
					var defaultShow = attribute['defaultShow'];
					if (defaultShow && defaultShow === 'hidden') {
						$(element).css('display', 'none');
					}
					controller.registerForNotification(function(notification) {
						if (notification === type) {
							$(element).css('display', '');
						} else {
							$(element).css('display', 'none');
						}
					});
				}
			};
		}]);

	dir.directive('stlTooltipTranslate', ['$translate', function ($translate) {
			return {
				restrict: 'A',
				link: function (scope, element, attr) {
					if (!element.attr('data-placement')) {
						element.attr('data-placement', 'top');
					}
					$translate(element.attr('stl-tooltip-translate')).then(function (translatedValue) {
						element.attr('data-original-title', translatedValue);
					});
					element.tooltip();
				}
			};
		}]);

	dir.directive('stlTooltip', [function() {
		return {
				restrict: 'A',
				link: function (scope, element, attr) {
					if (!element.attr('data-placement')) {
						element.attr('data-placement', 'top');
					}

					if (!attr['stlUpdate']) {
						element.attr('stl-tooltip', 'data-toggle');
						element.tooltip();
					} else {
						scope.$watch(attr['stlUpdate'], function(newValue) {
							if (newValue) {
								element.on('mouseenter', function() {
									element.tooltip('show');
								});
								element.on('click', function() {
									element.tooltip('hide');
								});
							}
						});
					}

					scope.$watch(attr['stlTooltip'], function(newValue) {
						element.attr('data-original-title', newValue);
					});
			}
		};
		}]);



	dir.directive('fixedPosition', [function() {
			return {
				restrict: 'A',
				scope: {},
				link: function(scope, element, attribute) {
					var event = attribute['eventListener'];
					element.css('position', 'relative');
					var currentPosition = 0;
					var update = function(data) {
						var position = (element.offset().top - currentPosition - data.top) * -1;
						if (position < 0) {
							position = 0;
						}
						currentPosition = position;
						element.css('top', currentPosition + 'px');
					};
					if (event === 'body') {
						var body = $('#content');

						body.on('scroll', function(e) {
							update({
								scroll: body.scrollTop(),
								height: body.height(),
								outerHeight: body.outerHeight(),
								innerHeight: body.innerHeight(),
								scrollHeiht: body[0].scrollHeight,
								top: body.offset().top,
								left: body.offset().left
							});
						});
					}

					scope.$on(event + '-scroll', function(e, data) {
						update(data);
					});
					scope.$on(event + '-resize', function(e, data) {
						update(data);
					});
				}
			};
		}]);

	dir.directive('stlTextareaMaxRows', [function() {
			return {
				restrict: 'A',
				link: function(scope, element, attribute) {
					var lines = attribute['stlTextareaMaxRows'];

					element.keydown(function(e) {

						var newLines = $(this).val().split('\n').length;

						if (e.keyCode === 13 && newLines >= lines) {
							return false;
						}

					});
				}
			};
		}]);

	dir.directive('stlLastModification', function($translate, StlDateUtils, $sce, ObjectUtils) {
		return {
			restrict: 'A',

			link: function(scope, element, attr) {
				var ar = false;
				var subPath = attr['subPath'];
				if (attr['typeArray']) {
					ar = true;
				}

				element.attr('data-placement', 'bottom');
				element.attr('stl-tooltip', 'data-toggle');
				element.tooltip({
					'delay': {show: 1000}
				});
				var MAX_LEVEL = 3;

				var getMaxDate = function(object, _lastModification) {

					var lastModification = _lastModification;
					if (object.dateModification && StlDateUtils.convertFromBusinessDateGlobal(object.dateModification).getTime() > _lastModification.dateModification.getTime()) {
						lastModification = {
							dateModification: StlDateUtils.convertFromBusinessDateGlobal(object.dateModification),
							utilisateurModification: object.utilisateurModification
						};
					} else if (object.length) {

						for (var i = 0; i < object.length; i++) {
							var current = object[i];
							if (StlDateUtils.convertFromBusinessDateGlobal(current.dateModification).getTime() > lastModification.dateModification.getTime()) {
								lastModification = {
									dateModification: StlDateUtils.convertFromBusinessDateGlobal(current.dateModification),
									utilisateurModification: current.utilisateurModification
								};
							}
						}


					}

					return lastModification;
				};

				element.addClass('stl-tooltip-info');
				scope.$watch(attr['stlLastModification'], function(newValue) {
					var title;
					var i;
					if (!ar && newValue && newValue.dateModification && !subPath) {
						title = $sce.trustAsHtml($translate.instant('DerniereModification') + '\n' + StlDateUtils.convertToHumainDateWithSecs(newValue.dateModification) + '\n' + newValue.utilisateurModification);
						element.attr('data-original-title', title);
					} else if (ar && newValue && newValue.length && newValue.length > 0) {
						var current = newValue[0];
						var date = StlDateUtils.convertFromBusinessDateGlobal(current.dateModification).getTime();
						title = $translate.instant('DerniereModification') + '\n' + StlDateUtils.convertToHumainDateWithSecs(current.dateModification) + '\n' + current.utilisateurModification;
						for (i = 1; i < newValue.length; i++) {
							current = newValue[i];
							if (StlDateUtils.convertFromBusinessDateGlobal(current.dateModification).getTime() > date) {
								title = $translate.instant('DerniereModification') + '\n' + StlDateUtils.convertToHumainDateWithSecs(current.dateModification) + '\n' + current.utilisateurModification;
								date = StlDateUtils.convertFromBusinessDateGlobal(current.dateModification).getTime();
							}
						}
						element.attr('data-original-title', title);
					} else if (subPath && newValue && newValue.dateModification) {
						var modification = {
							dateModification: StlDateUtils.convertFromBusinessDateGlobal(newValue.dateModification),
							utilisateurModification: newValue.utilisateurModification
						};
						var objectsPath = subPath.split(',');
						for (i = 0; i < objectsPath.length; i++) {
							var obj = ObjectUtils.readPath(newValue, objectsPath[i]);
							modification = getMaxDate(obj, modification);
						}
						title = $sce.trustAsHtml($translate.instant('DerniereModification') + '\n' + StlDateUtils.convertToHumainDateWithSecs(modification.dateModification) + '\n' + modification.utilisateurModification);
						element.attr('data-original-title', title);
					}
				});
			}
		};
	});

	dir.directive('stlNbTranslate', ['$translate', function ($translate) {
		return {
			restrict: 'A',
			link: function (scope, element, attr) {
				var key = attr['stlNbTranslate'];
				var translatedValue = $translate.instant(key);
				if (translatedValue) {
					element.html(translatedValue.replace(/ /g, '&nbsp;'));
				}
			}
		};
		}]);

	dir.directive('stlShortcut', function () {
		return {
			restrict: 'A',
			replace: true,
			scope: true,
			link: function (scope, iElement, iAttrs) {
				jQuery(document).on('keypress', function (e) {
					scope.$apply(scope.keyPressed(e));
				});
			}
		};
	});

	dir.directive('focusOn', function () {
		return function (scope, elem, attr) {
			scope.$on(attr.focusOn, function (e) {
				elem[0].focus();
			});
		};
	});

})(angular);
;
//need jquery to work
GLOBALVARS = {};

function testIEandChrome(ua, tem, M) {
	if (/trident/i.test(M[1])) {
		tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
		return 'IE ' + (tem[1] || '');
	}
	if (M[1] === 'Chrome') {
		tem = ua.match(/\bOPR\/(\d+)/);
		if (tem !== null) {
			return 'Opera ' + tem[1];
		}
	}
	return null;
}

function get_browser() {
	var ua = navigator.userAgent, tem, M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];

	var res = testIEandChrome(ua, tem, M);
	if (res) {
		return res;
	}

	M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
	if ((tem = ua.match(/version\/(\d+)/i)) !== null) {
		M.splice(1, 1, tem[1]);
	}
	return M[0];
}

function get_browser_version() {
	var ua = navigator.userAgent, tem, M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];

	var res = testIEandChrome(ua, tem, M);
	if (res) {
		return res;
	}

	M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
	if ((tem = ua.match(/version\/(\d+)/i)) != null) {
		M.splice(1, 1, tem[1]);
	}
	return M[1];
}

function getOs() {
	var appVersion = navigator.appVersion;
	var osDesc = 'os';
	if (appVersion.indexOf('Win') !== -1) {
		osDesc = 'windows';
	} else if (appVersion.indexOf('Mac') !== -1) {
		osDesc = 'macos';
	}
	return osDesc;
}

function getBrowserInfos() {
	var browserType;
	var tooOld = false;
	var browserDesc = 'browser';
	var agt = navigator.userAgent.toLowerCase();
	var ver = get_browser_version();

	if (agt.indexOf('firefox') !== -1) {
		browserDesc = 'firefox';
		if (ver < 3.6) {
			tooOld = true;
		}
	}

	if (agt.indexOf('chrome') !== -1) {
		browserDesc = 'chrome';
	} else if (agt.indexOf('safari') !== -1) {
		browserDesc = 'safari';
		var v = navigator.userAgent.match(/version\/([0-9]+[.]?)*/i);
		ver = v && v[0] ? v[0].match(/([0-9]+.?[0-9]*.?[0-9]*)/i)[0] : 0;
		if (ver < 5.1) {
			tooOld = true;
		}
	}

	browserType = browserDesc;

	if (navigator.appName === 'Microsoft Internet Explorer' || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
		browserType = 'ie';
		browserDesc = 'ie11';
		ver = '11.0';
	}

	if (/MSIE (\d+\.\d+);/.test(navigator.userAgent)) {
		browserType = 'ie';
		ver = 0;
		var re = new RegExp('MSIE ([0-9]{1,}[\.0-9]{0,})');
		if (re.exec(navigator.userAgent) !== null) {
			ver = parseFloat(RegExp.$1);
		}

		if (ver < 7.0) {
			browserDesc = 'ie6';
			tooOld = true;
		} else if (ver < 8.0) {
			browserDesc = 'ie7';
			tooOld = true;
		} else if (ver < 9.0) {
			tooOld = true;
			browserDesc = 'ie8';
		} else if (ver < 10.0) {
			browserDesc = 'ie9';
		} else if (ver < 11.0) {
			browserDesc = 'ie10';
		}
	}
	return {
		browserType: browserType,
		browserDesc: browserDesc,
		tooOld: tooOld
	};
}

function markConfigurationToBody() {
	var agt = navigator.userAgent.toLowerCase();

	//os
	//var browser = get_browser();
	var ver = get_browser_version();
	var osDesc = getOs();


	var infos = getBrowserInfos();
	var browserType = infos['browserType'];
	var browserDesc = infos['browserDesc'];
	var tooOld = infos['tooOld'];


	if (agt.indexOf('iphone') !== -1) {
		browserDesc = 'iphone';
		browserType = 'iphone';
	}
	if (agt.indexOf('android') !== -1) {
		browserDesc = 'android';
		browserType = 'android';
	}

	var mobile = false;
	if (agt.match(/(android|iphone|ipad|blackberry|symbian|symbianos|symbos|netfront|model-orange|javaplatform|iemobile|windows phone|samsung|htc|opera mobile|opera mobi|opera mini|presto|huawei|blazer|bolt|doris|fennec|gobrowser|iris|maemo browser|mib|cldc|minimo|semc-browser|skyfire|teashark|teleca|uzard|uzardweb|meego|nokia|bb10|playbook)/gi)) {
		mobile = true;
	}

	browserDescGlobal = browserDesc;

	GLOBALVARS['browser'] = {
		os: osDesc,
		version: ver,
		type: browserType,
		description: browserDesc,
		mobile: mobile
	};
	//marquage
	//browser
	document.getElementsByTagName('body')[0].className += ' ' + osDesc;
	document.getElementsByTagName('body')[0].className += ' ' + browserDesc;
	document.getElementsByTagName('body')[0].className += ' ' + browserType;
	if (tooOld) {
		document.getElementsByTagName('body')[0].className += ' old-browser';
	}
	//alert(document.getElementsByTagName('body')[0].className);
}
//window.onload = markConfigurationToBody;
markConfigurationToBody();

;
(function () {
	'use strict';

	// Boot package related to Spring-Boot specific use.

	angular
			.module('Core')
			.service('InfoService', InfoService);

	InfoService.$inject = ['$rootScope', '$q', '$http'];

	/*
	 * Application info services /info
	 */
	function InfoService($rootScope, $q, $http) {
		var _info;
		var service = {
			load: load,
			getVersion: getVersion,
			getTechnicalVersion: getTechnicalVersion,
			getTypeVersion: getTypeVersion,
			getEnv: getEnv
		};
		return service;

		function load() {
			var deferred = $q.defer();
			$http({
				method: 'get',
				url: 'info'
			}).success(function (data) {
				_info = data;
				$rootScope.info = data;
				deferred.resolve(data);
			}).error(function (data) {
				deferred.reject(data);
			});
			return deferred.promise;
		}

		function getVersion() {
			return _info.build.version;
		}

		function getTechnicalVersion() {
			return _info.build.version;
		}

		function getTypeVersion() {
			return _info.build.buildProfile;
		}

		function getEnv() {
			return _info.app.env;
		}

	}

})();
;
(function() {
    'use strict';

    angular
        .module('formonlineApp', [
            'ngStorage',
            'tmh.dynamicLocale',
            'pascalprecht.translate',
            'ngResource',
            'ngCookies',
            'ngAria',
            'ngCacheBuster',
            'ngFileUpload',
            'ngMessages',
            'ngSanitize',
            'ui.bootstrap',
            'ui.bootstrap.datetimepicker',
            'ui.router',
            'ui.select',
            'toaster',
            'infinite-scroll',
            // jhipster-needle-angularjs-add-module JHipster will add new module here
            'angular-loading-bar',
            'ui.bootstrap.showErrors',
			// app modules (core and co)
			'Core',
			'CoreUtils',
            'vcRecaptcha',
            'ngMask'
        ])
        .run(run);

    run.$inject = ['stateHandler', 'translationHandler', '$http'];

    function run(stateHandler, translationHandler, $http) {
        stateHandler.initialize();
        translationHandler.initialize();
    }
})();
;
(function () {
    'use strict';

    angular
        .module('formonlineApp')
        .factory('User', User);

    User.$inject = ['$resource'];

    function User ($resource) {
        var service = $resource('api/users/:login', {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'save': { method:'POST' },
            'update': { method:'PUT' },
            'delete':{ method:'DELETE'}
        });

        return service;
    }
})();
;
(function () {
    'use strict';

    angular
        .module('formonlineApp')
        .factory('Register', Register);

    Register.$inject = ['$resource'];

    function Register ($resource) {
        return $resource('api/register', {}, {});
    }
})();
;
(function() {
    'use strict';

    angular
        .module('formonlineApp')
        .factory('Principal', Principal);

    Principal.$inject = ['$q', 'Account'];

    function Principal ($q, Account) {
        var _identity,
            _authenticated = false;

        var service = {
            authenticate: authenticate,
            hasAnyAuthority: hasAnyAuthority,
            hasAuthority: hasAuthority,
            identity: identity,
            isAuthenticated: isAuthenticated,
            isIdentityResolved: isIdentityResolved
        };

        return service;

        function authenticate (identity) {
            _identity = identity;
            _authenticated = identity !== null;
        }

        function hasAnyAuthority (authorities) {
            if (!_authenticated || !_identity || !_identity.authorities) {
                return false;
            }

            for (var i = 0; i < authorities.length; i++) {
                if (_identity.authorities.indexOf(authorities[i]) !== -1) {
                    return true;
                }
            }

            return false;
        }

        function hasAuthority (authority) {
            if (!_authenticated) {
                return $q.when(false);
            }

            return this.identity().then(function(_id) {
                return _id.authorities && _id.authorities.indexOf(authority) !== -1;
            }, function(){
                return false;
            });
        }

        function identity (force) {
            var deferred = $q.defer();

            if (force === true) {
                _identity = undefined;
            }

            // check and see if we have retrieved the identity data from the server.
            // if we have, reuse it by immediately resolving
            if (angular.isDefined(_identity)) {
                deferred.resolve(_identity);

                return deferred.promise;
            }

            // retrieve the identity data from the server, update the identity object, and then resolve.
            Account.get().$promise
                .then(getAccountThen)
                .catch(getAccountCatch);

            return deferred.promise;

            function getAccountThen (account) {
                _identity = account.data;
                _authenticated = true;
                deferred.resolve(_identity);
            }

            function getAccountCatch () {
                _identity = null;
                _authenticated = false;
                deferred.resolve(_identity);
            }
        }

        function isAuthenticated () {
            return _authenticated;
        }

        function isIdentityResolved () {
            return angular.isDefined(_identity);
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('formonlineApp')
        .factory('Password', Password);

    Password.$inject = ['$resource'];

    function Password($resource) {
        var service = $resource('api/account/change_password', {}, {});

        return service;
    }
})();
;
(function() {
    'use strict';

    angular
        .module('formonlineApp')
        .factory('PasswordResetInit', PasswordResetInit);

    PasswordResetInit.$inject = ['$resource'];

    function PasswordResetInit($resource) {
        var service = $resource('api/account/reset_password/init', {}, {});

        return service;
    }
})();
;
(function() {
    'use strict';

    angular
        .module('formonlineApp')
        .factory('PasswordResetFinish', PasswordResetFinish);

    PasswordResetFinish.$inject = ['$resource'];

    function PasswordResetFinish($resource) {
        var service = $resource('api/account/reset_password/finish', {}, {});

        return service;
    }
})();
;
(function() {
    'use strict';

    angular
        .module('formonlineApp')
        .directive('hasAuthority', hasAuthority);

    function hasAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authority = attrs.hasAuthority.replace(/\s+/g, '');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {

                    if (reset) {
                        setVisible();
                    }

                    Principal.hasAuthority(authority)
                        .then(function (result) {
                            if (result) {
                                setVisible();
                            } else {
                                setHidden();
                            }
                        });
                };

            if (authority.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('formonlineApp')
        .directive('hasAnyAuthority', hasAnyAuthority);

    function hasAnyAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authorities = attrs.hasAnyAuthority.replace(/\s+/g, '').split(',');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {
                    var result;
                    if (reset) {
                        setVisible();
                    }

                    result = Principal.hasAnyAuthority(authorities);
                    if (result) {
                        setVisible();
                    } else {
                        setHidden();
                    }
                };

            if (authorities.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('formonlineApp')
        .factory('Auth', Auth);

    Auth.$inject = ['$rootScope', '$state', '$sessionStorage', '$q', '$translate', 'Principal', 'AuthServerProvider', 'Account', 'LoginService', 'Register', 'Activate', 'Password', 'PasswordResetInit', 'PasswordResetFinish'];

    function Auth ($rootScope, $state, $sessionStorage, $q, $translate, Principal, AuthServerProvider, Account, LoginService, Register, Activate, Password, PasswordResetInit, PasswordResetFinish) {
        var service = {
            activateAccount: activateAccount,
            authorize: authorize,
            changePassword: changePassword,
            createAccount: createAccount,
            login: login,
            logout: logout,
            loginWithToken: loginWithToken,
            resetPasswordFinish: resetPasswordFinish,
            resetPasswordInit: resetPasswordInit,
            updateAccount: updateAccount
        };

        return service;

        function activateAccount (key, callback) {
            var cb = callback || angular.noop;

            return Activate.get(key,
                function (response) {
                    return cb(response);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function authorize (force) {
            var authReturn = Principal.identity(force).then(authThen);

            return authReturn;

            function authThen () {
                var isAuthenticated = Principal.isAuthenticated();

                // an authenticated user can't access to login and register pages
                if (isAuthenticated && $rootScope.toState.parent === 'account' && ($rootScope.toState.name === 'login' || $rootScope.toState.name === 'register' || $rootScope.toState.name === 'social-auth')) {
                    $state.go('home');
                }

                // recover and clear previousState after external login redirect (e.g. oauth2)
                if (isAuthenticated && !$rootScope.fromState.name && $sessionStorage.previousStateName) {
                    var previousStateName = $sessionStorage.previousStateName;
                    var previousStateParams = $sessionStorage.previousStateParams;
                    delete $sessionStorage.previousStateName;
                    delete $sessionStorage.previousStateParams;
                    $state.go(previousStateName, previousStateParams);
                }

                if ($rootScope.toState.data.authorities && $rootScope.toState.data.authorities.length > 0 && !Principal.hasAnyAuthority($rootScope.toState.data.authorities)) {
                    if (isAuthenticated) {
                        // user is signed in but not authorized for desired state
                        $state.go('accessdenied');
                    }
                    else {
                        // user is not authenticated. stow the state they wanted before you
                        // send them to the login service, so you can return them when you're done
                        $sessionStorage.previousStateName = $rootScope.toState.name;
                        $sessionStorage.previousStateParams = $rootScope.toStateParams;

                        // now, send them to the signin state so they can log in
                        $state.go('accessdenied').then(function() {
                            LoginService.open();
                        });
                    }
                }
            }
        }

        function changePassword (newPassword, callback) {
            var cb = callback || angular.noop;

            return Password.save(newPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function createAccount (account, callback) {
            var cb = callback || angular.noop;

            return Register.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    this.logout();
                    return cb(err);
                }.bind(this)).$promise;
        }

        function login (credentials, callback) {
            var cb = callback || angular.noop;
            var deferred = $q.defer();

            AuthServerProvider.login(credentials)
                .then(loginThen)
                .catch(function (err) {
                    this.logout();
                    deferred.reject(err);
                    return cb(err);
                }.bind(this));

            function loginThen (data) {
                Principal.identity(true).then(function(account) {
                    // After the login the language will be changed to
                    // the language selected by the user during his registration
                    if (account!== null) {
                        $translate.use(account.langKey).then(function () {
                            $translate.refresh();
                        });
                    }
                    deferred.resolve(data);
                });
                return cb();
            }

            return deferred.promise;
        }

        function loginWithToken(jwt, rememberMe) {
            return AuthServerProvider.loginWithToken(jwt, rememberMe);
        }

        function logout () {
            AuthServerProvider.logout();
            Principal.authenticate(null);

            // Reset state memory
            delete $sessionStorage.previousStateName;
            delete $sessionStorage.previousStateParams;
        }

        function resetPasswordFinish (keyAndPassword, callback) {
            var cb = callback || angular.noop;

            return PasswordResetFinish.save(keyAndPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function resetPasswordInit (mail, callback) {
            var cb = callback || angular.noop;

            return PasswordResetInit.save(mail, function() {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function updateAccount (account, callback) {
            var cb = callback || angular.noop;

            return Account.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('formonlineApp')
        .factory('AuthServerProvider', AuthServerProvider);

    AuthServerProvider.$inject = ['$http', '$localStorage', '$sessionStorage', '$q'];

    function AuthServerProvider ($http, $localStorage, $sessionStorage, $q) {
        var service = {
            getToken: getToken,
            hasValidToken: hasValidToken,
            login: login,
            loginWithToken: loginWithToken,
            storeAuthenticationToken: storeAuthenticationToken,
            logout: logout
        };

        return service;

        function getToken () {
            return $localStorage.authenticationToken || $sessionStorage.authenticationToken;
        }

        function hasValidToken () {
            var token = this.getToken();
            return token && token.expires && token.expires > new Date().getTime();
        }

        function login (credentials) {
            var data = {
                username: credentials.username,
                password: credentials.password,
                rememberMe: credentials.rememberMe
            };
            return $http.post('api/authenticate', data).success(authenticateSuccess);

            function authenticateSuccess (data, status, headers) {
                var bearerToken = headers('Authorization');
                if (angular.isDefined(bearerToken) && bearerToken.slice(0, 7) === 'Bearer ') {
                    var jwt = bearerToken.slice(7, bearerToken.length);
                    service.storeAuthenticationToken(jwt, credentials.rememberMe);
                    return jwt;
                }
            }
        }

        function loginWithToken(jwt, rememberMe) {
            var deferred = $q.defer();

            if (angular.isDefined(jwt)) {
                this.storeAuthenticationToken(jwt, rememberMe);
                deferred.resolve(jwt);
            } else {
                deferred.reject();
            }

            return deferred.promise;
        }

        function storeAuthenticationToken(jwt, rememberMe) {
            if(rememberMe){
                $localStorage.authenticationToken = jwt;
            } else {
                $sessionStorage.authenticationToken = jwt;
            }
        }

        function logout () {
            delete $localStorage.authenticationToken;
            delete $sessionStorage.authenticationToken;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('formonlineApp')
        .factory('Activate', Activate);

    Activate.$inject = ['$resource'];

    function Activate ($resource) {
        var service = $resource('api/activate', {}, {
            'get': { method: 'GET', params: {}, isArray: false}
        });

        return service;
    }
})();
;
(function() {
    'use strict';

    angular
        .module('formonlineApp')
        .factory('Account', Account);

    Account.$inject = ['$resource'];

    function Account ($resource) {
        var service = $resource('api/account', {}, {
            'get': { method: 'GET', params: {}, isArray: false,
                interceptor: {
                    response: function(response) {
                        // expose response
                        return response;
                    }
                }
            }
        });

        return service;
    }
})();
;
(function() {
    'use strict';

    angular
        .module('formonlineApp')
        .controller('JhNavbarController', JhNavbarController);

    JhNavbarController.$inject = ['$state', 'Auth', 'Principal', 'ENV', 'LoginService'];

    function JhNavbarController ($state, Auth, Principal, ENV, LoginService) {
        var vm = this;

        vm.isNavbarCollapsed = true;
        vm.isAuthenticated = Principal.isAuthenticated;
        vm.inProduction = ENV === 'prod';
        vm.login = login;
        vm.logout = logout;
        vm.toggleNavbar = toggleNavbar;
        vm.collapseNavbar = collapseNavbar;
        vm.$state = $state;

        function login () {
            collapseNavbar();
            LoginService.open();
        }

        function logout () {
            collapseNavbar();
            Auth.logout();
            $state.go('home');
        }

        function toggleNavbar () {
            vm.isNavbarCollapsed = !vm.isNavbarCollapsed;
        }

        function collapseNavbar () {
            vm.isNavbarCollapsed = true;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('formonlineApp')
        .directive('activeMenu', activeMenu);

    function activeMenu($translate, $locale, tmhDynamicLocale) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var language = attrs.activeMenu;

            scope.$watch(function() {
                return $translate.use();
            }, function(selectedLanguage) {
                if (language === selectedLanguage) {
                    tmhDynamicLocale.set(language);
                    element.addClass('active');
                } else {
                    element.removeClass('active');
                }
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('formonlineApp')
        .directive('activeLink', activeLink);

    function activeLink() {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var clazz = attrs.activeLink;
            var path = attrs.href;
            path = path.substring(1); //hack because path does bot return including hashbang
            scope.location = location;
            scope.$watch('location.path()', function(newPath) {
                if (path === newPath) {
                    element.addClass(clazz);
                } else {
                    element.removeClass(clazz);
                }
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('formonlineApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('error', {
                parent: 'app',
                url: '/error',
                data: {
                    authorities: [],
                    pageTitle: 'error.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'scripts/components/layouts/error/error.html'
                    }
                },
                resolve: {
                    mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        $translatePartialLoader.addPart('error');
                        return $translate.refresh();
                    }]
                }
            })
            .state('accessdenied', {
                parent: 'app',
                url: '/accessdenied',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'scripts/components/layouts/error/accessdenied.html'
                    }
                },
                resolve: {
                    mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        $translatePartialLoader.addPart('error');
                        return $translate.refresh();
                    }]
                }
            });
    }
})();
;
'use strict';

angular.module('formonlineApp')
    .factory('Language', function ($q, $http, $translate, $location, LANGUAGES) {
        return {
			current: function() {
				return $translate.use();
			},
            getCurrent: function () {
                var deferred = $q.defer();
                var language = $translate.storage().get('NG_TRANSLATE_LANG_KEY');

                if (angular.isUndefined(language)) {
					language = 'fr';
                }

				deferred.resolve(language);
                return deferred.promise;
            },
            getAll: function () {
                var deferred = $q.defer();
                deferred.resolve(LANGUAGES);
                return deferred.promise;
            }
        };
    })

/*
 Languages codes are ISO_639-1 codes, see http://en.wikipedia.org/wiki/List_of_ISO_639-1_codes
 They are written in English to avoid character encoding issues (not a perfect solution)
 */
    .constant('LANGUAGES', [
		'fr', 'de'
        //JHipster will add new languages here
    ]
);
;
'use strict';

angular.module('formonlineApp')
    .controller('LanguageController', function ($scope, $translate, Language, tmhDynamicLocale) {
 		$scope.setCurrent = function (language) {
			$scope.language = language;
		};

        $scope.changeLanguage = function (languageKey) {
			$translate.use(languageKey).then($scope.setCurrent);
            tmhDynamicLocale.set(languageKey);
		};

        Language.getAll().then(function (languages) {
            $scope.languages = languages;
		});

		$scope.language = $translate.proposedLanguage();
		if (!$scope.language) {
			$scope.language = $translate.use();
		}

    });
;
(function() {
    'use strict';

    angular
        .module('formonlineApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('home', {
            parent: 'app',
            url: '/home',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'scripts/components/home/home.html',
                    controller: 'HomeController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('formonlineApp')
        .controller('HomeController', HomeController);

    HomeController.$inject = ['$scope', 'Principal', 'LoginService', '$state'];

    function HomeController ($scope, Principal, LoginService, $state) {
        var vm = this;

        vm.account = null;
        vm.isAuthenticated = null;
        vm.login = LoginService.open;
        vm.register = register;
        $scope.$on('authenticationSuccess', function() {
            getAccount();
        });

        getAccount();

        function getAccount() {
            Principal.identity().then(function(account) {
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;
            });
        }
        function register () {
            $state.go('register');
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('formonlineApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('entity', {
            abstract: true,
            parent: 'app'
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('formonlineApp')
        .filter('words', words);

    function words() {
        return wordsFilter;

        function wordsFilter(input, words) {
            if (isNaN(words)) {
                return input;
            }
            if (words <= 0) {
                return '';
            }
            if (input) {
                var inputWords = input.split(/\s+/);
                if (inputWords.length > words) {
                    input = inputWords.slice(0, words).join(' ') + '...';
                }
            }
            
            return input;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('formonlineApp')
        .filter('characters', characters);
        
    function characters () {
        return charactersFilter;

        function charactersFilter(input, chars, breakOnWord) {
            if (isNaN(chars)) {
                return input;
            }
            if (chars <= 0) {
                return '';
            }
            if (input && input.length > chars) {
                input = input.substring(0, chars);

                if (!breakOnWord) {
                    var lastspace = input.lastIndexOf(' ');
                    // Get last space
                    if (lastspace !== -1) {
                        input = input.substr(0, lastspace);
                    }
                } else {
                    while (input.charAt(input.length-1) === ' ') {
                        input = input.substr(0, input.length - 1);
                    }
                }
                return input + '...';
            }
            return input;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('formonlineApp')
        .directive('jhSort', jhSort);

    function jhSort () {
        var directive = {
            restrict: 'A',
            scope: {
                predicate: '=jhSort',
                ascending: '=',
                callback: '&'
            },
            controller: SortController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;
    }

    SortController.$inject = ['$scope', '$element'];

    function SortController ($scope, $element) {
        var vm = this;

        vm.applyClass = applyClass;
        vm.resetClasses = resetClasses;
        vm.sort = sort;
        vm.triggerApply = triggerApply;

        $scope.$watchGroup(['vm.predicate', 'vm.ascending'], vm.triggerApply);
        vm.triggerApply();

        function applyClass (element) {
            var thisIcon = element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt',
                remove = sortIcon + ' ' + sortDesc,
                add = sortAsc;
            if (!vm.ascending) {
                remove = sortIcon + ' ' + sortAsc;
                add = sortDesc;
            }
            vm.resetClasses();
            thisIcon.removeClass(remove);
            thisIcon.addClass(add);
        }

        function resetClasses () {
            var allThIcons = $element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt';
            allThIcons.removeClass(sortAsc + ' ' + sortDesc);
            allThIcons.addClass(sortIcon);
        }

        function sort (field) {
            if (field !== vm.predicate) {
                vm.ascending = true;
            } else {
                vm.ascending = !vm.ascending;
            }
            vm.predicate = field;
            $scope.$apply();
            vm.callback();
        }

        function triggerApply (values)  {
            vm.resetClasses();
            if (values && values[0] !== '_score') {
                vm.applyClass($element.find('th[jh-sort-by=\'' + values[0] + '\']'));
            }
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('formonlineApp')
        .directive('jhSortBy', jhSortBy);

    function jhSortBy() {
        var directive = {
            restrict: 'A',
            scope: false,
            require: '^jhSort',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs, parentCtrl) {
            element.bind('click', function () {
                parentCtrl.sort(attrs.jhSortBy);
            });
        }
    }
})();
;
(function(){
    'use strict';

    angular
        .module('formonlineApp')
        .factory('ParseLinks', ParseLinks);

    function ParseLinks () {

        var service = {
            parse : parse
        };

        return service;

        function parse (header) {
            if (header.length === 0) {
                throw new Error('input must not be of zero length');
            }

            // Split parts by comma
            var parts = header.split(',');
            var links = {};
            // Parse each part into a named link
            angular.forEach(parts, function (p) {
                var section = p.split(';');
                if (section.length !== 2) {
                    throw new Error('section could not be split on ";"');
                }
                var url = section[0].replace(/<(.*)>/, '$1').trim();
                var queryString = {};
                url.replace(
                    new RegExp('([^?=&]+)(=([^&]*))?', 'g'),
                    function($0, $1, $2, $3) { queryString[$1] = $3; }
                );
                var page = queryString.page;
                if( angular.isString(page) ) {
                    page = parseInt(page);
                }
                var name = section[1].replace(/rel="(.*)"/, '$1').trim();
                links[name] = page;
            });

            return links;
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('formonlineApp')
        .factory('PaginationUtil', PaginationUtil);

    function PaginationUtil () {

        var service = {
            parseAscending : parseAscending,
            parsePage : parsePage,
            parsePredicate : parsePredicate
        };

        return service;

        function parseAscending (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                return sort.split(',').slice(-1)[0] === 'asc';
            } else {
                // default to true if no sort defined
                return true;
            }
        }

        // query params are strings, and need to be parsed
        function parsePage (page) {
            return parseInt(page);
        }

        // sort can be in the format `id,asc` or `id`
        function parsePredicate (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                sortArray.pop();
            }
            return sortArray.join(',');
        }
    }
})();
;
(function() {
    'use strict';

    var jhiItemCount = {
        template: '<div class="info">' +
                    'Showing {{(($ctrl.page-1) * 20)==0 ? 1:(($ctrl.page-1) * 20)}} - ' +
                    '{{($ctrl.page * 20) < $ctrl.queryCount ? ($ctrl.page * 20) : $ctrl.queryCount}} ' +
                    'of {{$ctrl.queryCount}} items.' +
                '</div>',
        bindings: {
            page: '<',
            queryCount: '<total'
        }
    };

    angular
        .module('formonlineApp')
        .component('jhiItemCount', jhiItemCount);
})();
;
(function() {
    'use strict';

    angular
        .module('formonlineApp')
        .factory('DateUtils', DateUtils);

    DateUtils.$inject = ['$filter'];

    function DateUtils ($filter) {

        var service = {
            convertDateTimeFromServer : convertDateTimeFromServer,
            convertLocalDateFromServer : convertLocalDateFromServer,
            convertLocalDateToServer : convertLocalDateToServer,
            dateformat : dateformat
        };

        return service;

        function convertDateTimeFromServer (date) {
            if (date) {
                return new Date(date);
            } else {
                return null;
            }
        }

        function convertLocalDateFromServer (date) {
            if (date) {
                var dateString = date.split('-');
                return new Date(dateString[0], dateString[1] - 1, dateString[2]);
            }
            return null;
        }

        function convertLocalDateToServer (date) {
            if (date) {
                return $filter('date')(date, 'yyyy-MM-dd');
            } else {
                return null;
            }
        }

        function dateformat () {
            return 'yyyy-MM-dd';
        }
    }

})();
;
(function() {
    'use strict';

    angular
        .module('formonlineApp')
        .factory('DataUtils', DataUtils);

    DataUtils.$inject = ['$window'];

    function DataUtils ($window) {

        var service = {
            abbreviate: abbreviate,
            byteSize: byteSize,
            openFile: openFile,
            toBase64: toBase64
        };

        return service;

        function abbreviate (text) {
            if (!angular.isString(text)) {
                return '';
            }
            if (text.length < 30) {
                return text;
            }
            return text ? (text.substring(0, 15) + '...' + text.slice(-10)) : '';
        }

        function byteSize (base64String) {
            if (!angular.isString(base64String)) {
                return '';
            }

            function endsWith(suffix, str) {
                return str.indexOf(suffix, str.length - suffix.length) !== -1;
            }

            function paddingSize(base64String) {
                if (endsWith('==', base64String)) {
                    return 2;
                }
                if (endsWith('=', base64String)) {
                    return 1;
                }
                return 0;
            }

            function size(base64String) {
                return base64String.length / 4 * 3 - paddingSize(base64String);
            }

            function formatAsBytes(size) {
                return size.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' bytes';
            }

            return formatAsBytes(size(base64String));
        }

        function openFile (type, data) {
            $window.open('data:' + type + ';base64,' + data, '_blank', 'height=300,width=400');
        }

        function toBase64 (file, cb) {
            var fileReader = new FileReader();
            fileReader.readAsDataURL(file);
            fileReader.onload = function (e) {
                var base64Data = e.target.result.substr(e.target.result.indexOf('base64,') + 'base64,'.length);
                cb(base64Data);
            };
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('formonlineApp')
        .filter('capitalize', capitalize);

    function capitalize() {
        return capitalizeFilter;

        function capitalizeFilter (input) {
            if (input !== null) {
                input = input.toLowerCase();
            }
            return input.substring(0, 1).toUpperCase() + input.substring(1);
        }
    }
})();
;
(function() {
    /*jshint bitwise: false*/
    'use strict';

    angular
        .module('formonlineApp')
        .factory('Base64', Base64);

    function Base64 () {
        var keyStr = 'ABCDEFGHIJKLMNOP' +
            'QRSTUVWXYZabcdef' +
            'ghijklmnopqrstuv' +
            'wxyz0123456789+/' +
            '=';

        var service = {
            decode : decode,
            encode : encode
        };

        return service;

        function encode (input) {
            var output = '',
                chr1, chr2, chr3 = '',
                enc1, enc2, enc3, enc4 = '',
                i = 0;

            while (i < input.length) {
                chr1 = input.charCodeAt(i++);
                chr2 = input.charCodeAt(i++);
                chr3 = input.charCodeAt(i++);

                enc1 = chr1 >> 2;
                enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
                enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
                enc4 = chr3 & 63;

                if (isNaN(chr2)) {
                    enc3 = enc4 = 64;
                } else if (isNaN(chr3)) {
                    enc4 = 64;
                }

                output = output +
                    keyStr.charAt(enc1) +
                    keyStr.charAt(enc2) +
                    keyStr.charAt(enc3) +
                    keyStr.charAt(enc4);
                chr1 = chr2 = chr3 = '';
                enc1 = enc2 = enc3 = enc4 = '';
            }

            return output;
        }

        function decode (input) {
            var output = '',
                chr1, chr2, chr3 = '',
                enc1, enc2, enc3, enc4 = '',
                i = 0;

            // remove all characters that are not A-Z, a-z, 0-9, +, /, or =
            input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');

            while (i < input.length) {
                enc1 = keyStr.indexOf(input.charAt(i++));
                enc2 = keyStr.indexOf(input.charAt(i++));
                enc3 = keyStr.indexOf(input.charAt(i++));
                enc4 = keyStr.indexOf(input.charAt(i++));

                chr1 = (enc1 << 2) | (enc2 >> 4);
                chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
                chr3 = ((enc3 & 3) << 6) | enc4;

                output = output + String.fromCharCode(chr1);

                if (enc3 !== 64) {
                    output = output + String.fromCharCode(chr2);
                }
                if (enc4 !== 64) {
                    output = output + String.fromCharCode(chr3);
                }

                chr1 = chr2 = chr3 = '';
                enc1 = enc2 = enc3 = enc4 = '';
            }
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('formonlineApp')
        .factory('LoginService', LoginService);

    LoginService.$inject = ['$uibModal'];

    function LoginService ($uibModal) {
        var service = {
            open: open
        };

        var modalInstance = null;
        var resetModal = function () {
            modalInstance = null;
        };

        return service;

        function open () {
            if (modalInstance !== null) return;
            modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'scripts/components/components/login/login.html',
                controller: 'LoginController',
                controllerAs: 'vm',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('login');
                        return $translate.refresh();
                    }]
                }
            });
            modalInstance.result.then(
                resetModal,
                resetModal
            );
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('formonlineApp')
        .controller('LoginController', LoginController);

    LoginController.$inject = ['$rootScope', '$state', '$sessionStorage', '$timeout', 'Auth', '$uibModalInstance'];

    function LoginController ($rootScope, $state, $sessionStorage, $timeout, Auth, $uibModalInstance) {
        var vm = this;

        vm.authenticationError = false;
        vm.cancel = cancel;
        vm.credentials = {};
        vm.login = login;
        vm.password = null;
        vm.register = register;
        vm.rememberMe = true;
        vm.requestResetPassword = requestResetPassword;
        vm.username = null;

        $timeout(function (){angular.element('#username').focus();});

        function cancel () {
            vm.credentials = {
                username: null,
                password: null,
                rememberMe: true
            };
            vm.authenticationError = false;
            $uibModalInstance.dismiss('cancel');
        }

        function login (event) {
            event.preventDefault();
            Auth.login({
                username: vm.username,
                password: vm.password,
                rememberMe: vm.rememberMe
            }).then(function () {
                vm.authenticationError = false;
                $uibModalInstance.close();
                if ($state.current.name === 'register' || $state.current.name === 'activate' ||
                    $state.current.name === 'finishReset' || $state.current.name === 'requestReset') {
                    $state.go('home');
                }

                $rootScope.$broadcast('authenticationSuccess');

                // previousState was set in the authExpiredInterceptor before being redirected to login modal.
                // since login is succesful, go to stored previousState and clear previousState
                if ($sessionStorage.previousStateName) {
                    var previousStateName = $sessionStorage.previousStateName;
                    var previousStateParams = $sessionStorage.previousStateParams;
                    delete $sessionStorage.previousStateName;
                    delete $sessionStorage.previousStateParams;
                    $state.go(previousStateName, previousStateParams);
                }
            }).catch(function () {
                vm.authenticationError = true;
            });
        }

        function register () {
            $uibModalInstance.dismiss('cancel');
            $state.go('register');
        }

        function requestResetPassword () {
            $uibModalInstance.dismiss('cancel');
            $state.go('requestReset');
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('formonlineApp')
        .factory('JhiLanguageService', JhiLanguageService);

    JhiLanguageService.$inject = ['$q', '$http', '$translate', 'LANGUAGES'];

    function JhiLanguageService ($q, $http, $translate, LANGUAGES) {
        var service = {
            getAll: getAll,
            getCurrent: getCurrent
        };

        return service;

        function getAll () {
            var deferred = $q.defer();
            deferred.resolve(LANGUAGES);
            return deferred.promise;
        }

        function getCurrent () {
            var deferred = $q.defer();
            var language = $translate.storage().get('NG_TRANSLATE_LANG_KEY');

            deferred.resolve(language);

            return deferred.promise;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('formonlineApp')
        .filter('findLanguageFromKey', findLanguageFromKey);

    function findLanguageFromKey() {
        return findLanguageFromKeyFilter;

        function findLanguageFromKeyFilter(lang) {
            return {
                'ca': 'Català',
                'cs': 'Český',
                'da': 'Dansk',
                'de': 'Deutsch',
                'el': 'Ελληνικά',
                'en': 'English',
                'es': 'Español',
                'fr': 'Français',
                'gl': 'Galego',
                'hu': 'Magyar',
                'hi': 'हिंदी',
                'it': 'Italiano',
                'ja': '日本語',
                'ko': '한국어',
                'mr': 'मराठी',
                'nl': 'Nederlands',
                'pl': 'Polski',
                'pt-br': 'Português (Brasil)',
                'pt-pt': 'Português',
                'ro': 'Română',
                'ru': 'Русский',
                'sk': 'Slovenský',
                'sv': 'Svenska',
                'ta': 'தமிழ்',
                'tr': 'Türkçe',
                'zh-cn': '中文（简体）',
                'zh-tw': '繁體中文'
            }[lang];
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('formonlineApp')
        .controller('JhiLanguageController', JhiLanguageController);

    JhiLanguageController.$inject = ['$translate', 'JhiLanguageService', 'tmhDynamicLocale'];

    function JhiLanguageController ($translate, JhiLanguageService, tmhDynamicLocale) {
        var vm = this;

        vm.changeLanguage = changeLanguage;
        vm.languages = null;

        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });

        function changeLanguage (languageKey) {
            $translate.use(languageKey);
            tmhDynamicLocale.set(languageKey);
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('formonlineApp')

        /*
         Languages codes are ISO_639-1 codes, see http://en.wikipedia.org/wiki/List_of_ISO_639-1_codes
         They are written in English to avoid character encoding issues (not a perfect solution)
         */
        .constant('LANGUAGES', [
            'fr',
            'de'
            // jhipster-needle-i18n-language-constant - JHipster will add/remove languages in this array
        ]
    );
})();
;
(function() {
    'use strict';

    angular
        .module('formonlineApp')
        .config(paginationConfig);

    function paginationConfig(uibPaginationConfig, paginationConstants) {
        uibPaginationConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPaginationConfig.maxSize = 5;
        uibPaginationConfig.boundaryLinks = true;
        uibPaginationConfig.firstText = '«';
        uibPaginationConfig.previousText = '‹';
        uibPaginationConfig.nextText = '›';
        uibPaginationConfig.lastText = '»';
    }
})();
;
(function () {
    'use strict';

    angular
        .module('formonlineApp')
        .config(pagerConfig);

    function pagerConfig(uibPagerConfig, paginationConstants) {
        uibPagerConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPagerConfig.previousText = '«';
        uibPagerConfig.nextText = '»';
    }
})();
;
(function() {
    'use strict';

    angular
        .module('formonlineApp')
        .directive('showValidation', showValidation);

    function showValidation () {
        var directive = {
            restrict: 'A',
            require: 'form',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element) {
            element.find('.form-group').each(function() {
                var $formGroup = angular.element(this);
                var $inputs = $formGroup.find('input[ng-model],textarea[ng-model],select[ng-model]');

                if ($inputs.length > 0) {
                    $inputs.each(function() {
                        var $input = angular.element(this);
                        scope.$watch(function() {
                            return $input.hasClass('ng-invalid') && $input.hasClass('ng-dirty');
                        }, function(isInvalid) {
                            $formGroup.toggleClass('has-error', isInvalid);
                        });
                    });
                }
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('formonlineApp')
        .constant('paginationConstants', {
            'itemsPerPage': 20
        });
})();
;
(function() {
    'use strict';

    angular
        .module('formonlineApp')
        .directive('minbytes', minbytes);

    function minbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.minbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) >= attrs.minbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('formonlineApp')
        .directive('maxbytes', maxbytes);

    function maxbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.maxbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) <= attrs.maxbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }

})();
;
(function() {
    'use strict';

    angular
        .module('formonlineApp')
        .provider('AlertService', AlertService);

    function AlertService () {
        this.toast = false;
        /*jshint validthis: true */
        this.$get = getService;

        this.showAsToast = function(isToast) {
            this.toast = isToast;
        };

        getService.$inject = ['$timeout', '$sce', '$translate'];

        function getService ($timeout, $sce,$translate) {
            var toast = this.toast,
                alertId = 0, // unique id for each alert. Starts from 0.
                alerts = [],
                timeout = 5000; // default timeout

            return {
                factory: factory,
                isToast: isToast,
                add: addAlert,
                closeAlert: closeAlert,
                closeAlertByIndex: closeAlertByIndex,
                clear: clear,
                get: get,
                success: success,
                error: error,
                info: info,
                warning : warning
            };

            function isToast() {
                return toast;
            }

            function clear() {
                alerts = [];
            }

            function get() {
                return alerts;
            }

            function success(msg, params, position) {
                return this.add({
                    type: 'success',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function error(msg, params, position) {
                return this.add({
                    type: 'danger',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function warning(msg, params, position) {
                return this.add({
                    type: 'warning',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function info(msg, params, position) {
                return this.add({
                    type: 'info',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function factory(alertOptions) {
                var alert = {
                    type: alertOptions.type,
                    msg: $sce.trustAsHtml(alertOptions.msg),
                    id: alertOptions.alertId,
                    timeout: alertOptions.timeout,
                    toast: alertOptions.toast,
                    position: alertOptions.position ? alertOptions.position : 'top right',
                    scoped: alertOptions.scoped,
                    close: function (alerts) {
                        return closeAlert(this.id, alerts);
                    }
                };
                if(!alert.scoped) {
                    alerts.push(alert);
                }
                return alert;
            }

            function addAlert(alertOptions, extAlerts) {
                alertOptions.alertId = alertId++;
                alertOptions.msg = $translate.instant(alertOptions.msg, alertOptions.params);
                var that = this;
                var alert = this.factory(alertOptions);
                if (alertOptions.timeout && alertOptions.timeout > 0) {
                    $timeout(function () {
                        that.closeAlert(alertOptions.alertId, extAlerts);
                    }, alertOptions.timeout);
                }
                return alert;
            }

            function closeAlert(id, extAlerts) {
                var thisAlerts = extAlerts ? extAlerts : alerts;
                return closeAlertByIndex(thisAlerts.map(function(e) { return e.id; }).indexOf(id), thisAlerts);
            }

            function closeAlertByIndex(index, thisAlerts) {
                return thisAlerts.splice(index, 1);
            }
        }
    }
})();
;
(function() {
    'use strict';

    var jhiAlert = {
        template: '<div class="alerts" ng-cloak="">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre>{{ alert.msg }}</pre></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertController
    };

    angular
        .module('formonlineApp')
        .component('jhiAlert', jhiAlert);

    jhiAlertController.$inject = ['$scope', 'AlertService'];

    function jhiAlertController($scope, AlertService) {
        var vm = this;

        vm.alerts = AlertService.get();
        $scope.$on('$destroy', function () {
            vm.alerts = [];
        });
    }
})();
;
(function() {
    'use strict';

    var jhiAlertError = {
        template: '<div class="alerts" ng-cloak="">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre>{{ alert.msg }}</pre></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertErrorController
    };
    
    angular
        .module('formonlineApp')
        .component('jhiAlertError', jhiAlertError);

    jhiAlertErrorController.$inject = ['$scope', 'AlertService', '$rootScope', '$translate'];

    function jhiAlertErrorController ($scope, AlertService, $rootScope, $translate) {
        var vm = this;

        vm.alerts = [];

        function addErrorAlert (message, key, data) {
            key = key && key !== null ? key : message;
            vm.alerts.push(
                AlertService.add(
                    {
                        type: 'danger',
                        msg: key,
                        params: data,
                        timeout: 5000,
                        toast: AlertService.isToast(),
                        scoped: true
                    },
                    vm.alerts
                )
            );
        }

        var cleanHttpErrorListener = $rootScope.$on('formonlineApp.httpError', function (event, httpResponse) {
            var i;
            event.stopPropagation();
            switch (httpResponse.status) {
            // connection refused, server not reachable
            case 0:
                addErrorAlert('Server not reachable','error.server.not.reachable');
                break;

            case 400:
                var errorHeader = httpResponse.headers('X-formonlineApp-error');
                var entityKey = httpResponse.headers('X-formonlineApp-params');
                if (errorHeader) {
                    var entityName = $translate.instant('global.menu.entities.' + entityKey);
                    addErrorAlert(errorHeader, errorHeader, {entityName: entityName});
                } else if (httpResponse.data && httpResponse.data.fieldErrors) {
                    for (i = 0; i < httpResponse.data.fieldErrors.length; i++) {
                        var fieldError = httpResponse.data.fieldErrors[i];
                        // convert 'something[14].other[4].id' to 'something[].other[].id' so translations can be written to it
                        var convertedField = fieldError.field.replace(/\[\d*\]/g, '[]');
                        var fieldName = $translate.instant('formonlineApp.' + fieldError.objectName + '.' + convertedField);
                        addErrorAlert('Field ' + fieldName + ' cannot be empty', 'error.' + fieldError.message, {fieldName: fieldName});
                    }
                } else if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message, httpResponse.data.message, httpResponse.data);
                } else {
                    addErrorAlert(httpResponse.data);
                }
                break;

            default:
                if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message);
                } else {
                    addErrorAlert(angular.toJson(httpResponse));
                }
            }
        });

        $scope.$on('$destroy', function () {
            if(angular.isDefined(cleanHttpErrorListener) && cleanHttpErrorListener !== null){
                cleanHttpErrorListener();
                vm.alerts = [];
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('formonlineApp')
        .factory('notificationInterceptor', notificationInterceptor);

    notificationInterceptor.$inject = ['$q', '$injector', '$log'];

    function notificationInterceptor ($q, $injector, $log) {
        var service = {
            response: response
        };

        return service;

        function response (response) {
            var alertService = $injector.get('AlertService');
            var alertKey = response.headers('X-formonlineApp-alert');
            if (angular.isString(alertKey)) {
                if (alertService) {
                    alertService.success(alertKey, { param : response.headers('X-formonlineApp-params')});
                } else {
                    $log.error('Could not get \'AlertService\'!');
                }
            }
            return response;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('formonlineApp')
        .factory('errorHandlerInterceptor', errorHandlerInterceptor);

    errorHandlerInterceptor.$inject = ['$q', '$rootScope'];

    function errorHandlerInterceptor ($q, $rootScope) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError (response) {
            if (!(response.status === 401 && (response.data === '' || (response.data.path && response.data.path.indexOf('/api/account') === 0 )))) {
                $rootScope.$emit('formonlineApp.httpError', response);
            }
            return $q.reject(response);
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('formonlineApp')
        .factory('authInterceptor', authInterceptor);

    authInterceptor.$inject = ['$rootScope', '$q', '$location', '$localStorage', '$sessionStorage'];

    function authInterceptor ($rootScope, $q, $location, $localStorage, $sessionStorage) {
        var service = {
            request: request
        };

        return service;

        function request (config) {
            /*jshint camelcase: false */
            config.headers = config.headers || {};
            var token = $localStorage.authenticationToken || $sessionStorage.authenticationToken;
            
            if (token) {
                config.headers.Authorization = 'Bearer ' + token;
            }
            
            return config;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('formonlineApp')
        .factory('authExpiredInterceptor', authExpiredInterceptor);

    
    authExpiredInterceptor.$inject = ['$rootScope', '$q', '$injector', '$localStorage', '$sessionStorage'];

    function authExpiredInterceptor($rootScope, $q, $injector, $localStorage, $sessionStorage) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError(response) {
            if (response.status === 401) {
                delete $localStorage.authenticationToken;
                delete $sessionStorage.authenticationToken;
                var Principal = $injector.get('Principal');
                if (Principal.isAuthenticated()) {
                    var Auth = $injector.get('Auth');
                    Auth.authorize(true);
                }
            }
            return $q.reject(response);
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('formonlineApp')
        .factory('translationHandler', translationHandler);

    translationHandler.$inject = ['$rootScope', '$window', '$state', '$translate'];

    function translationHandler($rootScope, $window, $state, $translate) {
        return {
            initialize: initialize,
            updateTitle: updateTitle
        };

        function initialize() {
            // if the current translation changes, update the window title
            var translateChangeSuccess = $rootScope.$on('$translateChangeSuccess', function() {
                updateTitle();
            });

            $rootScope.$on('$destroy', function () {
                if(angular.isDefined(translateChangeSuccess) && translateChangeSuccess !== null){
                    translateChangeSuccess();
                }
            });
        }

        // update the window title using params in the following
        // precendence
        // 1. titleKey parameter
        // 2. $state.$current.data.pageTitle (current state page title)
        // 3. 'global.title'
        function updateTitle(titleKey) {
            if (!titleKey && $state.$current.data && $state.$current.data.pageTitle) {
                titleKey = $state.$current.data.pageTitle;
            }
            $translate(titleKey || 'global.title').then(function (title) {
                $window.document.title = title;
            });
        }
    }
})();
;
(function () {
	'use strict';

	angular
			.module('formonlineApp')
			.factory('stateHandler', stateHandler);

	stateHandler.$inject = ['$rootScope', '$state', '$sessionStorage', '$translate', 'JhiLanguageService', 'translationHandler', '$window',
		'Auth', 'Principal', 'ENV', 'VERSION', '$log'];

	function stateHandler($rootScope, $state, $sessionStorage, $translate, JhiLanguageService, translationHandler, $window,
			Auth, Principal, ENV, VERSION, $log) {
		$rootScope.$state = $state;
		return {
			initialize: initialize
		};

		function initialize() {
			$rootScope.ENV = ENV;
			$rootScope.VERSION = VERSION;

			var stateChangeStart = $rootScope.$on('$stateChangeStart', function (event, toState, toStateParams, fromState) {
				$rootScope.toState = toState;
				$rootScope.toStateParams = toStateParams;
				$rootScope.fromState = fromState;

				// Redirect to a state with an external URL (http://stackoverflow.com/a/30221248/1098564)
				if (toState.external) {
					event.preventDefault();
					$window.open(toState.url, '_self');
				}

				/*
				if (Principal.isIdentityResolved()) {
					Auth.authorize();
				}
				*/

				// Update the language
				JhiLanguageService.getCurrent().then(function (language) {
					$translate.use(language);
				});

			});

			var stateChangeSuccess = $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
				var titleKey = 'global.title';

				// Set the page title key to the one configured in state or use default one
				if (toState.data.pageTitle) {
					titleKey = toState.data.pageTitle;
				}
				translationHandler.updateTitle(titleKey);
			});

			$rootScope.$on('$destroy', function () {
				if (angular.isDefined(stateChangeStart) && stateChangeStart !== null) {
					stateChangeStart();
				}
				if (angular.isDefined(stateChangeSuccess) && stateChangeSuccess !== null) {
					stateChangeSuccess();
				}
			});
		}
	}
})();
;
(function() {
    'use strict';

    angular
        .module('formonlineApp')
        .config(translationConfig);

    translationConfig.$inject = ['$translateProvider', 'tmhDynamicLocaleProvider'];

    function translationConfig($translateProvider, tmhDynamicLocaleProvider) {
        // Initialize angular-translate
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: 'i18n/{lang}/{part}.json'
        });

        $translateProvider.preferredLanguage('en');
        $translateProvider.useStorage('translationStorageProvider');
        $translateProvider.useSanitizeValueStrategy('escaped');
        $translateProvider.addInterpolation('$translateMessageFormatInterpolation');

        tmhDynamicLocaleProvider.localeLocationPattern('i18n/angular-locale_{{locale}}.js');
        tmhDynamicLocaleProvider.useCookieStorage();
        tmhDynamicLocaleProvider.storageKey('NG_TRANSLATE_LANG_KEY');
    }
})();
;
(function() {
    'use strict';

    angular
        .module('formonlineApp')
        .factory('translationStorageProvider', translationStorageProvider);

    translationStorageProvider.$inject = ['$cookies', '$log', 'LANGUAGES'];

    function translationStorageProvider($cookies, $log, LANGUAGES) {
        return {
            get: get,
            put: put
        };

        function get(name) {
            if (LANGUAGES.indexOf($cookies.getObject(name)) === -1) {
                $log.info('Resetting invalid cookie language "' + $cookies.getObject(name) + '" to prefered language "en"');
                $cookies.putObject(name, 'en');
            }
            return $cookies.getObject(name);
        }

        function put(name, value) {
            $cookies.putObject(name, value);
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('formonlineApp')
        .config(localStorageConfig);

    localStorageConfig.$inject = ['$localStorageProvider'];

    function localStorageConfig($localStorageProvider) {
        $localStorageProvider.setKeyPrefix('jhi-');
    }
})();
;
(function() {
    'use strict';

    angular
        .module('formonlineApp')
        .config(httpConfig);

    httpConfig.$inject = ['$urlRouterProvider', '$httpProvider', 'httpRequestInterceptorCacheBusterProvider', '$urlMatcherFactoryProvider'];

    function httpConfig($urlRouterProvider, $httpProvider, httpRequestInterceptorCacheBusterProvider, $urlMatcherFactoryProvider) {
        
        //Cache everything except rest api requests
        httpRequestInterceptorCacheBusterProvider.setMatchlist([/.*api.*/, /.*protected.*/], true);

        $urlRouterProvider.otherwise('/');

        $httpProvider.interceptors.push('errorHandlerInterceptor');
        $httpProvider.interceptors.push('authExpiredInterceptor');
        $httpProvider.interceptors.push('authInterceptor');
        $httpProvider.interceptors.push('notificationInterceptor');
        // jhipster-needle-angularjs-add-interceptor JHipster will add new application http interceptor here

        $urlMatcherFactoryProvider.type('boolean', {
            name : 'boolean',
            decode: function(val) { return val === true || val === 'true'; },
            encode: function(val) { return val ? 1 : 0; },
            equals: function(a, b) { return this.is(a) && a === b; },
            is: function(val) { return [true,false,0,1].indexOf(val) >= 0; },
            pattern: /bool|true|0|1/
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('formonlineApp')
        .config(compileServiceConfig);

    compileServiceConfig.$inject = ['$compileProvider', 'ENV'];

    function compileServiceConfig($compileProvider, ENV) {
        // disable debug data on prod profile to improve performance
        if(ENV === 'prod'){
            $compileProvider.debugInfoEnabled(false);
        }

        /*
        If you wish to debug an application with this information
        then you should open up a debug console in the browser
        then call this method directly in this console:

		angular.reloadWithDebugInfo();
		*/
    }
})();
;
(function() {
    'use strict';

    angular
        .module('formonlineApp')
        .config(alertServiceConfig);

    alertServiceConfig.$inject = ['AlertServiceProvider'];

    function alertServiceConfig(AlertServiceProvider) {
        // set below to true to make alerts look like toast
        AlertServiceProvider.showAsToast(false);
    }
})();
;
(function() {
    'use strict';

    angular
        .module('formonlineApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('user-management', {
            parent: 'admin',
            url: '/user-management',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'user-management.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'scripts/components/admin/user-management/user-management.html',
                    controller: 'UserManagementController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('user-management');
                    return $translate.refresh();
                }]
            }
        })
        .state('user-management-detail', {
            parent: 'admin',
            url: '/user/:login',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'user-management.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'scripts/components/admin/user-management/user-management-detail.html',
                    controller: 'UserManagementDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('user-management');
                    return $translate.refresh();
                }]
            }
        })
        .state('user-management.new', {
            parent: 'user-management',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'scripts/components/admin/user-management/user-management-dialog.html',
                    controller: 'UserManagementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                id: null, login: null, firstName: null, lastName: null, email: null,
                                activated: true, langKey: null, createdBy: null, createdDate: null,
                                lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
                                resetKey: null, authorities: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('user-management');
                });
            }]
        })
        .state('user-management.edit', {
            parent: 'user-management',
            url: '/{login}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'scripts/components/admin/user-management/user-management-dialog.html',
                    controller: 'UserManagementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['User', function(User) {
                            return User.get({login : $stateParams.login});
                        }]
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('user-management.delete', {
            parent: 'user-management',
            url: '/{login}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'scripts/components/admin/user-management/user-management-delete-dialog.html',
                    controller: 'UserManagementDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['User', function(User) {
                            return User.get({login : $stateParams.login});
                        }]
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }
})();
;
(function () {
	'use strict';

	angular
		.module('formonlineApp')
		.controller('UserManagementController', UserManagementController);

	UserManagementController.$inject = ['Principal', 'User', 'ParseLinks', 'paginationConstants', 'JhiLanguageService'];

	function UserManagementController(Principal, User, ParseLinks, paginationConstants, JhiLanguageService) {
		var vm = this;

		vm.authorities = ['ROLE_USER', 'ROLE_ADMIN'];
		vm.clear = clear;
		vm.currentAccount = null;
		vm.languages = null;
		vm.links = null;
		vm.loadAll = loadAll;
		vm.loadPage = loadPage;
		vm.page = 1;
		vm.setActive = setActive;
		vm.totalItems = null;
		vm.users = [];


		vm.loadAll();


		JhiLanguageService.getAll().then(function (languages) {
			vm.languages = languages;
		});

		Principal.identity().then(function (account) {
			vm.currentAccount = account;
		});


		function loadAll() {
			User.query({page: vm.page - 1, size: paginationConstants.itemsPerPage}, function (result, headers) {
				vm.links = ParseLinks.parse(headers('link'));
				vm.totalItems = headers('X-Total-Count');
				vm.users = result;
			});
		}

		function loadPage(page) {
			vm.page = page;
			vm.loadAll();
		}

		function setActive(user, isActivated) {
			user.activated = isActivated;
			User.update(user, function () {
				vm.loadAll();
				vm.clear();
			});
		}

		function clear() {
			vm.user = {
				id: null, login: null, firstName: null, lastName: null, email: null,
				activated: null, langKey: null, createdBy: null, createdDate: null,
				lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
				resetKey: null, authorities: null
			};
			vm.editForm.$setPristine();
			vm.editForm.$setUntouched();
		}
	}
})();
;
(function() {
    'use strict';

    angular
        .module('formonlineApp')
        .controller('UserManagementDialogController',UserManagementDialogController);

    UserManagementDialogController.$inject = ['$stateParams', '$uibModalInstance', 'entity', 'User', 'JhiLanguageService'];

    function UserManagementDialogController ($stateParams, $uibModalInstance, entity, User, JhiLanguageService) {
        var vm = this;

        vm.authorities = ['ROLE_USER', 'ROLE_ADMIN'];
        vm.clear = clear;
        vm.languages = null;
        vm.save = save;
        vm.user = entity;


        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function onSaveSuccess (result) {
            vm.isSaving = false;
            $uibModalInstance.close(result);
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function save () {
            vm.isSaving = true;
            if (vm.user.id !== null) {
                User.update(vm.user, onSaveSuccess, onSaveError);
            } else {
                User.save(vm.user, onSaveSuccess, onSaveError);
            }
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('formonlineApp')
        .controller('UserManagementDetailController', UserManagementDetailController);

    UserManagementDetailController.$inject = ['$stateParams', 'User'];

    function UserManagementDetailController ($stateParams, User) {
        var vm = this;

        vm.load = load;
        vm.user = {};

        vm.load($stateParams.login);

        function load (login) {
            User.get({login: login}, function(result) {
                vm.user = result;
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('formonlineApp')
        .controller('UserManagementDeleteController', UserManagementDeleteController);

    UserManagementDeleteController.$inject = ['$uibModalInstance', 'entity', 'User'];

    function UserManagementDeleteController ($uibModalInstance, entity, User) {
        var vm = this;

        vm.user = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (login) {
            User.delete({login: login},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('formonlineApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-metrics', {
            parent: 'admin',
            url: '/metrics',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'metrics.title'
            },
            views: {
                'content@': {
                    templateUrl: 'scripts/components/admin/metrics/metrics.html',
                    controller: 'JhiMetricsMonitoringController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('metrics');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('formonlineApp')
        .factory('JhiMetricsService', JhiMetricsService);

    JhiMetricsService.$inject = ['$rootScope', '$http'];

    function JhiMetricsService ($rootScope, $http) {
        var service = {
            getMetrics: getMetrics,
            threadDump: threadDump
        };

        return service;

        function getMetrics () {
            return $http.get('metrics/metrics').then(function (response) {
                return response.data;
            });
        }

        function threadDump () {
            return $http.get('dump').then(function (response) {
                return response.data;
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('formonlineApp')
        .controller('JhiMetricsMonitoringModalController', JhiMetricsMonitoringModalController);

    JhiMetricsMonitoringModalController.$inject = ['$uibModalInstance', 'threadDump'];

    function JhiMetricsMonitoringModalController ($uibModalInstance, threadDump) {
        var vm = this;

        vm.cancel = cancel;
        vm.getLabelClass = getLabelClass;
        vm.threadDump = threadDump;
        vm.threadDumpAll = 0;
        vm.threadDumpBlocked = 0;
        vm.threadDumpRunnable = 0;
        vm.threadDumpTimedWaiting = 0;
        vm.threadDumpWaiting = 0;

        angular.forEach(threadDump, function(value) {
            if (value.threadState === 'RUNNABLE') {
                vm.threadDumpRunnable += 1;
            } else if (value.threadState === 'WAITING') {
                vm.threadDumpWaiting += 1;
            } else if (value.threadState === 'TIMED_WAITING') {
                vm.threadDumpTimedWaiting += 1;
            } else if (value.threadState === 'BLOCKED') {
                vm.threadDumpBlocked += 1;
            }
        });

        vm.threadDumpAll = vm.threadDumpRunnable + vm.threadDumpWaiting +
            vm.threadDumpTimedWaiting + vm.threadDumpBlocked;

        function cancel () {
            $uibModalInstance.dismiss('cancel');
        }

        function getLabelClass (threadState) {
            if (threadState === 'RUNNABLE') {
                return 'label-success';
            } else if (threadState === 'WAITING') {
                return 'label-info';
            } else if (threadState === 'TIMED_WAITING') {
                return 'label-warning';
            } else if (threadState === 'BLOCKED') {
                return 'label-danger';
            }
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('formonlineApp')
        .controller('JhiMetricsMonitoringController', JhiMetricsMonitoringController);

    JhiMetricsMonitoringController.$inject = ['$scope','JhiMetricsService', '$uibModal'];

    function JhiMetricsMonitoringController ($scope, JhiMetricsService, $uibModal) {
        var vm = this;

        vm.cachesStats = {};
        vm.metrics = {};
        vm.refresh = refresh;
        vm.refreshThreadDumpData = refreshThreadDumpData;
        vm.servicesStats = {};
        vm.updatingMetrics = true;

        vm.refresh();

        $scope.$watch('vm.metrics', function (newValue) {
            vm.servicesStats = {};
            vm.cachesStats = {};
            angular.forEach(newValue.timers, function (value, key) {
                if (key.indexOf('web.rest') !== -1 || key.indexOf('service') !== -1) {
                    vm.servicesStats[key] = value;
                }
                if (key.indexOf('net.sf.ehcache.Cache') !== -1) {
                    // remove gets or puts
                    var index = key.lastIndexOf('.');
                    var newKey = key.substr(0, index);

                    // Keep the name of the domain
                    index = newKey.lastIndexOf('.');
                    vm.cachesStats[newKey] = {
                        'name': newKey.substr(index + 1),
                        'value': value
                    };
                }
            });
        });

        function refresh () {
            vm.updatingMetrics = true;
            JhiMetricsService.getMetrics().then(function (promise) {
                vm.metrics = promise;
                vm.updatingMetrics = false;
            }, function (promise) {
                vm.metrics = promise.data;
                vm.updatingMetrics = false;
            });
        }

        function refreshThreadDumpData () {
            JhiMetricsService.threadDump().then(function(data) {
                $uibModal.open({
                    templateUrl: 'scripts/components/admin/metrics/metrics.modal.html',
                    controller: 'JhiMetricsMonitoringModalController',
                    controllerAs: 'vm',
                    size: 'lg',
                    resolve: {
                        threadDump: function() {
                            return data;
                        }

                    }
                });
            });
        }


    }
})();
;
(function() {
    'use strict';

    angular
        .module('formonlineApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('logs', {
            parent: 'admin',
            url: '/logs',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'logs.title'
            },
            views: {
                'content@': {
                    templateUrl: 'scripts/components/admin/logs/logs.html',
                    controller: 'LogsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('logs');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('formonlineApp')
        .factory('LogsService', LogsService);

    LogsService.$inject = ['$resource'];

    function LogsService ($resource) {
        var service = $resource('api/logs', {}, {
            'findAll': { method: 'GET', isArray: true},
            'changeLevel': { method: 'PUT'}
        });

        return service;
    }
})();
;
(function() {
    'use strict';

    angular
        .module('formonlineApp')
        .controller('LogsController', LogsController);

    LogsController.$inject = ['LogsService'];

    function LogsController (LogsService) {
        var vm = this;

        vm.changeLevel = changeLevel;
        vm.loggers = LogsService.findAll();

        function changeLevel (name, level) {
            LogsService.changeLevel({name: name, level: level}, function () {
                vm.loggers = LogsService.findAll();
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('formonlineApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-health', {
            parent: 'admin',
            url: '/health',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'health.title'
            },
            views: {
                'content@': {
                    templateUrl: 'scripts/components/admin/health/health.html',
                    controller: 'JhiHealthCheckController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('health');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('formonlineApp')
        .factory('JhiHealthService', JhiHealthService);

    JhiHealthService.$inject = ['$rootScope', '$http'];

    function JhiHealthService ($rootScope, $http) {
        var service = {
            checkHealth: checkHealth
        };

        return service;

        function checkHealth () {
            return $http.get('health').then(function (response) {
                return response.data;
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular.module('formonlineApp')
        .controller('HealthModalController', HealthModalController);

    HealthModalController.$inject = ['$uibModalInstance', 'currentHealth', 'baseName', 'subSystemName'];

    function HealthModalController ($uibModalInstance, currentHealth, baseName, subSystemName) {
        var vm = this;

        vm.cancel = cancel;
        vm.currentHealth = currentHealth;
        vm.baseName = baseName;
        vm.subSystemName = subSystemName;

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('formonlineApp')
        .controller('JhiHealthCheckController', JhiHealthCheckController);

    JhiHealthCheckController.$inject = ['JhiHealthService', '$uibModal'];

    function JhiHealthCheckController (JhiHealthService, $uibModal) {
        var vm = this;

        vm.addHealthObject = addHealthObject;
        vm.baseName = baseName;
        vm.flattenHealthData = flattenHealthData;
        vm.getLabelClass = getLabelClass;
        vm.getModuleName = getModuleName;
        vm.hasSubSystem = hasSubSystem;
        vm.isHealthObject = isHealthObject;
        vm.refresh = refresh;
        vm.updatingHealth = true;
        vm.separator = '.';
        vm.showHealth = showHealth;
        vm.subSystemName = subSystemName;
        vm.transformHealthData = transformHealthData;

        vm.refresh();


        function addHealthObject (result, isLeaf, healthObject, name) {

            var healthData = {
                'name': name
            };
            var details = {};
            var hasDetails = false;

            angular.forEach(healthObject, function (value, key) {
                if (key === 'status' || key === 'error') {
                    healthData[key] = value;
                } else {
                    if (!vm.isHealthObject(value)) {
                        details[key] = value;
                        hasDetails = true;
                    }
                }
            });

            // Add the of the details
            if (hasDetails) {
                angular.extend(healthData, { 'details': details});
            }

            // Only add nodes if they provide additional information
            if (isLeaf || hasDetails || healthData.error) {
                result.push(healthData);
            }
            return healthData;
        }

        function baseName (name) {
            if (name) {
                var split = name.split('.');
                return split[0];
            }
        }

        function flattenHealthData (result, path, data) {
            angular.forEach(data, function (value, key) {
                if (vm.isHealthObject(value)) {
                    if (vm.hasSubSystem(value)) {
                        vm.addHealthObject(result, false, value, vm.getModuleName(path, key));
                        vm.flattenHealthData(result, vm.getModuleName(path, key), value);
                    } else {
                        vm.addHealthObject(result, true, value, vm.getModuleName(path, key));
                    }
                }
            });
            return result;
        }

        function getLabelClass (statusState) {
            if (statusState === 'UP') {
                return 'label-success';
            } else {
                return 'label-danger';
            }
        }

        function getModuleName (path, name) {
            var result;
            if (path && name) {
                result = path + vm.separator + name;
            }  else if (path) {
                result = path;
            } else if (name) {
                result = name;
            } else {
                result = '';
            }
            return result;
        }

        function hasSubSystem (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value) {
                if (value && value.status) {
                    result = true;
                }
            });
            return result;
        }

        function isHealthObject (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value, key) {
                if (key === 'status') {
                    result = true;
                }
            });
            return result;
        }

        function refresh () {
            vm.updatingHealth = true;
            JhiHealthService.checkHealth().then(function (response) {
                vm.healthData = vm.transformHealthData(response);
                vm.updatingHealth = false;
            }, function (response) {
                vm.healthData =  vm.transformHealthData(response.data);
                vm.updatingHealth = false;
            });
        }

        function showHealth (health) {
            $uibModal.open({
                templateUrl: 'scripts/components/admin/health/health.modal.html',
                controller: 'HealthModalController',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    currentHealth: function() {
                        return health;
                    },
                    baseName: function() {
                        return vm.baseName;
                    },
                    subSystemName: function() {
                        return vm.subSystemName;
                    }

                }
            });
        }

        function subSystemName (name) {
            if (name) {
                var split = name.split('.');
                split.splice(0, 1);
                var remainder = split.join('.');
                return remainder ? ' - ' + remainder : '';
            }
        }

        function transformHealthData (data) {
            var response = [];
            vm.flattenHealthData(response, null, data);
            return response;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('formonlineApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('docs', {
            parent: 'admin',
            url: '/docs',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'global.menu.admin.apidocs'
            },
            views: {
                'content@': {
                    templateUrl: 'scripts/components/admin/docs/docs.html'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', function ($translate) {
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('formonlineApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-configuration', {
            parent: 'admin',
            url: '/configuration',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'configuration.title'
            },
            views: {
                'content@': {
                    templateUrl: 'scripts/components/admin/configuration/configuration.html',
                    controller: 'JhiConfigurationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('configuration');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('formonlineApp')
        .factory('JhiConfigurationService', JhiConfigurationService);

    JhiConfigurationService.$inject = ['$filter', '$http'];

    function JhiConfigurationService ($filter, $http) {
        var service = {
            get: get,
            getEnv: getEnv
        };

        return service;

        function get () {
            return $http.get('configprops').then(getConfigPropsComplete);

            function getConfigPropsComplete (response) {
                var properties = [];
                angular.forEach(response.data, function (data) {
                    properties.push(data);
                });
                var orderBy = $filter('orderBy');
                return orderBy(properties, 'prefix');
            }
        }

        function getEnv () {
            return $http.get('env').then(getEnvComplete);

            function getEnvComplete (response) {
                var properties = {};
                angular.forEach(response.data, function (val,key) {
                    var vals = [];
                    angular.forEach(val, function (v,k) {
                        vals.push({ key:k, val:v });
                    });
                    properties[key] = vals;
                });
                return properties;
            }
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('formonlineApp')
        .controller('JhiConfigurationController', JhiConfigurationController);

    JhiConfigurationController.$inject = ['$filter','JhiConfigurationService'];

    function JhiConfigurationController (filter,JhiConfigurationService) {
        var vm = this;

        vm.allConfiguration = null;
        vm.configuration = null;

        JhiConfigurationService.get().then(function(configuration) {
            vm.configuration = configuration;
        });
        JhiConfigurationService.getEnv().then(function (configuration) {
            vm.allConfiguration = configuration;
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('formonlineApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('audits', {
            parent: 'admin',
            url: '/audits',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'audits.title'
            },
            views: {
                'content@': {
                    templateUrl: 'scripts/components/admin/audits/audits.html',
                    controller: 'AuditsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('audits');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('formonlineApp')
        .factory('AuditsService', AuditsService);

    AuditsService.$inject = ['$resource'];

    function AuditsService ($resource) {
        var service = $resource('api/audits/:id', {}, {
            'get': {
                method: 'GET',
                isArray: true
            },
            'query': {
                method: 'GET',
                isArray: true,
                params: {fromDate: null, toDate: null}
            }
        });

        return service;
    }
})();
;
(function () {
	'use strict';

	angular
		.module('formonlineApp')
		.controller('AuditsController', AuditsController);

	AuditsController.$inject = ['$filter', 'AuditsService', 'ParseLinks'];

	function AuditsController($filter, AuditsService, ParseLinks) {
		var vm = this;

		vm.audits = null;
		vm.fromDate = null;
		vm.links = null;
		vm.loadPage = loadPage;
		vm.onChangeDate = onChangeDate;
		vm.page = 1;
		vm.previousMonth = previousMonth;
		vm.toDate = null;
		vm.today = today;
		vm.totalItems = null;

		vm.today();
		vm.previousMonth();
		vm.onChangeDate();

		function onChangeDate() {
			var dateFormat = 'yyyy-MM-dd';
			var fromDate = $filter('date')(vm.fromDate, dateFormat);
			var toDate = $filter('date')(vm.toDate, dateFormat);

			AuditsService.query({page: vm.page - 1, size: 20, fromDate: fromDate, toDate: toDate}, function (result, headers) {
				vm.audits = result;
				vm.links = ParseLinks.parse(headers('link'));
				vm.totalItems = headers('X-Total-Count');
			});
		}

		// Date picker configuration
		function today() {
			// Today + 1 day - needed if the current day must be included
			var date = new Date();
			vm.toDate = new Date(date.getFullYear(), date.getMonth(), date.getDate() + 1);
		}

		function previousMonth() {
			var fromDate = new Date();
			if (fromDate.getMonth() === 0) {
				fromDate = new Date(fromDate.getFullYear() - 1, 11, fromDate.getDate());
			} else {
				fromDate = new Date(fromDate.getFullYear(), fromDate.getMonth() - 1, fromDate.getDate());
			}

			vm.fromDate = fromDate;
		}

		function loadPage(page) {
			vm.page = page;
			vm.onChangeDate();
		}
	}
})();
;
(function () {
    'use strict';

    angular
        .module('formonlineApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('admin', {
            abstract: true,
            parent: 'app'
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('formonlineApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('settings', {
            parent: 'account',
            url: '/settings',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.menu.account.settings'
            },
            views: {
                'content@': {
                    templateUrl: 'scripts/components/account/settings/settings.html',
                    controller: 'SettingsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('settings');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('formonlineApp')
        .controller('SettingsController', SettingsController);

    SettingsController.$inject = ['Principal', 'Auth', 'JhiLanguageService', '$translate'];

    function SettingsController (Principal, Auth, JhiLanguageService, $translate) {
        var vm = this;

        vm.error = null;
        vm.save = save;
        vm.settingsAccount = null;
        vm.success = null;

        /**
         * Store the "settings account" in a separate variable, and not in the shared "account" variable.
         */
        var copyAccount = function (account) {
            return {
                activated: account.activated,
                email: account.email,
                firstName: account.firstName,
                langKey: account.langKey,
                lastName: account.lastName,
                login: account.login
            };
        };

        Principal.identity().then(function(account) {
            vm.settingsAccount = copyAccount(account);
        });

        function save () {
            Auth.updateAccount(vm.settingsAccount).then(function() {
                vm.error = null;
                vm.success = 'OK';
                Principal.identity(true).then(function(account) {
                    vm.settingsAccount = copyAccount(account);
                });
                JhiLanguageService.getCurrent().then(function(current) {
                    if (vm.settingsAccount.langKey !== current) {
                        $translate.use(vm.settingsAccount.langKey);
                    }
                });
            }).catch(function() {
                vm.success = null;
                vm.error = 'ERROR';
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('formonlineApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('requestReset', {
            parent: 'account',
            url: '/reset/request',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'scripts/components/account/reset/request/reset.request.html',
                    controller: 'RequestResetController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('reset');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('formonlineApp')
        .controller('RequestResetController', RequestResetController);

    RequestResetController.$inject = ['$timeout', 'Auth'];

    function RequestResetController ($timeout, Auth) {
        var vm = this;

        vm.error = null;
        vm.errorEmailNotExists = null;
        vm.requestReset = requestReset;
        vm.resetAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#email').focus();});

        function requestReset () {

            vm.error = null;
            vm.errorEmailNotExists = null;

            Auth.resetPasswordInit(vm.resetAccount.email).then(function () {
                vm.success = 'OK';
            }).catch(function (response) {
                vm.success = null;
                if (response.status === 400 && response.data === 'e-mail address not registered') {
                    vm.errorEmailNotExists = 'ERROR';
                } else {
                    vm.error = 'ERROR';
                }
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('formonlineApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('finishReset', {
            parent: 'account',
            url: '/reset/finish?key',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'scripts/components/account/reset/finish/reset.finish.html',
                    controller: 'ResetFinishController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('reset');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('formonlineApp')
        .controller('ResetFinishController', ResetFinishController);

    ResetFinishController.$inject = ['$stateParams', '$timeout', 'Auth', 'LoginService'];

    function ResetFinishController ($stateParams, $timeout, Auth, LoginService) {
        var vm = this;

        vm.keyMissing = angular.isUndefined($stateParams.key);
        vm.confirmPassword = null;
        vm.doNotMatch = null;
        vm.error = null;
        vm.finishReset = finishReset;
        vm.login = LoginService.open;
        vm.resetAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#password').focus();});

        function finishReset() {
            if (vm.resetAccount.password !== vm.confirmPassword) {
                vm.doNotMatch = 'ERROR';
            } else {
                Auth.resetPasswordFinish({key: $stateParams.key, newPassword: vm.resetAccount.password}).then(function () {
                    vm.success = 'OK';
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('formonlineApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('register', {
            parent: 'account',
            url: '/register',
            data: {
                authorities: [],
                pageTitle: 'register.title'
            },
            views: {
                'content@': {
                    templateUrl: 'scripts/components/account/register/register.html',
                    controller: 'RegisterController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('register');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('formonlineApp')
        .controller('RegisterController', RegisterController);


    RegisterController.$inject = ['$translate', '$timeout', 'Auth', 'LoginService'];

    function RegisterController ($translate, $timeout, Auth, LoginService) {
        var vm = this;

        vm.doNotMatch = null;
        vm.error = null;
        vm.errorUserExists = null;
        vm.login = LoginService.open;
        vm.register = register;
        vm.registerAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#login').focus();});

        function register () {
            if (vm.registerAccount.password !== vm.confirmPassword) {
                vm.doNotMatch = 'ERROR';
            } else {
                vm.registerAccount.langKey = $translate.use();
                vm.doNotMatch = null;
                vm.error = null;
                vm.errorUserExists = null;
                vm.errorEmailExists = null;

                Auth.createAccount(vm.registerAccount).then(function () {
                    vm.success = 'OK';
                }).catch(function (response) {
                    vm.success = null;
                    if (response.status === 400 && response.data === 'login already in use') {
                        vm.errorUserExists = 'ERROR';
                    } else if (response.status === 400 && response.data === 'e-mail address already in use') {
                        vm.errorEmailExists = 'ERROR';
                    } else {
                        vm.error = 'ERROR';
                    }
                });
            }
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('formonlineApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('password', {
            parent: 'account',
            url: '/password',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.menu.account.password'
            },
            views: {
                'content@': {
                    templateUrl: 'scripts/components/account/password/password.html',
                    controller: 'PasswordController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('password');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('formonlineApp')
        .controller('PasswordController', PasswordController);

    PasswordController.$inject = ['Auth', 'Principal'];

    function PasswordController (Auth, Principal) {
        var vm = this;

        vm.changePassword = changePassword;
        vm.doNotMatch = null;
        vm.error = null;
        vm.success = null;

        Principal.identity().then(function(account) {
            vm.account = account;
        });

        function changePassword () {
            if (vm.password !== vm.confirmPassword) {
                vm.error = null;
                vm.success = null;
                vm.doNotMatch = 'ERROR';
            } else {
                vm.doNotMatch = null;
                Auth.changePassword(vm.password).then(function () {
                    vm.error = null;
                    vm.success = 'OK';
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }
    }
})();
;
/* globals $ */
(function() {
    'use strict';

    angular
        .module('formonlineApp')
        .directive('passwordStrengthBar', passwordStrengthBar);

    function passwordStrengthBar () {
        var directive = {
            replace: true,
            restrict: 'E',
            template: '<div id="strength">' +
                '<small translate="global.messages.validate.newpassword.strength">Password strength:</small>' +
                '<ul id="strengthBar">' +
                '<li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li>' +
                '</ul>' +
                '</div>',
            scope: {
                passwordToCheck: '='
            },
            link: linkFunc
        };

        return directive;

        /* private helper methods*/

        function linkFunc(scope, iElement) {
            var strength = {
                colors: ['#F00', '#F90', '#FF0', '#9F0', '#0F0'],
                mesureStrength: function (p) {

                    var _force = 0;
                    var _regex = /[$-/:-?{-~!"^_`\[\]]/g; // "

                    var _lowerLetters = /[a-z]+/.test(p);
                    var _upperLetters = /[A-Z]+/.test(p);
                    var _numbers = /[0-9]+/.test(p);
                    var _symbols = _regex.test(p);

                    var _flags = [_lowerLetters, _upperLetters, _numbers, _symbols];
                    var _passedMatches = $.grep(_flags, function (el) {
                        return el === true;
                    }).length;

                    _force += 2 * p.length + ((p.length >= 10) ? 1 : 0);
                    _force += _passedMatches * 10;

                    // penality (short password)
                    _force = (p.length <= 6) ? Math.min(_force, 10) : _force;

                    // penality (poor variety of characters)
                    _force = (_passedMatches === 1) ? Math.min(_force, 10) : _force;
                    _force = (_passedMatches === 2) ? Math.min(_force, 20) : _force;
                    _force = (_passedMatches === 3) ? Math.min(_force, 40) : _force;

                    return _force;

                },
                getColor: function (s) {

                    var idx = 0;
                    if (s <= 10) {
                        idx = 0;
                    }
                    else if (s <= 20) {
                        idx = 1;
                    }
                    else if (s <= 30) {
                        idx = 2;
                    }
                    else if (s <= 40) {
                        idx = 3;
                    }
                    else {
                        idx = 4;
                    }

                    return { idx: idx + 1, col: this.colors[idx] };
                }
            };
            scope.$watch('passwordToCheck', function (password) {
                if (password) {
                    var c = strength.getColor(strength.mesureStrength(password));
                    iElement.removeClass('ng-hide');
                    iElement.find('ul').children('li')
                        .css({ 'background-color': '#DDD' })
                        .slice(0, c.idx)
                        .css({ 'background-color': c.col });
                }
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('formonlineApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('activate', {
            parent: 'account',
            url: '/activate?key',
            data: {
                authorities: [],
                pageTitle: 'activate.title'
            },
            views: {
                'content@': {
                    templateUrl: 'scripts/components/account/activate/activate.html',
                    controller: 'ActivationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('activate');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('formonlineApp')
        .controller('ActivationController', ActivationController);

    ActivationController.$inject = ['$stateParams', 'Auth', 'LoginService'];

    function ActivationController ($stateParams, Auth, LoginService) {
        var vm = this;

        Auth.activateAccount({key: $stateParams.key}).then(function () {
            vm.error = null;
            vm.success = 'OK';
        }).catch(function () {
            vm.success = null;
            vm.error = 'ERROR';
        });

        vm.login = LoginService.open;
    }
})();
;
(function() {
    'use strict';

    angular
        .module('formonlineApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('account', {
            abstract: true,
            parent: 'app'
        });
    }
})();
;
'use strict';

angular.module('formonlineApp').service('WhitelistService', ['$http',
    function ($http) {
        this.check = function (nDC, annee, type, code, successFn, errorFn) {
            var params = {
                nDC: nDC,
                annee: annee,
                type: type,
                code: code
            };
            $http({
                method: 'get',
                url: 'api/whitelist/check',
                params: params
            }).success(successFn).error(errorFn);
        };
    }]);
;
'use strict';

angular.module('formonlineApp').service('LocaliteService', ['$http',
    function ($http) {

        this.getAll = function () {
            return $http({
                method: 'get',
                url: 'api/localite'
            });
        };

        this.getByCanton = function (canton) {
            return $http({
                method: 'get',
                url: 'api/localite/canton/' + canton,
            });
        };

    }]);
;
'use strict';

angular.module('formonlineApp').service('ListUtils', [
    function () {

        this.isStringInList = function (list, string) {
            if (!list || !string) {
                return false;
            }
            return list.filter(function(x) { return x === string}).length !== 0;
        }

    }]);
;
'use strict';

angular.module('formonlineApp').service('IframeService', ['$timeout',
    function ($timeout) {

        this.sendHeightToParent = function(idDiv) {
            $timeout(function() {
                var height = document.getElementById(idDiv).offsetHeight;
                parent.postMessage({ scrollHeight: height }, '*');
            }, 250);
        }

    }]);
;
'use strict';

angular.module('formonlineApp').service('FrontendlogService', ['$http',
    function ($http) {

        var getStackTrace = function(error) {
            var stack = error.stack || '';
            stack = stack.split('\n').map(function (line) { return line.trim(); });
            return stack.join('\n');
        };

        this.logCaptcha = function (captcha, error, successFn, errorFn) {
            var data = {
                captcha: captcha,
                log: getStackTrace(error)
            };

            return $http({
                method: 'post',
                url: 'api/frontendlog/captcha',
                data: data
            }).success(successFn).error(errorFn);
        };

        this.logWhitelist = function (ndc, annee, codeSecurite, error, successFn, errorFn) {
            var data = {
                ndc: ndc,
                annee: annee,
                codeSecurite: codeSecurite,
                formType: 'DECLARIS',
                log: getStackTrace(error)
            };

            return $http({
                method: 'post',
                url: 'api/frontendlog/whitelist',
                data: data
            }).success(successFn).error(errorFn);
        };

    }]);
;
(function() {
    'use strict';

    angular
        .module('formonlineApp')
        .directive('customOnChange', function() {
            return {
                restrict: 'A',
                link: function (scope, element, attrs) {
                    var onChangeFunc = scope.$eval(attrs.customOnChange);
                    element.bind('change', onChangeFunc);
                }
            };
        });
})();
;
'use strict';

angular.module('formonlineApp').service('ContextFiscal', function ($resource) {

    return $resource('api/contextefiscal/:id', {id: '@id'}, {
        'list': {method: 'GET', isArray: true},
        'update': {method: 'PUT'}
    });

});

angular.module('formonlineApp').service('ContextFiscalService', ['ContextFiscal', '$http',
    function (ContextFiscal, $http) {
        this.get = function (idStr) {
            return ContextFiscal.get({
                id: idStr
            }).$promise;
        };

        this.getByAnnee = function (annFis) {
            return $http({
                method: 'get',
                url: 'api/contextefiscal/annee/' + annFis
            });
        };

        this.getAnneesFiscales = function () {
            return $http({
                method: 'get',
                url: 'api/contextefiscal/annees'
            });
        };

        this.getLastValid = function () {
            return $http({
                method: 'get',
                url: 'api/contextefiscal/annee/last'
            });
        };

    }]);
;
'use strict';

//création de l'objet
angular.module('formonlineApp').factory('Bareme', ['$resource',
    function ($resource) {
        var Bareme = $resource('api/bareme/:id', {id: '@id'}, {
            'update': {method: 'PUT'}
        });

        Bareme.prototype.update = function (cb, ecb) {
            return Bareme.update({id: this.id},
                angular.extend({}, this, {id: undefined}), cb, ecb);
        };

        return Bareme;
    }]);


//liste des services
angular.module('formonlineApp').service('BaremeService',
    function (Bareme, $http, Language) {
        // Service methods...
        this.get = function (idStr) {
            return Bareme.get({
                id: idStr,
                locale: Language.current()
            }).$promise;
        };

        this.getCodeLRByAnnFis = function (annFis) {
            return $http({
                method: 'get',
                url: 'api/bareme/annee/' + annFis + '/lr'
            });
        };

        this.getCodeSansRevenuDeterminantByAnnee = function (annFis) {
            return $http({
                method: 'get',
                url: 'api/bareme/annee/' + annFis + '/sansrevenudeterminant'
            });
        };

        this.getCodeEnfantObligatoireByAnnee = function (annFis) {
            return $http({
                method: 'get',
                url: 'api/bareme/annee/' + annFis + '/enfantobligatoire'
            });
        };

        this.getCodeAvecEnfantsByAnnee = function (annFis) {
            return $http({
                method: 'get',
                url: 'api/bareme/annee/' + annFis + '/avecenfants'
            });
        };

        this.getCodeCalculetteByAnnee = function (annFis) {
            return $http({
                method: 'get',
                url: 'api/bareme/annee/' + annFis + '/calculette'
            });
        };

        this.getCodeCalculetteSansRevenuDeterminantByAnnee = function (annFis) {
            return $http({
                method: 'get',
                url: 'api/bareme/annee/' + annFis + '/calculettesansrevenudeterminant'
            });
        };

        this.getCodeCalculetteEnfantObligatoireByAnnee = function (annFis) {
            return $http({
                method: 'get',
                url: 'api/bareme/annee/' + annFis + '/calculetteenfantobligatoire'
            });
        };

        this.getCodeCalculetteAvecEnfantsByAnnee = function (annFis) {
            return $http({
                method: 'get',
                url: 'api/bareme/annee/' + annFis + '/calculetteavecenfants'
            });
        };

        this.getCodeFormulaireByAnnee = function (annFis) {
            return $http({
                method: 'get',
                url: 'api/bareme/annee/' + annFis + '/formulaire'
            });
        };

        this.list = function () {
            return $http({
                method: 'get',
                url: 'api/bareme/'
            });
        };

        this.getVariante = function (annee, baremeCode, revenu, etatCivil) {
            return $http({
                method: 'get',
                url: 'api/bareme/annee/' + annee + '/code/' + baremeCode + '/variante',
                params: {revenu: revenu, etatCivil: etatCivil}
            });
        };

        this.calculerCote = function (contexteFiscal, dateDebut, dateFin, baremeCode, nbEnfants, revenuBrut, travailDiscontinu, tauxActivite,
                                      tauxAutresActivites, nbHeuresTravail, revenuDeterminant) {
            var data = {
                contexteFiscal: {annee: contexteFiscal.annee},
                dateDebut: dateDebut,
                dateFin: dateFin,
                typeBareme: baremeCode,
                nbEnfants: nbEnfants,
                revenu: revenuBrut,
                impotParoisse: true,
                tauxActivite: tauxActivite ? tauxActivite : 1,
                tauxAutresActivites: tauxAutresActivites ? tauxAutresActivites : 0,
                extrapolerSurTauxActivite: true,
                travailDiscontinu: travailDiscontinu,
                nbHeuresTravail: nbHeuresTravail,
                revenuDeterminant: revenuDeterminant
            };
            return $http({
                method: 'post',
                url: 'api/bareme/cote',
                data: data
            });
        };

        this.calculerCoteByNbJours = function (nbJours, contexteFiscal, baremeCode, nbEnfants, revenuBrut, revenuConjoint,
                                               tauxActivite, tauxAutresActivites,
                                               travailDiscontinu, nbHeuresTravail,
                                               retenue, commission, revenuDeterminant, dossierTauxCommission, etatCivil, nbPersonnes) {
            var data = {
                nbJours: nbJours,
                nbEnfants: nbEnfants,
                revenu: revenuBrut,
                revenuConjoint: revenuConjoint,
                tauxActivite: tauxActivite,
                tauxAutresActivites: tauxAutresActivites,
                extrapolerSurTauxActivite: true,
                travailDiscontinu: travailDiscontinu,
                nbHeuresTravail: nbHeuresTravail,
                nbJoursTravail: null,
                retenue: null,
                commission: commission,
                contexteFiscal: {annee: contexteFiscal.annee},
                revenuDeterminant: revenuDeterminant,
                dossierTauxCommission: dossierTauxCommission,
                etatCivil: etatCivil,
                typeBareme: baremeCode,
                nbPersonnes: nbPersonnes,
                impotParoisse: true
            };
            return $http({
                method: 'post',
                url: 'api/bareme/cote',
                data: data
            });
        };

        this.calculerNbJours = function (dateDebut, dateFin) {
            return $http({
                method: 'post',
                url: 'api/bareme/datediff',
                params: {dateDebut: dateDebut, dateFin: dateFin}
            });
        };

        this.calculerDeduction = function (anneeFiscale, baremeCode, revenu, fraisDeduits) {
            return $http({
                method: 'post',
                url: 'api/bareme/deductionForfaitaire',
                params: {anneeFiscale: anneeFiscale, typeBareme: baremeCode, revenu: revenu, fraisDeduits: fraisDeduits}
            });
        };
    });
;
(function() {
    'use strict';

	angular.module('formonlineApp')
		.config(function ($stateProvider) {
        $stateProvider
            .state('main', {
                parent: 'fullwidth',
                url: '/',
                data: {
					authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'scripts/app/main/main.html',
                        controller: 'MainController'
                    }
                }
//				,
//                resolve: {
//                    mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
//                        $translatePartialLoader.addPart('main');
//                        return $translate.refresh();
//                    }]
//                }
            });
    });

})();
;
(function () {
	'use strict';

	var formonlineApp = angular.module('formonlineApp');

	formonlineApp.controller('MainController', function ($scope, $stateParams, Principal, $log, SidebarService, $http) {
		Principal.identity().then(function (account) {
			$scope.account = account;
			$scope.isAuthenticated = Principal.isAuthenticated;
			$scope.$watch($scope.isAuthenticated, function (isAuthenticated) {
				if (isAuthenticated) {
					Principal.identity().then(function (param) {
						$scope.account = param;
					});
				} else {
					$scope.account = null;
				}
			});
			$log.debug('account', account);
		});

		$scope.clearSideBarMenu = function () {
			//on vide le menu
			SidebarService.delAllMenus();
		};

	});

})();
;
'use strict';

angular.module('formonlineApp')
	.controller('SubmenuController', function ($scope, $location, $state, Auth, Principal, submenuSettings) {
		$scope.isAuthenticated = Principal.isAuthenticated;
		$scope.$state = $state;

		$scope.items = null;

		this.init = function (title, breadcrumbItems, menuItems) {
			$scope.title = title;
			$scope.breadcrumbItems = breadcrumbItems;
			$scope.menuItems = menuItems;
		};

		submenuSettings.setCallback(this.init);

	});
;
'use strict';

var formonlineApp = angular.module('formonlineApp');

formonlineApp.service('SidebarService', function ($filter, $log, $localStorage) {

	this.LOCAL_STORAGE_KEY = 'LS_SIDEBAR_TREE';

	this.nodeSelected = {};
	this.nodeSelected.menus = [];
	this.tree = [];
	this.idSsMenuSelected;
	this.ssMenuSelected;
	this.menuSelected;


	/* Exemple :
	this.tree = [{
		type: 'D',
		menus: [{
				label: 'Recherche',
				url: 'dossier',
				ssmenus : []
			}, {
				label: 'Dossiers ouverts',
				url: '',
				ssmenus : [
					{
						label: '1234',
						url: 'dossier.detail(1234)',
						id: 1234,
						ssmenus: []
					}]
			}]
		}];
	*/

	this.searchSsMenu = function (id) {
		for (var i = 0; i < this.nodeSelected.menus.length; i++) {
			for (var j = 0; j < this.nodeSelected.menus[i].ssmenus.length; j++) {
				if (this.nodeSelected.menus[i].ssmenus[j].id.toString() === id.toString()) {
					return this.nodeSelected.menus[i].ssmenus[j];
				}
			}
		}
		return null;
	};
	this.searchMenu = function (id) {
		for (var i = 0; i < this.nodeSelected.menus.length; i++) {
			for (var j = 0; j < this.nodeSelected.menus[i].ssmenus.length; j++) {
				if (this.nodeSelected.menus[i].ssmenus[j].id.toString() === id.toString()) {
					return this.nodeSelected.menus[i];
				}
			}
		}
		return null;
	};

	this.removeSsMenu = function (indexMenu, indexSsMenu) {
		for (var i = 0; i < this.tree.length; i++) {
			if (this.tree[i].type === this.nodeSelected.type) {
				this.tree[i].menus[indexMenu].ssmenus.splice(indexSsMenu,1);
			}
		}
		$localStorage.set(this.LOCAL_STORAGE_KEY, this.tree);
		this.selectNode(this.nodeSelected.type);
	};

	this.removeCurrentSsMenu = function () {
		for (var i = 0; i < this.nodeSelected.menus.length; i++) {
			if (this.nodeSelected.menus[i] === this.menuSelected) {
				for (var j = 0; j < this.nodeSelected.menus[i].ssmenus.length; j++) {
					if (this.nodeSelected.menus[i].ssmenus[j] === this.ssMenuSelected) {
						this.nodeSelected.menus[i].ssmenus.splice(j, 1);
						for (var k = 0; k < this.tree.length; k++) {
							if (this.tree[k].type === this.nodeSelected.type) {
								this.tree[k].menus[i].ssmenus.splice(j, 1);
								$localStorage.set(this.LOCAL_STORAGE_KEY, this.tree);
							}
						}
					}
				}
			}
		}
	};

	this.addSsMenu = function (indexMenu, index, item) {
		for (var i = 0; i < this.tree.length; i++) {
			if (this.tree[i].type === this.nodeSelected.type) {
				this.tree[i].menus[indexMenu].ssmenus.splice(index, 0, item);
			}
		}
		$localStorage.set(this.LOCAL_STORAGE_KEY, this.tree);
	};

	this.removeDossier = function (indexMenu, dossier) {
		for (var i = 0; i < this.tree.length; i++) {
			if (this.tree[i].type === 'D') {
				for (var j = 0; j < this.tree[i].menus[indexMenu].ssmenus.length; j++) {
					if (this.tree[i].menus[indexMenu].ssmenus[j].id === dossier.noDossier) {
						this.tree[i].menus[indexMenu].ssmenus.splice(j, 1);
					}
				}
			}
		}
		$localStorage.set(this.LOCAL_STORAGE_KEY, this.tree);
	};

	this.selectNode = function (type) {
		this.tree = $localStorage.get(this.LOCAL_STORAGE_KEY);
		if (this.tree === null) {
            this.tree = [];
        }
		for (var i = 0; i < this.tree.length; i++) {
			if (this.tree[i].type === type) {
				this.nodeSelected = this.tree[i];
				return this.tree[i];
			}
		}
		return null;
	};

	this.getNode = function () {
		return this.selectNode(this.nodeSelected);
	};

	this.createNode = function (type, label, isRecherche, urlRecherche) {

		var newNode = {
			type: type,
			menus: []
		};

		if (isRecherche) {
			newNode.menus.push({label: 'Recherche',
				url: urlRecherche,
				ssmenus: []});
		}
		newNode.menus.push({label: label,
			url: '',
			ssmenus: []});

		this.tree.push(newNode);
		$localStorage.set(this.LOCAL_STORAGE_KEY, this.tree);
	};

	this.getIdSsMenuSelected = function () {
		return this.idSsMenuSelected;
	};

	this.setIdSsMenuSelected = function (id) {
		this.menuSelected = this.searchMenu(id);
		this.ssMenuSelected = this.searchSsMenu(id);
		this.idSsMenuSelected = id;
	};

});
;
'use strict';

angular.module('formonlineApp')
		.controller('SidebarController', function ($scope, $state, $log, Principal, SidebarService) {

        $scope.isAuthenticated = Principal.isAuthenticated;
		$scope.$state = $state;
		$scope.service = SidebarService;

		$scope.node = SidebarService.getNode();

		$scope.removeSsMenu = function (indexMenu, indexSsMenu) {
				SidebarService.removeSsMenu(indexMenu, indexSsMenu);
		};

		$scope.isSsMenuSelected = function (id) {
			var idSelected = SidebarService.getIdSsMenuSelected();
			if (id !== undefined && idSelected !== undefined && id.toString() === idSelected.toString()) {
				return 'selected';
			}
			return '';
		};


	});
;
'use strict';

angular.module('formonlineApp')
    .directive('activeMenu', function($translate, $locale, tmhDynamicLocale) {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                var language = attrs.activeMenu;

                scope.$watch(function() {
                    return $translate.use();
                }, function(selectedLanguage) {
                    if (language === selectedLanguage) {
                        tmhDynamicLocale.set(language);
                        element.addClass('active');
                    } else {
                        element.removeClass('active');
                    }
                });
            }
        };
    })
    .directive('activeLink', function(location) {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                var clazz = attrs.activeLink;
                var path = attrs.href;
                path = path.substring(1); //hack because path does bot return including hashbang
                scope.location = location;
                scope.$watch('location.path()', function(newPath) {
                    if (path === newPath) {
                        element.addClass(clazz);
                    } else {
                        element.removeClass(clazz);
                    }
                });
            }
        };
    });
;
'use strict';

angular.module('formonlineApp')
		.controller('NavbarController', function ($scope, $state, $log, Auth, Principal, SidebarService) {
			$scope.isAuthenticated = Principal.isAuthenticated;
			$scope.$state = $state;

			$scope.logout = function () {
				Auth.logout();
				$state.go('home');
			};

			$scope.clearSideBarMenu = function () {
				//on vide le menu
				SidebarService.delAllMenus();
			};
		});
;
'use strict';

angular.module('formonlineApp')
    .controller('FooterController', function ($scope, $location, $state, Auth, Principal, toolbarSettings) {
        $scope.isAuthenticated = Principal.isAuthenticated;
        $scope.$state = $state;

		$scope.buttons = null;

		this.init = function(buttons) {
			$scope.buttons = buttons;
		};

		toolbarSettings.setCallback(this.init);
    });
;
'use strict';

angular.module('formonlineApp').service('DelaiFiduService', ['$http',
    function ($http) {

        this.create = function (delaiFiduciaire, file) {
            return $http({
                method: 'post',
                url: 'api/delaifiduciaire',
                headers: {'Content-Type': undefined },
                transformRequest: function () {
                    var formData = new FormData();

                    formData.append('form', new Blob([angular.toJson(delaiFiduciaire)], {
                        type: 'application/json'
                    }));
                    formData.append('file', file);
                    return formData;
                },
                data: { data: delaiFiduciaire, file: file }
            });
        };

        this.check = function (delaiFiduciaire, file) {
            return $http({
                method: 'post',
                url: 'api/delaifiduciaire/check',
                headers: {'Content-Type': undefined },
                transformRequest: function () {
                    var formData = new FormData();

                    formData.append('form', new Blob([angular.toJson(delaiFiduciaire)], {
                        type: 'application/json'
                    }));
                    formData.append('file', file);
                    return formData;
                },
                data: { data: delaiFiduciaire, file: file }
            });
        };

    }]);
;
'use strict';

angular.module('formonlineApp')
    .config(function ($stateProvider) {
        $stateProvider.state('delaifidu', {
            parent: 'fullwidth',
            url: '/delaifidu/{locale}',
            views: {
                'content@': {
                    templateUrl: 'scripts/app/form/delaifidu/delaifidu.html',
                    controller: 'DelaifiduController'
                }
            }
        });
    });
;
'use strict';

angular.module('formonlineApp')
    .controller('DelaifiduController', function ($scope, $log, $stateParams, $translate, $sce, ObjectUtils, StringUtil,
                                                 PrintUtil, DelaiFiduService, $window, $interval, FrontendlogService,
                                                 ErrorUtil, ValidationUtil, ERROR_PREFIX, IframeService) {

        var vm = $scope;

        var localStorageKey = 'formOnline.fiduciaire';

        vm.formHelper = {};
        vm.formHelper.type = 'FORM';
        vm.formHelper.step = 1;
        vm.formHelper.recaptchaSuccess = false;
        vm.formHelper.fileUploadError = null;
        vm.formHelper.saveHeader = false;
        vm.formHelper.saved = $window.localStorage.getItem(localStorageKey);
        vm.formHelper.dateDemande = new Date();
        vm.formHelper.valid = false;
        vm.formHelper.errorMsg = null;
        vm.formHelper.showValidationMsg = false;

        vm.errors = {};
        vm.warnings = {};

        var delaiFiduciaireOriginal = {
            demandesDelai: [{
                index: 1
            }]
        };

        if (vm.formHelper.saved != null) {
            delaiFiduciaireOriginal.fiduciaire = JSON.parse(vm.formHelper.saved);
            delaiFiduciaireOriginal.fiduciaire.periodeFiscale = new Date().getFullYear() - 1;
            vm.formHelper.saveHeader = true;
        } else {
            delaiFiduciaireOriginal.fiduciaire = {
                periodeFiscale: new Date().getFullYear() - 1,
                langue: 'fr'
            };
        }

        vm.delaiFiduciaire = angular.copy(delaiFiduciaireOriginal);

        if ($stateParams.locale === 'de') {
            vm.delaiFiduciaire.fiduciaire.langue = $stateParams.locale;
            $translate.use($stateParams.locale);
            $('.datepicker').datepicker({
                language: $stateParams.locale
            });
        } else {
            vm.delaiFiduciaire.fiduciaire.langue = 'fr';
            $translate.use('fr');
            $('.datepicker').datepicker({
                language: 'fr'
            });
        }

        var filterErrors = function (errors) {
            vm.errors = {};
            angular.forEach(errors, function (value) {
                if (value.index > 0) {
                    vm.errors[value.index + value.field] = value;
                }
            });
        };

        var filterWarnings = function(warnings) {
            vm.warnings = {};
            angular.forEach(warnings, function (value) {
                if (value.index > 0) {
                    vm.warnings[value.index + value.field] = value;
                }
            });
        };

        vm.treatError = function(error, frontend) {
            vm.formHelper.errorMsg = ErrorUtil.translateError(error, ERROR_PREFIX + 'error.internalServerError', ERROR_PREFIX);

            ErrorUtil.treatError(error, frontend, function() {
                FrontendlogService.logCaptcha(vm.delaiFiduciaire.recaptchaResponse, error, function (value) {
                    // We don't care, it's logging
                }, function (err) {
                    // We don't care, it's logging
                });
            });
        };

        vm.uploadExcelFile = function () {
            try {
                DelaiFiduService.check(vm.delaiFiduciaire, vm.delaiFiduciaire.excelFile).then(function (response) {
                    var value = response.data;
                    var tmpExcelFile = vm.delaiFiduciaire.excelFile;
                    vm.delaiFiduciaire = value.delaiFiduciaire;
                    vm.delaiFiduciaire.excelFile = tmpExcelFile;
                    filterErrors(value.errors);
                    filterWarnings(value.warnings);
                    vm.formHelper.fileUploaded = true;
                }).catch(function (error) {
                    $log.error('Erreur appel ws /delaifiduciaire/check');
                    $log.error(error);
                    vm.formHelper.fileUploadError = ErrorUtil.translateError(error, ERROR_PREFIX + 'error.internalServerError', ERROR_PREFIX);
                });
            } catch (err) {
                vm.treatError(err, true);
            }
        };

        vm.sendRequest = function () {
            try {
                if (vm.formHelper.saveHeader) {
                    $window.localStorage.setItem(localStorageKey, JSON.stringify(vm.delaiFiduciaire.fiduciaire));
                } else {
                    $window.localStorage.removeItem(localStorageKey);
                }

                DelaiFiduService.create(vm.delaiFiduciaire, vm.delaiFiduciaire.excelFile).then(function () {
                    vm.formHelper.step = 2;
                    vm.sendHeightToParent();
                }).catch(function (error) {
                    $log.error('Erreur appel ws /delaifiduciaire');
                    vm.treatError(error);
                });
            } catch (err) {
                vm.treatError(err, true);
            }
        };

        vm.addEntry = function () {
            var lastEntry = vm.delaiFiduciaire.demandesDelai[vm.delaiFiduciaire.demandesDelai.length - 1];
            var newIndex = lastEntry.index + 1;
            vm.delaiFiduciaire.demandesDelai.push({index: newIndex});
            vm.sendHeightToParent();
        };

        vm.removeEntry = function (index) {
            var indexKey = null;
            angular.forEach(vm.delaiFiduciaire.demandesDelai, function (value, key) {
                if (value.index === index) {
                    indexKey = key;
                    return;
                }
            });
            vm.delaiFiduciaire.demandesDelai.splice(indexKey, 1);
            vm.sendHeightToParent();
        };

        vm.resetInputFile = function () {
            var excelInput = document.getElementById('excel');
            if (excelInput) {
                excelInput.value = '';
            }
            vm.formHelper.fileUploaded = false;
            vm.formHelper.fileUploadError = null;
        };

        vm.hasErrors = function (demandeDelai, fields) {
            var errorMessage = ValidationUtil.getValidationMessage(vm.errors, demandeDelai, fields);
            return !angular.isUndefined(errorMessage) && errorMessage !== null;
        };

        vm.hasWarnings = function (demandeDelai, fields) {
            if (vm.hasErrors(demandeDelai, fields)) {
                // Les erreurs sont prioritaires par rapport aux warning
                return false;
            }
            var warningMessage = ValidationUtil.getValidationMessage(vm.warnings, demandeDelai, fields);
            return !angular.isUndefined(warningMessage) && warningMessage !== null;
        };

        var trusted = {}
        vm.getValidationMessage = function (demandeDelai, fields) {
            var html = ValidationUtil.getValidationMessage(vm.errors, demandeDelai, fields);
            if (angular.isUndefined(html) || html === null) {
                html = ValidationUtil.getValidationMessage(vm.warnings, demandeDelai, fields);
            }
            // Caching nécessaire à cause du problème https://github.com/angular/angular.js/issues/3932
            return trusted[html] || (trusted[html] = $sce.trustAsHtml(html));
        };

        vm.resetForm = function () {
            vm.formHelper.fileUploadError = null;
            vm.delaiFiduciaire = angular.copy(delaiFiduciaireOriginal);
            vm.resetInputFile(document.getElementById('excel'));
            vm.$broadcast('show-errors-reset');
            vm.formHelper.showValidationMsg = false;
            vm.formHelper.errorMsg = null;
        };

        vm.printDiv = function (divId) {
            PrintUtil.printDiv(divId, 800, 600);
        };

        vm.onRecaptchaSuccess = function () {
            vm.formHelper.recaptchaSuccess = true;
            vm.formHelper.showValidationMsg = false;
        };

        vm.areItemsValid = function() {
            return (vm.delaifiduForm && !vm.delaifiduForm.$invalid) && (vm.formHelper.type === 'FORM' || vm.delaiFiduciaire.excelFile);
        };

        vm.isFormValid = function (skipCaptchaCheck) {
            var valid = vm.areItemsValid() && !ObjectUtils.isNonEmptyObject(vm.errors) && (skipCaptchaCheck || vm.formHelper.recaptchaSuccess) && !vm.formHelper.fileUploadError;
            if (valid) {
                vm.formHelper.showValidationMsg = false;
            }
            return valid;
        };

        vm.countNbDemandes = function() {
            if (vm.delaiFiduciaire && vm.delaiFiduciaire.demandesDelai) {
                return vm.delaiFiduciaire.demandesDelai.length;
            }
            return 0;
        };

        vm.showValidation = function(skipCaptchaCheck) {
            vm.formHelper.showValidationMsg = true;
            vm.isFormValid(skipCaptchaCheck);
            vm.$broadcast('show-errors-check-validity');
        };

        $interval(function(){
            vm.formHelper.valid = vm.isFormValid();
        }, 1000);

        //Fonction pour les appels depuis le template
        vm.sendHeightToParent = function() {
            IframeService.sendHeightToParent('delaifidu-form-content-wrapper');
        }

        var init = function() {
            vm.sendHeightToParent();
        }

        init();

    });
;
'use strict';

angular.module('formonlineApp')
    .config(function ($stateProvider) {
        $stateProvider.state('declaris-lr', {
            parent: 'fullwidth',
            url: '/declaris/lr/{locale}',
            views: {
                'content@': {
                    templateUrl: 'scripts/app/form/declaris/lr/declaris.lr.html',
                    controller: 'DeclarisLRController'
                }
            }
        });
    });
;
'use strict';

angular.module('formonlineApp')
    .controller('DeclarisLRController', function ($scope, $log, $state, $stateParams, $translate, $sce, StringUtil, ObjectUtils,
                                                  PrintUtil, ContextFiscalService, BaremeService, DeclarationLRService,
                                                  WhitelistService, LocaliteService, $window, $timeout, FrontendlogService,
                                                  ErrorUtil, ValidationUtil, Language, ListUtils, ERROR_PREFIX, IframeService, $http) {
        var vm = $scope;

        var localStorageKey = 'formOnline.declaris';

        var cantonFRCode = 'FR';

        vm.baremes = [];
        vm.baremesSansRevenuDeterminant = [];
        vm.baremesEnfantObligatoire = [];
        vm.baremesAvecEnfants = [];

        vm.localites = [];

        vm.formHelper = {};
        vm.formHelper.step = 1;
        vm.formHelper.fileUploaded = false;
        vm.formHelper.contexteFiscale = null;
        vm.formHelper.anneesFiscales = null;
        vm.formHelper.authorized = false;
        vm.formHelper.fileUploadError = null;
        vm.formHelper.saveHeader = false;
        vm.formHelper.saved = $window.localStorage.getItem(localStorageKey);
        vm.formHelper.dateDemande = new Date();
        vm.formHelper.errorMsg = null;
        vm.formHelper.showValidationMsg = false;

        vm.errors = {};
        vm.warnings = {};

        vm.ongoingRequest = false;

        vm.declaration = {
            anneeFiscale: null,
            typeDeclarationIs: 'FORM',
            langue: 'fr'
        };

        vm.checkAuthorization = function () {
            if (vm.declaration.ndc && vm.declaration.ndc !== '' && vm.declaration.codeSecurite && vm.declaration.codeSecurite !== '' && vm.declaration.anneeFiscale && vm.declaration.anneeFiscale !== '') {
                WhitelistService.check(vm.declaration.ndc.replace(/\.|\/|_/g, ''), vm.declaration.anneeFiscale, 'DECLARIS', vm.declaration.codeSecurite, function (value) {
                    vm.formHelper.authorized = value;
                    vm.formHelper.showValidationMsg = !vm.formHelper.authorized;
                }, function (error) {
                    $log.error('Erreur appel ws /whitelist/check');
                    vm.treatError(error);
                });
            }
        };

        vm.getDateDebut = function () {
            if (vm.declaration && vm.declaration.anneeFiscale) {
                return vm.declaration.anneeFiscale + '-01-01';
            }
            return (new Date().getFullYear() - 1) + '-01-01';
        };

        vm.getDateFin = function () {
            if (vm.declaration && vm.declaration.anneeFiscale) {
                return vm.declaration.anneeFiscale + '-12-31';
            }
            return (new Date().getFullYear() - 1) + '-12-31';
        };

        vm.getLanguage = function() {
            return Language.current();
        };

        // L'année est surchargée, seuls les mois et jours sont conservés.
        var oriLR = {index: 1, pisInconnue: false, sexe: 'M', nbEnfants: 0, periodeDu: vm.getDateDebut(), periodeAu: vm.getDateFin(),
            tauxActivite: 1, tauxAutresActivites: 0, travailDiscontinu: false, nbHeuresTravail: null,tauxTeletravailFrance: null,
            paysResidence: null};

        vm.declaration.listesRecapitulatives = [angular.copy(oriLR)];

        var oriDeclaration = angular.copy(vm.declaration);

        var resetPeriod = function() {
            angular.forEach(vm.declaration.listesRecapitulatives, function (value) {
                value.periodeDu = vm.getDateDebut();
                value.periodeAu = vm.getDateFin();
            });
            oriLR.periodeDu = vm.getDateDebut();
            oriLR.periodeAu = vm.getDateFin();
        };

        function preventDefault(e) {
            e.preventDefault();
        }

        var init = function () {
            if (vm.formHelper.saved != null) {
                vm.declaration = JSON.parse(vm.formHelper.saved);
                vm.declaration.revenuTotal = null;
                vm.declaration.revenuDeterminantTotal = null;
                vm.declaration.retenueTotal = null;
                vm.declaration.commission = null;
                vm.declaration.retenueNette = null;
                vm.declaration.remarque = null;
                vm.declaration.excelFile = null;
                vm.declaration.listesRecapitulatives = [angular.copy(oriLR)];
                vm.declaration.typeDeclarationIs = 'FORM';
                vm.checkAuthorization();
                vm.formHelper.saveHeader = true;
            }

            if ($stateParams.locale) {
                vm.declaration.langue = $stateParams.locale;
                $translate.use($stateParams.locale);
            } else {
                $translate.use('fr');
            }

            LocaliteService.getByCanton(cantonFRCode).then(function (response) {
                vm.localites = response.data;
            }).catch(function (error) {
                $log.error('Erreur appel ws /localite/canton');
                vm.treatError(error);
            });

            ContextFiscalService.getAnneesFiscales().then(function (response) {
                vm.formHelper.anneesFiscales = response.data;
                var lastYear = new Date().getFullYear() - 1;
                var defaultAnneeFiscale = -1;
                angular.forEach(vm.formHelper.anneesFiscales, function (val) {
                    if (val === lastYear) {
                        defaultAnneeFiscale = val;
                        return;
                    }
                });
                if(!vm.declaration.anneeFiscale) {
                    vm.declaration.anneeFiscale = defaultAnneeFiscale;
                }
                vm.anneeFiscaleSelected();
                oriDeclaration.anneeFiscale = vm.declaration.anneeFiscale;
            }).catch(function (error) {
                $log.error('Erreur appel ws /contextefiscal');
                vm.treatError(error);
            });

            $scope.$on('cfpLoadingBar:started', function () {
                $window.addEventListener('keydown', preventDefault);
            });

            $scope.$on('cfpLoadingBar:completed', function () {
                $window.removeEventListener('keydown', preventDefault);
                vm.sendHeightToParent();
            });
            $scope.loadCountries();
        }

        $scope.normaliserTauxTeletravail = function (listeRecapitulative) {
            var t = listeRecapitulative.tauxTeletravailFrance;

            if (t == null || t === '') {
                return;
            }

            t = Number(t);
            if (isNaN(t)) {
                listeRecapitulative.tauxTeletravailFrance = null;
                return;
            }

            if (t < 0) {
                t = 0;
            }
            if (t > 100) {
                t = 100;
            }

            listeRecapitulative.tauxTeletravailFrance = t;
        };


        $scope.loadCountries = function () {

            // Déterminer la langue de l'utilisateur : on force à 'fr' ou 'de'
            var userLang = $translate.use() === 'de' ? 'de' : 'fr';

            // Construire l'URL du fichier JSON statique
            var url = 'content/countries-' + userLang + '.json';

            $http.get(url)
                .then(function (response) {

                    $scope.countryList = [
                        { code: 'FR', name: 'FRANCE' }
                    ];
                })
                .catch(function (error) {
                    // Journaliser l'erreur mais ne pas bloquer le formulaire
                    $log.error('Erreur lors du chargement de la liste des pays : ', error);
                    $scope.countryList = [];
                });
        };


        vm.sanitizeTauxTeletravail = function (lr) {
            // Ne rien faire si le modèle est vide
            if (lr.tauxTeletravailFrance === null || lr.tauxTeletravailFrance === undefined || lr.tauxTeletravailFrance === '') {
                return;
            }

            // Forcer un nombre entier
            var value = parseInt(lr.tauxTeletravailFrance, 10);

            // Si ce n’est pas un nombre, on remet à null
            if (isNaN(value)) {
                lr.tauxTeletravailFrance = null;
                return;
            }

            // Bornes 0–100
            if (value < 0) {
                value = 0;
            } else if (value > 100) {
                value = 100;
            }

            lr.tauxTeletravailFrance = value;
        };


        $scope.$on('$translateChangeSuccess', function () {
            $scope.loadCountries();
        });


        // synchroniser le pays de résidence avec le taux de télétravail
        $scope.syncPaysResidenceFromTeletravail = function (lr) {
            // Vérifier la présence + conversion numérique
            var v = lr && lr.tauxTeletravailFrance;

            // Si vide => on nettoie le pays (optionnel)
            if (v === null || v === undefined || v === '') {
                lr.paysResidence = null;
                return;
            }

            // Conversion en nombre (gère "10", "10.5", "10,5")
            var n = Number(String(v).replace(',', '.'));

            // Si valide (0..100) => France
            if (!isNaN(n) && n >= 0 && n <= 100) {
                lr.paysResidence = 'FR';
            } else {
                // Si invalide => on nettoie (optionnel)
                lr.paysResidence = null;
            }
        };




        //Fonction pour les appels depuis le template
        vm.sendHeightToParent = function() {
            IframeService.sendHeightToParent('declaris-form-content-wrapper');
        }

        init();

        vm.anneeFiscaleSelected = function () {
            if (vm.declaration.anneeFiscale) {
                BaremeService.getCodeLRByAnnFis(vm.declaration.anneeFiscale).then(function (response) {
                    vm.baremes = response.data;
                }).catch(function (error) {
                    $log.error('Erreur appel ws /bareme/annee/' + vm.declaration.anneeFiscale, +'/lr');
                    vm.treatError(error);
                });

                BaremeService.getCodeSansRevenuDeterminantByAnnee(vm.declaration.anneeFiscale).then(function (response) {
                    vm.baremesSansRevenuDeterminant = response.data;
                }).catch(function (error) {
                    $log.error('Erreur appel ws /bareme/annee/' + vm.declaration.anneeFiscale + '/sansrevenudeterminant');
                    vm.treatError(error);
                });

                BaremeService.getCodeEnfantObligatoireByAnnee(vm.declaration.anneeFiscale).then(function (response) {
                    vm.baremesEnfantObligatoire = response.data;
                }).catch(function (error) {
                    $log.error('Erreur appel ws /bareme/annee/' + vm.declaration.anneeFiscale + '/enfantobligatoire');
                    vm.treatError(error);
                });

                BaremeService.getCodeAvecEnfantsByAnnee(vm.declaration.anneeFiscale).then(function (response) {
                    vm.baremesAvecEnfants = response.data;
                }).catch(function (error) {
                    $log.error('Erreur appel ws /bareme/annee/' + vm.declaration.anneeFiscale + '/avecenfants');
                    vm.treatError(error);
                });

                ContextFiscalService.getByAnnee(vm.declaration.anneeFiscale).then(function (response) {
                    vm.formHelper.contexteFiscale = response.data;
                }).catch(function (error) {
                    $log.error('Erreur appel ws /contextefiscal');
                    vm.treatError(error);
                });
                vm.declaration.periodeDebut = vm.declaration.anneeFiscale + '-01-01';
                vm.declaration.periodeFin = vm.declaration.anneeFiscale + '-12-31';

                resetPeriod();

                vm.checkAuthorization();
            }
        };

        vm.addEntry = function () {
            var lastEntry = vm.declaration.listesRecapitulatives[vm.declaration.listesRecapitulatives.length - 1];

            var newIndex = lastEntry.index + 1;

            var newEntry = angular.copy(oriLR);
            newEntry['index'] = newIndex;

            vm.declaration.listesRecapitulatives.push(newEntry);
            vm.calculateTotals();
            vm.$broadcast('show-errors-reset');
            vm.sendHeightToParent();
        };

        vm.removeEntry = function (index) {

            var indexKey = null;

            angular.forEach(vm.declaration.listesRecapitulatives, function (value, key) {
                if (value.index === index) {
                    indexKey = key;
                    return;
                }
            });

            vm.declaration.listesRecapitulatives.splice(indexKey, 1);
            vm.calculateTotals();
            vm.sendHeightToParent();
        };

        vm.goToFirstStep = function () {
            vm.formHelper.step = 1;
            vm.formHelper.errorMsg = null;
            vm.formHelper.showValidationMsg = false;
            vm.errors = {};
            vm.warnings = {};
        };

        var filterErrors = function(errors) {
            vm.errors = {};
            angular.forEach(errors, function (value) {
                if (value.index > 0) {
                    vm.errors[value.index + value.field] = value;
                }
            });
        };

        var filterWarnings = function(warnings) {
            vm.warnings = {};
            angular.forEach(warnings, function (value) {
                if (value.index > 0) {
                    vm.warnings[value.index + value.field] = value;
                }
            });
        };

        vm.treatError = function(error, frontend) {
            vm.formHelper.errorMsg = ErrorUtil.translateError(error, ERROR_PREFIX + 'error.internalServerError', ERROR_PREFIX);

            ErrorUtil.treatError(error, frontend, function() {
                FrontendlogService.logWhitelist(vm.declaration.ndc, vm.declaration.anneeFiscale, vm.declaration.codeSecurite, error, function (value) {
                    // We don't care, it's logging
                }, function (err) {
                    // We don't care, it's logging
                });
            });
        };

        vm.goToSecondStep = function () {
            try {
                if (vm.formHelper.saveHeader) {
                    $window.localStorage.setItem(localStorageKey, JSON.stringify(vm.declaration));
                } else {
                    $window.localStorage.removeItem(localStorageKey);
                }

                vm.$broadcast('show-errors-check-validity');
                if (vm.isFormValid()) {
                    var stopWatching = vm.$watch(function (){return vm.ongoingRequest;},function(newVal) {
                        if(newVal === false) {
                            stopWatching();
                            DeclarationLRService.check(vm.declaration, vm.declaration.excelFile).then(function (response) {
                                var value = response.data;
                                var excelFile = vm.declaration.excelFile;
                                vm.declaration = value.declarationLRDTO;
                                vm.declaration.excelFile = excelFile;
                                filterErrors(value.errors);
                                filterWarnings(value.warnings);
                                vm.formHelper.step = 2;
                            }).catch(function (error) {
                                $log.error('Erreur appel ws /declaration/lr/check');
                                vm.treatError(error);
                            });
                        }
                    });
                }
            } catch (err) {
                vm.treatError(err, true);
            }
        };

        vm.getRemarqueScc = function () {
            return vm.declaration.remarqueScc.split('\n').join('<br>');
        };

        vm.getRemarqueSccLines = function () {
            if (vm.declaration && vm.declaration.remarqueScc) {
                return vm.declaration.remarqueScc.split('\n');
            }
            return "";
        };

        $scope.verifierTeletravailFrance = function(lr) {
            if (lr.tauxTeletravailFrance < 0) lr.tauxTeletravailFrance = 0;
            if (lr.tauxTeletravailFrance > 100) lr.tauxTeletravailFrance = 100;
        };

        vm.sendDeclaration = function () {
            try {
                DeclarationLRService.create(vm.declaration, vm.declaration.excelFile).then(function () {
                    vm.formHelper.step = 3;
                }).catch(function (error) {
                    $log.error('Erreur appel ws /declaration/lr');
                    vm.treatError(error);
                });
            } catch(err) {
                vm.treatError(err, true);
            }
        };

        vm.uploadExcelFile = function () {
            try {
                DeclarationLRService.check(vm.declaration, vm.declaration.excelFile).then(function (response) {
                    var value = response.data;
                    var tmpExcelFile = vm.declaration.excelFile;
                    vm.declaration = value.declarationLRDTO;
                    vm.declaration.excelFile = tmpExcelFile;
                    filterErrors(value.errors);
                    filterWarnings(value.warnings);
                    vm.formHelper.fileUploaded = true;
                }).catch(function (error) {
                    $log.error('Erreur appel ws /declaration/lr/check');
                    $log.error(error);
                    vm.formHelper.fileUploadError = ErrorUtil.translateError(error, ERROR_PREFIX + 'error.internalServerError', ERROR_PREFIX);
                });
            } catch(err) {
                vm.treatError(err, true);
            }
        };

        vm.loadExcelFile = function () {
            var excelInput = document.getElementById('excel');
            var excelFile = excelInput.files[0];
            var reader = new FileReader();
            reader.onload = function () {
                vm.uploadExcelFile();
            };
            reader.readAsDataURL(excelFile);
        };

        vm.resetInputFile = function () {
            var excelInput = document.getElementById('excel');
            if (excelInput) {
                excelInput.value = '';
            }
            vm.formHelper.fileUploaded = false;
            vm.formHelper.fileUploadError = null;
            vm.declaration.listesRecapitulatives = [angular.copy(oriLR)];
        };

        vm.calculer = function (listeRecapitulative) {
            if (this.isBaremeEnfantObligatoire(listeRecapitulative.bareme) && listeRecapitulative.nbEnfants < 1) {
                listeRecapitulative.nbEnfants = 1;
            }
            if (this.isBaremeSansRevenuDeterminant(listeRecapitulative.bareme) || !this.isBaremeAvecEnfants(listeRecapitulative.bareme)) {
                listeRecapitulative.nbEnfants = 0;
            }
            if (listeRecapitulative.bareme && listeRecapitulative.revenu > 0 && listeRecapitulative.periodeDu && listeRecapitulative.periodeAu) {
                vm.ongoingRequest = true;
                BaremeService.calculerCote(vm.formHelper.contexteFiscale,
                                            listeRecapitulative.periodeDu, listeRecapitulative.periodeAu, listeRecapitulative.bareme,
                                            listeRecapitulative.nbEnfants, listeRecapitulative.revenu, listeRecapitulative.travailDiscontinu,
                                            listeRecapitulative.tauxActivite, listeRecapitulative.tauxAutresActivites, listeRecapitulative.nbHeuresTravail,
                                            listeRecapitulative.revenuDeterminant)
                    .then(function (response) {
                        vm.ongoingRequest = false;
                        var value = response.data;
                        listeRecapitulative.retenue = value.retenue;
                        listeRecapitulative.computedRetenue = value.retenue;
                        listeRecapitulative.revenuDeterminant = value.revenuDeterminant;
                        listeRecapitulative.computedRevenuDeterminant = value.revenuDeterminantCalcule;
                        vm.calculateTotals();
                    }).catch(function (error) {
                        vm.ongoingRequest = false;
                        $log.error('Erreur appel ws /bareme/cote');
                        vm.treatError(error);
                    });
            } else {
                listeRecapitulative.retenue = null;
                listeRecapitulative.computedRetenue = null;
                listeRecapitulative.revenuDeterminant = null;
                listeRecapitulative.computedRevenuDeterminant = null;
            }
            vm.calculateTotals();
        };

        vm.resetRevenuDeterminantEtCalculer = function (listeRecapitulative) {
            listeRecapitulative.revenuDeterminant = null;
            listeRecapitulative.computedRevenuDeterminant = null;
            vm.calculer(listeRecapitulative);
        }

        vm.calculateTotals = function () {
            vm.declaration.revenuTotal = Number(0.0);
            vm.declaration.revenuDeterminantTotal = Number(0.0);
            vm.declaration.retenueTotal = Number(0.0);

            angular.forEach(vm.declaration.listesRecapitulatives, function (value) {
                if (!isNaN(value.revenu)) {
                    vm.declaration.revenuTotal += Number(value.revenu);
                }
                if (!isNaN(value.retenue)) {
                    vm.declaration.retenueTotal += Number(value.retenue);
                }
                if (!isNaN(value.revenuDeterminant)) {
                    vm.declaration.revenuDeterminantTotal += Number(value.revenuDeterminant);
                }
            });

            vm.declaration.commission = Math.round(vm.declaration.retenueTotal * vm.formHelper.contexteFiscale.tauxCommission * 20) / 20;
            vm.declaration.retenueNette = vm.declaration.retenueTotal - vm.declaration.commission;
        };

        vm.hasErrors = function (listeRecapitulative, fields) {
            var errorMessage = ValidationUtil.getValidationMessage(vm.errors, listeRecapitulative, fields);
            return !angular.isUndefined(errorMessage) && errorMessage !== null;
        };

        vm.hasWarnings = function (listeRecapitulative, fields) {
            if (vm.hasErrors(listeRecapitulative, fields)) {
                // Les erreurs sont prioritaires par rapport aux warning
                return false;
            }
            var warningMessage = ValidationUtil.getValidationMessage(vm.warnings, listeRecapitulative, fields);
            return !angular.isUndefined(warningMessage) && warningMessage !== null;
        };

        var trusted = {}
        vm.getValidationMessage = function (listeRecapitulative, fields) {
            var html = ValidationUtil.getValidationMessage(vm.errors, listeRecapitulative, fields);
            if (angular.isUndefined(html) || html === null) {
                html = ValidationUtil.getValidationMessage(vm.warnings, listeRecapitulative, fields);
            }
            // Caching nécessaire à cause du problème https://github.com/angular/angular.js/issues/3932
            return trusted[html] || (trusted[html] = $sce.trustAsHtml(html));
        };

        vm.showAuthorizationResult = function () {
            if (vm.declaration.ndc && vm.declaration.ndc !== '' && vm.declaration.codeSecurite && vm.declaration.codeSecurite !== '') {
                return !vm.formHelper.authorized;
            }
            return false;
        };

        var hasValidationErrors = function() {
            return ObjectUtils.isNonEmptyObject(vm.errors) || vm.formHelper.fileUploadError;
        };

        vm.isFormValid = function () {
            var lrFormValid = true;
            if (this.declarationIsForm) {
                lrFormValid = vm.declaration.typeDeclarationIs === 'FORM' && !this.declarationIsForm.$invalid;
            }

            var headerFormValid = true;
            if (this.declarationHeaderForm) {
                headerFormValid = !this.declarationHeaderForm.$invalid;
            }

            var excelFormValid = vm.declaration.typeDeclarationIs === 'EXCEL'
                    && vm.declaration.excelFile !== undefined && vm.declaration.excelFile !== null;

            var formValid = headerFormValid && (lrFormValid || excelFormValid);

            var valid = formValid && !hasValidationErrors() && vm.formHelper.authorized;

            if (valid) {
                vm.formHelper.showValidationMsg = false;
            }

            return valid;
        };

        vm.retenueModified = function (listeRecapitulative) {
            if (!listeRecapitulative.retenue || listeRecapitulative.retenue <= 0) {
                vm.calculer(listeRecapitulative);
            }
            vm.calculateTotals();
        };

        vm.isRetenueModified = function (listeRecapitulative) {
            if (!listeRecapitulative.retenue && !listeRecapitulative.computedRetenue) {
                return false;
            }
            return listeRecapitulative.retenue && listeRecapitulative.computedRetenue && listeRecapitulative.retenue !== listeRecapitulative.computedRetenue;
        };

        vm.isRevenuDeterminantModified = function (listeRecapitulative) {
            if (!listeRecapitulative.revenuDeterminant || !listeRecapitulative.computedRevenuDeterminant) {
                return false;
            }
            return listeRecapitulative.revenuDeterminant !== listeRecapitulative.computedRevenuDeterminant;
        };

        vm.resetForm = function () {
            vm.formHelper.fileUploadError = null;
            vm.declaration = oriDeclaration;
            vm.resetInputFile(document.getElementById('excel'));
            vm.$broadcast('show-errors-reset');
            vm.formHelper.showValidationMsg = false;
            vm.formHelper.errorMsg = null;
        };

        vm.printDiv = function() {
            try {
                DeclarationLRService.download(vm.declaration, vm.declaration.excelFile).then(function (response) {
                    var file = new Blob([response.data], {
                        type: 'application/pdf'
                    });
                    var fileURL = URL.createObjectURL(file);
                    var a = document.createElement('a');
                    a.href = fileURL;
                    a.target = '_blank';
                    a.download = 'download.pdf';
                    document.body.appendChild(a);
                    a.click();
                    document.body.removeChild(a);
                }).catch(function (error) {
                    $log.error('Erreur appel ws /declaration/lr/download');
                    vm.treatError(error);
                });
            } catch(err) {
                vm.treatError(err, true);
            }
        };

        vm.showValidation = function() {
            vm.formHelper.showValidationMsg = true;
            vm.$broadcast('show-errors-check-validity');
        };

        vm.customInputChange = function(lr) {
            vm.calculer(lr);
            $timeout(function() {
                vm.showValidation();
            }, 500);
        };

        vm.localiteSelected = function(lr, localite) {
            lr.npa = localite.npa;
            lr.localite = localite.nom;
        }

        vm.updateValidation = function () {
            // Obligatoire pour palier à un bug dans ui-select en combinaison avec show-errors
            vm.$broadcast('show-errors-check-validity');
        };

        vm.isBaremeSansRevenuDeterminant = function (bareme) {
            return ListUtils.isStringInList(vm.baremesSansRevenuDeterminant, bareme)
        };

        vm.isBaremeEnfantObligatoire = function (bareme) {
            return ListUtils.isStringInList(vm.baremesEnfantObligatoire, bareme)
        };

        vm.isBaremeAvecEnfants = function (bareme) {
            return ListUtils.isStringInList(vm.baremesAvecEnfants, bareme)
        };

        vm.activiteChange = function(lr) {
            lr.nbHeuresTravail = null;
            lr.tauxActivite = null;
            lr.tauxAutresActivites = null;
            if(lr.travailDiscontinu) {
                lr.nbHeuresTravail = 1;
            } else {
                lr.tauxActivite = 1;
                lr.tauxAutresActivites = 0;
            }
            vm.calculer(lr);
        }

        vm.isBaremeAAvecEnfant = function (lr) {
            return lr.bareme === 'A' && lr.nbEnfants > 0;
        }

    });
;
'use strict';

angular.module('formonlineApp').service('DeclarationLRService', ['$http',
    function ($http) {

        this.create = function (declarationIs, file) {
            return $http({
                method: 'post',
                url: 'api/declaration/lr',
                headers: {'Content-Type': undefined },
                transformRequest: function (data) {
                    var formData = new FormData();

                    formData.append('form', new Blob([angular.toJson(declarationIs)], {
                        type: 'application/json'
                    }));
                    formData.append('file', file);
                    return formData;
                },
                data: { data: declarationIs, file: file }
            });
        };

        this.download = function (declarationIs, file) {
            return $http({
                method: 'post',
                url: 'api/declaration/lr/download',
                headers: {'Content-Type': undefined },
                responseType: 'arraybuffer',
                transformRequest: function (data) {
                    var formData = new FormData();

                    formData.append('form', new Blob([angular.toJson(declarationIs)], {
                        type: 'application/json'
                    }));
                    formData.append('file', file);
                    return formData;
                },
                data: { data: declarationIs, file: file }
            });
        };

        this.check = function (declarationIs, file) {
            return $http({
                method: 'post',
                url: 'api/declaration/lr/check',
                headers: {'Content-Type': undefined },
                transformRequest: function (data) {
                    var formData = new FormData();

                    formData.append('form', new Blob([angular.toJson(declarationIs)], {
                        type: 'application/json'
                    }));
                    formData.append('file', file);
                    return formData;
                },
                data: { data: declarationIs, file: file }
            });
        };

    }]);
;
'use strict';

angular.module('formonlineApp')
    .config(function ($stateProvider) {
        $stateProvider.state('calculis', {
            parent: 'fullwidth',
            url: '/calculis/{locale}',
            views: {
                'content@': {
                    templateUrl: 'scripts/app/form/calculis/calculis.html',
                    controller: 'CalculetteController'
                }
            }
        });
    });
;
'use strict';

angular.module('formonlineApp')
    .controller('CalculetteController', function ($scope, $log, $q, $stateParams, $translate, ContextFiscalService,
                                                  BaremeService, ErrorUtil, Language, ListUtils, IframeService) {
        const NB_JOURS_ANNEE = 360;
        const NB_JOURS_MOIS = 30;

        var vm = $scope;

        vm.baremes = [];
        vm.baremesSansRevenuDeterminant = [];
        vm.baremesEnfantObligatoire = [];
        vm.baremesAvecEnfants = [];

        vm.calcul = {};
        vm.calcul.bareme = null;
        vm.calcul.nbDeJours = NB_JOURS_ANNEE;
        vm.calcul.baseCalculMensuel = 30;
        vm.calcul.anneesFiscales = [];
        vm.calcul.anneeFiscale = null;
        vm.calcul.revenuBrut = 60000;
        vm.calcul.nbEnfants = 0;
        vm.calcul.etatCivil = 'INCONNU';
        vm.calcul.tauxActivite = 1;
        vm.calcul.tauxAutresActivites = 0;
        vm.calcul.extrapolerSurTauxActivite = true;
        vm.calcul.travailDiscontinu = false;
        vm.calcul.nbHeuresTravail = 0;
        vm.calcul.errorMsg = null;
        vm.calcul.revenuMensuel = false;

        if ($stateParams.locale) {
            $translate.use($stateParams.locale);
        } else {
            $translate.use('fr');
        }

        var getCodeCalculetteByAnnee = function () {
            return BaremeService.getCodeCalculetteByAnnee(vm.calcul.anneeFiscale).then(function (response) {
                vm.baremes = response.data;
            }).catch(function (error) {
                $log.error('Erreur appel ws /bareme/annee/' + vm.calcul.anneeFiscale + '/calculette');
                $log.error(error);
                vm.calcul.errorMsg = ErrorUtil.translateError(error, 'error.error.internalServerError', 'error.');
            });
        }

        var getCodeCalculetteSansRevenuDeterminantByAnnee = function () {
            return BaremeService.getCodeCalculetteSansRevenuDeterminantByAnnee(vm.calcul.anneeFiscale).then(function (response) {
                vm.baremesSansRevenuDeterminant = response.data;
            }).catch(function (error) {
                $log.error('Erreur appel ws /bareme/annee/' + vm.calcul.anneeFiscale + '/calculettesansrevenudeterminant');
                $log.error(error);
                vm.calcul.errorMsg = ErrorUtil.translateError(error, 'error.error.internalServerError', 'error.');
            });
        }

        var getCodeCalculetteEnfantObligatoireByAnnee = function () {
            return BaremeService.getCodeCalculetteEnfantObligatoireByAnnee(vm.calcul.anneeFiscale).then(function (response) {
                vm.baremesEnfantObligatoire = response.data;
            }).catch(function (error) {
                $log.error('Erreur appel ws /bareme/annee/' + vm.calcul.anneeFiscale + '/calculetteenfantobligatoire');
                $log.error(error);
                vm.calcul.errorMsg = ErrorUtil.translateError(error, 'error.error.internalServerError', 'error.');
            });
        }

        var getCodeCalculetteAvecEnfantsByAnnee = function () {
            return BaremeService.getCodeCalculetteAvecEnfantsByAnnee(vm.calcul.anneeFiscale).then(function (response) {
                vm.baremesAvecEnfants = response.data;
            }).catch(function (error) {
                $log.error('Erreur appel ws /bareme/annee/' + vm.calcul.anneeFiscale + '/calculetteavecenfants');
                $log.error(error);
                vm.calcul.errorMsg = ErrorUtil.translateError(error, 'error.error.internalServerError', 'error.');
            });
        }

        var getByAnnee = function () {
            return ContextFiscalService.getByAnnee(vm.calcul.anneeFiscale).then(function (response) {
                vm.calcul.cf = response.data;
            }).catch(function (error) {
                $log.error('Erreur appel ws /contextefiscal');
                $log.error(error);
                vm.calcul.errorMsg = ErrorUtil.translateError(error, 'error.error.internalServerError', 'error.');
            });
        }

        var loadBaremeLists = function () {
            return $q.all([getCodeCalculetteByAnnee(),
                getCodeCalculetteSansRevenuDeterminantByAnnee(),
                getCodeCalculetteEnfantObligatoireByAnnee(),
                getCodeCalculetteAvecEnfantsByAnnee(),
                getByAnnee()]);
        }

        var init = function () {
            $scope.$on('cfpLoadingBar:completed', function () {
                vm.sendHeightToParent();
            });

            ContextFiscalService.getAnneesFiscales().then(function (response) {
                vm.calcul.anneesFiscales = response.data;
                var thisYear = new Date().getFullYear();
                angular.forEach(vm.calcul.anneesFiscales, function (val) {
                    if (val === thisYear) {
                        vm.calcul.anneeFiscale = val;
                        return;
                    }
                });
                if (!vm.calcul.anneeFiscale) {
                    vm.calcul.anneeFiscale = value[0];
                }
                vm.anneeFiscaleSelected();
            }).catch(function (error) {
                $log.error('Erreur appel ws /contextefiscal');
                $log.error(error);
                vm.calcul.errorMsg = ErrorUtil.translateError(error, 'error.error.internalServerError', 'error.');
            });
        }

        init();

        //Fonction pour les appels depuis le template
        vm.sendHeightToParent = function() {
            IframeService.sendHeightToParent('calculis-form-content-wrapper');
        }

        vm.getLanguage = function() {
            return Language.current();
        };

        vm.anneeFiscaleSelected = function () {
            if (vm.calcul.anneeFiscale) {
                vm.calcul.travailDiscontinu = false;
                vm.calcul.tauxActivite = 1;
                vm.calcul.tauxAutresActivites = 0;
                vm.calcul.nbHeuresTravail = null;
                vm.calcul.bareme = null;

                loadBaremeLists().then(function () {
                    vm.resetRevenuDeterminantEtCalculer();
                }).catch(function (error) {
                    $log.error('Erreur lors du chargement des barèmes')
                    $log.error(error);
                });
            }
        };

        vm.calculer = function () {
            try {
                if (vm.calcul.bareme && vm.calcul.revenuBrut
                    && (!this.isBaremeAvecEnfants(vm.calcul.bareme) || Number.isInteger(vm.calcul.nbEnfants))
                    && !vm.calculisForm.$invalid) {

                    if (this.isBaremeEnfantObligatoire(vm.calcul.bareme) && vm.calcul.nbEnfants < 1) {
                        vm.calcul.nbEnfants = 1;
                    }
                    if (this.isBaremeSansRevenuDeterminant(vm.calcul.bareme) || !this.isBaremeAvecEnfants(vm.calcul.bareme)) {
                        vm.calcul.nbEnfants = 0;
                    }
                    vm.calcul.nbDeJours = vm.calcul.revenuMensuel ? NB_JOURS_MOIS : NB_JOURS_ANNEE;
                    BaremeService.calculerCoteByNbJours(vm.calcul.nbDeJours, vm.calcul.cf, vm.calcul.bareme, vm.calcul.nbEnfants, vm.calcul.revenuBrut, null /* revenuConjoint */,
                        vm.calcul.tauxActivite, vm.calcul.tauxAutresActivites, vm.calcul.travailDiscontinu, vm.calcul.nbHeuresTravail,
                        null /* retenue */, null /* commission */, vm.calcul.revenuDeterminant /* revenuDeterminant */, null /* dossierTauxCommission */, vm.calcul.etatCivil, 0 /* nbPersonnes*/)
                        .then(function (response) {
                            var value = response.data;
                            vm.calcul.taux = value.taux / 100;
                            vm.calcul.retenue = value.retenue;
                            vm.calcul.revenuDeterminant = value.revenuDeterminant;
                            vm.calcul.computedRevenuDeterminant = value.revenuDeterminantCalcule;
                        }).catch(function (error) {
                            $log.error('Erreur appel ws /bareme/cote');
                            $log.error(error);
                            vm.calcul.errorMsg = ErrorUtil.translateError(error, 'error.error.internalServerError', 'error.');
                        });
                } else {
                    vm.calcul.taux = null;
                    vm.calcul.retenue = null;
                    vm.calcul.revenuDeterminant = null;
                    vm.calcul.computedRevenuDeterminant = null;
                }
            } catch (error) {
                $log.error(error);
                vm.calcul.errorMsg = $translate.instant('error.error.internalServerError');
            }
        };

        vm.isBaremeSansRevenuDeterminant = function (bareme) {
            return ListUtils.isStringInList(vm.baremesSansRevenuDeterminant, bareme);
        };

        vm.isBaremeEnfantObligatoire = function (bareme) {
            return ListUtils.isStringInList(vm.baremesEnfantObligatoire, bareme);
        };

        vm.isBaremeAvecEnfants = function (bareme) {
            return ListUtils.isStringInList(vm.baremesAvecEnfants, bareme);
        };

        vm.activiteChange = function() {
            vm.calcul.nbHeuresTravail = null;
            vm.calcul.tauxActivite = null;
            vm.calcul.tauxAutresActivites = null;
            if(vm.calcul.travailDiscontinu) {
                vm.calcul.nbHeuresTravail = 1;
            } else {
                vm.calcul.tauxActivite = 1;
                vm.calcul.tauxAutresActivites = 0;
            }
            vm.resetRevenuDeterminantEtCalculer();
        }

        vm.isRevenuDeterminantModified = function () {
            if (!vm.calcul.revenuDeterminant || !vm.calcul.computedRevenuDeterminant) {
                return false;
            }
            return vm.calcul.revenuDeterminant !== vm.calcul.computedRevenuDeterminant;
        };

        vm.resetRevenuDeterminantEtCalculer = function () {
            vm.calcul.revenuDeterminant = null;
            vm.calcul.computedRevenuDeterminant = null;
            vm.calculer();
        }

    });
;
(function () {
    'use strict';

    angular.module('formonlineApp')
        .config(translateConfig);

    translateConfig.$inject = ['$translateProvider'];

    function translateConfig($translateProvider) {
        $translateProvider.useUrlLoader('api/messageSource');
        $translateProvider.preferredLanguage('fr');
        $translateProvider.fallbackLanguage('fr');
        $translateProvider.useCookieStorage();
        $translateProvider.useSanitizeValueStrategy('escaped');
    }
})();
;
(function () {
	'use strict';

	angular.module('formonlineApp')
			.config(stateConfig);

	stateConfig.$inject = ['$stateProvider'];

	function stateConfig($stateProvider) {
		$stateProvider.state('app', {
			abstract: true,
			data: {
				contentWrapperCls: 'col-md-12'
			},
			views: {
				'navbar@': {
					templateUrl: 'scripts/app/layouts/navbar/navbar.html',
					controller: 'NavbarController',
					controllerAs: 'vm'
				}
			},
			resolve: {
				info: function (InfoService) {
					return InfoService.load();
				}
//				translatePartialLoader: function ($translate, $translatePartialLoader) {
//					$translatePartialLoader.addPart('global');
//				}
			}
		}).state('fullwidth', {
			parent: 'app',
			abstract: true,
			data: {
				contentWrapperCls: 'col-md-12'
			}
		}).state('sidebar', {
			parent: 'app',
			abstract: true,
			data: {
				contentWrapperCls: 'col-md-10 col-sm-9'
			},
			views: {
				'sidebar@': {
					templateUrl: 'scripts/app/layouts/sidebar/sidebar.html',
					controller: 'SidebarController'
				}
			}
		}).state('footer', {
			parent: 'fullwidth',
			abstract: true,
			data: {
				contentWrapperCls: 'col-md-12 content-footer'
			},
			views: {
				'footer@': {
					templateUrl: 'scripts/app/layouts/footer/footer.html',
					controller: 'FooterController'
				}
			},
			resolve: {
				toolbarSettings: function (ObjectUtils) {
					return new ObjectUtils.initToolbarSettings();
				}
			}
		}).state('submenu', {
			parent: 'fullwidth',
			abstract: true,
			data: {
				contentWrapperCls: 'col-md-12 content-submenu'
			},
			views: {
				'submenu@': {
					templateUrl: 'scripts/app/layouts/submenu/submenu.html',
					controller: 'SubmenuController'
				}
			},
			resolve: {
				submenuSettings: function (ObjectUtils) {
					return new ObjectUtils.initSubmenuSettings();
				}
			}
		}).state('sidebar-footer', {
			parent: 'sidebar',
			abstract: true,
			data: {
				contentWrapperCls: 'col-md-10 col-sm-9 content-footer'
			},
			views: {
				'footer@': {
					templateUrl: 'scripts/app/layouts/footer/footer.html',
					controller: 'FooterController'
				}
			},
			resolve: {
				toolbarSettings: function (ObjectUtils) {
					return new ObjectUtils.initToolbarSettings();
				}
			}
		}).state('sidebar-submenu', {
			parent: 'sidebar',
			abstract: true,
			data: {
				contentWrapperCls: 'col-md-10 col-sm-9 content-submenu'
			},
			views: {
				'submenu@': {
					templateUrl: 'scripts/app/layouts/submenu/submenu.html',
					controller: 'SubmenuController'
				}
			},
			resolve: {
				submenuSettings: function (ObjectUtils) {
					return new ObjectUtils.initSubmenuSettings();
				}
			}
		}).state('sidebar-submenu-footer', {
			parent: 'sidebar-footer',
			abstract: true,
			data: {
				contentWrapperCls: 'col-md-10 col-sm-9 content-submenu-footer'
			},
			views: {
				'submenu@': {
					templateUrl: 'scripts/app/layouts/submenu/submenu.html',
					controller: 'SubmenuController'
				}
			},
			resolve: {
				submenuSettings: function (ObjectUtils) {
					return new ObjectUtils.initSubmenuSettings();
				}
			}
		});
	}
})();
;
(function () {
    "use strict";
    // DO NOT EDIT THIS FILE, EDIT THE GULP TASK NGCONSTANT SETTINGS INSTEAD WHICH GENERATES THIS FILE
    angular.module("formonlineApp")

.constant("ENV", "prod")

.constant("VERSION", "${revision}")

.constant("ERROR_PREFIX", "error.")

;
})();
;
(function () {
    'use strict';

    angular.module('formonlineApp')
        .config(accessibilityConfig);

    accessibilityConfig.$inject = ['$ariaProvider'];

    function accessibilityConfig($ariaProvider) {
        $ariaProvider.config({
            tabindex: false
        });
    }
})();
;(function(){angular.module("formonlineApp").run(["$templateCache", function($templateCache) {$templateCache.put("scripts/app/main/main.html","<div class=\"panel panel-default\"><div class=\"panel-body\"><div class=\"row\"></div></div></div>");
$templateCache.put("scripts/components/home/home.html","<div ng-cloak><div class=\"row\"><div class=\"col-md-4\"><span class=\"hipster img-responsive img-rounded\"></span></div><div class=\"col-md-8\"><h1 translate=\"home.title\">Welcome, Java Hipster!</h1><p class=\"lead\" translate=\"home.subtitle\">This is your homepage</p><div ng-switch=\"vm.isAuthenticated()\"><div class=\"alert alert-success\" ng-switch-when=\"true\" translate=\"home.logged.message\" translate-values=\"{username: \'{{vm.account.login}}\'}\">You are logged in as user \"{{vm.account.login}}\".</div><div class=\"alert alert-warning\" ng-switch-when=\"false\" translate=\"global.messages.info.authenticated\" translate-compile>If you want to <a class=\"alert-link\" href=\"\" ng-click=\"vm.login()\">sign in</a>, you can try the default accounts:<br>- Administrator (login=\"admin\" and password=\"admin\")<br>- User (login=\"user\" and password=\"user\").</div><div class=\"alert alert-warning\" ng-switch-when=\"false\" translate=\"global.messages.info.register\" translate-compile>You don\'t have an account yet? <a class=\"alert-link\" ui-sref=\"register\">Register a new account</a></div></div><p translate=\"home.question\">If you have any question on JHipster:</p><ul><li><a href=\"http://jhipster.github.io/\" target=\"_blank\" translate=\"home.link.homepage\">JHipster homepage</a></li><li><a href=\"http://stackoverflow.com/tags/jhipster/info\" target=\"_blank\" translate=\"home.link.stackoverflow\">JHipster on Stack Overflow</a></li><li><a href=\"https://github.com/jhipster/generator-jhipster/issues?state=open\" target=\"_blank\" translate=\"home.link.bugtracker\">JHipster bug tracker</a></li><li><a href=\"https://gitter.im/jhipster/generator-jhipster\" target=\"_blank\" translate=\"home.link.chat\">JHipster public chat room</a></li><li><a href=\"https://twitter.com/java_hipster\" target=\"_blank\" translate=\"home.link.follow\">follow @java_hipster on Twitter</a></li></ul><p><span translate=\"home.like\">If you like JHipster, don\'t forget to give us a star on </span>&nbsp;<a href=\"https://github.com/jhipster/generator-jhipster\" target=\"_blank\" translate=\"home.github\">Github</a>!</p></div></div></div>");
$templateCache.put("scripts/core/form/core-form-controls.html","<div class=\"stl-form-controls container-fluid\" role=\"navigation\" ng-show=\"buttonsShown !== 0\"><button stl-form-controls-btn ng-if=\"!editMode && closeBtn\" href=\"\" class=\"btn btn-primary\" ng-click=\"close()\"><i18n key=\"bouton.fermer\"></i18n></button> <button stl-form-controls-btn ng-if=\"!editMode && !readOnly && editBtn\" href=\"\" class=\"btn btn-default\" ng-click=\"edit()\"><i18n key=\"bouton.modifier\"></i18n></button> <button stl-form-controls-btn ng-if=\"editMode && saveBtn\" href=\"\" class=\"btn btn-primary\" ng-click=\"save()\" ng-disabled=\"!dirty || !valid\"><i18n key=\"bouton.sauvegarder\"></i18n></button> <button stl-form-controls-btn ng-if=\"editMode && saveCloseBtn\" href=\"\" class=\"btn btn-primary\" ng-click=\"saveClose()\" ng-disabled=\"!dirty || !valid\"><i18n key=\"bouton.sauvegarderFermer\"></i18n></button> <button stl-form-controls-btn ng-if=\"editMode && btnSaveAndNew\" href=\"\" class=\"btn btn-primary\" ng-click=\"saveNew()\" ng-disabled=\"!dirty || !valid\"><i18n key=\"bouton.sauvegarderNouveau\"></i18n></button> <button stl-form-controls-btn ng-if=\"editMode && cancelBtn\" href=\"\" class=\"btn btn-default\" ng-click=\"cancel()\"><i18n key=\"bouton.annuler\"></i18n></button><!-- delete button --> <button stl-form-controls-btn ng-if=\"deletable && deletePermitted\" href=\"\" class=\"btn btn-primary\" ng-click=\"saveNew()\" ng-disabled=\"!dirty || !valid\"><i18n key=\"bouton.sauvegarderNouveau\"></i18n></button> <span ng-transclude></span></div>");
$templateCache.put("scripts/core/navbar/navbar.html","<div class=\"stl-navbar\" ng-class=\"{\'stl-navbar-open\' : navbarOpen}\"><div class=\"stl-navbar-content\" fixed-position event-listener=\"body\"><div class=\"chevron\" ng-class=\"{\'chevron-left\' : navbarOpen,\n							 \'chevron-right\' : !navbarOpen\n						 }\" ng-click=\"toggleNavbar()\"></div><div ng-repeat=\"item in items\" ng-click=\"select(item)\" ng-class=\"{\'stl-navbar-item-selected\': item === ngModel.item}\" class=\"stl-navbar-item-line\" ng-mouseenter=\"o[$index] = true\" ng-mouseleave=\"o[$index] = false\"><stl-secured secured-action=\"item.securedAction\" has-any policy=\"remove\"><div class=\"stl-navbar-image\" ng-show=\"o[$index] === true || item === ngModel.item\"><img ng-src=\"{{item.hoverImg}}\" alt=\"image\"></div><div class=\"stl-navbar-image\" ng-show=\"!o[$index] && item !== ngModel.item\"><img ng-src=\"{{item.img}}\" alt=\"image\"></div><div class=\"stl-navbar-name\">{{item.name}}</div></stl-secured></div></div></div>");
$templateCache.put("scripts/core/navigation/navigation-tabs.html","<div class=\"collapse navbar-collapse main-navbar\" id=\"main-menu\"><ul class=\"nav navbar-nav main-tabs\" ng-class=\"{disabled: !navEnabled}\"><li ng-class=\"{active: tab.active, \'tab-closeable\': tab.closeable, dirty: tab.dirty}\" ng-repeat=\"tab in tabs\" ng-if=\"!tab.hidden\"><a href=\"\" ng-click=\"activate(tab.tabId)\" class=\"tab-link\"><img ng-src=\"{{tab.iconUrl}}\" alt=\"image\" class=\"tab-icon\" ng-if=\"!tab.loading && tab.iconUrl != null && tab.iconUrl != \'\'\"> <span ng-if=\"tab.loading\" class=\"tab-loading\"></span> <span class=\"tab-text\">{{tab.text}}</span> <span class=\"tab-dirty\" ng-if=\"tab.dirty\"></span> </a><a href=\"\" ng-click=\"close(tab.tabId)\" ng-if=\"tab.closeable\" class=\"close-btn\"></a></li></ul></div>");
$templateCache.put("scripts/core/table/paginator.html","<table class=\"stl-table-paging btn-toolbar\"><tr><td width=\"200\"><div class=\"stl-table-page-count-container\"><span ng-bind-html=\"elementsCount\"></span></div></td><td align=\"center\"><div class=\"stl-table-page-container btn-group\" ng-show=\"pages.length > 1\"><button type=\"button\" class=\"btn btn-default stl-table-page stl-table-page-prev\" ng-click=\"prev()\" ng-disabled=\"parameters.selectedPage === 0\">&lt;</button> <button type=\"button\" class=\"btn btn-default stl-table-page\" ng-class=\"{\'btn-primary\' : parameters.selectedPage === page.index}\" ng-repeat=\"page in pages\" ng-click=\"selectPage(page.index)\" ng-disabled=\"page.index === null\">{{page.label}}</button> <button type=\"button\" class=\"btn btn-default stl-table-page stl-table-page-next\" ng-click=\"next()\" ng-disabled=\"parameters.selectedPage >= (totalPages-1)\">&gt;</button></div></td><td width=\"200\" align=\"right\"><div class=\"btn-group stl-table-page-formating-container\" ng-if=\"parameters.pageFormating !== undefined && parameters.pageFormating[0] < count\"><button type=\"button\" class=\"btn btn-default stl-table-page-formating\" ng-class=\"{\'btn-primary\' : parameters.totalElementsPerPage === format}\" ng-repeat=\"format in parameters.pageFormating\" ng-click=\"selectFormat(format)\">{{format}}</button></div></td></tr></table>");
$templateCache.put("scripts/core/toggler/toggler.html","<div class=\"toggler\"><div class=\"toggler-content\" ng-show=\"intTog\"><div ng-transclude></div></div><div class=\"toggler-command\"><a href=\"\" ng-click=\"exp()\"><span class=\"btn btn-default\"><span ng-show=\"!intTog\" class=\"glyphicon glyphicon-plus\"></span> <span ng-show=\"intTog\" class=\"glyphicon glyphicon-chevron-up\"></span> </span><span class=\"toggler-command-span\">{{tTitle}}</span></a></div></div>");
$templateCache.put("scripts/app/form/calculis/calculis.html","<div class=\"panel panel-default\"><div id=\"calculis-form-content-wrapper\" class=\"panel-body\"><div class=\"wrapper\"><h1 translate=\"CalculetteImpotSource\">Calculette de l\'impôt à la source</h1><div class=\"row\"><div class=\"col-md-12\"><form class=\"form-horizontal\" role=\"form\" name=\"calculisForm\"><div class=\"row form-group\"><div class=\"col-xs-4\"><label for=\"anneeFiscale\" class=\"control-label\" translate=\"AnneeFiscale\">Année fiscale</label></div><div class=\"col-xs-4\"><ui-select id=\"anneeFiscale\" name=\"anneeFiscale\" ng-model=\"calcul.anneeFiscale\" theme=\"bootstrap\" required ng-change=\"anneeFiscaleSelected()\"><ui-select-match>{{$select.selected}}</ui-select-match><ui-select-choices position=\"down\" repeat=\"a in calcul.anneesFiscales | filter: $select.search | orderBy : \'-\'\"><div ng-bind-html=\"\'\'+ a | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div><div class=\"row form-group\"><div class=\"col-xs-4\"><label class=\"control-label\" translate=\"Bareme\">Barème</label></div><div class=\"col-xs-4\"><ui-select ng-model=\"calcul.bareme\" theme=\"bootstrap\" required ng-change=\"resetRevenuDeterminantEtCalculer()\"><ui-select-match allow-clear=\"true\">{{$select.selected}}</ui-select-match><ui-select-choices position=\"down\" repeat=\"b in baremes | filter: $select.search\"><div ng-bind-html=\"\'\'+b | highlight: $select.search\" uib-popover=\"{{calcul.cf.elementsBaremeLocalisation[b][\'description\' + getLanguage().toUpperCase()]}}\" popover-trigger=\"mouseenter\" popover-append-to-body=\"true\"></div></ui-select-choices></ui-select></div></div><div class=\"row form-group\" show-errors ng-if=\"isBaremeAvecEnfants(calcul.bareme)\"><div class=\"col-xs-4\"><label class=\"control-label\" translate=\"NombreEnfants\">Nombre d\'enfants</label></div><div class=\"col-xs-4\"><input type=\"number\" class=\"form-control input-sm\" name=\"nbEnfants\" ng-model=\"calcul.nbEnfants\" max=\"{{calcul.anneeFiscale >= 2023 ? 9 : 6}}\" min=\"0\" ng-change=\"resetRevenuDeterminantEtCalculer()\" required=\"\"></div></div><div class=\"row form-group\"><div class=\"col-xs-4\"><label class=\"control-label\" translate=\"RevenuBrut\">Revenu brut</label><label ng-if=\"!isBaremeSansRevenuDeterminant(calcul.bareme) && !calcul.travailDiscontinu\"><input type=\"radio\" ng-model=\"calcul.revenuMensuel\" ng-value=\"false\" ng-checked=\"!calcul.revenuMensuel\" ng-blur=\"resetRevenuDeterminantEtCalculer()\" class=\"revenuMensuelAnnuel\"> {{\'RevenuBrutAnnuel\'|translate}}</label><label ng-if=\"!isBaremeSansRevenuDeterminant(calcul.bareme) && !calcul.travailDiscontinu\"><input type=\"radio\" ng-model=\"calcul.revenuMensuel\" ng-value=\"true\" ng-checked=\"calcul.revenuMensuel\" ng-blur=\"resetRevenuDeterminantEtCalculer()\" class=\"revenuMensuelAnnuel\"> {{\'RevenuBrutMensuel\'|translate}}</label></div><div class=\"col-xs-4\"><input type=\"text\" class=\"form-control input-sm\" ng-model=\"calcul.revenuBrut\" stl-currency-input required ng-blur=\"resetRevenuDeterminantEtCalculer()\"></div></div><div class=\"row form-group\" show-errors ng-if=\"!isBaremeSansRevenuDeterminant(calcul.bareme) && calcul.cf.annee >= 2021\"><div class=\"col-xs-4\"><label for=\"revenuDeterminant\" class=\"control-label\" translate=\"ModifierRevenuDeterminant\">Modifier le revenu déterminant</label></div><div class=\"col-xs-4\"><input id=\"revenuDeterminant\" name=\"revenuDeterminant\" type=\"text\" class=\"form-control input-sm\" ng-model=\"calcul.revenuDeterminant\" stl-currency-input ng-blur=\"calculer()\" ng-class=\"{\'alert-warning\': isRevenuDeterminantModified()}\" uib-popover=\"{{isRevenuDeterminantModified() ? (calcul.computedRevenuDeterminant | currency:2:0) : \'\'}}\" popover-title=\"{{\'MontantAttendu\' | translate}}\" popover-trigger=\"mouseenter\" popover-placement=\"top\" popover-append-to-body=\"true\"></div></div><div class=\"row form-group\" ng-if=\"!isBaremeSansRevenuDeterminant(calcul.bareme) && calcul.cf.annee >= 2021\"><div class=\"col-xs-4\"><label class=\"control-label\" translate=\"TravailDiscontinu\">Travail non stable</label></div><div class=\"col-xs-4\"><input type=\"checkbox\" name=\"travailDiscontinu\" ng-model=\"calcul.travailDiscontinu\" ng-change=\"activiteChange()\"></div></div><div class=\"row form-group\" show-errors ng-if=\"!isBaremeSansRevenuDeterminant(calcul.bareme) && calcul.cf.annee >= 2021 && !calcul.travailDiscontinu\"><div class=\"col-xs-4\"><label for=\"tauxActivite\" class=\"control-label label-required\" translate=\"TauxActivite\">Taux d\'activité</label></div><div class=\"col-xs-4\"><input id=\"tauxActivite\" name=\"tauxActivite\" type=\"text\" stl-percentage-input min=\"1\" max=\"200\" class=\"form-control input-sm\" ng-model=\"calcul.tauxActivite\" required ng-blur=\"resetRevenuDeterminantEtCalculer()\"></div></div><div class=\"row form-group\" show-errors ng-if=\"!isBaremeSansRevenuDeterminant(calcul.bareme) && calcul.cf.annee >= 2021 && !calcul.travailDiscontinu\"><div class=\"col-xs-4\"><label for=\"tauxAutresActivites\" class=\"control-label label-required\" translate=\"tauxAutresActivites\">Total des autres activités</label></div><div class=\"col-xs-4\"><input id=\"tauxAutresActivites\" name=\"tauxAutresActivites\" type=\"text\" stl-percentage-input min=\"0\" max=\"200\" class=\"form-control input-sm\" ng-model=\"calcul.tauxAutresActivites\" required ng-blur=\"resetRevenuDeterminantEtCalculer()\"></div></div><div class=\"row form-group\" show-errors ng-if=\"!isBaremeSansRevenuDeterminant(calcul.bareme) && calcul.cf.annee >= 2021 && calcul.travailDiscontinu\"><div class=\"col-xs-4\"><label for=\"nbHeuresTravail\" class=\"control-label label-required\" translate=\"NbHeuresTravail\">Heures travaillées</label></div><div class=\"col-xs-4\"><input id=\"nbHeuresTravail\" name=\"nbHeuresTravail\" type=\"number\" min=\"1\" max=\"2160\" class=\"form-control input-sm\" ng-model=\"calcul.nbHeuresTravail\" required ng-blur=\"resetRevenuDeterminantEtCalculer()\"></div></div></form></div></div><hr><div class=\"row\"><div class=\"col-xs-12\"><div class=\"row form-group\"><div class=\"col-xs-4\"><label class=\"control-label\" translate=\"Taux\">Taux</label></div><div class=\"col-xs-4\"><p class=\"form-control-static\">{{calcul.taux | percentage}}</p></div></div><div class=\"row form-group\"><div class=\"col-xs-4\"><label class=\"control-label\" translate=\"ImpotARetenir\">Impôt à retenir</label></div><div class=\"col-xs-4\"><p class=\"form-control-static\">{{calcul.retenue | currency:2:1}}</p></div></div></div></div><div class=\"row\"><div class=\"col-xs-12\"><div class=\"alert alert-danger\" role=\"alert\" ng-show=\"calcul.errorMsg\"><span class=\"glyphicon glyphicon-exclamation-sign\" aria-hidden=\"true\"></span> <span>{{calcul.errorMsg}}</span></div></div></div></div></div></div>");
$templateCache.put("scripts/app/form/delaifidu/delaifidu.html","<div id=\"form-wrapper\" class=\"panel panel-default\"><div id=\"delaifidu-form-content-wrapper\" class=\"panel-body\"><div id=\"form-content\"><div class=\"col-xs-12\"><h1 translate=\"DelaiRepresentant\">Délai représentant</h1><div ng-show=\"formHelper.step == 1\"><form role=\"form\" name=\"delaifiduForm\" autocomplete=\"on\"><h2>{{\'Etape1\' | translate}} - {{\'InformationsRepresentant\' | translate}}</h2><div class=\"row form-group\" show-errors><div class=\"col-xs-4\"><label for=\"ndc\" class=\"control-label\" translate=\"NoDeReferenceNDC\">No de référence - NDC</label></div><div class=\"col-xs-8\"><input id=\"ndc\" name=\"ndc\" type=\"text\" class=\"form-control input-sm\" ng-model=\"delaiFiduciaire.fiduciaire.ndc\" placeholder=\"999.999.999/99\" ng-pattern=\"/\\d{3}\\.\\d{3}\\.\\d{3}/\\d{2}$/\" ng-model-options=\"{ updateOn: \'blur\'}\" mask=\"999.999.999/99\"></div></div><div class=\"row form-group\" show-errors><div class=\"col-xs-4\"><label for=\"raisonSociale\" class=\"control-label label-required\" translate=\"NomPrenomRaisonSociale\">Nom Prénom / Raison sociale</label></div><div class=\"col-xs-8\"><input id=\"raisonSociale\" name=\"raisonSociale\" type=\"text\" class=\"form-control input-sm\" ng-model=\"delaiFiduciaire.fiduciaire.raisonSociale\" required></div></div><div class=\"row form-group\" show-errors><div class=\"col-xs-4\"><label for=\"rueNPALocalite\" class=\"control-label label-required\" translate=\"RueNPALocalite\">Rue, NPA, Localite</label></div><div class=\"col-xs-8\"><input id=\"rueNPALocalite\" name=\"rueNPALocalite\" type=\"text\" class=\"form-control input-sm\" ng-model=\"delaiFiduciaire.fiduciaire.adresse\" required></div></div><div class=\"row form-group\" show-errors><div class=\"col-xs-4\"><label for=\"contact\" class=\"control-label label-required\" translate=\"PersonneDeContact\">Personne de contact</label></div><div class=\"col-xs-8\"><input id=\"contact\" name=\"contact\" type=\"text\" class=\"form-control input-sm\" ng-model=\"delaiFiduciaire.fiduciaire.contact\" required></div></div><div class=\"row form-group\" show-errors><div class=\"col-xs-4\"><label for=\"email\" class=\"control-label label-required\" translate=\"Courriel\">Courriel</label></div><div class=\"col-xs-8\"><input id=\"email\" name=\"email\" type=\"email\" class=\"form-control input-sm\" ng-model=\"delaiFiduciaire.fiduciaire.email\" required></div></div><div class=\"row form-group\" show-errors><div class=\"col-xs-4\"><label for=\"telephone\" class=\"control-label label-required\" translate=\"Telephone\">Téléphone</label></div><div class=\"col-xs-8\"><input id=\"telephone\" name=\"telephone\" type=\"text\" class=\"form-control input-sm\" ng-model=\"delaiFiduciaire.fiduciaire.telephone\" placeholder=\"099 999 99 99\" ng-pattern=\"/[\\\\+](\\d\\s*){11,}$|[0](\\d\\s*){9,}$/g\" mask=\"*99 999 99 9?9?s?9?9?s?99\" required></div></div><div class=\"row form-group\"><div class=\"col-xs-4\"></div><div class=\"col-xs-8\"><label><input type=\"checkbox\" ng-model=\"formHelper.saveHeader\"> {{\'ConserverLesDonneesDansCeNavigateur\' | translate}}</label></div></div><div class=\"row\"><div class=\"col-xs-4\"><p>*&nbsp;{{\'champsObligatoires\' | translate}}</p></div></div><div class=\"spacer\"></div><h2>{{\'Etape2\' | translate}} - {{\'DeclarationsPPgereesParRepresentant\' | translate}}</h2><div class=\"row form-group\"><div class=\"col-xs-4\"><label class=\"control-label\" translate=\"PeriodeFiscale\">Periode fiscale</label></div><div class=\"col-xs-2\"><p class=\"form-control-static\">{{delaiFiduciaire.fiduciaire.periodeFiscale}}</p></div></div><div class=\"spacer\"></div><div translate=\"PossibilitesCommunicationDemandesDelai\">Vous avez la possiblité de communiquer les demandes de délai de deux manières :</div><div class=\"row\"><div class=\"col-sm-12\"><div class=\"radio\"><label><input type=\"radio\" ng-model=\"formHelper.type\" name=\"type\" value=\"FORM\" ng-disabled=\"formHelper.fileUploaded\" ng-change=\"sendHeightToParent()\"> {{\'EnRemplissantFormulaire\' | translate}}</label></div><div class=\"radio\"><label><input type=\"radio\" ng-model=\"formHelper.type\" name=\"type\" value=\"EXCEL\" ng-disabled=\"formHelper.fileUploaded\" ng-change=\"sendHeightToParent()\"> {{\'EnEnvoyantFichierExcel\' | translate}}</label></div></div></div><div ng-if=\"formHelper.type === \'EXCEL\'\"><div class=\"row form-group\"><div class=\"col-xs-12\"><p><strong>{{\'DelaiFiduTexteEtape1a\' | translate}}&nbsp;<a href=\"content/xls/delais-fiduciaire.xlsx\">{{\'LeNouveauFichierExcel\' | translate}}</a>&nbsp;{{\'DelaiFiduTexteEtape1b\' | translate}}.</strong></p></div><div class=\"col-xs-4\"><label for=\"excel\" class=\"control-label label-required\" translate=\"FeuilleExcel\">Feuille Excel</label></div><div class=\"col-xs-8 input-file-wrapper\"><input id=\"excel\" name=\"excel\" type=\"file\" class=\"form-control input-sm input-file\" file-model=\"delaiFiduciaire.excelFile\" ng-click=\"resetInputFile()\" custom-on-change=\"uploadExcelFile\" accept=\"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel\" required></div></div><div class=\"row\" ng-show=\"formHelper.fileUploadError\"><div class=\"col-xs-4\"></div><div class=\"col-xs-8\"><div class=\"alert alert-danger\" role=\"alert\"><span class=\"glyphicon glyphicon-exclamation-sign\" aria-hidden=\"true\"></span> <span>{{formHelper.fileUploadError}}</span></div></div></div></div><div ng-if=\"formHelper.type === \'FORM\'\"><div ng-repeat=\"demande in delaiFiduciaire.demandesDelai\"><hr><div class=\"bs-callout bs-callout-info\" ng-show=\"demande.index % 5 == 0\"><span class=\"glyphicon glyphicon-info-sign\" aria-hidden=\"true\"></span> <span>{{\'TexteInfoPlusieursPersonnes1\' | translate}}&nbsp;<a href=\"content/xls/delais-fiduciaire.xlsx\" class=\"callout-link\">{{\'FichierExcel\' | translate}}</a>&nbsp;{{\'TexteInfoPlusieursPersonnes2\' | translate}}</span></div><div class=\"row\"><div class=\"col-xs-4\"><h4>{{\'Demande\' | translate}}&nbsp;{{demande.index}}</h4></div><div class=\"col-xs-6 col-xs-8\"><button type=\"button\" class=\"btn btn-default pull-right\" ng-click=\"removeEntry(demande.index)\" ng-show=\"demande.index > 1\" translate=\"SupprimerEntree\">Supprimer entrée</button></div></div><div class=\"row form-group\" show-errors><div class=\"col-xs-4\"><label for=\"ref{{demande.index}}\" class=\"control-label label-required\" translate=\"NoDeReferenceNDC\">No de référence - NDC</label></div><div class=\"col-xs-8\"><input id=\"ref{{demande.index}}\" name=\"ref{{demande.index}}\" type=\"text\" class=\"form-control input-sm\" ng-model=\"demande.ref\" placeholder=\"999.999.999/99\" ng-pattern=\"/^(?!0)\\d{3}\\.\\d{3}\\.\\d{3}/\\d{2}$/\" ng-model-options=\"{ updateOn: \'blur\'}\" mask=\"999.999.999/99\" required></div></div><div class=\"row form-group\" show-errors><div class=\"col-xs-4\"><label for=\"nom{{demande.index}}\" class=\"control-label label-required\" translate=\"Nom\">Nom</label></div><div class=\"col-xs-8\"><input id=\"nom{{demande.index}}\" name=\"nom{{demande.index}}\" type=\"text\" class=\"form-control input-sm\" ng-model=\"demande.nom\" required></div></div><div class=\"row form-group\" show-errors><div class=\"col-xs-4\"><label for=\"prenom{{demande.index}}\" class=\"control-label label-required\" translate=\"Prenom\">Prénom</label></div><div class=\"col-xs-8\"><input id=\"prenom{{demande.index}}\" name=\"prenom{{demande.index}}\" type=\"text\" class=\"form-control input-sm\" ng-model=\"demande.prenom\" required></div></div><div class=\"row form-group\" show-errors><div class=\"col-xs-4\"><label for=\"localite{{demande.index}}\" class=\"control-label label-required\" translate=\"Localite\">Localité</label></div><div class=\"col-xs-8\"><input id=\"localite{{demande.index}}\" name=\"localite{{demande.index}}\" type=\"text\" class=\"form-control input-sm\" ng-model=\"demande.localite\" required></div></div></div><div class=\"row\"><div class=\"col-xs-12\"><span class=\"pull-right\"><div class=\"btn-wrapper-right\" ng-mouseover=\"showValidation(true)\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"addEntry()\" ng-disabled=\"!areItemsValid()\" translate=\"AjouterNouvelleEntree\">Ajouter nouvelle entrée</button></div></span></div></div></div></form><div ng-show=\"formHelper.fileUploaded\" id=\"recap\"><hr><div class=\"row\"><div class=\"col-xs-4\"><label class=\"control-label\" translate=\"NombreDeDemandes\">Nombre de demandes</label></div><div class=\"col-xs-4\"><p class=\"form-control-static text-left\">{{countNbDemandes()}}</p></div><div class=\"col-xs-4\"><a class=\"pull-right\" ng-click=\"printDiv(\'recap\')\"><span class=\"iconbtn iconexp iconexp-printer\" uib-tooltip=\"{{\'Imprimer\' | translate}}\" tooltip-placement=\"left\"></span></a></div></div><table class=\"table\"><thead><tr><th><label>#</label></th><th><label translate=\"NoDeReferenceNDC\">No de référence - NDC</label></th><th><label translate=\"Nom\">Nom</label></th><th><label translate=\"Prenom\">Prénom</label></th><th><label translate=\"Localite\">Localité</label></th></tr></thead><tbody><tr ng-repeat=\"demandeDelai in delaiFiduciaire.demandesDelai\"><td>{{::demandeDelai.index}}</td><td ng-class=\"{\'alert-danger\': hasErrors(demandeDelai, [\'ref\']), \'alert-warning\': hasWarnings(demandeDelai, [\'ref\'])}\" uib-popover-html=\"getValidationMessage(demandeDelai, [\'ref\'])\" popover-trigger=\"mouseenter\" popover-append-to-body=\"true\" popover-placement=\"right\">{{::demandeDelai.ref}}</td><td ng-class=\"{\'alert-danger\': hasErrors(demandeDelai, [\'nom\']), \'alert-warning\': hasWarnings(demandeDelai, [\'nom\'])}\" uib-popover-html=\"getValidationMessage(demandeDelai, [\'nom\'])\" popover-trigger=\"mouseenter\" popover-append-to-body=\"true\">{{::demandeDelai.nom}}</td><td ng-class=\"{\'alert-danger\': hasErrors(demandeDelai, [\'prenom\']), \'alert-warning\': hasWarnings(demandeDelai, [\'prenom\'])}\" uib-popover-html=\"getValidationMessage(demandeDelai, [\'prenom\'])\" popover-trigger=\"mouseenter\" popover-append-to-body=\"true\">{{::demandeDelai.prenom}}</td><td ng-class=\"{\'alert-danger\': hasErrors(demandeDelai, [\'localite\']), \'alert-warning\': hasWarnings(demandeDelai, [\'localite\'])}\" uib-popover-html=\"getValidationMessage(demandeDelai, [\'localite\'])\" popover-trigger=\"mouseenter\" popover-append-to-body=\"true\" popover-placement=\"left\">{{::demandeDelai.localite}}</td></tr></tbody></table></div><hr></div><div ng-if=\"formHelper.step == 2\"><h2 class=\"\" translate=\"ConfirmationEnvoi\">Confirmation d\'envoi</h2><p translate=\"TexteConfirmationEnvoi\">TexteConfirmationEnvoi</p><p translate=\"TexteConfirmationDelaiFidu1\">TexteConfirmationDelaiFidu1</p><p translate=\"TexteConfirmationDelaiFidu2\">TexteConfirmationDelaiFidu2</p></div></div></div><div ng-hide=\"formHelper.step == 2\" id=\"form-footer-big\"><div class=\"col-xs-12\"><div class=\"row\"><div class=\"col-xs-4\"><label class=\"control-label label-required\" translate=\"Verification\">Vérification</label></div><div class=\"col-xs-8\"><div vc-recaptcha key=\"\'6LdsigwUAAAAAMZEcUcyjqvQVBmhMETUndwLISTv\'\" ng-model=\"delaiFiduciaire.recaptchaResponse\" on-success=\"onRecaptchaSuccess()\"></div></div></div><div class=\"row\"><div class=\"col-xs-2\"><div class=\"btn-wrapper-left\"><button type=\"button\" class=\"btn btn-default\" translate=\"Annuler\" ng-click=\"resetForm()\">Annuler</button></div></div><div class=\"col-xs-8\"><div class=\"alert alert-danger\" role=\"alert\" ng-show=\"formHelper.errorMsg\"><span class=\"glyphicon glyphicon-exclamation-sign\" aria-hidden=\"true\"></span> <span>{{formHelper.errorMsg}}</span></div><div class=\"alert alert-danger\" role=\"alert\" ng-show=\"formHelper.showValidationMsg\"><span class=\"glyphicon glyphicon-ban-circle\" aria-hidden=\"true\"></span> <span>{{\'FormulaireIncomplet\' | translate}}</span></div></div><div class=\"col-xs-2\"><span class=\"pull-right\"><div class=\"btn-wrapper-right\" ng-mouseover=\"showValidation()\"><button type=\"submit\" class=\"btn btn-primary\" ng-click=\"sendRequest()\" ng-disabled=\"!formHelper.valid\" translate=\"Envoyer\">Envoyer</button></div></span></div></div></div></div></div></div>");
$templateCache.put("scripts/app/layouts/footer/footer.html","<div id=\"footer\"><a href=\"#\" ng-repeat=\"button in buttons\" ng-click=\"button.action()\" ng-disabled=\"button.disabled()\" ng-class=\"button.primary ? \'btn btn-primary btn-gap\' : \'btn btn-default btn-gap\'\">{{button.name| translate}}</a></div>");
$templateCache.put("scripts/app/layouts/navbar/navbar.html","<div class=\"row\"><div class=\"column visible-lg logo-fr col-lg-2\" id=\"logo-container\"></div><div class=\"column col-lg-10 col-xs-12\" id=\"main-menu-container\"><div class=\"collapse navbar-collapse main-navbar\" id=\"main-menu\"><ul class=\"nav navbar-nav\"><li ng-class=\"{active: $state.is(\'main\')}\"><a href=\"#/\" translate=\"Accueil\">Accueil</a></li><li ng-class=\"{active: $state.includes(\'calculis\')}\"><a ui-sref=\"calculis\" translate=\"CalculatriceIS\">Calculatrice IS</a></li><li ng-class=\"{active: $state.includes(\'declaris\')}\"><a ui-sref=\"declaris\" translate=\"DeclarationIS\">Déclaration IS</a></li><li ng-class=\"{active: $state.includes(\'delaifidu\')}\"><a ui-sref=\"delaifidu\" translate=\"DelaisFiduciaire\">Délais Fiduciaire</a></li></ul></div></div></div>");
$templateCache.put("scripts/app/layouts/sidebar/sidebar.html","<div id=\"sidebar-wrapper\" class=\"col-md-2 col-sm-3 col-xs-6\"><div id=\"sidebar\"><ul class=\"nav nav-list nav-sidebar\"><li><ul ng-repeat=\"menu in service.nodeSelected.menus\" class=\"nav nav-list tree side-nav-list\"><li><a ng-show=\"menu.url!==\'\'\" ui-sref=\"{{menu.url!==\'\' ? menu.url : \'.\'}}\">{{menu.label | translate}}</a> <span ng-show=\"menu.url==\'\'\">{{menu.label | translate}}</span></li><li ng-show=\"menu.ssmenus.length > 0\"><ul ng-repeat=\"ssmenu in menu.ssmenus\" class=\"nav nav-list tree\"><li><div ng-class=\"isSsMenuSelected(ssmenu.id)\" style=\"display:block; cursor:pointer\" ui-sref=\"{{ssmenu.url}}\" ui-sref-opts=\"{reload: true}\"><a>{{ssmenu.label}}</a> <a aria-label=\"Fermer\" style=\"margin-right: 10px\" class=\"btn btn-xs btn-link pull-right\" ng-click=\"removeSsMenu($parent.$index, $index)\" ng-show=\"!isSsMenuSelected(ssmenu.id)\"><i class=\"iconbtn iconexp iconexp-delete sb-close-btn\" aria-hidden=\"true\"></i></a></div></li></ul></li></ul></li></ul></div></div>");
$templateCache.put("scripts/app/layouts/submenu/submenu.html","<div id=\"submenu\" class=\"panel-heading\"><ol class=\"breadcrumb\"><li ng-repeat=\"breadcrumbItem in breadcrumbItems\" class=\"active\"><span ng-if=\"$first\"><b>{{title|translate}} : </b></span>{{breadcrumbItem}}</li></ol><div class=\"panel-navigation\"><nav class=\"navbar navbar-default\"><div class=\"container-fluid\"><div class=\"navbar-header\"><button type=\"button\" class=\"navbar-toggle collapsed\" data-toggle=\"collapse\" data-target=\"#navbar\" aria-expanded=\"false\" aria-controls=\"navbar\"><span class=\"sr-only\">Toggle navigation</span> <span class=\"icon-bar\"></span> <span class=\"icon-bar\"></span> <span class=\"icon-bar\"></span></button></div><div id=\"navbar\" class=\"navbar-collapse collapse\"><ul class=\"nav navbar-nav\"><li ng-repeat=\"menuItem in menuItems\" ui-sref-active=\"active\"><a ui-sref=\"{{menuItem.url}}\">{{menuItem.titre | translate}}</a></li></ul></div></div></nav></div></div>");
$templateCache.put("scripts/components/account/activate/activate.html","<div><div class=\"row\"><div class=\"col-md-8 col-md-offset-2\"><h1 translate=\"activate.title\">Activation</h1><div class=\"alert alert-success\" ng-show=\"vm.success\" translate=\"activate.messages.success\" translate-compile><strong>Your user has been activated.</strong> Please <a class=\"alert-link\" href=\"\" ng-click=\"vm.login()\">sign in</a>.</div><div class=\"alert alert-danger\" ng-show=\"vm.error\" translate=\"activate.messages.error\"><strong>Your user could not be activated.</strong> Please use the registration form to sign up.</div></div></div></div>");
$templateCache.put("scripts/components/account/password/password.html","<div><div class=\"row\"><div class=\"col-md-8 col-md-offset-2\"><h2 translate=\"password.title\" translate-values=\"{username: \'{{vm.account.login}}\'}\">Password for [<b>{{vm.account.login}}</b>]</h2><div class=\"alert alert-success\" ng-show=\"vm.success\" translate=\"password.messages.success\"><strong>Password changed!</strong></div><div class=\"alert alert-danger\" ng-show=\"vm.error\" translate=\"password.messages.error\"><strong>An error has occurred!</strong> The password could not be changed.</div><div class=\"alert alert-danger\" ng-show=\"vm.doNotMatch\" translate=\"global.messages.error.dontmatch\">The password and its confirmation do not match!</div><form name=\"form\" role=\"form\" novalidate ng-submit=\"vm.changePassword()\" show-validation><div class=\"form-group\"><label class=\"control-label\" for=\"password\" translate=\"global.form.newpassword\">New password</label><input type=\"password\" class=\"form-control\" id=\"password\" name=\"password\" placeholder=\"{{\'global.form.newpassword.placeholder\' | translate}}\" ng-model=\"vm.password\" ng-minlength=\"4\" ng-maxlength=\"50\" required><div ng-show=\"form.password.$dirty && form.password.$invalid\"><p class=\"help-block\" ng-show=\"form.password.$error.required\" translate=\"global.messages.validate.newpassword.required\">Your password is required.</p><p class=\"help-block\" ng-show=\"form.password.$error.minlength\" translate=\"global.messages.validate.newpassword.minlength\">Your password is required to be at least 4 characters.</p><p class=\"help-block\" ng-show=\"form.password.$error.maxlength\" translate=\"global.messages.validate.newpassword.maxlength\">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check=\"vm.password\"></password-strength-bar></div><div class=\"form-group\"><label class=\"control-label\" for=\"confirmPassword\" translate=\"global.form.confirmpassword\">New password confirmation</label><input type=\"password\" class=\"form-control\" id=\"confirmPassword\" name=\"confirmPassword\" placeholder=\"{{\'global.form.confirmpassword.placeholder\' | translate}}\" ng-model=\"vm.confirmPassword\" ng-minlength=\"4\" ng-maxlength=\"50\" required><div ng-show=\"form.confirmPassword.$dirty && form.confirmPassword.$invalid\"><p class=\"help-block\" ng-show=\"form.confirmPassword.$error.required\" translate=\"global.messages.validate.confirmpassword.required\">Your confirmation password is required.</p><p class=\"help-block\" ng-show=\"form.confirmPassword.$error.minlength\" translate=\"global.messages.validate.confirmpassword.minlength\">Your confirmation password is required to be at least 4 characters.</p><p class=\"help-block\" ng-show=\"form.confirmPassword.$error.maxlength\" translate=\"global.messages.validate.confirmpassword.maxlength\">Your confirmation password cannot be longer than 50 characters.</p></div></div><button type=\"submit\" ng-disabled=\"form.$invalid\" class=\"btn btn-primary\" translate=\"password.form.button\">Save</button></form></div></div></div>");
$templateCache.put("scripts/components/account/register/register.html","<div><div class=\"row\"><div class=\"col-md-8 col-md-offset-2\"><h1 translate=\"register.title\">Registration</h1><div class=\"alert alert-success\" ng-show=\"vm.success\" translate=\"register.messages.success\"><strong>Registration saved!</strong> Please check your email for confirmation.</div><div class=\"alert alert-danger\" ng-show=\"vm.error\" translate=\"register.messages.error.fail\"><strong>Registration failed!</strong> Please try again later.</div><div class=\"alert alert-danger\" ng-show=\"vm.errorUserExists\" translate=\"register.messages.error.userexists\"><strong>Login name already registered!</strong> Please choose another one.</div><div class=\"alert alert-danger\" ng-show=\"vm.errorEmailExists\" translate=\"register.messages.error.emailexists\"><strong>E-mail is already in use!</strong> Please choose another one.</div><div class=\"alert alert-danger\" ng-show=\"vm.doNotMatch\" translate=\"global.messages.error.dontmatch\">The password and its confirmation do not match!</div></div><div class=\"col-md-8 col-md-offset-2\"><form ng-show=\"!vm.success\" name=\"form\" role=\"form\" novalidate ng-submit=\"vm.register()\" show-validation><div class=\"form-group\"><label class=\"control-label\" for=\"login\" translate=\"global.form.username\">Username</label><input type=\"text\" class=\"form-control\" id=\"login\" name=\"login\" placeholder=\"{{\'global.form.username.placeholder\' | translate}}\" ng-model=\"vm.registerAccount.login\" ng-minlength=\"1\" ng-maxlength=\"50\" ng-pattern=\"/^[a-z0-9]*$/\" required><div ng-show=\"form.login.$dirty && form.login.$invalid\"><p class=\"help-block\" ng-show=\"form.login.$error.required\" translate=\"register.messages.validate.login.required\">Your username is required.</p><p class=\"help-block\" ng-show=\"form.login.$error.minlength\" translate=\"register.messages.validate.login.minlength\">Your username is required to be at least 1 character.</p><p class=\"help-block\" ng-show=\"form.login.$error.maxlength\" translate=\"register.messages.validate.login.maxlength\">Your username cannot be longer than 50 characters.</p><p class=\"help-block\" ng-show=\"form.login.$error.pattern\" translate=\"register.messages.validate.login.pattern\">Your username can only contain lower-case letters and digits.</p></div></div><div class=\"form-group\"><label class=\"control-label\" for=\"email\" translate=\"global.form.email\">E-mail</label><input type=\"email\" class=\"form-control\" id=\"email\" name=\"email\" placeholder=\"{{\'global.form.email.placeholder\' | translate}}\" ng-model=\"vm.registerAccount.email\" ng-minlength=\"5\" ng-maxlength=\"100\" required><div ng-show=\"form.email.$dirty && form.email.$invalid\"><p class=\"help-block\" ng-show=\"form.email.$error.required\" translate=\"global.messages.validate.email.required\">Your e-mail is required.</p><p class=\"help-block\" ng-show=\"form.email.$error.email\" translate=\"global.messages.validate.email.invalid\">Your e-mail is invalid.</p><p class=\"help-block\" ng-show=\"form.email.$error.minlength\" translate=\"global.messages.validate.email.minlength\">Your e-mail is required to be at least 5 characters.</p><p class=\"help-block\" ng-show=\"form.email.$error.maxlength\" translate=\"global.messages.validate.email.maxlength\">Your e-mail cannot be longer than 100 characters.</p></div></div><div class=\"form-group\"><label class=\"control-label\" for=\"password\" translate=\"global.form.newpassword\">New password</label><input type=\"password\" class=\"form-control\" id=\"password\" name=\"password\" placeholder=\"{{\'global.form.newpassword.placeholder\' | translate}}\" ng-model=\"vm.registerAccount.password\" ng-minlength=\"4\" ng-maxlength=\"50\" required><div ng-show=\"form.password.$dirty && form.password.$invalid\"><p class=\"help-block\" ng-show=\"form.password.$error.required\" translate=\"global.messages.validate.newpassword.required\">Your password is required.</p><p class=\"help-block\" ng-show=\"form.password.$error.minlength\" translate=\"global.messages.validate.newpassword.minlength\">Your password is required to be at least 4 characters.</p><p class=\"help-block\" ng-show=\"form.password.$error.maxlength\" translate=\"global.messages.validate.newpassword.maxlength\">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check=\"vm.registerAccount.password\"></password-strength-bar></div><div class=\"form-group\"><label class=\"control-label\" for=\"confirmPassword\" translate=\"global.form.confirmpassword\">New password confirmation</label><input type=\"password\" class=\"form-control\" id=\"confirmPassword\" name=\"confirmPassword\" placeholder=\"{{\'global.form.confirmpassword.placeholder\' | translate}}\" ng-model=\"vm.confirmPassword\" ng-minlength=\"4\" ng-maxlength=\"50\" required><div ng-show=\"form.confirmPassword.$dirty && form.confirmPassword.$invalid\"><p class=\"help-block\" ng-show=\"form.confirmPassword.$error.required\" translate=\"global.messages.validate.confirmpassword.required\">Your confirmation password is required.</p><p class=\"help-block\" ng-show=\"form.confirmPassword.$error.minlength\" translate=\"global.messages.validate.confirmpassword.minlength\">Your confirmation password is required to be at least 4 characters.</p><p class=\"help-block\" ng-show=\"form.confirmPassword.$error.maxlength\" translate=\"global.messages.validate.confirmpassword.maxlength\">Your confirmation password cannot be longer than 50 characters.</p></div></div><button type=\"submit\" ng-disabled=\"form.$invalid\" class=\"btn btn-primary\" translate=\"register.form.button\">Register</button></form><p></p><div class=\"alert alert-warning\" translate=\"global.messages.info.authenticated\" translate-compile>If you want to <a class=\"alert-link\" href=\"\" ng-click=\"vm.login()\">sign in</a>, you can try the default accounts:<br>- Administrator (login=\"admin\" and password=\"admin\")<br>- User (login=\"user\" and password=\"user\").</div></div></div></div>");
$templateCache.put("scripts/components/account/settings/settings.html","<div><div class=\"row\"><div class=\"col-md-8 col-md-offset-2\"><h2 translate=\"settings.title\" translate-values=\"{username: \'{{vm.settingsAccount.login}}\'}\">User settings for [<b>{{vm.settingsAccount.login}}</b>]</h2><div class=\"alert alert-success\" ng-show=\"vm.success\" translate=\"settings.messages.success\"><strong>Settings saved!</strong></div><div class=\"alert alert-danger\" ng-show=\"vm.errorEmailExists\" translate=\"settings.messages.error.emailexists\"><strong>E-mail is already in use!</strong> Please choose another one.</div><div class=\"alert alert-danger\" ng-show=\"vm.error\" translate=\"settings.messages.error.fail\"><strong>An error has occurred!</strong> Settings could not be saved.</div><form name=\"form\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"form-group\"><label class=\"control-label\" for=\"firstName\" translate=\"settings.form.firstname\">First Name</label><input type=\"text\" class=\"form-control\" id=\"firstName\" name=\"firstName\" placeholder=\"{{\'settings.form.firstname.placeholder\' | translate}}\" ng-model=\"vm.settingsAccount.firstName\" ng-minlength=\"1\" ng-maxlength=\"50\" required maxlength=\"50\"><div ng-show=\"form.firstName.$dirty && form.firstName.$invalid\"><p class=\"help-block\" ng-show=\"form.firstName.$error.required\" translate=\"settings.messages.validate.firstname.required\">Your first name is required.</p><p class=\"help-block\" ng-show=\"form.firstName.$error.minlength\" translate=\"settings.messages.validate.firstname.minlength\">Your first name is required to be at least 1 character.</p><p class=\"help-block\" ng-show=\"form.firstName.$error.maxlength\" translate=\"settings.messages.validate.firstname.maxlength\">Your first name cannot be longer than 50 characters.</p></div></div><div class=\"form-group\"><label class=\"control-label\" for=\"lastName\" translate=\"settings.form.lastname\">Last Name</label><input type=\"text\" class=\"form-control\" id=\"lastName\" name=\"lastName\" placeholder=\"{{\'settings.form.lastname.placeholder\' | translate}}\" ng-model=\"vm.settingsAccount.lastName\" ng-minlength=\"1\" ng-maxlength=\"50\" required maxlength=\"50\"><div ng-show=\"form.lastName.$dirty && form.lastName.$invalid\"><p class=\"help-block\" ng-show=\"form.lastName.$error.required\" translate=\"settings.messages.validate.lastname.required\">Your last name is required.</p><p class=\"help-block\" ng-show=\"form.lastName.$error.minlength\" translate=\"settings.messages.validate.lastname.minlength\">Your last name is required to be at least 1 character.</p><p class=\"help-block\" ng-show=\"form.lastName.$error.maxlength\" translate=\"settings.messages.validate.lastname.maxlength\">Your last name cannot be longer than 50 characters.</p></div></div><div class=\"form-group\"><label class=\"control-label\" for=\"email\" translate=\"global.form.email\">E-mail</label><input type=\"email\" class=\"form-control\" id=\"email\" name=\"email\" placeholder=\"{{\'global.form.email.placeholder\' | translate}}\" ng-model=\"vm.settingsAccount.email\" ng-minlength=\"5\" ng-maxlength=\"100\" required maxlength=\"100\"><div ng-show=\"form.email.$dirty && form.email.$invalid\"><p class=\"help-block\" ng-show=\"form.email.$error.required\" translate=\"global.messages.validate.email.required\">Your e-mail is required.</p><p class=\"help-block\" ng-show=\"form.email.$error.email\" translate=\"global.messages.validate.email.invalid\">Your e-mail is invalid.</p><p class=\"help-block\" ng-show=\"form.email.$error.minlength\" translate=\"global.messages.validate.email.minlength\">Your e-mail is required to be at least 5 characters.</p><p class=\"help-block\" ng-show=\"form.email.$error.maxlength\" translate=\"global.messages.validate.email.maxlength\">Your e-mail cannot be longer than 100 characters.</p></div></div><div class=\"form-group\"><label for=\"langKey\" translate=\"settings.form.language\">Language</label><select id=\"langKey\" name=\"langKey\" class=\"form-control\" ng-model=\"vm.settingsAccount.langKey\" ng-controller=\"JhiLanguageController as languageVm\" ng-options=\"code as (code | findLanguageFromKey) for code in languageVm.languages\"></select></div><button type=\"submit\" ng-disabled=\"form.$invalid\" class=\"btn btn-primary\" translate=\"settings.form.button\">Save</button></form></div></div></div>");
$templateCache.put("scripts/components/admin/audits/audits.html","<div><h2 translate=\"audits.title\">Audits</h2><div class=\"row\"><div class=\"col-md-5\"><h4 translate=\"audits.filter.title\">Filter by date</h4><p class=\"input-group\"><span class=\"input-group-addon\" translate=\"audits.filter.from\">from</span> <input type=\"date\" class=\"input-sm form-control\" name=\"start\" ng-model=\"vm.fromDate\" ng-change=\"vm.onChangeDate()\" required> <span class=\"input-group-addon\" translate=\"audits.filter.to\">to</span> <input type=\"date\" class=\"input-sm form-control\" name=\"end\" ng-model=\"vm.toDate\" ng-change=\"vm.onChangeDate()\" required></p></div></div><table class=\"table table-condensed table-striped table-bordered table-responsive\"><thead><tr><th ng-click=\"predicate = \'timestamp\'; reverse=!reverse\"><span translate=\"audits.table.header.date\">Date</span></th><th ng-click=\"predicate = \'principal\'; reverse=!reverse\"><span translate=\"audits.table.header.principal\">User</span></th><th ng-click=\"predicate = \'type\'; reverse=!reverse\"><span translate=\"audits.table.header.status\">State</span></th><th ng-click=\"predicate = \'data.message\'; reverse=!reverse\"><span translate=\"audits.table.header.data\">Extra data</span></th></tr></thead><tr ng-repeat=\"audit in vm.audits | filter:filter | orderBy:predicate:reverse\" ng-hide=\"audit.filtered\"><td><span>{{audit.timestamp| date:\'medium\'}}</span></td><td><small>{{audit.principal}}</small></td><td>{{audit.type}}</td><td><span ng-show=\"audit.data.message\">{{audit.data.message}}</span> <span ng-show=\"audit.data.remoteAddress\"><span translate=\"audits.table.data.remoteAddress\">Remote Address</span> {{audit.data.remoteAddress}}</span></td></tr></table><div class=\"text-center\"><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.loadPage(vm.page)\"></uib-pagination></div></div>");
$templateCache.put("scripts/components/admin/configuration/configuration.html","<div><h2 translate=\"configuration.title\">Configuration</h2><span translate=\"configuration.filter\">Filter (by prefix)</span> <input type=\"text\" ng-model=\"filter\" class=\"form-control\"><label ng-hide=\"filteredConfig.length == 0\">Spring configuration</label><table class=\"table table-condensed table-striped table-bordered table-responsive\" style=\"table-layout:fixed\" ng-hide=\"filteredConfig.length == 0\"><thead><tr><th ng-click=\"predicate = \'prefix\'; reverse=!reverse\" class=\"col-sm-4\"><span translate=\"configuration.table.prefix\">Prefix</span></th><th translate=\"configuration.table.properties\" class=\"col-sm-8\">Properties</th></tr></thead><tr ng-repeat=\"entry in filtered = (vm.configuration | filter:filter | orderBy:predicate:reverse)\"><td><span>{{entry.prefix}}</span></td><td><div class=\"row\" ng-repeat=\"(key, value) in entry.properties\"><div class=\"col-md-4\">{{key}}</div><div class=\"col-md-8\"><span class=\"pull-right label label-default break\">{{value}}</span></div></div></td></tr></table><div ng-repeat=\"(key, value) in vm.allConfiguration\"><label ng-hide=\"filtered.length == 0\"><span>{{key}}</span></label><table class=\"table table-condensed table-striped table-bordered table-responsive\" style=\"table-layout:fixed\" ng-hide=\"filtered.length == 0\"><thead><tr><th class=\"col-sm-4\">Property</th><th class=\"col-sm-8\">Value</th></tr></thead><tbody><tr ng-repeat=\"item in filtered = (value | filter:filter)\"><td class=\"break\">{{item.key}}</td><td class=\"break\"><span class=\"pull-right label label-default break\">{{item.val}}</span></td></tr></tbody></table></div></div>");
$templateCache.put("scripts/components/admin/docs/docs.html","<iframe src=\"swagger-ui/index.html\" frameborder=\"0\" marginheight=\"0\" marginwidth=\"0\" width=\"100%\" height=\"900\" scrolling=\"auto\" target=\"_top\"></iframe>");
$templateCache.put("scripts/components/admin/health/health.html","<div><h2 translate=\"health.title\">Health Checks</h2><p><button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.refresh()\"><span class=\"glyphicon glyphicon-refresh\"></span>&nbsp;<span translate=\"health.refresh.button\">Refresh</span></button></p><table id=\"healthCheck\" class=\"table table-striped\"><thead><tr><th class=\"col-md-7\" translate=\"health.table.service\">Service Name</th><th class=\"col-md-2 text-center\" translate=\"health.table.status\">Status</th><th class=\"col-md-2 text-center\" translate=\"health.details.details\">Details</th></tr></thead><tbody><tr ng-repeat=\"health in vm.healthData\"><td>{{\'health.indicator.\' + vm.baseName(health.name) | translate}} {{vm.subSystemName(health.name)}}</td><td class=\"text-center\"><span class=\"label\" ng-class=\"vm.getLabelClass(health.status)\">{{\'health.status.\' + health.status | translate}}</span></td><td class=\"text-center\"><a class=\"hand\" ng-click=\"vm.showHealth(health)\" ng-show=\"health.details || health.error\"><i class=\"glyphicon glyphicon-eye-open\"></i></a></td></tr></tbody></table></div>");
$templateCache.put("scripts/components/admin/health/health.modal.html","<div class=\"modal-header\"><button aria-label=\"Close\" data-dismiss=\"modal\" class=\"close\" type=\"button\" ng-click=\"vm.cancel()\"><span aria-hidden=\"true\">&times;</span></button><h4 class=\"modal-title\" id=\"showHealthLabel\">{{\'health.indicator.\' + vm.baseName(vm.currentHealth.name) | translate}} {{vm.subSystemName(vm.currentHealth.name)}}</h4></div><div class=\"modal-body pad\"><div ng-show=\"vm.currentHealth.details\"><h4 translate=\"health.details.properties\">Properties</h4><table class=\"table table-striped\"><thead><tr><th class=\"col-md-6 text-left\" translate=\"health.details.name\">Name</th><th class=\"col-md-6 text-left\" translate=\"health.details.value\">Value</th></tr></thead><tbody><tr ng-repeat=\"(k,v) in vm.currentHealth.details\"><td class=\"col-md-6 text-left\">{{k}}</td><td class=\"col-md-6 text-left\">{{v}}</td></tr></tbody></table></div><div ng-show=\"vm.currentHealth.error\"><h4 translate=\"health.details.error\">Error</h4><pre>{{vm.currentHealth.error}}</pre></div></div><div class=\"modal-footer\"><button data-dismiss=\"modal\" class=\"btn btn-default pull-left\" type=\"button\" ng-click=\"vm.cancel()\">Done</button></div>");
$templateCache.put("scripts/components/admin/logs/logs.html","<div class=\"table-responsive\"><h2 translate=\"logs.title\">Logs</h2><p translate=\"logs.nbloggers\" translate-values=\"{total: \'{{ vm.loggers.length }}\'}\">There are {{ vm.loggers.length }} loggers.</p><span translate=\"logs.filter\">Filter</span> <input type=\"text\" ng-model=\"filter\" class=\"form-control\"><table class=\"table table-condensed table-striped table-bordered\"><thead><tr title=\"click to order\"><th ng-click=\"predicate = \'name\'; reverse=!reverse\"><span translate=\"logs.table.name\">Name</span></th><th ng-click=\"predicate = \'level\'; reverse=!reverse\"><span translate=\"logs.table.level\">Level</span></th></tr></thead><tr ng-repeat=\"logger in vm.loggers | filter:filter | orderBy:predicate:reverse\"><td><small>{{logger.name | characters:140}}</small></td><td><button ng-click=\"vm.changeLevel(logger.name, \'TRACE\')\" ng-class=\"(logger.level==\'TRACE\') ? \'btn-danger\' : \'btn-default\'\" class=\"btn btn-default btn-xs\">TRACE</button> <button ng-click=\"vm.changeLevel(logger.name, \'DEBUG\')\" ng-class=\"(logger.level==\'DEBUG\') ? \'btn-warning\' : \'btn-default\'\" class=\"btn btn-default btn-xs\">DEBUG</button> <button ng-click=\"vm.changeLevel(logger.name, \'INFO\')\" ng-class=\"(logger.level==\'INFO\') ? \'btn-info\' : \'btn-default\'\" class=\"btn btn-default btn-xs\">INFO</button> <button ng-click=\"vm.changeLevel(logger.name, \'WARN\')\" ng-class=\"(logger.level==\'WARN\') ? \'btn-success\' : \'btn-default\'\" class=\"btn btn-default btn-xs\">WARN</button> <button ng-click=\"vm.changeLevel(logger.name, \'ERROR\')\" ng-class=\"(logger.level==\'ERROR\') ? \'btn-primary\' : \'btn-default\'\" class=\"btn btn-default btn-xs\">ERROR</button></td></tr></table></div>");
$templateCache.put("scripts/components/admin/metrics/metrics.html","<div><h2 translate=\"metrics.title\">Application Metrics</h2><p><button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.refresh()\"><span class=\"glyphicon glyphicon-refresh\"></span>&nbsp;<span translate=\"metrics.refresh.button\">Refresh</span></button></p><h3 translate=\"metrics.jvm.title\">JVM Metrics</h3><div class=\"row\" ng-hide=\"vm.updatingMetrics\"><div class=\"col-md-4\"><b translate=\"metrics.jvm.memory.title\">Memory</b><p><span translate=\"metrics.jvm.memory.total\">Total Memory</span> ({{vm.metrics.gauges[\'jvm.memory.total.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.total.max\'].value / 1000000 | number:0}}M)</p><uib-progressbar min=\"0\" max=\"vm.metrics.gauges[\'jvm.memory.total.max\'].value\" value=\"vm.metrics.gauges[\'jvm.memory.total.used\'].value\" class=\"progress-striped active\" type=\"success\"><span>{{vm.metrics.gauges[\'jvm.memory.total.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.total.max\'].value | number:0}}%</span></uib-progressbar><p><span translate=\"metrics.jvm.memory.heap\">Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.heap.max\'].value / 1000000 | number:0}}M)</p><uib-progressbar min=\"0\" max=\"vm.metrics.gauges[\'jvm.memory.heap.max\'].value\" value=\"vm.metrics.gauges[\'jvm.memory.heap.used\'].value\" class=\"progress-striped active\" type=\"success\"><span>{{vm.metrics.gauges[\'jvm.memory.heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.heap.max\'].value | number:0}}%</span></uib-progressbar><p><span translate=\"metrics.jvm.memory.nonheap\">Non-Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value / 1000000 | number:0}}M)</p><uib-progressbar min=\"0\" max=\"vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value\" value=\"vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value\" class=\"progress-striped active\" type=\"success\"><span>{{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value | number:0}}%</span></uib-progressbar></div><div class=\"col-md-4\"><b translate=\"metrics.jvm.threads.title\">Threads</b> (Total: {{vm.metrics.gauges[\'jvm.threads.count\'].value}}) <a class=\"hand\" ng-click=\"vm.refreshThreadDumpData()\" data-toggle=\"modal\" data-target=\"#threadDump\"><i class=\"glyphicon glyphicon-eye-open\"></i></a><p><span translate=\"metrics.jvm.threads.runnable\">Runnable</span> {{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value}}</p><uib-progressbar min=\"0\" value=\"vm.metrics.gauges[\'jvm.threads.runnable.count\'].value\" max=\"vm.metrics.gauges[\'jvm.threads.count\'].value\" class=\"progress-striped active\" type=\"success\"><span>{{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span translate=\"metrics.jvm.threads.timedwaiting\">Timed Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value}})</p><uib-progressbar min=\"0\" value=\"vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value\" max=\"vm.metrics.gauges[\'jvm.threads.count\'].value\" class=\"progress-striped active\" type=\"warning\"><span>{{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span translate=\"metrics.jvm.threads.waiting\">Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value}})</p><uib-progressbar min=\"0\" value=\"vm.metrics.gauges[\'jvm.threads.waiting.count\'].value\" max=\"vm.metrics.gauges[\'jvm.threads.count\'].value\" class=\"progress-striped active\" type=\"warning\"><span>{{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span translate=\"metrics.jvm.threads.blocked\">Blocked</span> ({{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value}})</p><uib-progressbar min=\"0\" value=\"vm.metrics.gauges[\'jvm.threads.blocked.count\'].value\" max=\"vm.metrics.gauges[\'jvm.threads.count\'].value\" class=\"progress-striped active\" type=\"success\"><span>{{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar></div><div class=\"col-md-4\"><b translate=\"metrics.jvm.gc.title\">Garbage collections</b><div class=\"row\"><div class=\"col-md-9\" translate=\"metrics.jvm.gc.marksweepcount\">Mark Sweep count</div><div class=\"col-md-3 text-right\">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.count\'].value}}</div></div><div class=\"row\"><div class=\"col-md-9\" translate=\"metrics.jvm.gc.marksweeptime\">Mark Sweep time</div><div class=\"col-md-3 text-right\">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.time\'].value}}ms</div></div><div class=\"row\"><div class=\"col-md-9\" translate=\"metrics.jvm.gc.scavengecount\">Scavenge count</div><div class=\"col-md-3 text-right\">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.count\'].value}}</div></div><div class=\"row\"><div class=\"col-md-9\" translate=\"metrics.jvm.gc.scavengetime\">Scavenge time</div><div class=\"col-md-3 text-right\">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.time\'].value}}ms</div></div></div></div><div class=\"well well-lg\" ng-show=\"vm.updatingMetrics\" translate=\"metrics.updating\">Updating...</div><h3 translate=\"metrics.jvm.http.title\">HTTP requests (events per second)</h3><p><span translate=\"metrics.jvm.http.active\">Active requests</span> <b>{{vm.metrics.counters[\'com.codahale.metrics.servlet.InstrumentedFilter.activeRequests\'].count | number:0}}</b> - <span translate=\"metrics.jvm.http.total\">Total requests</span> <b>{{vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count | number:0}}</b></p><div class=\"table-responsive\"><table class=\"table table-striped\"><thead><tr><th translate=\"metrics.jvm.http.table.code\">Code</th><th translate=\"metrics.jvm.http.table.count\">Count</th><th class=\"text-right\" translate=\"metrics.jvm.http.table.mean\">Mean</th><th class=\"text-right\"><span translate=\"metrics.jvm.http.table.average\">Average</span> (1 min)</th><th class=\"text-right\"><span translate=\"metrics.jvm.http.table.average\">Average</span> (5 min)</th><th class=\"text-right\"><span translate=\"metrics.jvm.http.table.average\">Average</span> (15 min)</th></tr></thead><tbody><tr><td translate=\"metrics.jvm.http.code.ok\">OK</td><td><uib-progressbar min=\"0\" max=\"vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count\" value=\"vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count\" class=\"progress-striped active\" type=\"success\"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count}}</span></uib-progressbar></td><td class=\"text-right\">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].mean_rate | number:2}}</td><td class=\"text-right\">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m1_rate | number:2}}</td><td class=\"text-right\">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m5_rate | number:2}}</td><td class=\"text-right\">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m15_rate | number:2}}</td></tr><tr><td translate=\"metrics.jvm.http.code.notfound\">Not Found</td><td><uib-progressbar min=\"0\" max=\"vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count\" value=\"vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count\" class=\"progress-striped active\" type=\"success\"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count}}</span></uib-progressbar></td><td class=\"text-right\">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].mean_rate | number:2}}</td><td class=\"text-right\">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m1_rate | number:2}}</td><td class=\"text-right\">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m5_rate | number:2}}</td><td class=\"text-right\">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m15_rate | number:2}}</td></tr><tr><td translate=\"metrics.jvm.http.code.servererror\">Server error</td><td><uib-progressbar min=\"0\" max=\"vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count\" value=\"vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count\" class=\"progress-striped active\" type=\"success\"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count}}</span></uib-progressbar></td><td class=\"text-right\">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].mean_rate | number:2}}</td><td class=\"text-right\">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m1_rate | number:2}}</td><td class=\"text-right\">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m5_rate | number:2}}</td><td class=\"text-right\">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m15_rate | number:2}}</td></tr></tbody></table></div><h3 translate=\"metrics.servicesstats.title\">Services statistics (time in millisecond)</h3><div class=\"table-responsive\"><table class=\"table table-striped\"><thead><tr><th translate=\"metrics.servicesstats.table.name\">Service name</th><th class=\"text-right\" translate=\"metrics.servicesstats.table.count\">Count</th><th class=\"text-right\" translate=\"metrics.servicesstats.table.mean\">Mean</th><th class=\"text-right\" translate=\"metrics.servicesstats.table.min\">Min</th><th class=\"text-right\" translate=\"metrics.servicesstats.table.p50\">p50</th><th class=\"text-right\" translate=\"metrics.servicesstats.table.p75\">p75</th><th class=\"text-right\" translate=\"metrics.servicesstats.table.p95\">p95</th><th class=\"text-right\" translate=\"metrics.servicesstats.table.p99\">p99</th><th class=\"text-right\" translate=\"metrics.servicesstats.table.max\">Max</th></tr></thead><tbody><tr ng-repeat=\"(k, v) in vm.servicesStats\"><td>{{k}}</td><td class=\"text-right\">{{v.count}}</td><td class=\"text-right\">{{v.mean * 1000 | number:0}}</td><td class=\"text-right\">{{v.min * 1000 | number:0}}</td><td class=\"text-right\">{{v.p50 * 1000 | number:0}}</td><td class=\"text-right\">{{v.p75 * 1000 | number:0}}</td><td class=\"text-right\">{{v.p95 * 1000 | number:0}}</td><td class=\"text-right\">{{v.p99 * 1000 | number:0}}</td><td class=\"text-right\">{{v.max * 1000 | number:0}}</td></tr></tbody></table></div><h3 translate=\"metrics.ehcache.title\">Ehcache statistics</h3><div class=\"table-responsive\"><table class=\"table table-striped\"><thead><tr><th translate=\"metrics.ehcache.cachename\">Cache name</th><th class=\"text-right\" translate=\"metrics.ehcache.objects\">Objects</th><th class=\"text-right\" translate=\"metrics.ehcache.hits\">Hits</th><th class=\"text-right\" translate=\"metrics.ehcache.misses\">Misses</th><th class=\"text-right\" translate=\"metrics.ehcache.evictioncount\">Eviction count</th><th class=\"text-right\" translate=\"metrics.ehcache.mean\">Mean get time (ms)</th></tr></thead><tbody><tr ng-repeat=\"(k, v) in vm.cachesStats\" ng-once><td>{{v.name}}</td><td class=\"text-right\">{{vm.metrics.gauges[k + \'.objects\'].value}}</td><td class=\"text-right\">{{vm.metrics.gauges[k + \'.hits\'].value}}</td><td class=\"text-right\">{{vm.metrics.gauges[k + \'.misses\'].value}}</td><td class=\"text-right\">{{vm.metrics.gauges[k + \'.eviction-count\'].value}}</td><td class=\"text-right\">{{vm.metrics.gauges[k + \'.mean-get-time\'].value | number:2}}</td></tr></tbody></table></div><h3 translate=\"metrics.datasource.title\" ng-show=\"vm.metrics.gauges[\'HikariPool-0.pool.TotalConnections\'].value > 0\">DataSource statistics (time in millisecond)</h3><div class=\"table-responsive\" ng-show=\"vm.metrics.gauges[\'HikariPool-0.pool.TotalConnections\'].value > 0\"><table class=\"table table-striped\"><thead><tr><th><span translate=\"metrics.datasource.usage\">Usage</span> ({{vm.metrics.gauges[\'HikariPool-0.pool.ActiveConnections\'].value}} / {{vm.metrics.gauges[\'HikariPool-0.pool.TotalConnections\'].value}})</th><th class=\"text-right\" translate=\"metrics.datasource.count\">Count</th><th class=\"text-right\" translate=\"metrics.datasource.mean\">Mean</th><th class=\"text-right\" translate=\"metrics.datasource.min\">Min</th><th class=\"text-right\" translate=\"metrics.datasource.p50\">p50</th><th class=\"text-right\" translate=\"metrics.datasource.p75\">p75</th><th class=\"text-right\" translate=\"metrics.datasource.p95\">p95</th><th class=\"text-right\" translate=\"metrics.datasource.p99\">p99</th><th class=\"text-right\" translate=\"metrics.datasource.max\">Max</th></tr></thead><tbody><tr><td><div class=\"progress progress-striped\"><uib-progressbar min=\"0\" max=\"vm.metrics.gauges[\'HikariPool-0.pool.TotalConnections\'].value\" value=\"vm.metrics.gauges[\'HikariPool-0.pool.ActiveConnections\'].value\" class=\"progress-striped active\" type=\"success\"><span>{{vm.metrics.gauges[\'HikariPool-0.pool.ActiveConnections\'].value * 100 / vm.metrics.gauges[\'HikariPool-0.pool.TotalConnections\'].value | number:0}}%</span></uib-progressbar></div></td><td class=\"text-right\">{{vm.metrics.histograms[\'HikariPool-0.pool.Usage\'].count}}</td><td class=\"text-right\">{{vm.metrics.histograms[\'HikariPool-0.pool.Usage\'].mean | number:2}}</td><td class=\"text-right\">{{vm.metrics.histograms[\'HikariPool-0.pool.Usage\'].min | number:2}}</td><td class=\"text-right\">{{vm.metrics.histograms[\'HikariPool-0.pool.Usage\'].p50 | number:2}}</td><td class=\"text-right\">{{vm.metrics.histograms[\'HikariPool-0.pool.Usage\'].p75 | number:2}}</td><td class=\"text-right\">{{vm.metrics.histograms[\'HikariPool-0.pool.Usage\'].p95 | number:2}}</td><td class=\"text-right\">{{vm.metrics.histograms[\'HikariPool-0.pool.Usage\'].p99 | number:2}}</td><td class=\"text-right\">{{vm.metrics.histograms[\'HikariPool-0.pool.Usage\'].max | number:2}}</td></tr></tbody></table></div></div>");
$templateCache.put("scripts/components/admin/metrics/metrics.modal.html","<!-- Modal used to display the threads dump --><div class=\"modal-header\"><button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\">&times;</button><h4 class=\"modal-title\" translate=\"metrics.jvm.threads.dump.title\">Threads dump</h4></div><div class=\"modal-body pad\"><span class=\"label label-primary\" ng-click=\"threadDumpFilter = {}\">All&nbsp;<span class=\"badge\">{{vm.threadDumpAll}}</span></span>&nbsp; <span class=\"label label-success\" ng-click=\"threadDumpFilter = {threadState: \'RUNNABLE\'}\">Runnable&nbsp;<span class=\"badge\">{{vm.threadDumpRunnable}}</span></span>&nbsp; <span class=\"label label-info\" ng-click=\"threadDumpFilter = {threadState: \'WAITING\'}\">Waiting&nbsp;<span class=\"badge\">{{vm.threadDumpWaiting}}</span></span>&nbsp; <span class=\"label label-warning\" ng-click=\"threadDumpFilter = {threadState: \'TIMED_WAITING\'}\">Timed Waiting&nbsp;<span class=\"badge\">{{vm.threadDumpTimedWaiting}}</span></span>&nbsp; <span class=\"label label-danger\" ng-click=\"threadDumpFilter = {threadState: \'BLOCKED\'}\">Blocked&nbsp;<span class=\"badge\">{{vm.threadDumpBlocked}}</span></span>&nbsp;<div class=\"voffset2\">&nbsp;</div>Filter <input type=\"text\" ng-model=\"threadDumpFilter\" class=\"form-control\"><div class=\"row pad\" ng-repeat=\"(k, v) in vm.threadDump | filter:threadDumpFilter\"><h5><span class=\"label\" ng-class=\"vm.getLabelClass(v.threadState)\">{{v.threadState}}</span>&nbsp;{{v.threadName}} (ID {{v.threadId}}) <a ng-click=\"show = !show\"><span ng-show=\"!show\" translate=\"metrics.jvm.threads.dump.show\">Show StackTrace</span> <span ng-show=\"show\" translate=\"metrics.jvm.threads.dump.hide\">Hide StackTrace</span></a></h5><div class=\"well\" ng-show=\"show\"><div ng-repeat=\"(stK, stV) in v.stackTrace\">{{stV.className}}.{{stV.methodName}}({{stV.fileName}}:{{stV.lineNumber}}) <span class=\"voffset1\"></span></div></div><table class=\"table table-condensed\"><thead><tr><th class=\"text-right\" translate=\"metrics.jvm.threads.dump.blockedtime\">Blocked Time</th><th class=\"text-right\" translate=\"metrics.jvm.threads.dump.blockedcount\">Blocked Count</th><th class=\"text-right\" translate=\"metrics.jvm.threads.dump.waitedtime\">Waited Time</th><th class=\"text-right\" translate=\"metrics.jvm.threads.dump.waitedcount\">Waited Count</th><th translate=\"metrics.jvm.threads.dump.lockname\">Lock Name</th></tr></thead><tbody><tr><td>{{v.blockedTime}}</td><td>{{v.blockedCount}}</td><td>{{v.waitedTime}}</td><td>{{v.waitedCount}}</td><td>{{v.lockName}}</td></tr></tbody></table></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default pull-left\" data-dismiss=\"modal\" ng-click=\"vm.cancel()\">Done</button></div>");
$templateCache.put("scripts/components/admin/user-management/user-management-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.user.login)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"userManagement.delete.question\" translate-values=\"{login: \'{{vm.user.login}}\'}\">Are you sure you want to delete this User?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("scripts/components/admin/user-management/user-management-detail.html","<div><h2><span translate=\"userManagement.detail.title\">User</span> \"{{vm.user.login}}\"</h2><dl class=\"dl-horizontal\"><dt><span translate=\"userManagement.login\">Login</span></dt><dd><span>{{vm.user.login}}<span></span></span></dd><dt><span translate=\"userManagement.firstName\">First Name</span></dt><dd>{{vm.user.firstName}}</dd><dt><span translate=\"userManagement.lastName\">Last Name</span></dt><dd>{{vm.user.lastName}}</dd><dt><span translate=\"userManagement.email\">Email</span></dt><dd>{{vm.user.email}}</dd><dt><span translate=\"userManagement.activated\">Activated</span></dt><dd>{{vm.user.activated}}</dd><dt><span translate=\"userManagement.langKey\">Lang Key</span></dt><dd>{{vm.user.langKey}}</dd><dt><span translate=\"userManagement.createdBy\">Created By</span></dt><dd>{{vm.user.createdBy}}</dd><dt><span translate=\"userManagement.createdDate\">Created Date</span></dt><dd>{{vm.user.createdDate | date:\'dd/MM/yy HH:mm\' }}</dd><dt><span translate=\"userManagement.lastModifiedBy\">Last Modified By</span></dt><dd>{{vm.user.lastModifiedBy}}</dd><dt><span translate=\"userManagement.lastModifiedDate\">Last Modified Date</span></dt><dd>{{vm.user.lastModifiedDate | date:\'dd/MM/yy HH:mm\'}}</dd><dt><span translate=\"userManagement.profiles\">Profiles</span></dt><dd><ul class=\"list-unstyled\"><li ng-repeat=\"authority in user.authorities\"><span>{{authority}}</span></li></ul></dd></dl><button type=\"submit\" ui-sref=\"user-management\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("scripts/components/admin/user-management/user-management-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myUserLabel\" translate=\"userManagement.home.createOrEditLabel\">Create or edit a User</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\"><label translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" name=\"id\" ng-model=\"vm.user.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"userManagement.login\">Login</label><input type=\"text\" class=\"form-control\" name=\"login\" ng-model=\"vm.user.login\" ng-required=\"vm.user.id == null\" ng-maxlength=\"50\"><div ng-show=\"editForm.login.$invalid\"><p class=\"help-block\" ng-show=\"editForm.login.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.login.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"50\">This field cannot be longer than 50 characters.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"userManagement.firstName\">First Name</label><input type=\"text\" class=\"form-control\" name=\"firstName\" ng-model=\"vm.user.firstName\" ng-maxlength=\"50\"><div ng-show=\"editForm.firstName.$invalid\"><p class=\"help-block\" ng-show=\"editForm.firstName.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"50\">This field cannot be longer than 50 characters.</p></div></div><div class=\"form-group\"><label translate=\"userManagement.lastName\">Last Name</label><input type=\"text\" class=\"form-control\" name=\"lastName\" ng-model=\"vm.user.lastName\" ng-maxlength=\"50\"><div ng-show=\"editForm.lastName.$invalid\"><p class=\"help-block\" ng-show=\"editForm.lastName.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"50\">This field cannot be longer than 50 characters.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"userManagement.email\">Email</label><input type=\"email\" class=\"form-control\" name=\"email\" ng-model=\"vm.user.email\" required ng-maxlength=\"100\"><div ng-show=\"editForm.email.$invalid\"><p class=\"help-block\" ng-show=\"editForm.email.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.email.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"100\">This field cannot be longer than 100 characters.</p><p class=\"help-block\" ng-show=\"editForm.email.$error.email\" translate=\"global.messages.validate.email.invalid\">Your e-mail is invalid.</p></div></div><div class=\"form-group\"><label for=\"activated\"><input ng-disabled=\"vm.user.id === undefined\" type=\"checkbox\" id=\"activated\" ng-model=\"vm.user.activated\"> <span translate=\"userManagement.activated\">Activated</span></label></div><div class=\"form-group\"><label translate=\"userManagement.langKey\">Lang Key</label><select class=\"form-control\" name=\"langKey\" ng-model=\"vm.user.langKey\" ng-options=\"language as language for language in vm.languages track by language\"></select></div><div class=\"form-group\"><label translate=\"userManagement.profiles\">Profiles</label><select class=\"form-control\" multiple=\"multiple\" name=\"authority\" ng-model=\"vm.user.authorities\" ng-options=\"authority for authority in vm.authorities\"></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("scripts/components/admin/user-management/user-management.html","<div><h2 translate=\"userManagement.home.title\">Users</h2><jhi-alert></jhi-alert><div class=\"row\"><div class=\"col-md-4\"><button class=\"btn btn-primary\" ui-sref=\"user-management.new\"><span class=\"glyphicon glyphicon-flash\"></span> <span translate=\"userManagement.home.createLabel\">Create a new User</span></button></div></div><div class=\"table-responsive\"><table class=\"table table-striped\"><thead><tr><th translate=\"global.field.id\">ID</th><th translate=\"userManagement.login\">Login</th><th translate=\"userManagement.email\">Email</th><th></th><th translate=\"userManagement.langKey\">Lang Key</th><th translate=\"userManagement.profiles\">Profiles</th><th translate=\"userManagement.createdDate\">Created Date</th><th translate=\"userManagement.lastModifiedBy\">Last Modified By</th><th translate=\"userManagement.lastModifiedDate\">Last Modified Date</th><th></th></tr></thead><tbody><tr ng-repeat=\"user in vm.users track by user.id\"><td><a ui-sref=\"user-management-detail({login:user.login})\">{{user.id}}</a></td><td>{{user.login}}</td><td>{{user.email}}</td><td><span class=\"label label-danger\" ng-click=\"vm.setActive(user, true)\" ng-show=\"!user.activated\" translate=\"userManagement.deactivated\" style=\"cursor: pointer\">Desactivated</span> <span class=\"label label-success\" ng-click=\"vm.setActive(user, false)\" ng-show=\"user.activated\" translate=\"userManagement.activated\" style=\"cursor: pointer\">Activated</span></td><td>{{user.langKey}}</td><td><div ng-repeat=\"authority in user.authorities\"><span class=\"label label-info\">{{ authority }}</span></div></td><td>{{user.createdDate | date:\'dd/MM/yy HH:mm\'}}</td><td>{{user.lastModifiedBy}}</td><td>{{user.lastModifiedDate | date:\'dd/MM/yy HH:mm\'}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"user-management-detail({login:user.login})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"user-management.edit({login:user.login})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"user-management.delete({login:user.login})\" class=\"btn btn-danger btn-sm\" ng-disabled=\"vm.currentAccount.login==user.login\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.loadAll()\"></uib-pagination></div></div>");
$templateCache.put("scripts/components/components/login/login.html","<div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.cancel()\">&times;</button><h4 class=\"modal-title\" translate=\"login.title\">Sign in</h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-md-4 col-md-offset-4\"><h1 translate=\"login.title\">Sign in</h1></div><div class=\"col-md-8 col-md-offset-2\"><div class=\"alert alert-danger\" ng-show=\"vm.authenticationError\" translate=\"login.messages.error.authentication\"><strong>Failed to sign in!</strong> Please check your credentials and try again.</div></div><div class=\"col-md-8 col-md-offset-2\"><form class=\"form\" role=\"form\" ng-submit=\"vm.login($event)\"><div class=\"form-group\"><label for=\"username\" translate=\"global.form.username\">Login</label><input type=\"text\" class=\"form-control\" id=\"username\" placeholder=\"{{\'global.form.username.placeholder\' | translate}}\" ng-model=\"vm.username\"></div><div class=\"form-group\"><label for=\"password\" translate=\"login.form.password\">Password</label><input type=\"password\" class=\"form-control\" id=\"password\" placeholder=\"{{\'login.form.password.placeholder\' | translate}}\" ng-model=\"vm.password\"></div><div class=\"form-group\"><label for=\"rememberMe\"><input type=\"checkbox\" id=\"rememberMe\" ng-model=\"vm.rememberMe\" checked=\"checked\"> <span translate=\"login.form.rememberme\">Remember me</span></label></div><button type=\"submit\" class=\"btn btn-primary\" translate=\"login.form.button\">Sign in</button></form><p></p><div class=\"alert alert-warning\"><a class=\"alert-link\" href=\"\" ng-click=\"vm.requestResetPassword()\" translate=\"login.password.forgot\">Did you forget your password?</a></div><div class=\"alert alert-warning\" translate=\"global.messages.info.register\" translate-compile>You don\'t have an account yet? <a class=\"alert-link\" href=\"\" ng-click=\"vm.register()\">Register a new account</a></div></div></div></div>");
$templateCache.put("scripts/components/layouts/error/accessdenied.html","<div ng-cloak><div class=\"row\"><div class=\"col-md-4\"><span class=\"hipster img-responsive img-rounded\"></span></div><div class=\"col-md-8\"><h1 translate=\"error.title\">Error Page!</h1><div class=\"alert alert-danger\" translate=\"error.403\">You are not authorized to access the page.</div></div></div></div>");
$templateCache.put("scripts/components/layouts/error/error.html","<div ng-cloak><div class=\"row\"><div class=\"col-md-4\"><span class=\"hipster img-responsive img-rounded\"></span></div><div class=\"col-md-8\"><h1 translate=\"error.title\">Error Page!</h1><div ng-show=\"errorMessage\"><div class=\"alert alert-danger\">{{errorMessage}}</div></div></div></div></div>");
$templateCache.put("scripts/components/layouts/navbar/navbar.html","<nav class=\"navbar navbar-default\" role=\"navigation\"><div class=\"container\"><div class=\"navbar-header\"><button type=\"button\" class=\"navbar-toggle\" ng-click=\"vm.toggleNavbar()\"><span class=\"sr-only\">Toggle navigation</span> <span class=\"icon-bar\"></span> <span class=\"icon-bar\"></span> <span class=\"icon-bar\"></span></button> <a class=\"navbar-brand\" href=\"#/\" ng-click=\"vm.collapseNavbar()\"><span translate=\"global.title\">Formonline</span> <span class=\"navbar-version\">v{{VERSION}}</span></a></div><div class=\"navbar-collapse\" uib-collapse=\"vm.isNavbarCollapsed\" ng-switch=\"vm.isAuthenticated()\"><ul class=\"nav navbar-nav navbar-right\"><li ui-sref-active=\"active\"><a ui-sref=\"home\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-home\"></span> <span class=\"hidden-sm\" translate=\"global.menu.home\">Home</span></a></li><!-- jhipster-needle-add-element-to-menu - JHipster will add new menu items here --><li ng-class=\"{active: vm.$state.includes(\'entity\')}\" ng-switch-when=\"true\" uib-dropdown class=\"dropdown pointer\"><a class=\"dropdown-toggle\" uib-dropdown-toggle href=\"\" id=\"entity-menu\"><span><span class=\"glyphicon glyphicon-th-list\"></span> <span class=\"hidden-sm\" translate=\"global.menu.entities.main\">Entities </span><b class=\"caret\"></b></span></a><ul class=\"dropdown-menu\" uib-dropdown-menu><!-- jhipster-needle-add-entity-to-menu - JHipster will add entities to the menu here --></ul></li><li ng-class=\"{active: vm.$state.includes(\'account\')}\" uib-dropdown class=\"dropdown pointer\"><a class=\"dropdown-toggle\" uib-dropdown-toggle href=\"\" id=\"account-menu\"><span><span class=\"glyphicon glyphicon-user\"></span> <span class=\"hidden-sm\" translate=\"global.menu.account.main\">Account </span><b class=\"caret\"></b></span></a><ul class=\"dropdown-menu\" uib-dropdown-menu><li ui-sref-active=\"active\" ng-switch-when=\"true\"><a ui-sref=\"settings\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-wrench\"></span>&nbsp; <span translate=\"global.menu.account.settings\">Settings</span></a></li><li ui-sref-active=\"active\" ng-switch-when=\"true\"><a ui-sref=\"password\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-lock\"></span> <span translate=\"global.menu.account.password\">Password</span></a></li><li ui-sref-active=\"active\" ng-switch-when=\"true\"><a href=\"\" ng-click=\"vm.logout()\" id=\"logout\"><span class=\"glyphicon glyphicon-log-out\"></span>&nbsp; <span translate=\"global.menu.account.logout\">Sign out</span></a></li><li ui-sref-active=\"active\" ng-switch-when=\"false\"><a href=\"\" ng-click=\"vm.login()\" id=\"login\"><span class=\"glyphicon glyphicon-log-in\"></span>&nbsp; <span translate=\"global.menu.account.login\">Sign in</span></a></li><li ui-sref-active=\"active\" ng-switch-when=\"false\"><a ui-sref=\"register\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-plus-sign\"></span>&nbsp; <span translate=\"global.menu.account.register\">Register</span></a></li></ul></li><li ng-class=\"{active: vm.$state.includes(\'admin\')}\" ng-switch-when=\"true\" has-authority=\"ROLE_ADMIN\" uib-dropdown class=\"dropdown pointer\"><a class=\"dropdown-toggle\" uib-dropdown-toggle href=\"\" id=\"admin-menu\"><span><span class=\"glyphicon glyphicon-tower\"></span> <span class=\"hidden-sm\" translate=\"global.menu.admin.main\">Administration</span> <b class=\"caret\"></b></span></a><ul class=\"dropdown-menu\" uib-dropdown-menu><li ui-sref-active=\"active\"><a ui-sref=\"user-management\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-user\"></span>&nbsp; <span translate=\"global.menu.admin.userManagement\">User management</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"jhi-metrics\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-dashboard\"></span>&nbsp; <span translate=\"global.menu.admin.metrics\">Metrics</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"jhi-health\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-heart\"></span>&nbsp; <span translate=\"global.menu.admin.health\">Health</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"jhi-configuration\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-list-alt\"></span>&nbsp; <span translate=\"global.menu.admin.configuration\">Configuration</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"audits\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-bell\"></span>&nbsp; <span translate=\"global.menu.admin.audits\">Audits</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"logs\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-tasks\"></span>&nbsp; <span translate=\"global.menu.admin.logs\">Logs</span></a></li><li ng-hide=\"vm.inProduction\" ui-sref-active=\"active\"><a ui-sref=\"docs\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-book\"></span>&nbsp; <span translate=\"global.menu.admin.apidocs\">API</span></a></li><!-- jhipster-needle-add-element-to-admin-menu - JHipster will add entities to the admin menu here --><li ng-hide=\"vm.inProduction\"><a href=\"/h2-console\" target=\"_tab\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-hdd\"></span>&nbsp; <span translate=\"global.menu.admin.database\">Database</span></a></li></ul></li><li ui-sref-active=\"active\" uib-dropdown class=\"dropdown pointer\" ng-controller=\"JhiLanguageController as languageVm\"><a class=\"dropdown-toggle\" uib-dropdown-toggle href=\"\" ng-if=\"languageVm.languages.length > 1\"><span><span class=\"glyphicon glyphicon-flag\"></span> <span class=\"hidden-sm\" translate=\"global.menu.language\">Language</span> <b class=\"caret\"></b></span></a><ul class=\"dropdown-menu\" uib-dropdown-menu ng-if=\"languageVm.languages.length > 1\"><li active-menu=\"{{language}}\" ng-repeat=\"language in languageVm.languages\"><a href=\"\" ng-click=\"languageVm.changeLanguage(language);vm.collapseNavbar();\">{{language | findLanguageFromKey}}</a></li></ul></li></ul></div></div></nav>");
$templateCache.put("scripts/core/form/upload/upload.html","<div class=\"stl-upload\"><form action=\"{{uploadAction}}\" method=\"POST\" enctype=\"multipart/form-data\" file-upload=\"options\"><!-- The fileinput-button span is used to style the file input field as button --> <span class=\"btn fileinput-button btn-default\" ng-class=\"{disabled: uploadDisabled}\"><span>{{buttonText}}</span> <input type=\"file\" name=\"files\" multiple=\"\" ng-disabled=\"uploadDisabled\"></span></form></div>");
$templateCache.put("scripts/app/form/declaris/lr/declaris.lr.html","<div id=\"form-wrapper\" class=\"panel panel-default\"><div id=\"declaris-form-content-wrapper\" class=\"panel-body\"><div id=\"form-header\" ng-show=\"formHelper.step == 2\"><div class=\"col-xs-6\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"goToFirstStep()\" translate=\"Precedent\">Précédent</button></div><div class=\"col-xs-6\"><span class=\"pull-right\"><button type=\"submit\" class=\"btn btn-primary\" ng-click=\"sendDeclaration()\" ng-disabled=\"!isFormValid()\" translate=\"Envoyer\">Envoyer</button></span></div></div><div id=\"form-content\" ng-class=\"{\'content-spacer\': formHelper.step == 2}\"><div class=\"col-xs-12\"><h1>{{\'ImpotALaSource\' | translate}} - {{\'ListeRecapitulative\' | translate}}</h1><div ng-show=\"formHelper.step == 1\"><form role=\"form\" name=\"declarationHeaderForm\"><h2 translate=\"IdentificationDuDPI\">Identification du DPI</h2><div class=\"row form-group\" show-errors><div class=\"col-xs-4\"><label for=\"noReference\" class=\"control-label label-required\" translate=\"NoDeReference\">No de référence</label></div><div class=\"col-xs-8\" uib-popover=\"{{showAuthorizationResult() ? \'NoReferenceOuCodeIncorrect\' : \'\' | translate}}\" popover-trigger=\"mouseenter\" popover-placement=\"top\" popover-append-to-body=\"true\"><input id=\"noReference\" name=\"noReference\" type=\"text\" class=\"form-control input-sm\" ng-model=\"declaration.ndc\" placeholder=\"999.999.999/99\" ng-pattern=\"/\\d{3}\\.\\d{3}\\.\\d{3}/\\d{2}$/\" ng-model-options=\"{ updateOn: \'blur\'}\" mask=\"999.999.999/99\" ng-change=\"checkAuthorization()\" ng-class=\"{\'alert-danger\': showAuthorizationResult()}\" required></div></div><div class=\"row form-group\" show-errors><div class=\"col-xs-4\"><label for=\"codeSecurite\" class=\"control-label label-required\" translate=\"CodeDeSecurite\">Code de sécurité</label><span class=\"glyphicon glyphicon-question-sign help-icon\" uib-popover=\"{{\'InformationCodeSecurite\' | translate}}\" popover-title=\"{{\'CodeDeSecurite\' | translate}}\" popover-trigger=\"mouseenter\" popover-placement=\"bottom\" popover-append-to-body=\"true\"></span></div><div class=\"col-xs-8\" uib-popover=\"{{showAuthorizationResult() ? \'NoReferenceOuCodeIncorrect\' : \'\' | translate}}\" popover-trigger=\"mouseenter\" popover-placement=\"top\" popover-append-to-body=\"true\"><input id=\"codeSecurite\" name=\"codeSecurite\" type=\"text\" class=\"form-control input-sm\" ng-model=\"declaration.codeSecurite\" ng-model-options=\"{ updateOn: \'blur\'}\" ng-change=\"checkAuthorization()\" ng-class=\"{\'alert-danger\': showAuthorizationResult()}\" required></div></div><div class=\"row form-group\" show-errors><div class=\"col-xs-4\"><label for=\"nomDpi\" class=\"control-label label-required\" translate=\"Nom\">Nom</label></div><div class=\"col-xs-8\"><input id=\"nomDpi\" name=\"nomDpi\" type=\"text\" class=\"form-control input-sm\" ng-model=\"declaration.nomDpi\" required></div></div><div class=\"row form-group\" show-errors><div class=\"col-xs-4\"><label for=\"responsable\" class=\"control-label label-required\" translate=\"Responsable\">Responsable</label></div><div class=\"col-xs-8\"><input id=\"responsable\" name=\"responsable\" type=\"text\" class=\"form-control input-sm\" ng-model=\"declaration.responsable\" required></div></div><div class=\"row form-group\" show-errors><div class=\"col-xs-4\"><label for=\"telephone\" class=\"control-label label-required\" translate=\"Telephone\">Téléphone</label></div><div class=\"col-xs-8\"><input id=\"telephone\" name=\"telephone\" type=\"text\" class=\"form-control input-sm\" ng-model=\"declaration.telephone\" placeholder=\"099 999 99 99\" ng-pattern=\"/[0](\\d\\s*){9}$/\" mask=\"099 999 99 99\" required></div></div><div class=\"row form-group\" show-errors><div class=\"col-xs-4\"><label for=\"email\" class=\"control-label label-required\" translate=\"Email\">E-mail</label></div><div class=\"col-xs-8\"><input id=\"email\" name=\"email\" type=\"email\" class=\"form-control input-sm\" ng-model=\"declaration.email\" required></div></div><div class=\"row form-group\"><div class=\"col-xs-4\"><label for=\"anneeFiscale\" class=\"control-label label-required\" translate=\"AnneeFiscale\">Année fiscale</label></div><div class=\"col-xs-8\"><ui-select id=\"anneeFiscale\" name=\"anneeFiscale\" ng-model=\"declaration.anneeFiscale\" theme=\"bootstrap\" required ng-change=\"anneeFiscaleSelected()\"><ui-select-match>{{$select.selected}}</ui-select-match><ui-select-choices repeat=\"a in formHelper.anneesFiscales | filter: $select.search | orderBy : \'-\'\"><div ng-bind-html=\"\'\'+ a | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div><div class=\"row form-group\"><div class=\"col-xs-4\"><label for=\"remarqueScc\" class=\"control-label\" translate=\"RemarqueScc\">Remarque au SCC</label></div><div class=\"col-xs-8\"><textarea id=\"remarqueScc\" name=\"remarqueScc\" class=\"form-control\" ng-model=\"declaration.remarqueScc\"></textarea></div></div><div class=\"row form-group\"><div class=\"col-xs-4\"></div><div class=\"col-xs-8\"><label><input type=\"checkbox\" ng-model=\"formHelper.saveHeader\"> {{\'ConserverLesDonneesDansCeNavigateur\' | translate}}</label></div></div><div class=\"row\"><div class=\"col-xs-4\"><p>*&nbsp;{{\'champsObligatoires\' | translate}}</p></div></div><h2 translate=\"ListeRecapitulative\">Liste récapitulative</h2><div translate=\"PossibilitesCommunicationLR\">Vous avez la possibiliter de communiquer la liste récapitulative de deux manières :</div><div class=\"row\"><div class=\"col-sm-12\"><div class=\"radio\"><label><input type=\"radio\" ng-model=\"declaration.typeDeclarationIs\" name=\"type\" value=\"FORM\" ng-disabled=\"formHelper.fileUploaded\" ng-change=\"sendHeightToParent()\"> {{\'EnRemplissantFormulaire\' | translate}}</label></div><div class=\"radio\"><label><input type=\"radio\" ng-model=\"declaration.typeDeclarationIs\" name=\"type\" value=\"EXCEL\" ng-disabled=\"formHelper.fileUploaded\" ng-change=\"sendHeightToParent()\"> {{\'EnEnvoyantFichierExcel\' | translate}}&nbsp;({{\'MethodeConseilleeDesXPersonnes\' | translate}})</label></div></div></div></form><form role=\"form\" name=\"declarationIsForm\"><div ng-if=\"declaration.typeDeclarationIs === \'EXCEL\'\"><div class=\"row\"><div class=\"col-xs-12\"><hr></div></div><div class=\"row\"><div class=\"col-xs-12\">{{\'LaLRDoitEtreTransmiseAvecFeuilleExcel\' | translate}}&nbsp;<a href=\"content/xls/declaration-is-lr_2026.xlsx\">{{\'FeuilleExcelATelecharger\' | translate}}</a>&nbsp;{{\'Periodes2021EtSuivantes\' | translate}}<br>{{\'PeriodesJusqua2020\' | translate}}&nbsp;<a href=\"content/xls/declaration-is-lr_2021.xlsx\">{{\'FeuilleExcel2020\' | translate}}</a></div></div><div class=\"row form-group\"><div class=\"col-xs-4\"><label for=\"excel\" class=\"control-label label-required\" translate=\"FeuilleExcel\">Feuille Excel</label></div><div class=\"col-xs-8 input-file-wrapper\"><input id=\"excel\" name=\"excel\" type=\"file\" class=\"form-control input-sm input-file\" file-model=\"declaration.excelFile\" ng-click=\"resetInputFile()\" custom-on-change=\"loadExcelFile\" accept=\"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel\" required></div></div><div class=\"row\" ng-show=\"formHelper.fileUploadError\"><div class=\"col-xs-4\"></div><div class=\"col-xs-8\"><div class=\"alert alert-danger\" role=\"alert\"><span class=\"glyphicon glyphicon-exclamation-sign\" aria-hidden=\"true\"></span> <span>{{formHelper.fileUploadError}}</span></div></div></div><div ng-show=\"formHelper.fileUploaded\"><a ng-show=\"formHelper.step == 3\" class=\"pull-right\" ng-click=\"printDiv(\'recap\')\"><span class=\"iconbtn iconexp iconexp-printer\" uib-tooltip=\"{{\'Imprimer\' | translate}}\" tooltip-placement=\"left\"></span></a><div ng-include=\"\'scripts/app/form/declaris/lr/declaris.lr.recap.html\'\"></div></div></div><div ng-if=\"declaration.typeDeclarationIs === \'FORM\'\"><div ng-repeat=\"lr in declaration.listesRecapitulatives\"><div class=\"row\"><div class=\"col-xs-12\"><hr><div class=\"bs-callout bs-callout-info\" ng-show=\"lr.index % 5 == 0\"><span class=\"glyphicon glyphicon-info-sign\" aria-hidden=\"true\"></span> <span>{{\'TexteInfoPlusieursPersonnes1\' | translate}}&nbsp;<a href=\"content/xls/declaration-is-lr.xlsx\" class=\"callout-link\">{{\'FeuilleExcel\' | translate}}</a>&nbsp;{{\'TexteInfoPlusieursPersonnes2\' | translate}}</span></div></div></div><div class=\"row\"><div class=\"col-xs-4\"><h4>{{\'Personne\' | translate}}&nbsp;{{lr.index}}</h4></div><div class=\"col-xs-6 col-xs-8\"><button type=\"button\" class=\"btn btn-default pull-right\" ng-click=\"removeEntry(lr.index)\" ng-show=\"lr.index > 1\" translate=\"SupprimerPersonne\">Supprimer personne</button></div></div><div ng-hide=\"lr.pisInconnue\"><div class=\"row form-group\" show-errors><div class=\"col-xs-4\"><label for=\"noAVS{{lr.index}}\" class=\"control-label label-required\" translate=\"NoAvs\">No AVS</label></div><div class=\"col-xs-4\"><input id=\"noAVS{{lr.index}}\" name=\"noAVS{{lr.index}}\" type=\"text\" class=\"form-control input-sm\" placeholder=\"756.9999.9999.99\" mask=\"999.9999.9999.99\" ng-model=\"lr.noAvs\" ng-required=\"!lr.pisInconnue\"></div><div class=\"col-xs-4\"><label><input type=\"checkbox\" ng-model=\"lr.pisInconnue\"> {{\'PisSansNoAVS\' | translate}}</label></div></div></div><div ng-show=\"lr.pisInconnue\"><div class=\"row\" show-errors=\"{ skipFormGroupCheck: true }\"><div class=\"col-xs-4\"><label for=\"dateNaissance{{lr.index}}\" class=\"control-label label-required\" translate=\"DateNaissance\">Date de naissance</label></div><div class=\"col-xs-4\"><stl-date-picker id=\"dateNaissance{{lr.index}}\" name=\"dateNaissance{{lr.index}}\" ng-model=\"lr.dateNaissance\" ng-required=\"lr.pisInconnue\" ng-change=\"customInputChange(lr)\"></stl-date-picker><input name=\"dateNaissance{{lr.index}}\" type=\"text\" class=\"form-control hidden\" ng-model=\"lr.dateNaissance\" ng-required=\"lr.pisInconnue\"></div><div class=\"col-xs-4\"><label><input type=\"checkbox\" ng-model=\"lr.pisInconnue\"> {{\'PisSansNoAVS\' | translate}}</label></div></div><div class=\"row\"><div class=\"col-xs-4\"><label class=\"control-label label-required\" translate=\"Sexe\">Sexe</label></div><div class=\"col-xs-4\"><div class=\"radio\"><label><input type=\"radio\" ng-model=\"lr.sexe\" name=\"sexe\" value=\"M\"> {{\'Masculin\' | translate}}</label></div><div class=\"radio\"><label><input type=\"radio\" ng-model=\"lr.sexe\" name=\"sexe\" value=\"F\"> {{\'Feminin\' | translate}}</label></div></div></div></div><div class=\"row form-group\" show-errors><div class=\"col-xs-4\"><label for=\"nom{{lr.index}}\" class=\"control-label label-required\" translate=\"Nom\">Nom</label></div><div class=\"col-xs-8\"><input id=\"nom{{lr.index}}\" name=\"nom{{lr.index}}\" type=\"text\" class=\"form-control input-sm\" ng-model=\"lr.nom\" required></div></div><div class=\"row form-group\" show-errors><div class=\"col-xs-4\"><label for=\"prenom{{lr.index}}\" class=\"control-label label-required\" translate=\"Prenom\">Prénom</label></div><div class=\"col-xs-8\"><input id=\"prenom{{lr.index}}\" name=\"prenom{{lr.index}}\" type=\"text\" class=\"form-control input-sm\" ng-model=\"lr.prenom\" required></div></div><div class=\"row form-group\" show-errors><div class=\"col-xs-4\"><label for=\"localite{{lr.index}}\" class=\"control-label label-required\" translate=\"NpaLocalite\">NPA / Localité</label></div><div class=\"col-sm-4 col-xs-2\"><ui-select id=\"localite{{lr.index}}\" name=\"localite{{lr.index}}\" class=\"form-control inline-select\" ng-model=\"lr.localiteObj\" theme=\"bootstrap\" required on-select=\"localiteSelected(lr, $item)\" ng-change=\"updateValidation()\"><ui-select-match>{{$select.selected.npa + \' \' + $select.selected.nom}}</ui-select-match><ui-select-choices repeat=\"l in (localites | filter: $select.search)\"><span ng-bind-html=\"l.npa + \' \' +l.nom | highlight: $select.search\"></span></ui-select-choices></ui-select></div></div><div class=\"row form-group\"><div class=\"col-xs-4\"><label for=\"periodeDu{{lr.index}}\" class=\"control-label label-required\" translate=\"PeriodeDuAu\">Période du - au</label></div><div class=\"col-xs-4\" show-errors=\"{ skipFormGroupCheck: true }\"><stl-date-picker id=\"periodeDu{{lr.index}}\" name=\"periodeDu{{lr.index}}\" ng-model=\"lr.periodeDu\" start-date=\"getDateDebut()\" end-date=\"lr.periodeAu\" day-month-only=\"declaration.anneeFiscale\" required ng-change=\"customInputChange(lr)\"></stl-date-picker><input name=\"periodeDu{{lr.index}}\" type=\"text\" class=\"form-control hidden\" ng-model=\"lr.periodeDu\" required></div><div class=\"col-xs-4\" show-errors=\"{ skipFormGroupCheck: true }\"><stl-date-picker id=\"periodeAu{{lr.index}}\" name=\"periodeAu{{lr.index}}\" ng-model=\"lr.periodeAu\" start-date=\"lr.periodeDu\" end-date=\"getDateFin()\" day-month-only=\"declaration.anneeFiscale\" required ng-change=\"customInputChange(lr)\"></stl-date-picker><input name=\"periodeAu{{lr.index}}\" type=\"text\" class=\"form-control hidden\" ng-model=\"lr.periodeAu\" required></div></div><div class=\"row\"><div class=\"col-xs-4\"></div><div class=\"col-xs-4\"><label><input type=\"checkbox\" ng-model=\"lr.arrivee\"> {{\'Arrivee\' | translate}}</label></div><div class=\"col-xs-4\"><label><input type=\"checkbox\" ng-model=\"lr.depart\"> {{\'Depart\' | translate}}</label></div></div><div class=\"row form-group\" show-errors><div class=\"col-xs-4\"><label for=\"bareme{{lr.index}}\" class=\"control-label label-required\" translate=\"Bareme\">Barème</label></div><div class=\"col-xs-4\"><ui-select id=\"bareme{{lr.index}}\" name=\"bareme{{lr.index}}\" ng-model=\"lr.bareme\" theme=\"bootstrap\" required ng-change=\"customInputChange(lr)\"><ui-select-match allow-clear=\"false\">{{$select.selected}}</ui-select-match><ui-select-choices repeat=\"b in baremes | filter: $select.search\"><div ng-bind-html=\"\'\' + b | highlight: $select.search\" uib-popover=\"{{formHelper.contexteFiscale.elementsBaremeLocalisation[b][\'description\' + getLanguage().toUpperCase()]}}\" popover-trigger=\"mouseenter\" popover-append-to-body=\"true\"></div></ui-select-choices></ui-select><input name=\"bareme{{lr.index}}\" type=\"text\" class=\"form-control hidden\" ng-model=\"lr.bareme\" required></div></div><div class=\"row form-group\" show-errors ng-if=\"isBaremeAvecEnfants(lr.bareme)\"><div class=\"col-xs-4\"><label for=\"nbEnfants{{lr.index}}\" class=\"control-label label-required\" translate=\"NombreEnfants\">Nombre d\'enfants</label></div><div class=\"col-xs-2\"><input id=\"nbEnfants{{lr.index}}\" name=\"nbEnfants{{lr.index}}\" type=\"number\" min=\"0\" max=\"{{declaration.anneeFiscale >= 2023 ? 9 : 6}}\" class=\"form-control input-sm\" ng-model=\"lr.nbEnfants\" required ng-blur=\"resetRevenuDeterminantEtCalculer(lr)\"></div><div class=\"col-xs-5 bg-warning\" ng-show=\"isBaremeAAvecEnfant(lr)\">{{ \'TexteBaremeAAvecEnfant\' | translate }}</div></div><div class=\"row form-group\" ng-if=\"!isBaremeSansRevenuDeterminant(lr.bareme) && formHelper.contexteFiscale.annee >= 2021\"><div class=\"col-xs-4\"><label for=\"travailDiscontinu{{lr.index}}\" class=\"control-label\" translate=\"TravailDiscontinu\">Travail non stable</label></div><div class=\"col-xs-4\"><input type=\"checkbox\" id=\"travailDiscontinu{{lr.index}}\" name=\"travailDiscontinu{{lr.index}}\" ng-model=\"lr.travailDiscontinu\" ng-change=\"activiteChange(lr)\"></div></div><div class=\"row form-group\" show-errors ng-if=\"!isBaremeSansRevenuDeterminant(lr.bareme) && formHelper.contexteFiscale.annee >= 2021 && !lr.travailDiscontinu\"><div class=\"col-xs-4\"><label for=\"tauxActivite{{lr.index}}\" class=\"control-label label-required\" translate=\"TauxActivite\">Taux d\'activité</label></div><div class=\"col-xs-4\"><input id=\"tauxActivite{{lr.index}}\" name=\"tauxActivite{{lr.index}}\" type=\"text\" stl-percentage-input min=\"1\" max=\"200\" class=\"form-control input-sm\" ng-model=\"lr.tauxActivite\" required ng-blur=\"resetRevenuDeterminantEtCalculer(lr)\"></div></div><div class=\"row form-group\" show-errors ng-if=\"!isBaremeSansRevenuDeterminant(lr.bareme) && formHelper.contexteFiscale.annee >= 2021 && !lr.travailDiscontinu\"><div class=\"col-xs-4\"><label for=\"tauxAutresActivites{{lr.index}}\" class=\"control-label label-required\" translate=\"tauxAutresActivites\">Total des autres activités</label></div><div class=\"col-xs-4\"><input id=\"tauxAutresActivites{{lr.index}}\" name=\"tauxAutresActivites{{lr.index}}\" type=\"text\" stl-percentage-input min=\"0\" max=\"200\" class=\"form-control input-sm\" ng-model=\"lr.tauxAutresActivites\" required ng-blur=\"resetRevenuDeterminantEtCalculer(lr)\"></div></div><div class=\"row form-group\" show-errors ng-if=\"!isBaremeSansRevenuDeterminant(lr.bareme) && formHelper.contexteFiscale.annee >= 2021 && lr.travailDiscontinu\"><div class=\"col-xs-4\"><label for=\"nbHeuresTravail{{lr.index}}\" class=\"control-label label-required\" translate=\"NbHeuresTravail\">Heures travaillées</label></div><div class=\"col-xs-4\"><input id=\"nbHeuresTravail{{lr.index}}\" name=\"nbHeuresTravail{{lr.index}}\" type=\"number\" min=\"1\" max=\"2160\" class=\"form-control input-sm\" ng-model=\"lr.nbHeuresTravail\" required ng-blur=\"resetRevenuDeterminantEtCalculer(lr)\"></div></div><div class=\"row form-group\" show-errors><div class=\"col-xs-4\"><label for=\"revenu{{lr.index}}\" class=\"control-label label-required\" translate=\"RevenuBrutImpot\">Revenu brut / Impôt</label></div><div class=\"col-xs-4\"><input id=\"revenu{{lr.index}}\" name=\"revenu{{lr.index}}\" type=\"text\" class=\"form-control input-sm text-right\" ng-model=\"lr.revenu\" ng-model-options=\"{ debounce: 200 }\" stl-currency-input required ng-blur=\"resetRevenuDeterminantEtCalculer(lr)\"></div><div class=\"col-xs-4\"><input id=\"retenue{{lr.index}}\" name=\"retenue{{lr.index}}\" type=\"text\" class=\"form-control input-sm text-right\" ng-model=\"lr.retenue\" stl-currency-input required ng-blur=\"retenueModified(lr)\" ng-model-options=\"{ debounce: 200 }\" ng-class=\"{\'alert-warning\': isRetenueModified(lr)}\" uib-popover=\"{{isRetenueModified(lr) ? (lr.computedRetenue | currency:2:0) : \'\'}}\" popover-title=\"{{\'MontantAttendu\' | translate}}\" popover-trigger=\"mouseenter\" popover-placement=\"top\" popover-append-to-body=\"true\"></div></div><div class=\"row form-group\" show-errors ng-if=\"!isBaremeSansRevenuDeterminant(lr.bareme) && formHelper.contexteFiscale.annee >= 2021\"><div class=\"col-xs-4\"><label for=\"revenuDeterminant{{lr.index}}\" class=\"control-label\" translate=\"ModifierRevenuDeterminant\">Modifier le revenu déterminant</label></div><div class=\"col-xs-4\"><input id=\"revenuDeterminant{{lr.index}}\" name=\"revenuDeterminant{{lr.index}}\" type=\"text\" class=\"form-control input-sm text-right\" ng-model=\"lr.revenuDeterminant\" stl-currency-input ng-blur=\"calculer(lr)\" ng-model-options=\"{ debounce: 200 }\" ng-class=\"{\'alert-warning\': isRevenuDeterminantModified(lr)}\" uib-popover=\"{{isRevenuDeterminantModified(lr) ? (lr.computedRevenuDeterminant | currency:2:0) : \'\'}}\" popover-title=\"{{\'MontantAttendu\' | translate}}\" popover-trigger=\"mouseenter\" popover-placement=\"top\" popover-append-to-body=\"true\"></div></div><!-- Champs supplémentaires : télétravail et pays de résidence --><div class=\"row form-group\" show-errors><div class=\"col-xs-4\"><label for=\"tauxTeletravailFrance{{lr.index}}\" class=\"control-label\">{{\'TauxTeletravailEnFrance\' | translate}}</label></div><div class=\"col-xs-4\"><input id=\"tauxTeletravailFrance{{lr.index}}\" name=\"tauxTeletravailFrance{{lr.index}}\" type=\"text\" class=\"form-control input-sm text-right\" stl-percentage-input ng-model=\"lr.tauxTeletravailFrance\" ng-change=\"syncPaysResidenceFromTeletravail(lr)\" ng-blur=\"calculer(lr)\" ng-model-options=\"{ debounce: 200 }\" min=\"0\" max=\"100\"></div><div class=\"col-xs-1 control-label\">%</div></div><div class=\"row form-group\"><div class=\"col-xs-4\"><label for=\"paysResidence{{lr.index}}\" class=\"control-label\">{{\'PaysDeResidence\' | translate}}</label></div><div class=\"col-xs-4\"><select id=\"paysResidence{{lr.index}}\" name=\"paysResidence{{lr.index}}\" class=\"form-control input-sm\" ng-model=\"lr.paysResidence\" ng-disabled=\"true\" ng-options=\"c.code as c.name for c in countryList\"><option value=\"\">{{\'ChoisirPays\' | translate}}</option></select></div></div></div><div class=\"row\"><div class=\"col-xs-12\"><span class=\"pull-right\"><div class=\"btn-wrapper-right\" ng-mouseover=\"showValidation()\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"addEntry()\" ng-disabled=\"!isFormValid()\" translate=\"AjouterNouvellePersonne\">Ajouter nouvelle personne</button></div></span></div></div><h2 translate=\"Totaux\">Totaux</h2><div class=\"row\"><div class=\"col-xs-4\"><label class=\"control-label\" translate=\"RevenuBrutImpot\">Revenu Brut / Impôt</label></div><div class=\"col-xs-4\"><p class=\"form-control-static text-right\">{{declaration.revenuTotal | currency}}</p></div><div class=\"col-xs-4\"><p class=\"form-control-static text-right\">{{declaration.retenueTotal | currency}}</p></div></div><div ng-if=\"formHelper.contexteFiscale.annee >= 2021\" class=\"row\"><div class=\"col-xs-4\"><label class=\"control-label\" translate=\"RevenuDeterminant\">Revenu determinant</label></div><div class=\"col-xs-4\"><p class=\"form-control-static text-right\">{{declaration.revenuDeterminantTotal | currency}}</p></div></div><div class=\"row\"><div class=\"col-xs-4\"><label class=\"control-label\">{{\'CommissionDePercetionADeduire\' | translate}}&nbsp;({{formHelper.contexteFiscale.tauxCommission | percentage}})</label></div><div class=\"col-xs-4 col-xs-offset-4\"><p class=\"form-control-static text-right\">{{declaration.commission | currency}}</p></div></div><div class=\"row\"><div class=\"col-xs-4\"><label class=\"control-label\" translate=\"TotalNetAPayer\">Total net à payer</label></div><div class=\"col-xs-4 col-xs-offset-4\"><p class=\"form-control-static text-right\">{{declaration.retenueNette | currency}}</p></div></div></div></form><div class=\"spacer\"></div></div><div ng-show=\"formHelper.step > 1\"><div ng-show=\"formHelper.step == 3\" class=\"alert alert-success\"><h2 translate=\"ConfirmationEnvoi\">Confirmation d\'envoi</h2><p translate=\"TexteConfirmationEnvoi\">TexteConfirmationEnvoi</p></div><a ng-show=\"formHelper.step == 3\" class=\"pull-right\" ng-click=\"printDiv(\'recap\')\"><span class=\"iconbtn iconexp iconexp-printer\" uib-tooltip=\"{{\'Imprimer\' | translate}}\" tooltip-placement=\"left\"></span></a><div id=\"recap\"><form role=\"form\" name=\"declarationHeaderRecapForm\"><h2 translate=\"IdentificationDuDPI\">Identification du DPI</h2><div class=\"row form-group\"><div class=\"col-xs-4\"><label for=\"noReference\" class=\"control-label\" translate=\"NoDeReference\">No de référence</label></div><div class=\"col-xs-4\"><p class=\"form-control-static\">{{declaration.ndc}}</p></div></div><div class=\"row form-group\"><div class=\"col-xs-4\"><label for=\"nomDpi\" class=\"control-label\" translate=\"Nom\">Nom</label></div><div class=\"col-xs-4\"><p class=\"form-control-static\">{{declaration.nomDpi}}</p></div></div><div class=\"row form-group\"><div class=\"col-xs-4\"><label for=\"responsable\" class=\"control-label\" translate=\"Responsable\">Responsable</label></div><div class=\"col-xs-4\"><p class=\"form-control-static\">{{declaration.responsable}}</p></div></div><div class=\"row form-group\"><div class=\"col-xs-4\"><label for=\"telephone\" class=\"control-label\" translate=\"Telephone\">Téléphone</label></div><div class=\"col-xs-4\"><p class=\"form-control-static\">{{declaration.telephone}}</p></div></div><div class=\"row form-group\"><div class=\"col-xs-4\"><label for=\"email\" class=\"control-label\" translate=\"Email\">E-mail</label></div><div class=\"col-xs-4\"><p class=\"form-control-static\">{{declaration.email}}</p></div></div><div class=\"row form-group\"><div class=\"col-xs-4\"><label for=\"anneeFiscale\" class=\"control-label\" translate=\"AnneeFiscale\">Année fiscale</label></div><div class=\"col-xs-4\"><p class=\"form-control-static\">{{declaration.anneeFiscale}}</p></div></div><div class=\"row form-group\"><div class=\"col-xs-4\"><label for=\"remarqueScc\" class=\"control-label\" translate=\"RemarqueScc\">Remarque au SCC</label></div><div class=\"col-xs-4\"><p ng-repeat=\"line in getRemarqueSccLines() track by $index\" class=\"form-control-static\">{{line}}</p></div></div><div class=\"row form-group\"><div class=\"col-xs-4\"><label class=\"control-label\" translate=\"DateDeLaDemande\">Date de la demande</label></div><div class=\"col-xs-4\"><p class=\"form-control-static\">{{formHelper.dateDemande | date : \'dd.MM.yyyy\'}}</p></div></div><div class=\"row form-group\"><div class=\"col-xs-4\"><label class=\"control-label\" translate=\"NombreEnregistrements\">Nombre d\'enregistrements</label></div><div class=\"col-xs-4\"><p class=\"form-control-static\">{{declaration.listesRecapitulatives.length}}</p></div></div></form><h2 translate=\"ListeRecapitulative\">Liste récapitulative</h2><div ng-include=\"\'scripts/app/form/declaris/lr/declaris.lr.recap.html\'\"></div></div></div></div></div><div ng-hide=\"formHelper.step == 3\" id=\"form-footer\"><div ng-show=\"formHelper.step == 1\"><div class=\"col-xs-2\"><div class=\"btn-wrapper-left\"><button type=\"button\" class=\"btn btn-default\" translate=\"Annuler\" ng-click=\"resetForm()\">Annuler</button></div></div><div class=\"col-xs-8\"><div class=\"alert alert-danger\" role=\"alert\" ng-show=\"formHelper.errorMsg\"><span class=\"glyphicon glyphicon-exclamation-sign\" aria-hidden=\"true\"></span> <span>{{formHelper.errorMsg}}</span></div><div class=\"alert alert-danger\" role=\"alert\" ng-show=\"formHelper.showValidationMsg\"><span class=\"glyphicon glyphicon-ban-circle\" aria-hidden=\"true\"></span> <span>{{\'FormulaireIncomplet\' | translate}}</span></div></div><div class=\"col-xs-2\"><span class=\"pull-right\"><div class=\"btn-wrapper-right\" ng-mouseover=\"showValidation()\"><button type=\"submit\" class=\"btn btn-primary\" ng-click=\"goToSecondStep()\" ng-disabled=\"!isFormValid()\" translate=\"Suivant\">Suivant</button></div></span></div></div><div ng-show=\"formHelper.step == 2\"><div class=\"col-xs-2\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"goToFirstStep()\" translate=\"Precedent\">Précédent</button></div><div class=\"col-xs-8\"><div class=\"alert alert-danger\" role=\"alert\" ng-show=\"formHelper.errorMsg\"><span class=\"glyphicon glyphicon-exclamation-sign\" aria-hidden=\"true\"></span> <span>{{formHelper.errorMsg}}</span></div></div><div class=\"col-xs-2\"><span class=\"pull-right\"><button type=\"submit\" class=\"btn btn-primary\" ng-click=\"sendDeclaration()\" ng-disabled=\"!isFormValid()\" translate=\"Envoyer\">Envoyer</button></span></div></div></div></div></div>");
$templateCache.put("scripts/app/form/declaris/lr/declaris.lr.recap.html","<table class=\"table table-striped\"><thead><tr><th><label translate=\"NoAvs\">No AVS</label>&nbsp;/<br><label translate=\"DateNaissance\">Date de naissance</label></th><th><label>{{\'Nom\' | translate}}&nbsp;{{\'Prenom\' | translate}}</label></th><th><label translate=\"NpaLocalite\">NPA / Localité</label></th><th><label translate=\"TFF\">TFF</label></th><th><label translate=\"Periode\">Période</label></th><th><label translate=\"Bareme\">Barème</label></th><th ng-if=\"formHelper.contexteFiscale.annee >= 2021\"><label translate=\"TauxActivite\">TauxActivite</label></th><th ng-if=\"formHelper.contexteFiscale.annee >= 2021\"><label translate=\"tauxAutresActivites\">tauxAutresActivites</label></th><th ng-if=\"formHelper.contexteFiscale.annee >= 2021\"><label translate=\"NbHeuresTravail\">NbHeuresTravail</label></th><th class=\"text-right\"><label translate=\"RevenuBrut\">Revenu brut</label></th><th ng-if=\"formHelper.contexteFiscale.annee >= 2021\" class=\"text-right\"><label translate=\"RevenuDeterminant\">RevenuDeterminant</label></th><th class=\"text-right\"><label translate=\"Impot\">Impot</label></th></tr></thead><tbody><tr ng-repeat=\"lr in declaration.listesRecapitulatives\"><td ng-class=\"{\'alert-danger\': hasErrors(lr, [\'noAvs\', \'dateNaissance\']), \'alert-warning\': hasWarnings(lr, [\'noAvs\', \'dateNaissance\'])}\" uib-popover-html=\"getValidationMessage(lr, [\'noAvs\', \'dateNaissance\'])\" popover-trigger=\"mouseenter\" popover-append-to-body=\"true\" popover-placement=\"right\"><span ng-hide=\"lr.pisInconnue\">{{lr.noAvs}}</span><span ng-if=\"lr.pisInconnue\">{{lr.dateNaissance | date : \'dd.MM.yyyy\'}}{{\'enum.Sexe.\' + lr.sexe + \'.abrege\' | translate}}</span></td><td ng-class=\"{\'alert-danger\': hasErrors(lr, [\'nom\', \'prenom\']), \'alert-warning\': hasWarnings(lr, [\'nom\', \'prenom\'])}\" uib-popover-html=\"getValidationMessage(lr, [\'nom\', \'prenom\'])\" popover-trigger=\"mouseenter\" popover-append-to-body=\"true\">{{lr.nom}} {{lr.prenom}}</td><td ng-class=\"{\'alert-danger\': hasErrors(lr, [\'npa\', \'localite\']), \'alert-warning\': hasWarnings(lr, [\'npa\', \'localite\'])}\" uib-popover-html=\"getValidationMessage(lr, [\'npa\', \'localite\'])\" popover-trigger=\"mouseenter\" popover-append-to-body=\"true\">{{lr.npa}} {{lr.localite}}</td><td ng-class=\"{\'alert-danger\': hasErrors(lr, [\'TTF\']), \'alert-warning\': hasWarnings(lr, [\'TTF\'])}\" uib-popover-html=\"getValidationMessage(lr, [\'TTF\'])\" popover-trigger=\"mouseenter\" popover-append-to-body=\"true\">{{lr.tauxTeletravailFrance | percentage}}</td><td ng-class=\"{\'alert-danger\': hasErrors(lr, [\'periodeDu\', \'periodeAu\']), \'alert-warning\': hasWarnings(lr, [\'periodeDu\', \'periodeAu\'])}\" uib-popover-html=\"getValidationMessage(lr, [\'periodeDu\', \'periodeAu\'])\" popover-trigger=\"mouseenter\" popover-append-to-body=\"true\">{{lr.periodeDu | date : \'dd.MM\'}} - {{lr.periodeAu | date : \'dd.MM\'}}</td><td ng-class=\"{\'alert-danger\': hasErrors(lr, [\'bareme\']), \'alert-warning\': hasWarnings(lr, [\'bareme\'])}\" uib-popover-html=\"getValidationMessage(lr, [\'bareme\'])\" popover-trigger=\"mouseenter\" popover-append-to-body=\"true\">{{lr.bareme}}{{lr.nbEnfants}}</td><td ng-if=\"formHelper.contexteFiscale.annee >= 2021\" ng-class=\"{\'alert-danger\': hasErrors(lr, [\'tauxActivite\']), \'alert-warning\': hasWarnings(lr, [\'tauxActivite\'])}\" uib-popover-html=\"getValidationMessage(lr, [\'tauxActivite\'])\" popover-trigger=\"mouseenter\" popover-append-to-body=\"true\">{{lr.tauxActivite | percentage}}</td><td ng-if=\"formHelper.contexteFiscale.annee >= 2021\" ng-class=\"{\'alert-danger\': hasErrors(lr, [\'tauxAutresActivites\']), \'alert-warning\': hasWarnings(lr, [\'tauxAutresActivites\'])}\" uib-popover-html=\"getValidationMessage(lr, [\'tauxAutresActivites\'])\" popover-trigger=\"mouseenter\" popover-append-to-body=\"true\">{{lr.tauxAutresActivites | percentage}}</td><td ng-if=\"formHelper.contexteFiscale.annee >= 2021\" ng-class=\"{\'alert-danger\': hasErrors(lr, [\'nbHeuresTravail\']), \'alert-warning\': hasWarnings(lr, [\'nbHeuresTravail\'])}\" uib-popover-html=\"getValidationMessage(lr, [\'nbHeuresTravail\'])\" popover-trigger=\"mouseenter\" popover-append-to-body=\"true\">{{lr.nbHeuresTravail}}</td><td ng-class=\"{\'alert-danger\': hasErrors(lr, [\'revenu\']), \'alert-warning\': hasWarnings(lr, [\'revenu\'])}\" uib-popover-html=\"getValidationMessage(lr, [\'revenu\'])\" popover-trigger=\"mouseenter\" popover-append-to-body=\"true\" class=\"text-right\">{{lr.revenu | currency : 2 : false}}</td><td ng-if=\"formHelper.contexteFiscale.annee >= 2021\" ng-class=\"{\'alert-danger\': hasErrors(lr, [\'revenuDeterminant\']), \'alert-warning\': hasWarnings(lr, [\'revenuDeterminant\'])}\" uib-popover-html=\"getValidationMessage(lr, [\'revenuDeterminant\'])\" popover-trigger=\"mouseenter\" popover-append-to-body=\"true\" class=\"text-right\">{{lr.revenuDeterminant | currency : 2 : false}}</td><td ng-class=\"{\'alert-danger\': hasErrors(lr, [\'retenue\']), \'alert-warning\': hasWarnings(lr, [\'retenue\'])}\" uib-popover-html=\"getValidationMessage(lr, [\'retenue\'])\" popover-trigger=\"mouseenter\" popover-append-to-body=\"true\" popover-placement=\"left\" class=\"text-right\">{{lr.retenue | currency : 2 : false}}</td></tr></tbody></table><h2 translate=\"Totaux\">Totaux</h2><div class=\"row\"><div class=\"col-xs-4\"><label class=\"control-label\" translate=\"RevenuBrutImpot\">Revenu Brut / Impôt</label></div><div class=\"col-xs-4\"><p class=\"form-control-static text-right\">{{declaration.revenuTotal | currency}}</p></div><div class=\"col-xs-4\"><p class=\"form-control-static text-right\">{{declaration.retenueTotal | currency}}</p></div></div><div ng-if=\"formHelper.contexteFiscale.annee >= 2021\" class=\"row\"><div class=\"col-xs-4\"><label class=\"control-label\" translate=\"RevenuDeterminant\">Revenu determinant</label></div><div class=\"col-xs-4\"><p class=\"form-control-static text-right\">{{declaration.revenuDeterminantTotal | currency}}</p></div></div><div class=\"row\"><div class=\"col-xs-4\"><label class=\"control-label\">{{\'CommissionDePercetionADeduire\' | translate}}&nbsp;({{formHelper.contexteFiscale.tauxCommission | percentage}})</label></div><div class=\"col-xs-4 col-xs-offset-4\"><p class=\"form-control-static text-right\">{{declaration.commission | currency}}</p></div></div><div class=\"row\"><div class=\"col-xs-4\"><label class=\"control-label\" translate=\"TotalNetAPayer\">Total net à payer</label></div><div class=\"col-xs-4 col-xs-offset-4\"><p class=\"form-control-static text-right\">{{declaration.retenueNette | currency}}</p></div></div>");
$templateCache.put("scripts/components/account/reset/finish/reset.finish.html","<div><div class=\"row\"><div class=\"col-md-4 col-md-offset-4\"><h1 translate=\"reset.finish.title\">Reset password</h1><div class=\"alert alert-danger\" translate=\"reset.finish.messages.keymissing\" ng-show=\"vm.keyMissing\"><strong>The password reset key is missing.</strong></div><div class=\"alert alert-warning\" ng-hide=\"vm.success || vm.keyMissing\"><p translate=\"reset.finish.messages.info\">Choose a new password</p></div><div class=\"alert alert-danger\" ng-show=\"vm.error\"><p translate=\"reset.finish.messages.error\">Your password couldn\'t be reset. Remember a password request is only valid for 24 hours.</p></div><div class=\"alert alert-success\" ng-show=\"vm.success\"><p translate=\"reset.finish.messages.success\" translate-compile><strong>Your password has been reset.</strong> Please <a class=\"alert-link\" href=\"\" ng-click=\"vm.login()\">sign in</a>.</p></div><div class=\"alert alert-danger\" ng-show=\"vm.doNotMatch\" translate=\"global.messages.error.dontmatch\">The password and its confirmation do not match!</div><div ng-hide=\"vm.keyMissing\"><form ng-show=\"!vm.success\" name=\"form\" role=\"form\" novalidate ng-submit=\"vm.finishReset()\" show-validation><div class=\"form-group\"><label class=\"control-label\" for=\"password\" translate=\"global.form.newpassword\">New password</label><input type=\"password\" class=\"form-control\" id=\"password\" name=\"password\" placeholder=\"{{\'global.form.newpassword.placeholder\' | translate}}\" ng-model=\"vm.resetAccount.password\" ng-minlength=\"4\" ng-maxlength=\"50\" required><div ng-show=\"form.password.$dirty && form.password.$invalid\"><p class=\"help-block\" ng-show=\"form.password.$error.required\" translate=\"global.messages.validate.newpassword.required\">Your password is required.</p><p class=\"help-block\" ng-show=\"form.password.$error.minlength\" translate=\"global.messages.validate.newpassword.minlength\">Your password is required to be at least 4 characters.</p><p class=\"help-block\" ng-show=\"form.password.$error.maxlength\" translate=\"global.messages.validate.newpassword.maxlength\">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check=\"vm.resetAccount.password\"></password-strength-bar></div><div class=\"form-group\"><label class=\"control-label\" for=\"confirmPassword\" translate=\"global.form.confirmpassword\">New password confirmation</label><input type=\"password\" class=\"form-control\" id=\"confirmPassword\" name=\"confirmPassword\" placeholder=\"{{\'global.form.confirmpassword.placeholder\' | translate}}\" ng-model=\"vm.confirmPassword\" ng-minlength=\"4\" ng-maxlength=\"50\" required><div ng-show=\"form.confirmPassword.$dirty && form.confirmPassword.$invalid\"><p class=\"help-block\" ng-show=\"form.confirmPassword.$error.required\" translate=\"global.messages.validate.confirmpassword.required\">Your password confirmation is required.</p><p class=\"help-block\" ng-show=\"form.confirmPassword.$error.minlength\" translate=\"global.messages.validate.confirmpassword.minlength\">Your password confirmation is required to be at least 4 characters.</p><p class=\"help-block\" ng-show=\"form.confirmPassword.$error.maxlength\" translate=\"global.messages.validate.confirmpassword.maxlength\">Your password confirmation cannot be longer than 50 characters.</p></div></div><button type=\"submit\" ng-disabled=\"form.$invalid\" class=\"btn btn-primary\" translate=\"reset.finish.form.button\">Reset Password</button></form></div></div></div></div>");
$templateCache.put("scripts/components/account/reset/request/reset.request.html","<div><div class=\"row\"><div class=\"col-md-8 col-md-offset-2\"><h1 translate=\"reset.request.title\">Reset your password</h1><div class=\"alert alert-danger\" translate=\"reset.request.messages.notfound\" ng-show=\"vm.errorEmailNotExists\"><strong>E-Mail address isn\'t registered!</strong> Please check and try again.</div><div class=\"alert alert-warning\" ng-hide=\"vm.success\"><p translate=\"reset.request.messages.info\">Enter the e-mail address you used to register.</p></div><div class=\"alert alert-success\" ng-show=\"vm.success == \'OK\'\"><p translate=\"reset.request.messages.success\">Check your e-mails for details on how to reset your password.</p></div><form ng-show=\"!vm.success\" name=\"form\" role=\"form\" novalidate ng-submit=\"vm.requestReset()\" show-validation><div class=\"form-group\"><label class=\"control-label\" for=\"email\" translate=\"global.form.email\">E-mail</label><input type=\"email\" class=\"form-control\" id=\"email\" name=\"email\" placeholder=\"{{\'global.form.email.placeholder\' | translate}}\" ng-model=\"vm.resetAccount.email\" ng-minlength=\"5\" ng-maxlength=\"100\" required><div ng-show=\"form.email.$dirty && form.email.$invalid\"><p class=\"help-block\" ng-show=\"form.email.$error.required\" translate=\"global.messages.validate.email.required\">Your e-mail is required.</p><p class=\"help-block\" ng-show=\"form.email.$error.email\" translate=\"global.messages.validate.email.invalid\">Your e-mail is invalid.</p><p class=\"help-block\" ng-show=\"form.email.$error.minlength\" translate=\"global.messages.validate.email.minlength\">Your e-mail is required to be at least 5 characters.</p><p class=\"help-block\" ng-show=\"form.email.$error.maxlength\" translate=\"global.messages.validate.email.maxlength\">Your e-mail cannot be longer than 100 characters.</p></div></div><button type=\"submit\" ng-disabled=\"form.$invalid\" class=\"btn btn-primary\" translate=\"reset.request.form.button\">Reset</button></form></div></div></div>");}]);})();